var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/app/index.ts
import { z as z2 } from "zod";

// src/app/auth-exceptions.enum.ts
import { z } from "zod";
var AuthExceptionValues = [
  "TOKEN_EXPIRED",
  "INVALID_TOKEN",
  "UNAUTHORIZED"
];
var AuthExceptionEnumObj = z.enum(AuthExceptionValues);
var EAuthExceptionEnum = AuthExceptionEnumObj.enum;

// src/app/index.ts
var AppNameValues = [
  "PROGRAMS",
  "FIT",
  "RYC",
  "MEMBERS",
  "HELP_CENTER",
  "NOTIFICATION",
  "RYC_WEBSITE",
  "SITE_MONITOR"
];
var AppNameEnumObj = z2.enum(AppNameValues);
var EAppNameEnum = AppNameEnumObj.enum;
var AppKeySchema = z2.string();
var PROGRAM_DISPLAY_NAMES = {
  [EAppNameEnum.FIT]: "RYC FIT",
  [EAppNameEnum.RYC]: "RYC",
  [EAppNameEnum.MEMBERS]: "Members",
  [EAppNameEnum.PROGRAMS]: "Programs",
  [EAppNameEnum.HELP_CENTER]: "Help Center",
  [EAppNameEnum.NOTIFICATION]: "Notification",
  [EAppNameEnum.RYC_WEBSITE]: "RYC Website",
  [EAppNameEnum.SITE_MONITOR]: "Site Monitor"
};
var sanitizeAppName = /* @__PURE__ */ __name((appName) => {
  return appName.replace(/<[^>]*>/g, "").replace(/[®™©]/g, "").replace(/[^a-zA-Z0-9\s]/g, " ").replace(/\s+/g, " ").trim().toUpperCase().replace(/\s+/g, "_");
}, "sanitizeAppName");

// src/app-settings/index.ts
import { array, number, object, string, z as z3 } from "zod";
var AppRegistryTypeEnumObject = z3.enum([
  "SPACE",
  "MINI",
  "SPECIAL"
]);
var CreateAppRequestSchema = object({
  app: string().trim().min(1, "Slug is required").max(100, "Slug is too long (max 100 characters)").regex(/^[a-z0-9]+(?:[-_][a-z0-9]+)*$/, "Use lowercase letters, numbers, hyphens or underscores"),
  name: string().trim().max(200, "Name is too long (max 200 characters)").nullable().optional(),
  description: string().nullable().optional(),
  parentId: string().nullable().optional(),
  type: AppRegistryTypeEnumObject.nullable().optional()
});
var UpdateAppRequestSchema = CreateAppRequestSchema.omit({
  app: true
});
var ProgramGroupSchema = object({
  id: string().uuid(),
  name: string().min(1).max(100),
  displayOrder: number().int(),
  createdAt: string().optional(),
  updatedAt: string().optional(),
  // Number of apps assigned to this group (resolved on list).
  appCount: number().optional()
});
var CreateProgramGroupRequestSchema = object({
  name: string().min(1, "Name is required").max(100, "Name is too long (max 100 characters)"),
  displayOrder: number().int().default(0)
});
var UpdateProgramGroupRequestSchema = CreateProgramGroupRequestSchema.partial();
var AssignAppToGroupRequestSchema = object({
  groupId: string().uuid().nullable(),
  displayOrder: number().int().min(0).optional()
});
var AppAssignmentItemSchema = object({
  app: string(),
  type: AppRegistryTypeEnumObject.nullable().optional(),
  groupId: string().uuid().nullable(),
  name: string().nullable().optional(),
  displayOrder: number().int().optional()
});
var AppThumbnailsSchema = object({
  default: string(),
  1: string().optional(),
  2: string().optional(),
  3: string().optional()
});
var AppTierLabelsSchema = object({
  1: string().optional(),
  2: string().optional(),
  3: string().optional()
});
var GroupedAppSchema = object({
  app: string(),
  name: object({
    subscribed: string(),
    unsubscribed: string()
  }),
  description: string(),
  icon: string(),
  cardBackgroundColor: string(),
  thumbnails: AppThumbnailsSchema,
  tierLabels: AppTierLabelsSchema.optional(),
  salesPageUrl: string().nullable().optional(),
  // Registry `apps.type` — drives how the frontend launches the app: SPACE opens
  // the community space page, MINI opens the program (programs-fe) by slug via
  // OTT, null/SPECIAL fall back to the app's env launch URL.
  type: AppRegistryTypeEnumObject.nullable().optional()
});
var GroupedAppsGroupSchema = object({
  id: string().uuid(),
  name: string(),
  displayOrder: number().int(),
  apps: array(GroupedAppSchema)
});
var GroupedAppsResponseSchema = object({
  groups: array(GroupedAppsGroupSchema)
});

// src/auth/magic-link.ts
import { z as z4 } from "zod";
var MagicLinkEmailSchema = z4.object({
  email: z4.string().email("Enter a valid email")
});
var RequestMagicLinkSchema = z4.object({
  email: z4.string().email(),
  redirectUrl: z4.string().url(),
  returnUrl: z4.string().optional(),
  returnApp: z4.string().optional()
});

// src/auth/otp-login.ts
import { z as z5 } from "zod";
var OTP_LOGIN_CODE_LENGTH = 6;
var OtpEmailSchema = z5.string().trim().email("Enter a valid email").transform((value) => value.toLowerCase());
var RequestOtpLoginSchema = z5.object({
  email: OtpEmailSchema
});
var VerifyOtpLoginSchema = z5.object({
  email: OtpEmailSchema,
  code: z5.string().trim().regex(new RegExp(`^\\d{${OTP_LOGIN_CODE_LENGTH}}$`), `Enter the ${OTP_LOGIN_CODE_LENGTH}-digit code`)
});

// src/auth/ott.ts
import { z as z6 } from "zod";
var TargetAppEnum = z6.enum([
  EAppNameEnum.FIT,
  EAppNameEnum.RYC,
  EAppNameEnum.PROGRAMS,
  EAppNameEnum.MEMBERS,
  "HELP_CENTER",
  "DASHBOARD",
  "WORDPRESS"
]);
var ETargetApp = TargetAppEnum.enum;
var GenerateOttSchema = z6.object({
  email: z6.string().email(),
  targetApp: TargetAppEnum,
  redirectUrl: z6.string().url(),
  /** Optional in-app path the SSO page should navigate to after the session is established (e.g. a deep link). */
  redirectTo: z6.string().optional()
});
var GenerateOttUserSchema = z6.object({
  targetApp: TargetAppEnum,
  redirectUrl: z6.string().url(),
  /** Optional in-app path the SSO page should navigate to after the session is established (e.g. a deep link). */
  redirectTo: z6.string().optional()
});
var ValidateOttSchema = z6.object({
  token: z6.string().uuid()
});
var ConsumeOttSchema = z6.object({
  token: z6.string().uuid()
});

// src/auth/provider.ts
import { z as z7 } from "zod";
var AuthProviderEnumObj = z7.enum([
  "wordpress",
  "supabase"
]);
var AuthProviderEnum = AuthProviderEnumObj.enum;
var AUTH_PROVIDER_HEADER = "x-auth-provider";
var FEATURE_FLAGS_STORAGE_KEY = "featureFlags";

// src/auth/sb-database.types.ts
var Constants = {
  public: {
    Enums: {
      app_type: [
        "SPACE",
        "MINI",
        "SPECIAL"
      ],
      pro_directory_revision_status: [
        "pending",
        "approved",
        "rejected",
        "draft"
      ],
      status_type_enum: [
        "active",
        "inactive"
      ],
      teacher_directory_revision_status: [
        "pending",
        "approved",
        "rejected"
      ]
    }
  }
};

// src/auth/sso-context.ts
var EAuthType = /* @__PURE__ */ function(EAuthType2) {
  EAuthType2["supabase"] = "supabase";
  EAuthType2["wordpress"] = "wordpress";
  return EAuthType2;
}({});
var SSO_CONTEXT_PARAM = "auth_type";
var LC_SSO_CONTEXT_VALUE = "supabase";
var LC_SSO_CONTEXT_QUERY = `${SSO_CONTEXT_PARAM}=${LC_SSO_CONTEXT_VALUE}`;

// src/auth/supabase-auth.ts
import { z as z8 } from "zod";
var SupabaseLoginSchema = z8.object({
  email: z8.string().email(),
  password: z8.string().min(1)
});
var RefreshTokenSchema = z8.object({
  refresh_token: z8.string().min(1)
});
var WpLoginSchema = z8.object({
  email: z8.string().email(),
  password: z8.string().min(1)
});
var MembersLoginSchema = z8.object({
  identifier: z8.string().min(1).transform((v) => v.toLowerCase().trim()),
  password: z8.string().min(1)
});
var SupabaseJwtPayloadSchema = z8.object({
  aud: z8.union([
    z8.string(),
    z8.array(z8.string())
  ]).optional(),
  exp: z8.number(),
  iat: z8.number().optional(),
  iss: z8.string().optional(),
  sub: z8.string(),
  email: z8.string(),
  phone: z8.string().optional(),
  app_metadata: z8.object({
    provider: z8.string().optional(),
    providers: z8.array(z8.string()).optional()
  }).passthrough(),
  user_metadata: z8.record(z8.unknown()),
  role: z8.string(),
  aal: z8.string().optional(),
  amr: z8.array(z8.object({
    method: z8.string(),
    timestamp: z8.number()
  })).optional(),
  session_id: z8.string(),
  is_anonymous: z8.boolean().optional()
}).passthrough();

// src/badges/entity.ts
import { object as object2, z as z10 } from "zod";

// src/badges/meta.ts
import { z as z9 } from "zod";
var BadgeMetaSchemaBE = z9.object({
  autoRedeemed: z9.boolean().default(true).describe("Whether the badge was auto redeemed")
});
var defaultBadgeMetaValuesBE = JSON.stringify({
  autoRedeemed: true
});

// src/badges/entity.ts
var BadgeTypeArray = [
  "CHALLENGE",
  "MILESTONE",
  "SERIES"
];
var BadgeTypeEnumObject = z10.enum(BadgeTypeArray);
var EBadgeType = BadgeTypeEnumObject.enum;
var ChallengeBadgeNameArray = [
  "CHALLENGE_VIDEO",
  "CHALLENGE_DAY"
];
var ChallengeBadgeNameEnumObject = z10.enum(ChallengeBadgeNameArray);
var EChallengeBadgeName = ChallengeBadgeNameEnumObject.enum;
var MilestoneBadgeNameArray = [
  "CHALLENGE_CHAMPION",
  "DAILY_DEDICATION",
  "LIVE_CLASS",
  "COMMENTS",
  "WORKOUTS"
];
var MilestoneBadgeNameEnumObject = z10.enum(MilestoneBadgeNameArray);
var EMilestoneBadgeName = MilestoneBadgeNameEnumObject.enum;
var SeriesBadgeNameArray = [
  "SERIES_COMPLETED"
];
var SeriesBadgeNameEnumObject = z10.enum(SeriesBadgeNameArray);
var ESeriesBadgeName = SeriesBadgeNameEnumObject.enum;
var BadgeWeightEnum = z10.enum([
  "10",
  "25",
  "50",
  "100",
  "250",
  "500",
  "1000",
  "2500"
]);
var BadgeNameEnum = z10.enum([
  ...ChallengeBadgeNameEnumObject.options,
  ...MilestoneBadgeNameEnumObject.options,
  ...SeriesBadgeNameEnumObject.options
]);
var BaseBadgeFields = {
  id: z10.coerce.number(),
  userId: z10.string(),
  createdAt: z10.string(),
  updatedAt: z10.string(),
  meta: BadgeMetaSchemaBE
};
var ChallengeBadgeSchema = z10.object(__spreadProps(__spreadValues({}, BaseBadgeFields), {
  type: z10.literal(EBadgeType.CHALLENGE),
  badgeName: ChallengeBadgeNameEnumObject,
  challengeContentId: z10.string().nullable(),
  challengeId: z10.string(),
  challengeDayIndex: z10.number().nullable()
}));
var MilestoneBadgeSchema = z10.object(__spreadProps(__spreadValues({}, BaseBadgeFields), {
  type: z10.literal(EBadgeType.MILESTONE),
  badgeName: MilestoneBadgeNameEnumObject,
  badgeWeight: BadgeWeightEnum.optional().nullable(),
  challengeContentId: z10.null(),
  challengeId: z10.string().nullable()
}));
var SeriesBadgeSchema = z10.object(__spreadProps(__spreadValues({}, BaseBadgeFields), {
  type: z10.literal(EBadgeType.SERIES),
  badgeName: SeriesBadgeNameEnumObject,
  seriesId: z10.number(),
  seriesName: z10.string().nullable().optional(),
  badgeIconUrl: z10.string().nullable().optional(),
  challengeContentId: z10.null(),
  challengeId: z10.null(),
  challengeDayIndex: z10.null()
}));
var BadgeSchema = z10.discriminatedUnion("type", [
  ChallengeBadgeSchema,
  MilestoneBadgeSchema,
  SeriesBadgeSchema
]);
var BadgeTypeNameSchema = z10.discriminatedUnion("type", [
  object2({
    type: z10.literal(EBadgeType.CHALLENGE),
    badgeName: ChallengeBadgeNameEnumObject
  }),
  object2({
    type: z10.literal(EBadgeType.MILESTONE),
    badgeName: MilestoneBadgeNameEnumObject
  }),
  object2({
    type: z10.literal(EBadgeType.SERIES),
    badgeName: SeriesBadgeNameEnumObject
  })
]);
var GetBadgesQuerySchema = z10.object({
  type: BadgeTypeEnumObject.optional()
});
var GetUserBadgesParamsSchema = z10.object({
  userId: z10.string().min(1, "User ID is required")
});
var CommonCreateBadgeSchema = z10.object({
  userId: z10.string().min(1, "User ID is required")
});
var CreateChallengeBadgeSchema = CommonCreateBadgeSchema.extend({
  type: z10.literal(EBadgeType.CHALLENGE),
  badgeName: ChallengeBadgeNameEnumObject,
  challengeContentId: z10.string().min(1, "Challenge content ID is required").nullable(),
  challengeId: z10.string().min(1, "Challenge ID is required"),
  challengeDayIndex: z10.number().nullable()
});
var CreateMilestoneBadgeSchema = CommonCreateBadgeSchema.extend({
  type: z10.literal(EBadgeType.MILESTONE),
  badgeName: MilestoneBadgeNameEnumObject,
  badgeWeight: BadgeWeightEnum.optional(),
  challengeId: z10.string().min(1, "Challenge ID is required").or(z10.null())
});
var CreateSeriesBadgeSchema = CommonCreateBadgeSchema.extend({
  type: z10.literal(EBadgeType.SERIES),
  badgeName: SeriesBadgeNameEnumObject,
  seriesId: z10.number()
});
var CreateBadgeSchema = z10.discriminatedUnion("type", [
  CreateChallengeBadgeSchema,
  CreateMilestoneBadgeSchema,
  CreateSeriesBadgeSchema
]);
var BadgesResponseSchema = z10.object({
  badges: z10.array(BadgeSchema),
  total: z10.number()
});

// src/common/visible-text-length.ts
var visibleTextLength = /* @__PURE__ */ __name((html) => html.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, "").replace(/<[^>]*>/g, " ").replace(/&(?:nbsp|amp|lt|gt|quot|#39);/g, " ").replace(/\s+/g, " ").trim().length, "visibleTextLength");

// src/common/bio-html.ts
var BIO_ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "em",
  "u",
  "ul",
  "ol",
  "li",
  "a",
  "sup",
  "sub"
];
var BIO_ALLOWED_ATTRIBUTES = {
  a: [
    "href",
    "target",
    "rel"
  ]
};
var BIO_ALLOWED_SCHEMES = [
  "http",
  "https",
  "mailto"
];
var BIO_LINK_TARGET = "_blank";
var BIO_LINK_REL = "noopener noreferrer nofollow";
var BIO_MAX_VISIBLE_CHARS = 3e3;
var BIO_MIN_VISIBLE_CHARS = 50;
var BIO_MAX_RAW_CHARS = 15e3;
var HTML_TAG_PATTERN = /<\/?[a-z][^>]*>/i;
var escapeHtml = /* @__PURE__ */ __name((text) => text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"), "escapeHtml");
var plainTextToBioHtml = /* @__PURE__ */ __name((text) => text.split(/\n{2,}/).map((part) => part.trim()).filter(Boolean).map((part) => `<p>${escapeHtml(part).replace(/\n/g, "<br>")}</p>`).join(""), "plainTextToBioHtml");
var toBioHtml = /* @__PURE__ */ __name((value) => {
  const text = value != null ? value : "";
  return HTML_TAG_PATTERN.test(text) ? text : plainTextToBioHtml(text);
}, "toBioHtml");
var bioVisibleTextLength = /* @__PURE__ */ __name((value) => visibleTextLength(value != null ? value : ""), "bioVisibleTextLength");

// src/common/boolean.schema.ts
import { z as z11 } from "zod";
var StringToBooleanSchema = z11.union([
  z11.boolean(),
  z11.string(),
  z11.number()
]).transform((val) => {
  if (typeof val === "boolean") {
    return val;
  }
  if (typeof val === "number") {
    return val !== 0;
  }
  if (typeof val === "string") {
    const lower = val.toLowerCase().trim();
    return lower === "true" || lower === "1";
  }
  return false;
});

// src/common/cache-keys.enum.ts
var GlobalCacheKeyEnum = /* @__PURE__ */ function(GlobalCacheKeyEnum2) {
  GlobalCacheKeyEnum2["MENTION_USER_PROFILES"] = "mention-user-profiles";
  return GlobalCacheKeyEnum2;
}({});

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/errors.js
var _a;
var LuxonError = (_a = class extends Error {
}, __name(_a, "LuxonError"), _a);
var _InvalidDateTimeError = class _InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
};
__name(_InvalidDateTimeError, "InvalidDateTimeError");
var InvalidDateTimeError = _InvalidDateTimeError;
var _InvalidIntervalError = class _InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
};
__name(_InvalidIntervalError, "InvalidIntervalError");
var InvalidIntervalError = _InvalidIntervalError;
var _InvalidDurationError = class _InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
};
__name(_InvalidDurationError, "InvalidDurationError");
var InvalidDurationError = _InvalidDurationError;
var _ConflictingSpecificationError = class _ConflictingSpecificationError extends LuxonError {
};
__name(_ConflictingSpecificationError, "ConflictingSpecificationError");
var ConflictingSpecificationError = _ConflictingSpecificationError;
var _InvalidUnitError = class _InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
};
__name(_InvalidUnitError, "InvalidUnitError");
var InvalidUnitError = _InvalidUnitError;
var _InvalidArgumentError = class _InvalidArgumentError extends LuxonError {
};
__name(_InvalidArgumentError, "InvalidArgumentError");
var InvalidArgumentError = _InvalidArgumentError;
var _ZoneIsAbstractError = class _ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
};
__name(_ZoneIsAbstractError, "ZoneIsAbstractError");
var ZoneIsAbstractError = _ZoneIsAbstractError;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formats.js
var n = "numeric";
var s = "short";
var l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zone.js
var _Zone = class _Zone {
  /**
  * The type of zone
  * @abstract
  * @type {string}
  */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The name of this zone.
  * @abstract
  * @type {string}
  */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The IANA name of this zone.
  * Defaults to `name` if not overwritten by a subclass.
  * @abstract
  * @type {string}
  */
  get ianaName() {
    return this.name;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year.
  * @abstract
  * @type {boolean}
  */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's value as a string
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is equal to another zone
  * @abstract
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is valid.
  * @abstract
  * @type {boolean}
  */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
};
__name(_Zone, "Zone");
var Zone = _Zone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/systemZone.js
var singleton = null;
var _SystemZone = class _SystemZone extends Zone {
  /**
  * Get a singleton instance of the local zone
  * @return {SystemZone}
  */
  static get instance() {
    if (singleton === null) {
      singleton = new _SystemZone();
    }
    return singleton;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
};
__name(_SystemZone, "SystemZone");
var SystemZone = _SystemZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/IANAZone.js
var dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
__name(makeDTF, "makeDTF");
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date2) {
  const formatted = dtf.format(date2).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [
    fYear,
    fMonth,
    fDay,
    fadOrBc,
    fHour,
    fMinute,
    fSecond
  ];
}
__name(hackyOffset, "hackyOffset");
function partsOffset(dtf, date2) {
  const formatted = dtf.formatToParts(date2);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
__name(partsOffset, "partsOffset");
var ianaZoneCache = {};
var _IANAZone = class _IANAZone extends Zone {
  /**
  * @param {string} name - Zone name
  * @return {IANAZone}
  */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new _IANAZone(name);
    }
    return ianaZoneCache[name];
  }
  /**
  * Reset local caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
  * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
  * @param {string} s - The string to check validity on
  * @example IANAZone.isValidSpecifier("America/New_York") //=> true
  * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
  * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
  * @return {boolean}
  */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
  * Returns whether the provided string identifies a real zone
  * @param {string} zone - The string to check
  * @example IANAZone.isValidZone("America/New_York") //=> true
  * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
  * @example IANAZone.isValidZone("Sport~~blorp") //=> false
  * @return {boolean}
  */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = _IANAZone.isValidZone(name);
  }
  /**
  * The type of zone. `iana` for all instances of `IANAZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "iana";
  }
  /**
  * The name of this zone (i.e. the IANA zone name).
  * @override
  * @type {string}
  */
  get name() {
    return this.zoneName;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns false for all IANA zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return false;
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @override
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    const date2 = new Date(ts);
    if (isNaN(date2)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date2) : hackyOffset(dtf, date2);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date2;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
  * Return whether this Zone is equal to another zone
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
  * Return whether this Zone is valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return this.valid;
  }
};
__name(_IANAZone, "IANAZone");
var IANAZone = _IANAZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/locale.js
var intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedLF, "getCachedLF");
var intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedDTF, "getCachedDTF");
var intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
__name(getCachedINF, "getCachedINF");
var intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const _a5 = opts, { base } = _a5, cacheKeyOpts = __objRest(_a5, ["base"]);
  const key = JSON.stringify([
    locString,
    cacheKeyOpts
  ]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
__name(getCachedRTF, "getCachedRTF");
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
__name(systemLocale, "systemLocale");
var weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
__name(getCachedWeekInfo, "getCachedWeekInfo");
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [
      localeStr
    ];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [
      selectedStr,
      numberingSystem,
      calendar
    ];
  }
}
__name(parseLocaleString, "parseLocaleString");
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
__name(intlConfigString, "intlConfigString");
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapMonths, "mapMonths");
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapWeekdays, "mapWeekdays");
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
__name(listStuff, "listStuff");
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
__name(supportsFastNumbers, "supportsFastNumbers");
var _a2;
var PolyNumberFormatter = (_a2 = class {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const _a5 = opts, { padTo, floor } = _a5, otherOpts = __objRest(_a5, ["padTo", "floor"]);
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = __spreadValues({
        useGrouping: false
      }, opts);
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}, __name(_a2, "PolyNumberFormatter"), _a2);
var _a3;
var PolyDateFormatter = (_a3 = class {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z208 = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z208 = offsetZ;
        this.dt = dt;
      } else {
        z208 = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
          minutes: dt.offset
        });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z208 = dt.zone.name;
    } else {
      z208 = "UTC";
      this.dt = dt.setZone("UTC").plus({
        minutes: dt.offset
      });
      this.originalZone = dt.zone;
    }
    const intlOpts = __spreadValues({}, this.opts);
    intlOpts.timeZone = intlOpts.timeZone || z208;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return __spreadProps(__spreadValues({}, part), {
            value: offsetName
          });
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}, __name(_a3, "PolyDateFormatter"), _a3);
var _a4;
var PolyRelFormatter = (_a4 = class {
  constructor(intl, isEnglish, opts) {
    this.opts = __spreadValues({
      style: "long"
    }, opts);
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}, __name(_a4, "PolyRelFormatter"), _a4);
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [
    6,
    7
  ]
};
var _Locale = class _Locale {
  static fromOpts(opts) {
    return _Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new _Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return _Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return _Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: true
    }));
  }
  redefaultToSystem(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: false
    }));
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? {
        month: length,
        day: "numeric"
      } : {
        month: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? {
        weekday: length,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) => this.extract(dt, intl, "weekday"));
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(this, void 0, () => meridiems, () => {
      if (!this.meridiemCache) {
        const intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        this.meridiemCache = [
          DateTime.utc(2016, 11, 13, 9),
          DateTime.utc(2016, 11, 13, 19)
        ].map((dt) => this.extract(dt, intl, "dayperiod"));
      }
      return this.meridiemCache;
    });
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = {
        era: length
      };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [
          DateTime.utc(-40, 1, 1),
          DateTime.utc(2017, 1, 1)
        ].map((dt) => this.extract(dt, intl, "era"));
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
__name(_Locale, "Locale");
var Locale = _Locale;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/fixedOffsetZone.js
var singleton2 = null;
var _FixedOffsetZone = class _FixedOffsetZone extends Zone {
  /**
  * Get a singleton instance of UTC
  * @return {FixedOffsetZone}
  */
  static get utcInstance() {
    if (singleton2 === null) {
      singleton2 = new _FixedOffsetZone(0);
    }
    return singleton2;
  }
  /**
  * Get an instance with a specified offset
  * @param {number} offset - The offset in minutes
  * @return {FixedOffsetZone}
  */
  static instance(offset2) {
    return offset2 === 0 ? _FixedOffsetZone.utcInstance : new _FixedOffsetZone(offset2);
  }
  /**
  * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
  * @param {string} s - The offset string to parse
  * @example FixedOffsetZone.parseSpecifier("UTC+6")
  * @example FixedOffsetZone.parseSpecifier("UTC+06")
  * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
  * @return {FixedOffsetZone}
  */
  static parseSpecifier(s2) {
    if (s2) {
      const r = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new _FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
  * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "fixed";
  }
  /**
  * The name of this zone.
  * All fixed zones' names always start with "UTC" (plus optional offset)
  * @override
  * @type {string}
  */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
  * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
  *
  * @override
  * @type {string}
  */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
  * Returns the offset's common name at the specified timestamp.
  *
  * For fixed offset zones this equals to the zone name.
  * @override
  */
  offsetName() {
    return this.name;
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns true for all fixed offset zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return true;
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  *
  * For fixed offset zones, this is constant and does not depend on a timestamp.
  * @override
  * @return {number}
  */
  offset() {
    return this.fixed;
  }
  /**
  * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
  * Return whether this Zone is valid:
  * All fixed offset zones are valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return true;
  }
};
__name(_FixedOffsetZone, "FixedOffsetZone");
var FixedOffsetZone = _FixedOffsetZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/invalidZone.js
var _InvalidZone = class _InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
};
__name(_InvalidZone, "InvalidZone");
var InvalidZone = _InvalidZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/zoneUtil.js
function normalizeZone(input, defaultZone2) {
  let offset2;
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
__name(normalizeZone, "normalizeZone");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/digits.js
var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [
    1632,
    1641
  ],
  arabext: [
    1776,
    1785
  ],
  bali: [
    6992,
    7001
  ],
  beng: [
    2534,
    2543
  ],
  deva: [
    2406,
    2415
  ],
  fullwide: [
    65296,
    65303
  ],
  gujr: [
    2790,
    2799
  ],
  khmr: [
    6112,
    6121
  ],
  knda: [
    3302,
    3311
  ],
  laoo: [
    3792,
    3801
  ],
  limb: [
    6470,
    6479
  ],
  mlym: [
    3430,
    3439
  ],
  mong: [
    6160,
    6169
  ],
  mymr: [
    4160,
    4169
  ],
  orya: [
    2918,
    2927
  ],
  tamldec: [
    3046,
    3055
  ],
  telu: [
    3174,
    3183
  ],
  thai: [
    3664,
    3673
  ],
  tibt: [
    3872,
    3881
  ]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
__name(parseDigits, "parseDigits");
var digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}
__name(resetDigitRegexCache, "resetDigitRegexCache");
function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";
  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp(`${numberingSystems[ns]}${append}`);
  }
  return digitRegexCache[ns][append];
}
__name(digitRegex, "digitRegex");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/settings.js
var now = /* @__PURE__ */ __name(() => Date.now(), "now");
var defaultZone = "system";
var defaultLocale = null;
var defaultNumberingSystem = null;
var defaultOutputCalendar = null;
var twoDigitCutoffYear = 60;
var throwOnInvalid;
var defaultWeekSettings = null;
var _Settings = class _Settings {
  /**
  * Get the callback for returning the current timestamp.
  * @type {function}
  */
  static get now() {
    return now;
  }
  /**
  * Set the callback for returning the current timestamp.
  * The function should return a number, which will be interpreted as an Epoch millisecond count
  * @type {function}
  * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
  * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
  */
  static set now(n2) {
    now = n2;
  }
  /**
  * Set the default time zone to create DateTimes in. Does not affect existing instances.
  * Use the value "system" to reset this value to the system's time zone.
  * @type {string}
  */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
  * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
  * The default value is the system's time zone (the one set on the machine that runs this code).
  * @type {Zone}
  */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
  * Get the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
  * Set the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
  * Get the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
  * Set the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
  * Get the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
  * Set the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
  * @typedef {Object} WeekSettings
  * @property {number} firstDay
  * @property {number} minimalDays
  * @property {number[]} weekend
  */
  /**
  * @return {WeekSettings|null}
  */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
  * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
  * how many days are required in the first week of a year.
  * Does not affect existing instances.
  *
  * @param {WeekSettings|null} weekSettings
  */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
  * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
  * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
  * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
  * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
  * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
  * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
  */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
  * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
  * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  /**
  * Reset Luxon's global caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
};
__name(_Settings, "Settings");
var Settings = _Settings;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/invalid.js
var _Invalid = class _Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
};
__name(_Invalid, "Invalid");
var Invalid = _Invalid;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/conversions.js
var nonLeapLadder = [
  0,
  31,
  59,
  90,
  120,
  151,
  181,
  212,
  243,
  273,
  304,
  334
];
var leapLadder = [
  0,
  31,
  60,
  91,
  121,
  152,
  182,
  213,
  244,
  274,
  305,
  335
];
function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
__name(unitOutOfRange, "unitOutOfRange");
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
__name(dayOfWeek, "dayOfWeek");
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
__name(computeOrdinal, "computeOrdinal");
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day
  };
}
__name(uncomputeOrdinal, "uncomputeOrdinal");
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
__name(isoWeekdayToLocal, "isoWeekdayToLocal");
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return __spreadValues({
    weekYear,
    weekNumber,
    weekday
  }, timeObject(gregObj));
}
__name(gregorianToWeek, "gregorianToWeek");
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(weekData));
}
__name(weekToGregorian, "weekToGregorian");
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return __spreadValues({
    year,
    ordinal
  }, timeObject(gregData));
}
__name(gregorianToOrdinal, "gregorianToOrdinal");
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(ordinalData));
}
__name(ordinalToGregorian, "ordinalToGregorian");
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
  }
}
__name(usesLocalWeekValues, "usesLocalWeekValues");
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
__name(hasInvalidWeekData, "hasInvalidWeekData");
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
__name(hasInvalidOrdinalData, "hasInvalidOrdinalData");
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
__name(hasInvalidGregorianData, "hasInvalidGregorianData");
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
__name(hasInvalidTimeData, "hasInvalidTimeData");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/util.js
function isUndefined(o) {
  return typeof o === "undefined";
}
__name(isUndefined, "isUndefined");
function isNumber(o) {
  return typeof o === "number";
}
__name(isNumber, "isNumber");
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
__name(isInteger, "isInteger");
function isString(o) {
  return typeof o === "string";
}
__name(isString, "isString");
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
__name(isDate, "isDate");
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
__name(hasRelative, "hasRelative");
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
__name(hasLocaleWeekInfo, "hasLocaleWeekInfo");
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [
    thing
  ];
}
__name(maybeArray, "maybeArray");
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [
      by(next),
      next
    ];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
__name(bestBy, "bestBy");
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
__name(pick, "pick");
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
__name(hasOwnProperty, "hasOwnProperty");
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
__name(validateWeekSettings, "validateWeekSettings");
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
__name(integerBetween, "integerBetween");
function floorMod(x, n2) {
  return x - n2 * Math.floor(x / n2);
}
__name(floorMod, "floorMod");
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
__name(padStart, "padStart");
function parseInteger(string90) {
  if (isUndefined(string90) || string90 === null || string90 === "") {
    return void 0;
  } else {
    return parseInt(string90, 10);
  }
}
__name(parseInteger, "parseInteger");
function parseFloating(string90) {
  if (isUndefined(string90) || string90 === null || string90 === "") {
    return void 0;
  } else {
    return parseFloat(string90);
  }
}
__name(parseFloating, "parseFloating");
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
__name(parseMillis, "parseMillis");
function roundTo(number42, digits, towardZero = false) {
  const factor = __pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number42 * factor) / factor;
}
__name(roundTo, "roundTo");
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
__name(isLeapYear, "isLeapYear");
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
__name(daysInYear, "daysInYear");
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [
      31,
      null,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31
    ][modMonth - 1];
  }
}
__name(daysInMonth, "daysInMonth");
function objToLocalTS(obj) {
  let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
__name(objToLocalTS, "objToLocalTS");
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
__name(firstWeekOffset, "firstWeekOffset");
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
__name(weeksInWeekYear, "weeksInWeekYear");
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
__name(untruncateYear, "untruncateYear");
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date2 = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = __spreadValues({
    timeZoneName: offsetFormat
  }, intlOpts);
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date2).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
__name(parseZoneInfo, "parseZoneInfo");
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
__name(signedOffset, "signedOffset");
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
__name(asNumber, "asNumber");
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
__name(normalizeObject, "normalizeObject");
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
__name(formatOffset, "formatOffset");
function timeObject(obj) {
  return pick(obj, [
    "hour",
    "minute",
    "second",
    "millisecond"
  ]);
}
__name(timeObject, "timeObject");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/english.js
var monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var monthsNarrow = [
  "J",
  "F",
  "M",
  "A",
  "M",
  "J",
  "J",
  "A",
  "S",
  "O",
  "N",
  "D"
];
function months(length) {
  switch (length) {
    case "narrow":
      return [
        ...monthsNarrow
      ];
    case "short":
      return [
        ...monthsShort
      ];
    case "long":
      return [
        ...monthsLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ];
    case "2-digit":
      return [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ];
    default:
      return null;
  }
}
__name(months, "months");
var weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
var weekdaysShort = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun"
];
var weekdaysNarrow = [
  "M",
  "T",
  "W",
  "T",
  "F",
  "S",
  "S"
];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [
        ...weekdaysNarrow
      ];
    case "short":
      return [
        ...weekdaysShort
      ];
    case "long":
      return [
        ...weekdaysLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7"
      ];
    default:
      return null;
  }
}
__name(weekdays, "weekdays");
var meridiems = [
  "AM",
  "PM"
];
var erasLong = [
  "Before Christ",
  "Anno Domini"
];
var erasShort = [
  "BC",
  "AD"
];
var erasNarrow = [
  "B",
  "A"
];
function eras(length) {
  switch (length) {
    case "narrow":
      return [
        ...erasNarrow
      ];
    case "short":
      return [
        ...erasShort
      ];
    case "long":
      return [
        ...erasLong
      ];
    default:
      return null;
  }
}
__name(eras, "eras");
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
__name(meridiemForDateTime, "meridiemForDateTime");
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
__name(weekdayForDateTime, "weekdayForDateTime");
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
__name(monthForDateTime, "monthForDateTime");
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
__name(eraForDateTime, "eraForDateTime");
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: [
      "year",
      "yr."
    ],
    quarters: [
      "quarter",
      "qtr."
    ],
    months: [
      "month",
      "mo."
    ],
    weeks: [
      "week",
      "wk."
    ],
    days: [
      "day",
      "day",
      "days"
    ],
    hours: [
      "hour",
      "hr."
    ],
    minutes: [
      "minute",
      "min."
    ],
    seconds: [
      "second",
      "sec."
    ]
  };
  const lastable = [
    "hours",
    "minutes",
    "seconds"
  ].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
      default:
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
__name(formatRelativeTime, "formatRelativeTime");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formatter.js
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
__name(stringifyTokens, "stringifyTokens");
var macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
var _Formatter = class _Formatter {
  static create(locale, opts = {}) {
    return new _Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed || /^\s+$/.test(currentFull),
        val: currentFull
      });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p);
    }
    const opts = __spreadValues({}, this.opts);
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string90 = /* @__PURE__ */ __name((opts, extract) => this.loc.extract(dt, opts, extract), "string"), formatOffset2 = /* @__PURE__ */ __name((opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, "formatOffset"), meridiem = /* @__PURE__ */ __name(() => knownEnglish ? meridiemForDateTime(dt) : string90({
      hour: "numeric",
      hourCycle: "h12"
    }, "dayperiod"), "meridiem"), month = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string90(standalone ? {
      month: length
    } : {
      month: length,
      day: "numeric"
    }, "month"), "month"), weekday = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string90(standalone ? {
      weekday: length
    } : {
      weekday: length,
      month: "long",
      day: "numeric"
    }, "weekday"), "weekday"), maybeMacro = /* @__PURE__ */ __name((token) => {
      const formatOpts = _Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, "maybeMacro"), era = /* @__PURE__ */ __name((length) => knownEnglish ? eraForDateTime(dt, length) : string90({
      era: length
    }, "era"), "era"), tokenToString = /* @__PURE__ */ __name((token) => {
      switch (token) {
        // ms
        case "S":
          return this.num(dt.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        // hours
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        // offset
        case "Z":
          return formatOffset2({
            format: "narrow",
            allowZ: this.opts.allowZ
          });
        case "ZZ":
          return formatOffset2({
            format: "short",
            allowZ: this.opts.allowZ
          });
        case "ZZZ":
          return formatOffset2({
            format: "techie",
            allowZ: this.opts.allowZ
          });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "short",
            locale: this.loc.locale
          });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "long",
            locale: this.loc.locale
          });
        // zone
        case "z":
          return dt.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string90({
            day: "numeric"
          }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string90({
            day: "2-digit"
          }, "day") : this.num(dt.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string90({
            month: "numeric",
            day: "numeric"
          }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string90({
            month: "2-digit",
            day: "numeric"
          }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string90({
            month: "numeric"
          }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string90({
            month: "2-digit"
          }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string90({
            year: "numeric"
          }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string90({
            year: "2-digit"
          }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string90({
            year: "numeric"
          }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string90({
            year: "numeric"
          }, "year") : this.num(dt.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    }, "tokenToString");
    return stringifyTokens(_Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = /* @__PURE__ */ __name((token) => {
      switch (token[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, "tokenToField"), tokenToString = /* @__PURE__ */ __name((lildur) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        return this.num(lildur.get(mapped), token.length);
      } else {
        return token;
      }
    }, "tokenToString"), tokens = _Formatter.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal3, val }) => literal3 ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
};
__name(_Formatter, "Formatter");
var Formatter = _Formatter;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/regexParser.js
var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
__name(combineRegexes, "combineRegexes");
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(([mergedVals, mergedZone, cursor], ex) => {
    const [val, zone, next] = ex(m, cursor);
    return [
      __spreadValues(__spreadValues({}, mergedVals), val),
      zone || mergedZone,
      next
    ];
  }, [
    {},
    null,
    1
  ]).slice(0, 2);
}
__name(combineExtractors, "combineExtractors");
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [
      null,
      null
    ];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [
    null,
    null
  ];
}
__name(parse, "parse");
function simpleParse(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor + i]);
    }
    return [
      ret,
      null,
      cursor + i
    ];
  };
}
__name(simpleParse, "simpleParse");
var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
var isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
var sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`);
var sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
__name(int, "int");
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [
    item,
    null,
    cursor + 3
  ];
}
__name(extractISOYmd, "extractISOYmd");
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [
    item,
    null,
    cursor + 4
  ];
}
__name(extractISOTime, "extractISOTime");
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [
    {},
    zone,
    cursor + 3
  ];
}
__name(extractISOOffset, "extractISOOffset");
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [
    {},
    zone,
    cursor + 1
  ];
}
__name(extractIANAZone, "extractIANAZone");
var isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = /* @__PURE__ */ __name((num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num, "maybeNegate");
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
__name(extractISODuration, "extractISODuration");
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
__name(fromStrings, "fromStrings");
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [
    result,
    new FixedOffsetZone(offset2)
  ];
}
__name(extractRFC2822, "extractRFC2822");
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
__name(preprocessRFC2822, "preprocessRFC2822");
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/;
var rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/;
var ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractRFC1123Or850, "extractRFC1123Or850");
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractASCII, "extractASCII");
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseISODate(s2) {
  return parse(s2, [
    isoYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    isoWeekWithTimeExtensionRegex,
    extractISOWeekTimeAndOffset
  ], [
    isoOrdinalWithTimeExtensionRegex,
    extractISOOrdinalDateAndTime
  ], [
    isoTimeCombinedRegex,
    extractISOTimeAndOffset
  ]);
}
__name(parseISODate, "parseISODate");
function parseRFC2822Date(s2) {
  return parse(preprocessRFC2822(s2), [
    rfc2822,
    extractRFC2822
  ]);
}
__name(parseRFC2822Date, "parseRFC2822Date");
function parseHTTPDate(s2) {
  return parse(s2, [
    rfc1123,
    extractRFC1123Or850
  ], [
    rfc850,
    extractRFC1123Or850
  ], [
    ascii,
    extractASCII
  ]);
}
__name(parseHTTPDate, "parseHTTPDate");
function parseISODuration(s2) {
  return parse(s2, [
    isoDuration,
    extractISODuration
  ]);
}
__name(parseISODuration, "parseISODuration");
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse(s2, [
    isoTimeOnly,
    extractISOTimeOnly
  ]);
}
__name(parseISOTimeOnly, "parseISOTimeOnly");
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s2) {
  return parse(s2, [
    sqlYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    sqlTimeCombinedRegex,
    extractISOTimeOffsetAndIANAZone
  ]);
}
__name(parseSQL, "parseSQL");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/duration.js
var INVALID = "Invalid Duration";
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1e3
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1e3
  },
  seconds: {
    milliseconds: 1e3
  }
};
var casualMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var daysInYearAccurate = 146097 / 400;
var daysInMonthAccurate = 146097 / 4800;
var accurateMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var orderedUnits = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
var reverseUnits = orderedUnits.slice(0).reverse();
function clone(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : __spreadValues(__spreadValues({}, dur.values), alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
__name(clone, "clone");
function durationToMillis(matrix, vals) {
  var _a5;
  let sum = (_a5 = vals.milliseconds) != null ? _a5 : 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
__name(durationToMillis, "durationToMillis");
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
__name(normalizeValues, "normalizeValues");
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
__name(removeZeroes, "removeZeroes");
var _Duration = class _Duration {
  /**
  * @private
  */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
  * Create Duration from a number of milliseconds.
  * @param {number} count of milliseconds
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  static fromMillis(count, opts) {
    return _Duration.fromObject({
      milliseconds: count
    }, opts);
  }
  /**
  * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
  * If this object is empty then a zero milliseconds duration is returned.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.years
  * @param {number} obj.quarters
  * @param {number} obj.months
  * @param {number} obj.weeks
  * @param {number} obj.days
  * @param {number} obj.hours
  * @param {number} obj.minutes
  * @param {number} obj.seconds
  * @param {number} obj.milliseconds
  * @param {Object} [opts=[]] - options for creating this Duration
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the custom conversion system to use
  * @return {Duration}
  */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
    }
    return new _Duration({
      values: normalizeObject(obj, _Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
  * Create a Duration from DurationLike.
  *
  * @param {Object | number | Duration} durationLike
  * One of:
  * - object with keys like 'years' and 'hours'.
  * - number representing milliseconds
  * - Duration instance
  * @return {Duration}
  */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return _Duration.fromMillis(durationLike);
    } else if (_Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return _Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 duration string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the preset conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
  * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
  * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
  * @return {Duration}
  */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 time string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
  * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @return {Duration}
  */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create an invalid Duration.
  * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Duration}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new _Duration({
        invalid
      });
    }
  }
  /**
  * @private
  */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
  * Check if an object is a Duration. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
  * Get  the locale of a Duration, such 'en-GB'
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
  * * `S` for milliseconds
  * * `s` for seconds
  * * `m` for minutes
  * * `h` for hours
  * * `d` for days
  * * `w` for weeks
  * * `M` for months
  * * `y` for years
  * Notes:
  * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
  * * Tokens can be escaped by wrapping with single quotes.
  * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
  * @param {string} fmt - the format string
  * @param {Object} opts - options
  * @param {boolean} [opts.floor=true] - floor numerical values
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    const fmtOpts = __spreadProps(__spreadValues({}, opts), {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
  }
  /**
  * Returns a string representation of a Duration with all units included.
  * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
  * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
  * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
  * @example
  * ```js
  * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
  * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
  * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
  * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
  * ```
  */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID;
    const l2 = orderedUnits.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter(__spreadProps(__spreadValues({
        style: "unit",
        unitDisplay: "long"
      }, opts), {
        unit: unit.slice(0, -1)
      })).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter(__spreadValues({
      type: "conjunction",
      style: opts.listStyle || "narrow"
    }, opts)).format(l2);
  }
  /**
  * Returns a JavaScript object with this Duration's values.
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
  * @return {Object}
  */
  toObject() {
    if (!this.isValid) return {};
    return __spreadValues({}, this.values);
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
  * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
  * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
  * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
  * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
  * @return {string}
  */
  toISO() {
    if (!this.isValid) return null;
    let s2 = "P";
    if (this.years !== 0) s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s2 += this.weeks + "W";
    if (this.days !== 0) s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s2 += "T";
    if (this.hours !== 0) s2 += this.hours + "H";
    if (this.minutes !== 0) s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P") s2 += "T0S";
    return s2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
  * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
  * @return {string}
  */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = __spreadProps(__spreadValues({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts), {
      includeOffset: false
    });
    const dateTime = DateTime.fromMillis(millis, {
      zone: "UTC"
    });
    return dateTime.toISOTime(opts);
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
  * @return {string}
  */
  toString() {
    return this.toISO();
  }
  /**
  * Returns a string representation of this Duration appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns an milliseconds value of this Duration.
  * @return {number}
  */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
  * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration), result = {};
    for (const k of orderedUnits) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
  * Scale this Duration by the specified amount. Return a newly-constructed Duration.
  * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
  * @return {Duration}
  */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
  * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
  * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
  * @return {number}
  */
  get(unit) {
    return this[_Duration.normalizeUnit(unit)];
  }
  /**
  * "Set" the values of specified units. Return a newly-constructed Duration.
  * @param {Object} values - a mapping of units to numbers
  * @example dur.set({ years: 2017 })
  * @example dur.set({ hours: 8, minutes: 30 })
  * @return {Duration}
  */
  set(values) {
    if (!this.isValid) return this;
    const mixed = __spreadValues(__spreadValues({}, this.values), normalizeObject(values, _Duration.normalizeUnit));
    return clone(this, {
      values: mixed
    });
  }
  /**
  * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
  * @example dur.reconfigure({ locale: 'en-GB' })
  * @return {Duration}
  */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem
    });
    const opts = {
      loc,
      matrix,
      conversionAccuracy
    };
    return clone(this, opts);
  }
  /**
  * Return the length of the duration in the specified unit.
  * @param {string} unit - a unit such as 'minutes' or 'days'
  * @example Duration.fromObject({years: 1}).as('days') //=> 365
  * @example Duration.fromObject({years: 1}).as('months') //=> 12
  * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
  * @return {number}
  */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
  * Reduce this Duration to its canonical representation in its current units.
  * Assuming the overall value of the Duration is positive, this means:
  * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
  * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
  *   the overall value would be negative, see third example)
  * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
  *
  * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
  * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
  * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
  * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
  * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
  * @return {Duration}
  */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Rescale units to its largest representation
  * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
  * @return {Duration}
  */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Convert this Duration into its representation in a different set of units.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
  * @return {Duration}
  */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => _Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone(this, {
      values: built
    }, true);
  }
  /**
  * Shift this Duration to all available units.
  * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
  * @return {Duration}
  */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  }
  /**
  * Return the negative of this Duration.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
  * @return {Duration}
  */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone(this, {
      values: negated
    }, true);
  }
  /**
  * Get the years.
  * @type {number}
  */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
  * Get the quarters.
  * @type {number}
  */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
  * Get the months.
  * @type {number}
  */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
  * Get the weeks
  * @type {number}
  */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
  * Get the days.
  * @type {number}
  */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
  * Get the hours.
  * @type {number}
  */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
  * Get the minutes.
  * @type {number}
  */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
  * Get the seconds.
  * @return {number}
  */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
  * Get the milliseconds.
  * @return {number}
  */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
  * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
  * on invalid DateTimes or Intervals.
  * @return {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this Duration became invalid, or null if the Duration is valid
  * @return {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Equality check
  * Two Durations are equal iff they have the same units and the same values for each unit.
  * @param {Duration} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    __name(eq, "eq");
    for (const u of orderedUnits) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
};
__name(_Duration, "Duration");
var Duration = _Duration;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/interval.js
var INVALID2 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
  } else {
    return null;
  }
}
__name(validateStartEnd, "validateStartEnd");
var _Interval = class _Interval {
  /**
  * @private
  */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
  * Create an invalid Interval.
  * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Interval}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new _Interval({
        invalid
      });
    }
  }
  /**
  * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
  * @param {DateTime|Date|Object} start
  * @param {DateTime|Date|Object} end
  * @return {Interval}
  */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new _Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
  * Create an Interval from a start DateTime and a Duration to extend to.
  * @param {DateTime|Date|Object} start
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return _Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
  * Create an Interval from an end DateTime and a Duration to extend backwards to.
  * @param {DateTime|Date|Object} end
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return _Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
  * Create an Interval from an ISO 8601 string.
  * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
  * @param {string} text - the ISO string to parse
  * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {Interval}
  */
  static fromISO(text, opts) {
    const [s2, e] = (text || "").split("/", 2);
    if (s2 && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e2) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e2) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return _Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return _Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return _Interval.before(end, dur);
        }
      }
    }
    return _Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
  * Check if an object is an Interval. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
  * Returns the start of the Interval
  * @type {DateTime}
  */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
  * Returns the end of the Interval
  * @type {DateTime}
  */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
  * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
  * @type {boolean}
  */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
  * Returns an error code if this Interval is invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Returns the length of the Interval in the specified unit.
  * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
  * @return {number}
  */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[
      unit
    ]).get(unit) : NaN;
  }
  /**
  * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
  * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
  * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
  * @param {string} [unit='milliseconds'] - the unit of time to count.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
  * @return {number}
  */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts == null ? void 0 : opts.useLocaleWeeks) {
      end = this.end.reconfigure({
        locale: start.locale
      });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
  * Returns whether this Interval's start and end are both in the same unit of time
  * @param {string} unit - the unit of time to check sameness on
  * @return {boolean}
  */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
  * Return whether this Interval has the same start and end DateTimes.
  * @return {boolean}
  */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
  * Return whether this Interval's start is after the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
  * Return whether this Interval's end is before the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
  * Return whether this Interval contains the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
  * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
  * @param {Object} values - the values to set
  * @param {DateTime} values.start - the starting DateTime
  * @param {DateTime} values.end - the ending DateTime
  * @return {Interval}
  */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return _Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
  * Split this Interval at each of the specified DateTimes
  * @param {...DateTime} dateTimes - the unit of time to count.
  * @return {Array}
  */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      i += 1;
    }
    return results;
  }
  /**
  * Split this Interval into smaller Intervals, each of the specified length.
  * Left over time is grouped into a smaller interval
  * @param {Duration|Object|number} duration - The length of each resulting interval.
  * @return {Array}
  */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
  * Split this Interval into the specified number of smaller intervals.
  * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
  * @return {Array}
  */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
  * Return whether this Interval overlaps with the specified Interval
  * @param {Interval} other
  * @return {boolean}
  */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
  * Return whether this Interval's end is adjacent to the specified Interval's start.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
  * Return whether this Interval's start is adjacent to the specified Interval's end.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
  * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
  * @param {Interval} other
  * @return {boolean}
  */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
  * Return whether this Interval has the same start and end as the specified Interval.
  * @param {Interval} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
  * Return an Interval representing the intersection of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
  * Returns null if the intersection is empty, meaning, the intervals don't intersect.
  * @param {Interval} other
  * @return {Interval}
  */
  intersection(other) {
    if (!this.isValid) return this;
    const s2 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s2 >= e) {
      return null;
    } else {
      return _Interval.fromDateTimes(s2, e);
    }
  }
  /**
  * Return an Interval representing the union of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
  * @param {Interval} other
  * @return {Interval}
  */
  union(other) {
    if (!this.isValid) return this;
    const s2 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return _Interval.fromDateTimes(s2, e);
  }
  /**
  * Merge an array of Intervals into a equivalent minimal set of Intervals.
  * Combines overlapping and adjacent Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(([sofar, current], item) => {
      if (!current) {
        return [
          sofar,
          item
        ];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [
          sofar,
          current.union(item)
        ];
      } else {
        return [
          sofar.concat([
            current
          ]),
          item
        ];
      }
    }, [
      [],
      null
    ]);
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
  * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      {
        time: i.s,
        type: "s"
      },
      {
        time: i.e,
        type: "e"
      }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(_Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return _Interval.merge(results);
  }
  /**
  * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
  * @param {...Interval} intervals
  * @return {Array}
  */
  difference(...intervals) {
    return _Interval.xor([
      this
    ].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
  * Returns a string representation of this Interval appropriate for debugging.
  * @return {string}
  */
  toString() {
    if (!this.isValid) return INVALID2;
    return `[${this.s.toISO()} \u2013 ${this.e.toISO()})`;
  }
  /**
  * Returns a string representation of this Interval appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns a localized string representing this Interval. Accepts the same options as the
  * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
  * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
  * is browser-specific, but in general it will return an appropriate representation of the
  * Interval in the assigned locale. Defaults to the system's locale if no locale has been
  * specified.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
  * Intl.DateTimeFormat constructor options.
  * @param {Object} opts - Options to override the configuration of the start DateTime.
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Interval.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISO(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of date of this Interval.
  * The time components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {string}
  */
  toISODate() {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of time of this Interval.
  * The date components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISOTime(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
  * Returns a string representation of this Interval formatted according to the specified format
  * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
  * formatting tool.
  * @param {string} dateFormat - The format string. This string formats the start and end time.
  * See {@link DateTime#toFormat} for details.
  * @param {Object} opts - Options.
  * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
  * representations.
  * @return {string}
  */
  toFormat(dateFormat, { separator = " \u2013 " } = {}) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
  * Return a Duration representing the time spanned by this interval.
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
  * @return {Duration}
  */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
  * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
  * @param {function} mapFn
  * @return {Interval}
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
  */
  mapEndpoints(mapFn) {
    return _Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
};
__name(_Interval, "Interval");
var Interval = _Interval;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/info.js
var _Info = class _Info {
  /**
  * Return whether the specified zone contains a DST.
  * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
  * @return {boolean}
  */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }
  /**
  * Return whether the specified zone is a valid IANA specifier.
  * @param {string} zone - Zone to check
  * @return {boolean}
  */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
  * Converts the input into a {@link Zone} instance.
  *
  * * If `input` is already a Zone instance, it is returned unchanged.
  * * If `input` is a string containing a valid time zone name, a Zone instance
  *   with that name is returned.
  * * If `input` is a string that doesn't refer to a known time zone, a Zone
  *   instance with {@link Zone#isValid} == false is returned.
  * * If `input is a number, a Zone instance with the specified fixed offset
  *   in minutes is returned.
  * * If `input` is `null` or `undefined`, the default zone is returned.
  * @param {string|Zone|number} [input] - the value to be converted
  * @return {Zone}
  */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
  * Get the weekday on which the week starts according to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
  */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
  * Get the minimum number of days necessary in a week before it is considered part of the next year according
  * to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number}
  */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
  * Get the weekdays, which are considered the weekend according to the given locale
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
  */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
  * Return an array of standalone month names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @example Info.months()[0] //=> 'January'
  * @example Info.months('short')[0] //=> 'Jan'
  * @example Info.months('numeric')[0] //=> '1'
  * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
  * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
  * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
  * @return {Array}
  */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
  * Return an array of format month names.
  * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
  * changes the string.
  * See {@link Info#months}
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @return {Array}
  */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
  * Return an array of standalone week names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @example Info.weekdays()[0] //=> 'Monday'
  * @example Info.weekdays('short')[0] //=> 'Mon'
  * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
  * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
  * @return {Array}
  */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
  * Return an array of format week names.
  * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
  * changes the string.
  * See {@link Info#weekdays}
  * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale=null] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @return {Array}
  */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
  * Return an array of meridiems.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.meridiems() //=> [ 'AM', 'PM' ]
  * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
  * @return {Array}
  */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
  * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
  * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.eras() //=> [ 'BC', 'AD' ]
  * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
  * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
  * @return {Array}
  */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
  * Return the set of available features in this environment.
  * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
  * Keys:
  * * `relative`: whether this environment supports relative time formatting
  * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
  * @example Info.features() //=> { relative: false, localeWeek: true }
  * @return {Object}
  */
  static features() {
    return {
      relative: hasRelative(),
      localeWeek: hasLocaleWeekInfo()
    };
  }
};
__name(_Info, "Info");
var Info = _Info;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/diff.js
function dayDiff(earlier, later) {
  const utcDayStart = /* @__PURE__ */ __name((dt) => dt.toUTC(0, {
    keepLocalTime: true
  }).startOf("day").valueOf(), "utcDayStart"), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
__name(dayDiff, "dayDiff");
function highOrderDiffs(cursor, later, units) {
  const differs = [
    [
      "years",
      (a, b) => b.year - a.year
    ],
    [
      "quarters",
      (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4
    ],
    [
      "months",
      (a, b) => b.month - a.month + (b.year - a.year) * 12
    ],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    [
      "days",
      dayDiff
    ]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [
    cursor,
    results,
    highWater,
    lowestOrder
  ];
}
__name(highOrderDiffs, "highOrderDiffs");
function diff_default(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter((u) => [
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ].indexOf(u) >= 0);
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({
        [lowestOrder]: 1
      });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
__name(diff_default, "default");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/tokenParser.js
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s2]) => post(parseDigits(s2)), "deser")
  };
}
__name(intUnit, "intUnit");
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = `[ ${NBSP}]`;
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
__name(fixListRegex, "fixListRegex");
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
__name(stripInsensitivities, "stripInsensitivities");
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: /* @__PURE__ */ __name(([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex, "deser")
    };
  }
}
__name(oneOf, "oneOf");
function offset(regex, groups) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([, h, m]) => signedOffset(h, m), "deser"),
    groups
  };
}
__name(offset, "offset");
function simple(regex) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s2]) => s2, "deser")
  };
}
__name(simple, "simple");
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
__name(escapeToken, "escapeToken");
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal3 = /* @__PURE__ */ __name((t) => ({
    regex: RegExp(escapeToken(t.val)),
    deser: /* @__PURE__ */ __name(([s2]) => s2, "deser"),
    literal: true
  }), "literal"), unitate = /* @__PURE__ */ __name((t) => {
    if (token.literal) {
      return literal3(t);
    }
    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      // months
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      // ordinals
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      // time
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      // meridiem
      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      // weekdays
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal3(t);
    }
  }, "unitate");
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
__name(unitForToken, "unitForToken");
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
__name(tokenForPart, "tokenForPart");
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [
    `^${re}$`,
    units
  ];
}
__name(buildRegex, "buildRegex");
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [
      matches,
      all
    ];
  } else {
    return [
      matches,
      {}
    ];
  }
}
__name(match, "match");
function dateTimeFromMatches(matches) {
  const toField = /* @__PURE__ */ __name((token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  }, "toField");
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [
    vals,
    zone,
    specificOffset
  ];
}
__name(dateTimeFromMatches, "dateTimeFromMatches");
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
__name(getDummyDateTime, "getDummyDateTime");
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
__name(maybeExpandMacroToken, "maybeExpandMacroToken");
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
__name(expandMacroTokens, "expandMacroTokens");
var _TokenParser = class _TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return {
        input,
        tokens: this.tokens,
        invalidReason: this.invalidReason
      };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [
        null,
        null,
        void 0
      ];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
__name(_TokenParser, "TokenParser");
var TokenParser = _TokenParser;
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
__name(explainFromTokens, "explainFromTokens");
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [
    result,
    zone,
    specificOffset,
    invalidReason
  ];
}
__name(parseFromTokens, "parseFromTokens");
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
__name(formatOptsToTokens, "formatOptsToTokens");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/datetime.js
var INVALID3 = "Invalid DateTime";
var MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
__name(unsupportedZone, "unsupportedZone");
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
__name(possiblyCachedWeekData, "possiblyCachedWeekData");
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
  }
  return dt.localWeekData;
}
__name(possiblyCachedLocalWeekData, "possiblyCachedLocalWeekData");
function clone2(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(__spreadProps(__spreadValues(__spreadValues({}, current), alts), {
    old: current
  }));
}
__name(clone2, "clone");
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [
      utcGuess,
      o
    ];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [
      utcGuess,
      o2
    ];
  }
  return [
    localTS - Math.min(o2, o3) * 60 * 1e3,
    Math.max(o2, o3)
  ];
}
__name(fixOffset, "fixOffset");
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
__name(tsToObj, "tsToObj");
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
__name(objToTS, "objToTS");
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = __spreadProps(__spreadValues({}, inst.c), {
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }), millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return {
    ts,
    o
  };
}
__name(adjustTime, "adjustTime");
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, __spreadProps(__spreadValues({}, opts), {
      zone: interpretationZone,
      specificOffset
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
  }
}
__name(parseDataToDateTime, "parseDataToDateTime");
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
__name(toTechFormat, "toTechFormat");
function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
__name(toISODate, "toISODate");
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
__name(toISOTime, "toISOTime");
var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var orderedUnits2 = [
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedOrdinalUnits = [
  "year",
  "ordinal",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
__name(normalizeUnit, "normalizeUnit");
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
__name(normalizeUnitWithLocalWeeks, "normalizeUnitWithLocalWeeks");
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === void 0) {
      zoneOffsetTs = Settings.now();
    }
    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}
__name(guessOffsetForZone, "guessOffsetForZone");
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits2) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({
    ts,
    zone,
    loc,
    o
  });
}
__name(quickDT, "quickDT");
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round, format = /* @__PURE__ */ __name((c, unit) => {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, "format"), differ = /* @__PURE__ */ __name((unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  }, "differ");
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
__name(diffRelative, "diffRelative");
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [
    opts,
    args
  ];
}
__name(lastOpts, "lastOpts");
var zoneOffsetTs;
var zoneOffsetGuessCache = {};
var _DateTime = class _DateTime {
  /**
  * @access private
  */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [
          config.old.c,
          config.old.o
        ];
      } else {
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
  * Create a DateTime for the current instant, in the system's time zone.
  *
  * Use Settings to override these default values if needed.
  * @example DateTime.now().toISO() //~> now in the ISO format
  * @return {DateTime}
  */
  static now() {
    return new _DateTime({});
  }
  /**
  * Create a local DateTime
  * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month, 1-indexed
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @example DateTime.local()                                  //~> now
  * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
  * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
  * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
  * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
  * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
  * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
  * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
  * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
  * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
  * @return {DateTime}
  */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime in UTC
  * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @param {Object} options - configuration options for the DateTime
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.utc()                                              //~> now
  * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
  * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
  * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
  * @return {DateTime}
  */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime from a JavaScript Date object. Uses the default zone.
  * @param {Date} date - a JavaScript Date object
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @return {DateTime}
  */
  static fromJSDate(date2, options = {}) {
    const ts = isDate(date2) ? date2.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return _DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new _DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
  * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} milliseconds - a number of milliseconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return _DateTime.invalid("Timestamp out of range");
    } else {
      return new _DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} seconds - a number of seconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new _DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.year - a year, such as 1987
  * @param {number} obj.month - a month, 1-12
  * @param {number} obj.day - a day of the month, 1-31, depending on the month
  * @param {number} obj.ordinal - day of the year, 1-365 or 366
  * @param {number} obj.weekYear - an ISO week year
  * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
  * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
  * @param {number} obj.localWeekYear - a week year, according to the locale
  * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
  * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
  * @param {number} obj.hour - hour of the day, 0-23
  * @param {number} obj.minute - minute of the hour, 0-59
  * @param {number} obj.second - second of the minute, 0-59
  * @param {number} obj.millisecond - millisecond of the second, 0-999
  * @param {Object} opts - options for creating this DateTime
  * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
  * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
  * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
  * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
  * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
  * @return {DateTime}
  */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits2;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return _DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new _DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return _DateTime.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
    }
    if (!inst.isValid) {
      return _DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
  * Create a DateTime from an ISO 8601 string
  * @param {string} text - the ISO string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromISO('2016-05-25T09:08:34.123')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
  * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
  * @example DateTime.fromISO('2016-W05-4')
  * @return {DateTime}
  */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
  * Create a DateTime from an RFC 2822 string
  * @param {string} text - the RFC 2822 string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
  * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
  * @return {DateTime}
  */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
  * Create a DateTime from an HTTP header date
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @param {string} text - the HTTP header date
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
  * @return {DateTime}
  */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
  * Create a DateTime from an input string and format string.
  * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return _DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
  * @deprecated use fromFormat instead
  */
  static fromString(text, fmt, opts = {}) {
    return _DateTime.fromFormat(text, fmt, opts);
  }
  /**
  * Create a DateTime from a SQL date, time, or datetime
  * Defaults to en-US if no locale has been specified, regardless of the system's locale
  * @param {string} text - the string to parse
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @example DateTime.fromSQL('2017-05-15')
  * @example DateTime.fromSQL('2017-05-15 09:12:34')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
  * @example DateTime.fromSQL('09:12:34.342')
  * @return {DateTime}
  */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
  * Create an invalid DateTime.
  * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {DateTime}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new _DateTime({
        invalid
      });
    }
  }
  /**
  * Check if an object is an instance of DateTime. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
  * Produce the format string for a set of options
  * @param formatOpts
  * @param localeOpts
  * @returns {string}
  */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
  * Produce the the fully expanded format token for the locale
  * Does NOT quote characters, so quoted tokens will not round trip correctly
  * @param fmt
  * @param localeOpts
  * @returns {string}
  */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache = {};
  }
  // INFO
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
  * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
  * @return {number}
  */
  get(unit) {
    return this[unit];
  }
  /**
  * Returns whether the DateTime is valid. Invalid DateTimes occur when:
  * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
  * * The DateTime was created by an operation on another invalid date
  * @type {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
  *
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
  *
  * @type {string}
  */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
  * Get the time zone associated with this DateTime.
  * @type {Zone}
  */
  get zone() {
    return this._zone;
  }
  /**
  * Get the name of the time zone.
  * @type {string}
  */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
  * Get the year
  * @example DateTime.local(2017, 5, 25).year //=> 2017
  * @type {number}
  */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
  * Get the quarter
  * @example DateTime.local(2017, 5, 25).quarter //=> 2
  * @type {number}
  */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
  * Get the month (1-12).
  * @example DateTime.local(2017, 5, 25).month //=> 5
  * @type {number}
  */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
  * Get the day of the month (1-30ish).
  * @example DateTime.local(2017, 5, 25).day //=> 25
  * @type {number}
  */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
  * Get the hour of the day (0-23).
  * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
  * @type {number}
  */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
  * Get the minute of the hour (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
  * @type {number}
  */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
  * Get the second of the minute (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
  * @type {number}
  */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
  * Get the millisecond of the second (0-999).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
  * @type {number}
  */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
  * Get the week year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
  * @type {number}
  */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
  * Get the week number of the week year (1-52ish).
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
  * @type {number}
  */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the day of the week.
  * 1 is Monday and 7 is Sunday
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 11, 31).weekday //=> 4
  * @type {number}
  */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
  * Returns true if this date is on a weekend according to the locale, false otherwise
  * @returns {boolean}
  */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
  * Get the day of the week according to the locale.
  * 1 is the first day of the week and 7 is the last day of the week.
  * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
  * @returns {number}
  */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
  * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
  * because the week can start on different days of the week (see localWeekday) and because a different number of days
  * is required for a week to count as the first week of a year.
  * @returns {number}
  */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
  * differently, see localWeekNumber.
  * @returns {number}
  */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
  * Get the ordinal (meaning the day of the year)
  * @example DateTime.local(2017, 5, 25).ordinal //=> 145
  * @type {number|DateTime}
  */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
  * Get the human readable short month name, such as 'Oct'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
  * @type {string}
  */
  get monthShort() {
    return this.isValid ? Info.months("short", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable long month name, such as 'October'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthLong //=> October
  * @type {string}
  */
  get monthLong() {
    return this.isValid ? Info.months("long", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable short weekday, such as 'Mon'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
  * @type {string}
  */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the human readable long weekday, such as 'Monday'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
  * @type {string}
  */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the UTC offset of this DateTime in minutes
  * @example DateTime.now().offset //=> -240
  * @example DateTime.utc().offset //=> 0
  * @type {number}
  */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
  * Get the short human name for the zone's current offset, for example "EST" or "EDT".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get whether this zone's offset ever changes, as in a DST.
  * @type {boolean}
  */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
  * Get whether the DateTime is in a DST.
  * @type {boolean}
  */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({
        month: 1,
        day: 1
      }).offset || this.offset > this.set({
        month: 5
      }).offset;
    }
  }
  /**
  * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
  * in this DateTime's zone. During DST changes local time can be ambiguous, for example
  * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
  * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
  * @returns {DateTime[]}
  */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [
        this
      ];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [
        this
      ];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [
        clone2(this, {
          ts: ts1
        }),
        clone2(this, {
          ts: ts2
        })
      ];
    }
    return [
      this
    ];
  }
  /**
  * Returns true if this DateTime is in a leap year, false otherwise
  * @example DateTime.local(2016).isInLeapYear //=> true
  * @example DateTime.local(2013).isInLeapYear //=> false
  * @type {boolean}
  */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
  * Returns the number of days in this DateTime's month
  * @example DateTime.local(2016, 2).daysInMonth //=> 29
  * @example DateTime.local(2016, 3).daysInMonth //=> 31
  * @type {number}
  */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
  * Returns the number of days in this DateTime's year
  * @example DateTime.local(2016).daysInYear //=> 366
  * @example DateTime.local(2013).daysInYear //=> 365
  * @type {number}
  */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2004).weeksInWeekYear //=> 53
  * @example DateTime.local(2013).weeksInWeekYear //=> 52
  * @type {number}
  */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's local week year
  * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
  * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
  * @type {number}
  */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
  }
  /**
  * Returns the resolved Intl options for this DateTime.
  * This is useful in understanding the behavior of formatting methods
  * @param {Object} opts - the same options as toLocaleString
  * @return {Object}
  */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
    return {
      locale,
      numberingSystem,
      outputCalendar: calendar
    };
  }
  // TRANSFORM
  /**
  * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
  *
  * Equivalent to {@link DateTime#setZone}('utc')
  * @param {number} [offset=0] - optionally, an offset from UTC in minutes
  * @param {Object} [opts={}] - options to pass to `setZone()`
  * @return {DateTime}
  */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
  * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
  *
  * Equivalent to `setZone('local')`
  * @return {DateTime}
  */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
  * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
  *
  * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
  * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
  * @param {Object} opts - options
  * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
  * @return {DateTime}
  */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return _DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone2(this, {
        ts: newTS,
        zone
      });
    }
  }
  /**
  * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
  * @param {Object} properties - the properties to set
  * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
  * @return {DateTime}
  */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem,
      outputCalendar
    });
    return clone2(this, {
      loc
    });
  }
  /**
  * "Set" the locale. Returns a newly-constructed DateTime.
  * Just a convenient alias for reconfigure({ locale })
  * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
  * @return {DateTime}
  */
  setLocale(locale) {
    return this.reconfigure({
      locale
    });
  }
  /**
  * "Set" the values of specified units. Returns a newly-constructed DateTime.
  * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
  *
  * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
  * They cannot be mixed with ISO-week units like `weekday`.
  * @param {Object} values - a mapping of units to numbers
  * @example dt.set({ year: 2017 })
  * @example dt.set({ hour: 8, minute: 30 })
  * @example dt.set({ weekday: 5 })
  * @example dt.set({ year: 2005, ordinal: 234 })
  * @return {DateTime}
  */
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(__spreadValues(__spreadValues({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek)), normalized), minDaysInFirstWeek, startOfWeek);
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(__spreadValues(__spreadValues({}, gregorianToOrdinal(this.c)), normalized));
    } else {
      mixed = __spreadValues(__spreadValues({}, this.toObject()), normalized);
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone2(this, {
      ts,
      o
    });
  }
  /**
  * Add a period of time to this DateTime and return the resulting DateTime
  *
  * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @example DateTime.now().plus(123) //~> in 123 milliseconds
  * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
  * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
  * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
  * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
  * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
  * @return {DateTime}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * Subtract a period of time to this DateTime and return the resulting DateTime
  * See {@link DateTime#plus}
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  @return {DateTime}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * "Set" this DateTime to the beginning of a unit of time.
  * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
  * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
  * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
  * @return {DateTime}
  */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      case "milliseconds":
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
  * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
  * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
  * @return {DateTime}
  */
  endOf(unit, opts) {
    return this.isValid ? this.plus({
      [unit]: 1
    }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
  * Returns a string representation of this DateTime formatted according to the specified format string.
  * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
  * Defaults to en-US if no locale has been specified, regardless of the system's locale.
  * @param {string} fmt - the format string
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
  * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
  * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
  * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID3;
  }
  /**
  * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
  * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
  * of the DateTime in the assigned locale.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toLocaleString(); //=> 4/20/2017
  * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
  * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
  * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
  * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
  * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
  * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID3;
  }
  /**
  * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
  * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
  * @example DateTime.now().toLocaleParts(); //=> [
  *                                   //=>   { type: 'day', value: '25' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'month', value: '05' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'year', value: '1982' }
  *                                   //=> ]
  */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
  * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
  * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
  * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
  * @return {string}
  */
  toISO({ format = "extended", suppressSeconds = false, suppressMilliseconds = false, includeOffset = true, extendedZone = false } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's date component
  * @param {Object} opts - options
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
  * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
  * @return {string}
  */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's week date
  * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
  * @return {string}
  */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's time component
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
  * @return {string}
  */
  toISOTime({ suppressMilliseconds = false, suppressSeconds = false, includeOffset = true, includePrefix = false, extendedZone = false, format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c = includePrefix ? "T" : "";
    return c + toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
  }
  /**
  * Returns an RFC 2822-compatible string representation of this DateTime
  * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
  * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
  * @return {string}
  */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
  * Specifically, the string conforms to RFC 1123.
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
  * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
  * @return {string}
  */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Date
  * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
  * @return {string}
  */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Time
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc().toSQL() //=> '05:15:16.345'
  * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
  * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
  * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
  * @return {string}
  */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
  * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
  * @return {string}
  */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
  * Returns a string representation of this DateTime appropriate for debugging
  * @return {string}
  */
  toString() {
    return this.isValid ? this.toISO() : INVALID3;
  }
  /**
  * Returns a string representation of this DateTime appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Returns the epoch milliseconds of this DateTime.
  * @return {number}
  */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
  * Returns the epoch seconds of this DateTime.
  * @return {number}
  */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
  * Returns the epoch seconds (as a whole number) of this DateTime.
  * @return {number}
  */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
  * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns a BSON serializable equivalent to this DateTime.
  * @return {Date}
  */
  toBSON() {
    return this.toJSDate();
  }
  /**
  * Returns a JavaScript object with this DateTime's year, month, day, and so on.
  * @param opts - options for generating the object
  * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
  * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
  * @return {Object}
  */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = __spreadValues({}, this.c);
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
  * Returns a JavaScript Date equivalent to this DateTime.
  * @return {Date}
  */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
  * Return the difference between two DateTimes as a Duration.
  * @param {DateTime} otherDateTime - the DateTime to compare this one to
  * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example
  * var i1 = DateTime.fromISO('1982-05-25T09:45'),
  *     i2 = DateTime.fromISO('1983-10-14T10:30');
  * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
  * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
  * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
  * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
  * @return {Duration}
  */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = __spreadValues({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff_default(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
  * Return the difference between this DateTime and right now.
  * See {@link DateTime#diff}
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(_DateTime.now(), unit, opts);
  }
  /**
  * Return an Interval spanning between this DateTime and another DateTime
  * @param {DateTime} otherDateTime - the other end point of the Interval
  * @return {Interval}
  */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
  * Return whether this DateTime is in the same unit of time as another DateTime.
  * Higher-order units must also be identical for this function to return `true`.
  * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
  * @param {DateTime} otherDateTime - the other DateTime
  * @param {string} unit - the unit of time to check sameness on
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
  * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
  * @return {boolean}
  */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
  * Equality check
  * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
  * To compare just the millisecond values, use `+dt1 === +dt2`.
  * @param {DateTime} other - the other DateTime
  * @return {boolean}
  */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
  * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
  * platform supports Intl.RelativeTimeFormat. Rounds down by default.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
  * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
  * @param {boolean} [options.round=true] - whether to round the numbers in the output.
  * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
  * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
  * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
  * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
  * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
  * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
  */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = [
      "years",
      "months",
      "days",
      "hours",
      "minutes",
      "seconds"
    ];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), __spreadProps(__spreadValues({}, options), {
      numeric: "always",
      units,
      unit
    }));
  }
  /**
  * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
  * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
  * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
  * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
  */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), this, __spreadProps(__spreadValues({}, options), {
      numeric: "auto",
      units: [
        "years",
        "months",
        "days"
      ],
      calendary: true
    }));
  }
  /**
  * Return the min of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
  * @return {DateTime} the min DateTime, or undefined if called with no argument
  */
  static min(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
  * Return the max of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
  * @return {DateTime} the max DateTime, or undefined if called with no argument
  */
  static max(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
  * Explain how a string would be parsed by fromFormat()
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see description)
  * @param {Object} options - options taken by fromFormat()
  * @return {Object}
  */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
  * @deprecated use fromFormatExplain instead
  */
  static fromStringExplain(text, fmt, options = {}) {
    return _DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
  * Build a parser for `fmt` using the given locale. This parser can be passed
  * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
  * can be used to optimize cases where many dates need to be parsed in a
  * specific format.
  *
  * @param {String} fmt - the format the string is expected to be in (see
  * description)
  * @param {Object} options - options used to set locale and numberingSystem
  * for parser
  * @returns {TokenParser} - opaque object to be used
  */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
  * Create a DateTime from an input string and format parser.
  *
  * The format parser must have been created with the same locale as this call.
  *
  * @param {String} text - the string to parse
  * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
  * @param {Object} opts - options taken by fromFormat()
  * @returns {DateTime}
  */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`);
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return _DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
  }
  // FORMAT PRESETS
  /**
  * {@link DateTime#toLocaleString} format like 10/14/1983
  * @type {Object}
  */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983'
  * @type {Object}
  */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
  * @type {Object}
  */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
};
__name(_DateTime, "DateTime");
var DateTime = _DateTime;
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
  }
}
__name(friendlyDateTime, "friendlyDateTime");

// src/common/date.schema.ts
import { coerce, z as z12 } from "zod";
var CustomLuxonDateSchema = z12.custom((value) => value && DateTime.fromJSDate(value).toJSDate());
var CommonCustomDateSchema = coerce.string().date().or(coerce.string()).or(CustomLuxonDateSchema);
var CustomDateTimeSchema = coerce.string().datetime().or(coerce.string()).or(CustomLuxonDateSchema);

// src/common/id.ts
import { coerce as coerce2 } from "zod";
var UnsignedIDSchema = coerce2.number().int().nonnegative();

// src/common/pagination.schema.ts
import { number as number2, object as object3, string as string2 } from "zod";
var MetaSchema = object3({
  totalPages: number2().int().positive(),
  page: number2().int().positive(),
  perPage: number2().int().positive(),
  total: number2().int().positive()
});
var ErrorSchema = object3({
  code: string2(),
  message: string2()
});

// src/common/permissions.ts
var Permissions = {
  APP_ACTIVE: "sub.active",
  // ── Community / shared ──────────────────────────────────────────────
  CHAT_VIEW: "chat.view",
  CHAT_SEND: "chat.send",
  CHAT_EDIT: "chat.edit",
  CHAT_DELETE: "chat.delete",
  CONTENT_VIEW: "content.view",
  CONTENT_CREATE: "content.create",
  CONTENT_EDIT: "content.edit",
  CONTENT_DELETE: "content.delete",
  FEED_VIEW: "feed.view",
  POST_CREATE: "post.create",
  COMMENT_CREATE: "comment.create",
  SPACE_VIEW: "space.view",
  SPACE_MANAGE: "space.manage",
  // Community moderators are trusted authors: their posts/comments skip Slack moderation alerts.
  COMMUNITY_MODERATOR: "community.moderator",
  // ── FIT ─────────────────────────────────────────────────────────────
  FIT_CONTENT_VIEW: "fit.content.view",
  FIT_CONTENT_MANAGE: "fit.content.manage",
  FIT_SERIES_VIEW: "fit.series.view",
  FIT_SERIES_MANAGE: "fit.series.manage",
  FIT_CHALLENGE_VIEW: "fit.challenge.view",
  FIT_CHALLENGE_MANAGE: "fit.challenge.manage",
  FIT_COMMENT_VIEW: "fit.comment.view",
  FIT_COMMENT_WRITE: "fit.comment.write",
  FIT_COMMENT_EXPORT: "fit.comment.export",
  FIT_COMMENT_MODERATE: "fit.comment.moderate",
  FIT_CLASS_OF_THE_DAY_VIEW: "fit.class-of-the-day.view",
  FIT_CLASS_OF_THE_DAY_MANAGE: "fit.class-of-the-day.manage",
  FIT_SLIDESHOW_MANAGE: "fit.slideshow.manage",
  FIT_EVENT_MANAGE: "fit.event.manage",
  FIT_TRACKING_VIEW: "fit.tracking.view",
  FIT_SIMULATION_ADMIN: "fit.simulation.admin",
  // ── RYC ─────────────────────────────────────────────────────────────
  RYC_ACTIVE: "sub.active",
  RYC_CONTENT_VIEW: "ryc.content.view",
  RYC_CONTENT_MANAGE: "ryc.content.manage",
  RYC_JOURNEY_ACCESS: "ryc.journey.access",
  RYC_COACH_ACCESS: "ryc.coach.access",
  RYC_INSTRUCTION_MANAGE: "ryc.instruction.manage",
  RYC_USER_MANAGEMENT_MANAGE: "ryc.user-management.manage",
  RYC_STATS_VIEW: "ryc.stats.view",
  RYC_TRACKING_VIEW: "ryc.tracking.view",
  RYC_JOURNAL_WRITE: "ryc.journal.write",
  RYC_SIMULATION_ADMIN: "ryc.simulation.admin",
  // ── PD ──────────────────────────────────────────────────────────────
  PD_PUBLIC_LISTING: "pd.public-listing",
  PD_ACTIVE: "pro_directory.active"
};
var getAddonProgramViewPermission = /* @__PURE__ */ __name((slug) => `programs.${slug}`, "getAddonProgramViewPermission");

// src/common/redis-db.ts
var REDIS_DB_BY_APP = {
  global: 0,
  "members-api": 1,
  "fit-api": 2,
  "ryc-api": 3,
  notification: 4,
  "help-center-api": 5,
  "programs-api": 6,
  tracking: 7,
  webhook: 8,
  "site-monitor-api": 9
};
var MAX_REDIS_DB = Math.max(...Object.values(REDIS_DB_BY_APP));
var REDIS_DB_LIST = Object.entries(REDIS_DB_BY_APP).map(([app, db]) => ({
  db,
  app
})).sort((a, b) => a.db - b.db);

// src/common/request.schema.ts
import { coerce as coerce3, object as object4 } from "zod";

// src/coerce-boolean.ts
import { boolean, string as string3, union } from "zod";
var CoerceBoolean = union([
  boolean(),
  string3()
]).transform((value) => {
  if (value === "false") {
    return false;
  }
  if (value === "true") {
    return true;
  }
  return Boolean(value);
}).default(false);

// src/common/request.schema.ts
var RequestSchema = object4({
  perPage: coerce3.number().optional(),
  page: coerce3.number().optional(),
  isHidden: CoerceBoolean.optional()
});

// src/common/slug.ts
import { z as z13 } from "zod";
var SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
var SLUG_PATTERN_MESSAGE = "Lowercase letters, numbers, and hyphens only \u2014 no spaces or special characters";
var SlugSchema = z13.string().regex(SLUG_PATTERN, SLUG_PATTERN_MESSAGE);

// src/common/timezone.schema.ts
import { string as string4 } from "zod";
var timezoneSchema = string4().nullable().optional().transform((tz) => {
  if (!tz) {
    return "America/New_York";
  }
  try {
    Intl.DateTimeFormat(void 0, {
      timeZone: tz
    });
    return tz;
  } catch (e) {
    return "America/New_York";
  }
});

// src/comment/entity.ts
import { z as z14 } from "zod";
var MentionUserSchema = z14.object({
  id: z14.string(),
  displayName: z14.string(),
  username: z14.string().nullable().optional(),
  avatar: z14.string().nullable().optional()
});
var MentionUserCacheSchema = MentionUserSchema.extend({
  userId: z14.string(),
  isPrivate: z14.boolean(),
  apps: z14.array(AppNameEnumObj)
});
var CommentRejectReasonValues = [
  "SPAM",
  "HARASSMENT",
  "HATE_OR_OFFENSIVE",
  "INAPPROPRIATE",
  "OFF_TOPIC",
  "MISINFORMATION",
  "SELF_PROMOTION",
  "OTHER"
];
var CommentRejectReasonEnum = z14.enum(CommentRejectReasonValues);
var ECommentRejectReason = CommentRejectReasonEnum.enum;
var COMMENT_REJECT_REASON_LABELS = {
  SPAM: "Spam",
  HARASSMENT: "Harassment / Bullying",
  HATE_OR_OFFENSIVE: "Hate / Offensive language",
  INAPPROPRIATE: "Inappropriate / Explicit",
  OFF_TOPIC: "Off-topic",
  MISINFORMATION: "Misinformation",
  SELF_PROMOTION: "Self-promotion / Advertising",
  OTHER: "Other"
};
var CommentActivityActionValues = [
  "CREATED",
  "EDITED",
  "REVIEWED",
  "REJECTED",
  "UNREJECTED",
  "DELETED",
  "REPLIED"
];
var CommentActivityActionEnum = z14.enum(CommentActivityActionValues);
var ECommentActivityAction = CommentActivityActionEnum.enum;
var COMMENT_ACTIVITY_ACTION_LABELS = {
  CREATED: "Created",
  EDITED: "Edited",
  REVIEWED: "Reviewed",
  REJECTED: "Rejected",
  UNREJECTED: "Unrejected",
  DELETED: "Deleted",
  REPLIED: "Replied"
};
var CommentActivitySchema = z14.object({
  id: z14.string(),
  commentId: z14.number(),
  contentId: z14.string().nullable().optional(),
  action: CommentActivityActionEnum,
  actorUserId: z14.string(),
  actorName: z14.string().nullable().optional(),
  actorAvatar: z14.string().nullable().optional(),
  rejectReason: CommentRejectReasonEnum.nullable().optional(),
  note: z14.string().nullable().optional(),
  snapshot: z14.record(z14.unknown()).nullable().optional(),
  createdAt: z14.string()
});
var BaseCommentSchema = z14.object({
  id: z14.number(),
  contentId: z14.string(),
  userId: z14.coerce.string(),
  content: z14.string(),
  parentId: z14.number().nullable(),
  likesCount: z14.number(),
  isDeleted: z14.boolean(),
  isEdited: z14.boolean().optional(),
  reviewedAt: z14.string().nullable().optional(),
  isReject: z14.boolean(),
  rejectReason: CommentRejectReasonEnum.nullable().optional(),
  onBehalfOfUserId: z14.string().nullable().optional(),
  createdAt: z14.string(),
  updatedAt: z14.string(),
  userName: z14.string().optional(),
  userAvatar: z14.string().nullable().optional(),
  onBehalfOfUserName: z14.string().nullable().optional(),
  onBehalfOfUserAvatar: z14.string().nullable().optional(),
  isLikedByCurrentUser: z14.boolean().optional(),
  canEdit: z14.boolean().optional(),
  canDelete: z14.boolean().optional()
});
var AdminCommentRowSchema = BaseCommentSchema.extend({
  videoTitle: z14.string().nullable().optional(),
  videoId: z14.string().nullable().optional(),
  instructorName: z14.string().nullable().optional(),
  instructorId: z14.string().nullable().optional(),
  reviewedById: z14.string().nullable().optional(),
  reviewedByName: z14.string().nullable().optional()
});
var CommentWithRepliesSchema = z14.lazy(() => BaseCommentSchema.extend({
  replies: z14.array(CommentWithRepliesSchema).optional()
}));
var CommentSchema = CommentWithRepliesSchema;
var COMMENT_MAX_LENGTH = 3e3;
var docTextLength = /* @__PURE__ */ __name((nodes = []) => nodes.reduce((total, node) => {
  var _a5, _b;
  if (node.type === "text") {
    return total + ((_b = (_a5 = node.text) == null ? void 0 : _a5.length) != null ? _b : 0);
  }
  if (node.type === "mention") {
    return total + 1;
  }
  return total + docTextLength(node.content);
}, 0), "docTextLength");
var getCommentContentLength = /* @__PURE__ */ __name((val) => {
  const trimmed = val.trim();
  if (trimmed.startsWith("{")) {
    try {
      return docTextLength(JSON.parse(trimmed).content);
    } catch (e) {
    }
  }
  return trimmed.replace(/<[^>]*>/g, "").trim().length;
}, "getCommentContentLength");
var TOO_LONG_MESSAGE = `Comments are limited to ${COMMENT_MAX_LENGTH} characters`;
var CreateCommentDtoSchema = z14.object({
  contentId: z14.string().min(1, "content ID is required"),
  content: z14.string().refine((val) => getCommentContentLength(val) > 0, "Comment content is required").refine((val) => getCommentContentLength(val) <= COMMENT_MAX_LENGTH, TOO_LONG_MESSAGE),
  parentId: z14.number().optional()
});
var UpdateCommentDtoSchema = z14.object({
  content: z14.string().refine((val) => getCommentContentLength(val) > 0, "Comment content is required").refine((val) => getCommentContentLength(val) <= COMMENT_MAX_LENGTH, TOO_LONG_MESSAGE)
});
var GetCommentsDtoSchema = z14.object({
  contentId: z14.string().min(1, "content ID is required"),
  page: z14.coerce.number().min(1).default(1).optional(),
  limit: z14.coerce.number().min(1).max(100).default(10).optional(),
  enabled: z14.boolean().default(true).optional()
});
var CommentsResponseSchema = z14.object({
  comments: z14.array(CommentWithRepliesSchema),
  total: z14.number(),
  hasMore: z14.boolean()
});
var LikeResponseSchema = z14.object({
  liked: z14.boolean(),
  likesCount: z14.number()
});
var GetContentsByCommentsDateRangeSchema = z14.object({
  app: AppNameEnumObj,
  page: z14.coerce.number().min(1).default(1),
  limit: z14.coerce.number().min(1).max(100).default(15),
  fromDate: z14.string().optional(),
  toDate: z14.string().optional()
});
var csvStringToArray = z14.union([
  z14.string(),
  z14.array(z14.string())
]).transform((val) => {
  if (Array.isArray(val)) {
    return val.filter(Boolean);
  }
  if (!val) {
    return [];
  }
  return val.split(",").map((v) => v.trim()).filter(Boolean);
}).optional();
var InstructorFilterModeEnum = z14.enum([
  "include",
  "exclude"
]);
var GetAdminCommentsDtoSchema = z14.object({
  instructorIds: csvStringToArray,
  instructorMode: InstructorFilterModeEnum.optional(),
  isReject: z14.coerce.boolean().optional(),
  notReviewed: z14.coerce.boolean().optional(),
  fromDate: z14.string().optional(),
  toDate: z14.string().optional(),
  page: z14.coerce.number().min(1).default(1).optional(),
  limit: z14.coerce.number().min(1).max(200).default(20).optional()
});
var ExportAdminCommentsDtoSchema = z14.object({
  instructorIds: csvStringToArray,
  instructorMode: InstructorFilterModeEnum.optional(),
  isReject: z14.coerce.boolean().optional(),
  notReviewed: z14.coerce.boolean().optional(),
  fromDate: z14.string().optional(),
  toDate: z14.string().optional()
});
var CommentAnalyticsFiltersSchema = z14.object({
  instructorIds: csvStringToArray,
  instructorMode: InstructorFilterModeEnum.optional(),
  fromDate: z14.string().optional(),
  toDate: z14.string().optional()
});
var CommentAnalyticsGranularityEnum = z14.enum([
  "daily",
  "weekly",
  "monthly"
]);
var CommentAnalyticsTimelineFiltersSchema = CommentAnalyticsFiltersSchema.extend({
  granularity: CommentAnalyticsGranularityEnum.default("daily").optional()
});
var CommentAnalyticsOverviewSchema = z14.object({
  total: z14.number(),
  reviewed: z14.number(),
  rejected: z14.number(),
  pending: z14.number(),
  reviewRate: z14.number(),
  rejectionRate: z14.number(),
  avgReviewHours: z14.number().nullable()
});
var CommentAnalyticsInstructorRowSchema = z14.object({
  instructorId: z14.string().nullable(),
  instructorName: z14.string().nullable(),
  total: z14.number(),
  reviewed: z14.number(),
  rejected: z14.number(),
  pending: z14.number(),
  reviewRate: z14.number(),
  rejectionRate: z14.number(),
  avgReviewHours: z14.number().nullable()
});
var CommentAnalyticsByInstructorSchema = z14.array(CommentAnalyticsInstructorRowSchema);
var CommentAnalyticsTimelinePointSchema = z14.object({
  date: z14.string(),
  total: z14.number(),
  reviewed: z14.number(),
  rejected: z14.number()
});
var CommentAnalyticsTimelineSchema = z14.array(CommentAnalyticsTimelinePointSchema);
var CommentAnalyticsRejectionReasonSchema = z14.object({
  reason: CommentRejectReasonEnum.nullable(),
  count: z14.number()
});
var CommentAnalyticsRejectionReasonsSchema = z14.array(CommentAnalyticsRejectionReasonSchema);
var CommentAnalyticsReviewerSchema = z14.object({
  reviewerId: z14.string(),
  reviewerName: z14.string().nullable(),
  reviewed: z14.number(),
  rejected: z14.number(),
  total: z14.number()
});
var CommentAnalyticsReviewersSchema = z14.array(CommentAnalyticsReviewerSchema);
var AdminReplyDtoSchema = z14.object({
  contentId: z14.string().min(1, "content ID is required"),
  instructorId: z14.string().min(1, "instructor ID is required"),
  content: z14.string().refine((val) => getCommentContentLength(val) > 0, "Reply content is required").refine((val) => getCommentContentLength(val) <= COMMENT_MAX_LENGTH, `Replies are limited to ${COMMENT_MAX_LENGTH} characters`),
  parentId: z14.number().optional()
});
var ToggleRejectDtoSchema = z14.object({
  isReject: z14.boolean(),
  rejectReason: CommentRejectReasonEnum.optional(),
  rejectNote: z14.string().max(500).optional()
});
var validateCreateComment = /* @__PURE__ */ __name((data) => {
  return CreateCommentDtoSchema.parse(data);
}, "validateCreateComment");
var validateUpdateComment = /* @__PURE__ */ __name((data) => {
  return UpdateCommentDtoSchema.parse(data);
}, "validateUpdateComment");
var validateGetComments = /* @__PURE__ */ __name((data) => {
  return GetCommentsDtoSchema.parse(data);
}, "validateGetComments");
var validateGetContentsByCommentsDateRange = /* @__PURE__ */ __name((data) => {
  return GetContentsByCommentsDateRangeSchema.parse(data);
}, "validateGetContentsByCommentsDateRange");
var validateComment = /* @__PURE__ */ __name((data) => {
  return CommentWithRepliesSchema.parse(data);
}, "validateComment");
var validateCommentsResponse = /* @__PURE__ */ __name((data) => {
  return CommentsResponseSchema.parse(data);
}, "validateCommentsResponse");
var validateLikeResponse = /* @__PURE__ */ __name((data) => {
  return LikeResponseSchema.parse(data);
}, "validateLikeResponse");

// src/community-hub/chat.ts
import { z as z15 } from "zod";
var ConversationType = /* @__PURE__ */ function(ConversationType2) {
  ConversationType2["GROUP"] = "group";
  ConversationType2["DIRECT"] = "direct";
  return ConversationType2;
}({});
var ConversationTypeSchema = z15.nativeEnum(ConversationType);
var MessageType = /* @__PURE__ */ function(MessageType2) {
  MessageType2["TEXT"] = "text";
  MessageType2["SYSTEM"] = "system";
  return MessageType2;
}({});
var MessageTypeSchema = z15.nativeEnum(MessageType);
var CreateConversationSchema = z15.object({
  conversationType: ConversationTypeSchema,
  title: z15.string().max(255, "Title must be 255 characters or less").optional(),
  memberUserIds: z15.array(z15.string().uuid("Invalid user ID")).min(1, "At least one member is required")
});
var SendMessageSchema = z15.object({
  body: z15.string().min(1, "Message body is required").max(1e4, "Message is too long")
});
var UpdateMessageSchema = z15.object({
  body: z15.string().min(1, "Message body is required").max(1e4, "Message is too long")
});
var MarkAsReadSchema = z15.object({
  messageId: z15.string().uuid("Invalid message ID")
});
var ConversationBaseSchema = z15.object({
  id: z15.string().uuid(),
  spaceId: z15.string().uuid(),
  conversationType: ConversationTypeSchema,
  title: z15.string().max(255).nullable(),
  lastMessageAt: z15.coerce.date().nullable(),
  createdAt: z15.coerce.date()
});
var MessageBaseSchema = z15.object({
  id: z15.string().uuid(),
  conversationId: z15.string().uuid(),
  senderId: z15.string().uuid(),
  body: z15.string(),
  messageType: MessageTypeSchema,
  editedAt: z15.coerce.date().nullable(),
  deletedAt: z15.coerce.date().nullable(),
  createdAt: z15.coerce.date()
});

// src/community-hub/content.ts
import { z as z20 } from "zod";

// src/community-hub/space.ts
import { z as z19 } from "zod";

// src/supabase/profile.ts
import { array as array3, coerce as coerce4, number as number3, object as object6, string as string6, z as z18 } from "zod";

// src/feature-flags/index.ts
import { array as array2, boolean as boolean2, object as object5, record, string as string5, z as z16 } from "zod";
var FeatureFlagMapSchema = record(string5(), array2(string5()));
var hasFeatureFlag = /* @__PURE__ */ __name((featureFlags, flagSlug, app) => {
  var _a5, _b;
  if (!featureFlags) {
    return false;
  }
  if (app) {
    return (_b = (_a5 = featureFlags[app]) == null ? void 0 : _a5.includes(flagSlug)) != null ? _b : false;
  }
  return Object.values(featureFlags).some((slugs) => slugs.includes(flagSlug));
}, "hasFeatureFlag");
var EFeatureFlagSlug = {
  SHOW_WATCH_COUNT: "show-watch-count",
  // Opt-OUT flag: the apps landing hub is the default entry point for everyone.
  // Granting this to a user sends them straight into the tabbed app instead.
  // Named for what it does so a missing/off flag reads as "landing shown".
  HIDE_APPS_LANDING: "hide-apps-landing",
  SHOW_ENDPOINT_SWITCHER: "show-endpoint-switcher",
  SHOW_FIT_RYC_APPS: "show-fit-ryc-apps",
  // Shows the Privacy Mode toggle on the members-fe Security and Privacy tab
  // (the Profile tab always has it).
  SHOW_SECURITY_PRIVACY_TOGGLE: "show-security-privacy-toggle"
};
var FeatureFlagAssignmentSchema = object5({
  id: string5().uuid(),
  featureFlagId: string5().uuid(),
  userUuid: string5(),
  app: AppNameEnumObj,
  createdAt: string5().optional(),
  // Display fields resolved on the backend (the assigned user's profile).
  userName: string5().nullable().optional(),
  userEmail: string5().nullable().optional(),
  userAvatar: string5().nullable().optional()
});
var FeatureFlagSchema = object5({
  id: string5().uuid(),
  slug: string5(),
  label: string5(),
  description: string5().nullable().optional(),
  enabled: boolean2(),
  createdAt: string5().optional(),
  updatedAt: string5().optional(),
  assignmentCount: z16.number().optional(),
  assignments: array2(FeatureFlagAssignmentSchema).optional()
});
var CreateFeatureFlagRequestSchema = object5({
  slug: string5().min(1, "Slug is required").max(150, "Slug is too long (max 150 characters)").regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Slug must be lowercase kebab-case (e.g. new-checkout-flow)"),
  label: string5().min(1, "Label is required").max(150, "Label is too long (max 150 characters)"),
  description: string5().max(2e3, "Description is too long (max 2000 characters)").nullable().optional(),
  // New flags are live by default; the admin can create one disabled if needed.
  enabled: boolean2().default(true)
});
var UpdateFeatureFlagRequestSchema = CreateFeatureFlagRequestSchema.partial();
var AssignFeatureFlagRequestSchema = object5({
  userUuid: string5().min(1, "User is required"),
  app: AppNameEnumObj
});
var MyFeatureFlagSchema = object5({
  id: string5().uuid(),
  slug: string5(),
  label: string5(),
  description: string5().nullable().optional(),
  enabled: boolean2()
});
var FeatureFlagAudienceTypeEnumObject = z16.enum([
  "group",
  "space-members",
  "space-admins"
]);
var BulkAssignFeatureFlagRequestSchema = z16.discriminatedUnion("type", [
  object5({
    type: z16.literal(FeatureFlagAudienceTypeEnumObject.enum.group),
    groupId: z16.number().int().positive(),
    app: AppNameEnumObj
  }),
  object5({
    type: z16.literal(FeatureFlagAudienceTypeEnumObject.enum["space-members"]),
    spaceId: string5().uuid()
  }),
  object5({
    type: z16.literal(FeatureFlagAudienceTypeEnumObject.enum["space-admins"]),
    spaceId: string5().uuid()
  })
]);
var BulkAssignFeatureFlagResultSchema = object5({
  audienceType: FeatureFlagAudienceTypeEnumObject,
  app: AppNameEnumObj,
  resolved: z16.number(),
  granted: z16.number(),
  alreadyHadAccess: z16.number()
});

// src/roles/index.ts
import { z as z17 } from "zod";
var RoleValues = [
  "instructor",
  "administrator",
  "kit_organizer"
];
var RolesEnumObj = z17.enum(RoleValues);
var ERolesEnum = RolesEnumObj.enum;
var MANAGEMENT_ROLES = [
  ERolesEnum.administrator,
  ERolesEnum.kit_organizer
];

// src/supabase/profile.ts
var normalizeSubscription = /* @__PURE__ */ __name((data) => {
  var _a5, _b, _c, _d;
  if (!data || typeof data !== "object") {
    return data;
  }
  const d = data;
  const meta = d["meta"];
  return {
    appId: (_a5 = d["appId"]) != null ? _a5 : d["app_id"],
    appName: (_b = d["appName"]) != null ? _b : d["app_name"],
    isActive: (_c = d["isActive"]) != null ? _c : d["is_active"],
    meta: meta ? __spreadProps(__spreadValues({}, meta), {
      isTrial: (_d = meta["isTrial"]) != null ? _d : meta["is_trial"],
      tier: meta["tier"]
    }) : void 0
  };
}, "normalizeSubscription");
var normalizeSubscriptionAddon = /* @__PURE__ */ __name((data) => {
  var _a5, _b;
  if (!data || typeof data !== "object") {
    return data;
  }
  const d = data;
  return {
    appName: (_a5 = d["appName"]) != null ? _a5 : d["app_name"],
    access: d["access"],
    isActive: (_b = d["isActive"]) != null ? _b : d["is_active"]
  };
}, "normalizeSubscriptionAddon");
var Subscription = z18.preprocess(normalizeSubscription, object6({
  appId: coerce4.number().min(1),
  appName: string6().min(1),
  isActive: StringToBooleanSchema,
  meta: z18.object({
    isTrial: StringToBooleanSchema.optional(),
    tier: z18.coerce.string().optional(),
    isPlanChangeAllowed: StringToBooleanSchema.optional(),
    isUpgradable: z18.string().optional(),
    upgradeLink: z18.string().optional()
  }).catchall(z18.unknown()).optional()
}));
var SubscriptionAddon = z18.preprocess(normalizeSubscriptionAddon, object6({
  appName: string6().min(1),
  access: array3(string6()),
  isActive: z18.boolean().default(false)
}));
var WPSubscriptionArraySchema = z18.array(Subscription);
var SubscriptionObjectSchema = z18.record(z18.string(), Subscription);
var transformSubscriptionArrayToObject = /* @__PURE__ */ __name((subscriptionArray) => {
  return subscriptionArray.reduce((acc, sub) => {
    const key = sanitizeAppName(sub.appName);
    acc[key] = sub;
    return acc;
  }, {});
}, "transformSubscriptionArrayToObject");
var ProfileMetaSchema = object6({
  isInstructor: z18.boolean().nullable().default(false).optional()
});
var UserAccessPermissionSchema = object6({
  id: number3(),
  name: string6()
});
var UserAccessItemSchema = object6({
  roleId: number3(),
  roleName: string6(),
  permissions: z18.array(UserAccessPermissionSchema).optional()
});
var UserAccessMapSchema = z18.record(z18.string(), UserAccessItemSchema);
var hasPermissionInAccessMap = /* @__PURE__ */ __name((access, permissionName) => Object.values(access != null ? access : {}).some((entry) => {
  var _a5;
  return (_a5 = entry.permissions) == null ? void 0 : _a5.some((permission) => permission.name === permissionName);
}), "hasPermissionInAccessMap");
var hasPermissionForApp = /* @__PURE__ */ __name((access, app, permissionName) => {
  var _a5, _b, _c;
  return !!app && ((_c = (_b = (_a5 = access == null ? void 0 : access[app]) == null ? void 0 : _a5.permissions) == null ? void 0 : _b.some((permission) => permission.name === permissionName)) != null ? _c : false);
}, "hasPermissionForApp");
var isContentManagerForApp = /* @__PURE__ */ __name((access, app) => hasPermissionForApp(access, app, Permissions.CONTENT_EDIT) || hasPermissionForApp(access, app, Permissions.SPACE_MANAGE), "isContentManagerForApp");
var getPermissionIdSetFromAccessMap = /* @__PURE__ */ __name((access) => {
  var _a5;
  const ids = /* @__PURE__ */ new Set();
  for (const entry of Object.values(access != null ? access : {})) {
    for (const permission of (_a5 = entry.permissions) != null ? _a5 : []) {
      ids.add(permission.id);
    }
  }
  return ids;
}, "getPermissionIdSetFromAccessMap");
var getPermissionIdSetForApp = /* @__PURE__ */ __name((access, app) => {
  var _a5, _b;
  return new Set((app ? (_b = (_a5 = access == null ? void 0 : access[app]) == null ? void 0 : _a5.permissions) != null ? _b : [] : []).map((permission) => permission.id));
}, "getPermissionIdSetForApp");
var passesPermissionRestriction = /* @__PURE__ */ __name((requiredPermissionIds, userPermissionIds) => {
  const required = requiredPermissionIds != null ? requiredPermissionIds : [];
  return required.length === 0 || required.some((id2) => userPermissionIds.has(id2));
}, "passesPermissionRestriction");
var SupabaseRowProfileSchema = z18.object({
  id: z18.coerce.string(),
  // Legacy WP identifier — surfaced for cross-system integrations (e.g. Novu
  // subscriberId) that key off the original numeric WP user id.
  userid: z18.string().min(1).optional(),
  // Legacy WP subscription-type bucket — preserved for callers that still read
  // this denormalized list off the cached profile.
  subscriptionType: z18.array(z18.string()).optional(),
  first_name: z18.string().optional(),
  last_name: z18.string().optional(),
  name: z18.string(),
  display_name: z18.string().optional(),
  email: z18.string(),
  avatar: z18.string().nullable(),
  auth_user_id: z18.string(),
  created_at: z18.string(),
  updated_at: z18.string(),
  user_roles: z18.array(z18.string()).nullable().optional(),
  last_check_in: z18.string().or(z18.instanceof(Date)).or(CustomLuxonDateSchema).optional(),
  timezone: timezoneSchema,
  is_timezone_set: z18.boolean().default(false),
  occupation: z18.string().nullable().optional(),
  bio: z18.string().nullable().optional(),
  primary_language: z18.string().nullable().optional(),
  phone_number: z18.string().nullable().optional(),
  zoom_email: z18.string().nullable().optional(),
  is_teacher: z18.boolean().nullable().default(false).optional(),
  meta: object6({
    isInstructor: z18.boolean().nullable().default(false).optional()
  }).optional(),
  is_test_user: z18.boolean().nullable().default(false).optional(),
  is_private: z18.boolean().nullable().default(false).optional(),
  address: z18.object({
    street: z18.string().nullable().optional(),
    city: z18.string().nullable().optional(),
    state: z18.string().nullable().optional(),
    zip: z18.string().nullable().optional(),
    country: z18.string().nullable().optional(),
    countryId: z18.coerce.number().nullable().optional(),
    stateId: z18.coerce.number().nullable().optional(),
    cityId: z18.coerce.number().nullable().optional()
  }).nullable().optional(),
  socials: z18.object({
    facebook: z18.string().nullable().optional(),
    instagram: z18.string().nullable().optional(),
    youtube: z18.string().nullable().optional(),
    twitter: z18.string().nullable().optional(),
    linkedin: z18.string().nullable().optional(),
    tiktok: z18.string().nullable().optional()
  }).nullable().optional(),
  username: z18.string().nullable().optional(),
  user_uuid: z18.string(),
  mention_id: z18.string().uuid().nullable().optional(),
  access: UserAccessMapSchema.optional(),
  user_access: array3(object6({
    app: string6(),
    role: z18.object({
      id: z18.number(),
      name: z18.string(),
      role_permissions: z18.array(z18.object({
        permissions: z18.object({
          id: z18.number(),
          name: z18.string()
        }).nullable()
      })).optional()
    })
  })).optional()
});
var SupabaseProfileSchema = SupabaseRowProfileSchema.transform((values) => {
  var _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const _a5 = values, { id: id2, name, avatar, email, timezone, access, user_access } = _a5, rest = __objRest(_a5, ["id", "name", "avatar", "email", "timezone", "access", "user_access"]);
  const buildAccessEntry = /* @__PURE__ */ __name((r) => {
    var _a6, _b2;
    const permissions = (_b2 = (_a6 = r.role.role_permissions) == null ? void 0 : _a6.flatMap((rp) => rp.permissions ? [
      rp.permissions
    ] : [])) != null ? _b2 : [];
    return {
      roleId: r.role.id,
      roleName: r.role.name,
      permissions
    };
  }, "buildAccessEntry");
  const resolvedAccess = user_access && user_access.length > 0 ? Object.fromEntries(user_access.map((r) => [
    r.app,
    buildAccessEntry(r)
  ])) : access;
  return {
    id: id2,
    userId: id2,
    userid: rest.userid,
    subscriptionType: rest.subscriptionType,
    name,
    avatar,
    email,
    timezone,
    firstName: rest.first_name,
    lastName: rest.last_name,
    displayName: rest.display_name,
    authUserId: rest.auth_user_id,
    createdAt: rest.created_at,
    updatedAt: rest.updated_at,
    userRoles: (_b = rest.user_roles) != null ? _b : [],
    isManagement: ((_c = rest.user_roles) != null ? _c : []).some((r) => MANAGEMENT_ROLES.includes(r)),
    lastCheckIn: rest.last_check_in,
    isTimezoneSet: rest.is_timezone_set,
    occupation: (_d = rest.occupation) != null ? _d : null,
    bio: (_e = rest.bio) != null ? _e : null,
    primaryLanguage: (_f = rest.primary_language) != null ? _f : null,
    phoneNumber: (_g = rest.phone_number) != null ? _g : null,
    zoomEmail: (_h = rest.zoom_email) != null ? _h : null,
    isTeacher: (_i = rest.is_teacher) != null ? _i : false,
    meta: (_j = rest.meta) != null ? _j : {
      isInstructor: false
    },
    isTestUser: (_k = rest.is_test_user) != null ? _k : false,
    address: (_l = rest.address) != null ? _l : {
      street: null,
      city: null,
      state: null,
      zip: null,
      country: null,
      countryId: null,
      stateId: null,
      cityId: null
    },
    socials: (_m = rest.socials) != null ? _m : {
      facebook: null,
      instagram: null,
      youtube: null,
      twitter: null,
      linkedin: null,
      tiktok: null
    },
    isPrivate: (_n = rest.is_private) != null ? _n : false,
    username: (_o = rest.username) != null ? _o : "",
    userUUID: rest.user_uuid,
    mentionId: (_p = rest.mention_id) != null ? _p : null,
    access: resolvedAccess,
    // Populated post-parse by profile enrichment (see BaseSupabaseProfileService),
    // exactly like `access`. Not a column on the `profile` row.
    featureFlags: void 0
  };
});
var ProfileSchema = object6({
  id: coerce4.string().min(1),
  userId: coerce4.string().min(1),
  userid: string6().min(1).optional(),
  subscriptionType: array3(string6()).optional(),
  firstName: string6().optional(),
  lastName: string6().optional(),
  name: string6(),
  displayName: string6().optional(),
  avatar: string6().nullable(),
  email: string6(),
  timezone: timezoneSchema,
  authUserId: string6(),
  createdAt: string6(),
  updatedAt: string6(),
  userRoles: array3(string6()),
  isManagement: z18.boolean(),
  lastCheckIn: string6().or(z18.instanceof(Date)).or(CustomLuxonDateSchema).optional(),
  isTimezoneSet: z18.boolean(),
  occupation: string6().nullable(),
  bio: string6().nullable(),
  primaryLanguage: string6().nullable(),
  phoneNumber: string6().nullable(),
  zoomEmail: string6().nullable(),
  isTeacher: z18.boolean(),
  meta: ProfileMetaSchema,
  isTestUser: z18.boolean(),
  address: z18.object({
    street: string6().nullable().optional(),
    city: string6().nullable().optional(),
    state: string6().nullable().optional(),
    zip: string6().nullable().optional(),
    country: string6().nullable().optional(),
    countryId: z18.coerce.number().nullable().optional(),
    stateId: z18.coerce.number().nullable().optional(),
    cityId: z18.coerce.number().nullable().optional()
  }),
  socials: z18.object({
    facebook: string6().nullable().optional(),
    instagram: string6().nullable().optional()
  }),
  isPrivate: z18.boolean(),
  username: string6().nullable(),
  userUUID: string6().uuid(),
  mentionId: string6().uuid().nullable(),
  access: UserAccessMapSchema.optional(),
  featureFlags: FeatureFlagMapSchema.optional()
});
var SupabaseMentionableProfileRowSchema = z18.object({
  id: z18.coerce.string(),
  mention_id: z18.string().uuid().nullable().optional(),
  display_name: z18.string().nullable().optional(),
  name: z18.string().nullable().optional(),
  username: z18.string().nullable().optional(),
  avatar: z18.string().nullable().optional(),
  is_private: z18.boolean().nullable().optional(),
  // Active-app derivation comes from the `user_access` join, not a column.
  // `access` is not a real column — it is built from this join below.
  user_access: array3(object6({
    app: string6(),
    role: z18.object({
      id: z18.number(),
      name: z18.string(),
      role_permissions: z18.array(z18.object({
        permissions: z18.object({
          id: z18.number(),
          name: z18.string()
        }).nullable()
      })).optional()
    })
  })).optional()
});
var SupabaseMentionableProfileSchema = SupabaseMentionableProfileRowSchema.transform((row) => {
  var _a5, _b, _c, _d, _e, _f;
  const access = row.user_access && row.user_access.length > 0 ? Object.fromEntries(row.user_access.map((r) => {
    var _a6, _b2;
    return [
      r.app,
      {
        roleId: r.role.id,
        roleName: r.role.name,
        permissions: (_b2 = (_a6 = r.role.role_permissions) == null ? void 0 : _a6.flatMap((rp) => rp.permissions ? [
          rp.permissions
        ] : [])) != null ? _b2 : []
      }
    ];
  })) : void 0;
  return {
    id: row.id,
    mentionId: (_a5 = row.mention_id) != null ? _a5 : null,
    displayName: (_b = row.display_name) != null ? _b : null,
    name: (_c = row.name) != null ? _c : null,
    username: (_d = row.username) != null ? _d : null,
    avatar: (_e = row.avatar) != null ? _e : null,
    isPrivate: (_f = row.is_private) != null ? _f : false,
    access
  };
});

// src/community-hub/space.ts
var SpaceActionPermissionsSchema = z19.record(z19.string(), z19.array(z19.number().int()));
var SpaceParticipantRoleValues = [
  "teacher",
  "student"
];
var SpaceParticipantRoleSchema = z19.enum(SpaceParticipantRoleValues);
var ESpaceParticipantRole = SpaceParticipantRoleSchema.enum;
var SpaceParticipantPermissionsSchema = z19.object({
  teacher: z19.array(z19.number().int()).optional(),
  student: z19.array(z19.number().int()).optional()
});
var getSpaceParticipantRole = /* @__PURE__ */ __name((access, app, participantPermissionIds) => {
  const userPermissionIds = getPermissionIdSetForApp(access, app);
  const holdsAny = /* @__PURE__ */ __name((ids) => !!(ids == null ? void 0 : ids.length) && ids.some((id2) => userPermissionIds.has(id2)), "holdsAny");
  if (holdsAny(participantPermissionIds == null ? void 0 : participantPermissionIds.teacher)) {
    return ESpaceParticipantRole.teacher;
  }
  if (holdsAny(participantPermissionIds == null ? void 0 : participantPermissionIds.student)) {
    return ESpaceParticipantRole.student;
  }
  return null;
}, "getSpaceParticipantRole");
var SpaceType = /* @__PURE__ */ function(SpaceType2) {
  SpaceType2["CONTAINER"] = "container";
  SpaceType2["FEED"] = "feed";
  SpaceType2["CONTENT"] = "content";
  SpaceType2["CHAT"] = "chat";
  SpaceType2["SINGLE_LESSON"] = "single_lesson";
  SpaceType2["ANALYTICS"] = "analytics";
  SpaceType2["REVIEW"] = "review";
  return SpaceType2;
}({});
var SpaceTypeSchema = z19.nativeEnum(SpaceType);
var SpaceBannerDisplayValues = [
  "background",
  "image"
];
var SpaceBannerDisplaySchema = z19.enum(SpaceBannerDisplayValues);
var SPACE_BANNER_DISPLAY_KEY = "bannerDisplay";
var getSpaceBannerDisplay = /* @__PURE__ */ __name((settings) => {
  const parsed = SpaceBannerDisplaySchema.safeParse(settings == null ? void 0 : settings[SPACE_BANNER_DISPLAY_KEY]);
  return parsed.success ? parsed.data : "background";
}, "getSpaceBannerDisplay");
var SPACE_VIDEO_COMPLETION_PERCENT_KEY = "videoCompletionPercent";
var DEFAULT_VIDEO_COMPLETION_PERCENT = 100;
var VIDEO_COMPLETION_PERCENT_OPTIONS = [
  25,
  50,
  75,
  DEFAULT_VIDEO_COMPLETION_PERCENT
];
var VideoCompletionPercentSchema = z19.union([
  z19.literal(25),
  z19.literal(50),
  z19.literal(75),
  z19.literal(100)
]);
var getSpaceVideoCompletionPercent = /* @__PURE__ */ __name((settings) => {
  const parsed = VideoCompletionPercentSchema.safeParse(settings == null ? void 0 : settings[SPACE_VIDEO_COMPLETION_PERCENT_KEY]);
  return parsed.success ? parsed.data : null;
}, "getSpaceVideoCompletionPercent");
var SpaceStatus = /* @__PURE__ */ function(SpaceStatus2) {
  SpaceStatus2["DRAFT"] = "draft";
  SpaceStatus2["ACTIVE"] = "active";
  SpaceStatus2["ARCHIVED"] = "archived";
  return SpaceStatus2;
}({});
var SpaceStatusSchema = z19.nativeEnum(SpaceStatus);
var SPACE_OVERRIDABLE_ACTIONS = [
  {
    permission: "post.create",
    label: "Create posts",
    helperText: "Leave empty to let everyone post. Set it to make this a Q&A community.",
    spaceTypes: [
      "feed"
    ]
  },
  {
    permission: "comment.create",
    label: "Write comments",
    helperText: "Leave empty to let everyone reply to posts.",
    spaceTypes: [
      "feed"
    ]
  },
  {
    permission: "chat.send",
    label: "Send chat messages",
    helperText: "Leave empty to let everyone send messages.",
    spaceTypes: [
      "chat"
    ]
  }
];
var getOverridableActionsForSpaceType = /* @__PURE__ */ __name((spaceType) => {
  if (!spaceType || spaceType === "container") {
    return [
      ...SPACE_OVERRIDABLE_ACTIONS
    ];
  }
  return SPACE_OVERRIDABLE_ACTIONS.filter((action) => action.spaceTypes.includes(spaceType));
}, "getOverridableActionsForSpaceType");
var canPerformSpaceAction = /* @__PURE__ */ __name((permission, access, app, space, parentSpace) => {
  var _a5, _b, _c, _d;
  if (!hasPermissionForApp(access, app, permission)) {
    return false;
  }
  const own = (_b = (_a5 = space == null ? void 0 : space.actionPermissionIds) == null ? void 0 : _a5[permission]) != null ? _b : [];
  const required = own.length > 0 ? own : (_d = (_c = parentSpace == null ? void 0 : parentSpace.actionPermissionIds) == null ? void 0 : _c[permission]) != null ? _d : [];
  if (required.length === 0) {
    return true;
  }
  if (isContentManagerForApp(access, app)) {
    return true;
  }
  return passesPermissionRestriction(required, getPermissionIdSetForApp(access, app));
}, "canPerformSpaceAction");
var SpaceRefSchema = z19.object({
  id: z19.string().uuid(),
  name: z19.string(),
  // Legacy tracking slug (ch_spaces.slug). Transformed to a URL slug via
  // appKeyToSlug for the slug-based content routes.
  slug: z19.string().optional().nullable(),
  spaceType: SpaceTypeSchema,
  icon: z19.string().optional().nullable(),
  bannerImage: z19.string().max(500).optional().nullable(),
  mobileBannerImage: z19.string().max(500).optional().nullable(),
  thumbnailImage: z19.string().max(500).optional().nullable(),
  parentId: z19.string().uuid().optional().nullable(),
  app: z19.string().optional().nullable(),
  // Carried on the ref so a sub-space payload is enough for the frontend to apply
  // the container's overrides — `canPerformSpaceAction` falls back to the parent
  // when the sub-space sets none.
  actionPermissionIds: SpaceActionPermissionsSchema.optional(),
  // Same reason: a sub-space under a draft container is itself unpublished, and
  // the sub-space payload is all the frontend has to work that out.
  status: SpaceStatusSchema.optional(),
  // Per-user progress lock, populated on the member space catalog. A module is
  // locked while its prerequisite module is unfinished; `prerequisiteName` is
  // what the "Complete X to unlock" hint renders. Absent on admin listings.
  isLocked: z19.boolean().optional(),
  prerequisiteName: z19.string().optional().nullable()
});
var SlackWebhookUrlSchema = z19.string().url("Enter a valid URL").startsWith("https://hooks.slack.com/", "Must be a Slack webhook URL (https://hooks.slack.com/...)");
var SpaceSlackEventEnum = z19.enum([
  "post",
  "comment",
  "reply"
]);
var SPACE_SLACK_EVENTS = SpaceSlackEventEnum.options;
var SPACE_SLACK_EVENT_LABELS = {
  post: "New posts",
  comment: "New comments on a post",
  reply: "New replies to a comment"
};
var SpaceSlackEventsSchema = z19.array(SpaceSlackEventEnum);
var SpaceBaseSchema = z19.object({
  id: z19.string().uuid(),
  name: z19.string().min(1).max(150),
  // Legacy tracking slug (ch_spaces.slug). Transformed to a URL slug via
  // appKeyToSlug for the slug-based content routes.
  slug: z19.string().optional().nullable(),
  description: z19.string().optional().nullable(),
  /**
  * Optional second column beside the description on a module page — today the
  * module's learning objectives. Kept as its own field rather than more HTML
  * inside `description` because the layout is the app's decision, not the
  * author's: two columns on a wide screen, stacked on a phone. An author
  * writing that as a grid in the description cannot express the breakpoint,
  * and the sanitizer strips any <style> block they might reach for.
  */
  learningObjectives: z19.string().optional().nullable(),
  spaceType: SpaceTypeSchema,
  status: SpaceStatusSchema,
  parentId: z19.string().uuid().optional().nullable(),
  app: z19.string().optional().nullable(),
  icon: z19.string().optional().nullable(),
  bannerImage: z19.string().max(500).optional().nullable(),
  mobileBannerImage: z19.string().max(500).optional().nullable(),
  thumbnailImage: z19.string().max(500).optional().nullable(),
  position: z19.number().int().optional().nullable(),
  // Progress-based locking: prerequisite module that must be 100% complete to unlock this one
  prerequisiteSpaceId: z19.string().uuid().optional().nullable(),
  settings: z19.record(z19.unknown()).optional().nullable(),
  // Permission-based access allow-list. Empty = open to everyone with app access;
  // non-empty = the user must hold at least one of these permission ids (children
  // additionally inherit their ancestors' restrictions).
  requiredPermissionIds: z19.array(z19.number().int()).optional(),
  // Per-space overrides layered on top of the default role permissions — see
  // SpaceActionPermissionsSchema. Read it with `canPerformSpaceAction`.
  actionPermissionIds: SpaceActionPermissionsSchema.optional(),
  // Program-level: which permissions make a user a teacher / student here.
  // Read it with `getSpaceParticipantRole`.
  participantPermissionIds: SpaceParticipantPermissionsSchema.optional(),
  // When false, this community stops sending feed notifications (new post,
  // comment, reply, reaction) to its members. Direct @mentions still go out.
  notificationsEnabled: z19.boolean().optional(),
  // True when a Slack webhook is stored. The URL itself is write-only.
  hasSlackWebhook: z19.boolean().optional(),
  // Which member activity raises a Slack alert (only used when a webhook is stored).
  slackNotificationEvents: SpaceSlackEventsSchema.optional(),
  showProgressBar: z19.boolean(),
  showSubtitle: z19.boolean(),
  showIndexBadge: z19.boolean(),
  // Show the per-user "Watched Nx" chip on lesson video players in this space
  showWatchCount: z19.boolean(),
  showLessonLabel: z19.boolean(),
  showSectionLabel: z19.boolean(),
  createdAt: z19.coerce.date(),
  updatedAt: z19.coerce.date(),
  deletedAt: z19.coerce.date().optional().nullable(),
  // Computed stats for content-type sub-spaces (modules)
  lessonCount: z19.number().int().optional(),
  hasDownloadableAssets: z19.boolean().optional(),
  // Computed per-user lock state (populated on member sub-space listing)
  isLocked: z19.boolean().optional(),
  prerequisiteName: z19.string().optional().nullable(),
  // Relations (populated when loaded with relations)
  parent: SpaceRefSchema.optional().nullable(),
  children: z19.array(SpaceRefSchema).optional()
});
var CreateSpaceSchema = z19.object({
  name: z19.string().min(1, "Name is required").max(150, "Name must be 150 characters or less"),
  description: z19.string().optional(),
  learningObjectives: z19.string().optional(),
  app: z19.string().min(1, "App is required"),
  // Top-level space type: 'container' (default) holds sub-spaces; 'single_lesson' holds exactly one lesson
  spaceType: z19.enum([
    "container",
    "single_lesson"
  ]).optional(),
  icon: z19.string().optional(),
  bannerImage: z19.string().max(500).optional(),
  thumbnailImage: z19.string().max(500).optional(),
  position: z19.number().int().min(0).optional(),
  settings: z19.record(z19.unknown()).optional(),
  requiredPermissionIds: z19.array(z19.number().int()).optional(),
  actionPermissionIds: SpaceActionPermissionsSchema.optional(),
  participantPermissionIds: SpaceParticipantPermissionsSchema.optional(),
  notificationsEnabled: z19.boolean().optional(),
  slackWebhookUrl: SlackWebhookUrlSchema.optional(),
  slackNotificationEvents: SpaceSlackEventsSchema.optional(),
  showIndexBadge: z19.boolean().optional(),
  showWatchCount: z19.boolean().optional()
});
var SubSpaceUrlSlugSchema = z19.string().min(1, "URL slug is required").max(120, "URL slug must be 120 characters or less").regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Use lowercase letters, numbers and single dashes (e.g. my-analytics)");
var CreateSubSpaceSchema = z19.object({
  name: z19.string().min(1, "Name is required").max(150, "Name must be 150 characters or less"),
  /** Optional — generated from the name when omitted. */
  slug: SubSpaceUrlSlugSchema.optional(),
  description: z19.string().optional(),
  learningObjectives: z19.string().optional(),
  spaceType: z19.enum([
    "feed",
    "content",
    "chat",
    "analytics",
    "review"
  ], {
    errorMap: /* @__PURE__ */ __name(() => ({
      message: "Space type must be feed, content, chat, analytics, or review"
    }), "errorMap")
  }),
  icon: z19.string().optional(),
  bannerImage: z19.string().max(500).optional(),
  mobileBannerImage: z19.string().max(500).optional(),
  thumbnailImage: z19.string().max(500).optional(),
  position: z19.number().int().min(0).optional(),
  prerequisiteSpaceId: z19.string().uuid().nullable().optional(),
  settings: z19.record(z19.unknown()).optional(),
  requiredPermissionIds: z19.array(z19.number().int()).optional(),
  actionPermissionIds: SpaceActionPermissionsSchema.optional(),
  notificationsEnabled: z19.boolean().optional(),
  showProgressBar: z19.boolean().optional(),
  showSubtitle: z19.boolean().optional(),
  showLessonLabel: z19.boolean().optional(),
  showSectionLabel: z19.boolean().optional()
});
var UpdateSpaceSchema = z19.object({
  name: z19.string().min(1, "Name is required").max(150, "Name must be 150 characters or less").optional(),
  /** Sub-spaces only — a container's slug is its app key and cannot change. */
  slug: SubSpaceUrlSlugSchema.optional(),
  description: z19.string().optional(),
  learningObjectives: z19.string().optional(),
  app: z19.string().min(1).optional(),
  status: SpaceStatusSchema.optional(),
  icon: z19.string().optional(),
  bannerImage: z19.string().max(500).optional(),
  mobileBannerImage: z19.string().max(500).optional(),
  thumbnailImage: z19.string().max(500).optional(),
  position: z19.number().int().min(0).optional(),
  prerequisiteSpaceId: z19.string().uuid().nullable().optional(),
  settings: z19.record(z19.unknown()).optional(),
  requiredPermissionIds: z19.array(z19.number().int()).optional(),
  actionPermissionIds: SpaceActionPermissionsSchema.optional(),
  /** Top-level spaces only — sub-spaces use their program's value. */
  participantPermissionIds: SpaceParticipantPermissionsSchema.optional(),
  notificationsEnabled: z19.boolean().optional(),
  /** Omit = keep stored value, `null` = remove it. */
  slackWebhookUrl: SlackWebhookUrlSchema.nullable().optional(),
  slackNotificationEvents: SpaceSlackEventsSchema.optional(),
  showProgressBar: z19.boolean().optional(),
  showSubtitle: z19.boolean().optional(),
  showIndexBadge: z19.boolean().optional(),
  showWatchCount: z19.boolean().optional(),
  showLessonLabel: z19.boolean().optional(),
  showSectionLabel: z19.boolean().optional()
});
var FeedSpaceItemSchema = z19.object({
  id: z19.string().uuid(),
  name: z19.string(),
  icon: z19.string().nullable(),
  bannerImage: z19.string().nullable().optional(),
  thumbnailImage: z19.string().nullable().optional(),
  hasAccess: z19.boolean(),
  // The community (or its container) is unpublished — only ever true for a viewer
  // who can see it (a manager), so the sidebar can mark it as not yet live.
  isDraft: z19.boolean().optional()
});

// src/community-hub/content.ts
var LessonStatus = /* @__PURE__ */ function(LessonStatus2) {
  LessonStatus2["DRAFT"] = "draft";
  LessonStatus2["PUBLISHED"] = "published";
  LessonStatus2["ARCHIVED"] = "archived";
  return LessonStatus2;
}({});
var LessonStatusSchema = z20.nativeEnum(LessonStatus);
var EContentStatus = /* @__PURE__ */ function(EContentStatus2) {
  EContentStatus2["DRAFT"] = "draft";
  EContentStatus2["PUBLISHED"] = "published";
  EContentStatus2["ARCHIVED"] = "archived";
  return EContentStatus2;
}({});
var ContentStatusSchema = z20.nativeEnum(EContentStatus);
var LessonColorScheme = /* @__PURE__ */ function(LessonColorScheme2) {
  LessonColorScheme2["CORAL"] = "coral";
  LessonColorScheme2["GREEN"] = "green";
  LessonColorScheme2["PEACH"] = "peach";
  LessonColorScheme2["BLUE"] = "blue";
  LessonColorScheme2["DUSTY_BLUE"] = "dusty_blue";
  LessonColorScheme2["PEACH_CREAM"] = "peach_cream";
  LessonColorScheme2["CORAL_RED"] = "coral_red";
  LessonColorScheme2["MINT_CREAM"] = "mint_cream";
  LessonColorScheme2["ROSE_TAUPE"] = "rose_taupe";
  LessonColorScheme2["ICE_BLUE"] = "ice_blue";
  LessonColorScheme2["LIGHT_SAGE_GREEN"] = "light_sage_green";
  return LessonColorScheme2;
}({});
var LessonIconScheme = /* @__PURE__ */ function(LessonIconScheme2) {
  LessonIconScheme2["BOOK"] = "book";
  LessonIconScheme2["VIDEO"] = "video";
  LessonIconScheme2["FILES"] = "files";
  LessonIconScheme2["DOCUMENT"] = "document";
  return LessonIconScheme2;
}({});
var LessonColorSchemeSchema = z20.nativeEnum(LessonColorScheme);
var LessonIconSchemeSchema = z20.nativeEnum(LessonIconScheme);
var LessonTemplateType = /* @__PURE__ */ function(LessonTemplateType2) {
  LessonTemplateType2["DEFAULT"] = "default";
  LessonTemplateType2["INLINE"] = "inline";
  LessonTemplateType2["INLINE_DOCUMENT"] = "inline_document";
  LessonTemplateType2["INLINE_PLAYLIST"] = "inline_playlist";
  LessonTemplateType2["TEXT_ONLY"] = "text_only";
  return LessonTemplateType2;
}({});
var LessonTemplateTypeSchema = z20.nativeEnum(LessonTemplateType);
var ContentBlockType = /* @__PURE__ */ function(ContentBlockType2) {
  ContentBlockType2["TEXT"] = "text";
  ContentBlockType2["VIMEO"] = "vimeo";
  ContentBlockType2["PDF"] = "pdf";
  ContentBlockType2["QUIZ"] = "quiz";
  ContentBlockType2["FORM"] = "form";
  ContentBlockType2["EMBED"] = "embed";
  ContentBlockType2["REDIRECT"] = "redirect";
  ContentBlockType2["GCS_UPLOAD"] = "gcs_upload";
  ContentBlockType2["EVENT"] = "event";
  return ContentBlockType2;
}({});
var ContentBlockTypeSchema = z20.nativeEnum(ContentBlockType);
var ContentBlockResourceType = /* @__PURE__ */ function(ContentBlockResourceType2) {
  ContentBlockResourceType2["VIDEO"] = "video";
  ContentBlockResourceType2["PDF"] = "pdf";
  ContentBlockResourceType2["TEXT"] = "text";
  ContentBlockResourceType2["DOCUMENT"] = "document";
  ContentBlockResourceType2["CANVA_TEMPLATE"] = "canva_template";
  ContentBlockResourceType2["GOOGLE_DOC"] = "google_doc";
  ContentBlockResourceType2["WORKSHEET"] = "worksheet";
  ContentBlockResourceType2["WORKBOOK"] = "workbook";
  ContentBlockResourceType2["QUIZ"] = "quiz";
  ContentBlockResourceType2["FORM"] = "form";
  ContentBlockResourceType2["REDIRECT"] = "redirect";
  ContentBlockResourceType2["EMBED"] = "embed";
  return ContentBlockResourceType2;
}({});
var ContentBlockResourceTypeSchema = z20.nativeEnum(ContentBlockResourceType);
var ContentBlockResourceIcon = /* @__PURE__ */ function(ContentBlockResourceIcon2) {
  ContentBlockResourceIcon2["PDF"] = "pdf";
  ContentBlockResourceIcon2["DOCUMENT"] = "document";
  ContentBlockResourceIcon2["FORM"] = "form";
  ContentBlockResourceIcon2["WORKSHEET"] = "worksheet";
  ContentBlockResourceIcon2["WORKBOOK"] = "workbook";
  ContentBlockResourceIcon2["CHECKLIST"] = "checklist";
  ContentBlockResourceIcon2["VIDEO"] = "video";
  ContentBlockResourceIcon2["QUIZ"] = "quiz";
  ContentBlockResourceIcon2["LINK"] = "link";
  ContentBlockResourceIcon2["CANVA"] = "canva";
  ContentBlockResourceIcon2["GOOGLE_DOC"] = "google_doc";
  ContentBlockResourceIcon2["EMBED"] = "embed";
  ContentBlockResourceIcon2["UPLOAD"] = "upload";
  ContentBlockResourceIcon2["BOOK"] = "book";
  ContentBlockResourceIcon2["SPREADSHEET"] = "spreadsheet";
  ContentBlockResourceIcon2["PRESENTATION"] = "presentation";
  ContentBlockResourceIcon2["IMAGE"] = "image";
  ContentBlockResourceIcon2["AUDIO"] = "audio";
  return ContentBlockResourceIcon2;
}({});
var ContentBlockResourceIconSchema = z20.nativeEnum(ContentBlockResourceIcon);
var ContentBlockContentCategory = /* @__PURE__ */ function(ContentBlockContentCategory2) {
  ContentBlockContentCategory2["CARDIO"] = "CARDIO";
  ContentBlockContentCategory2["STRENGTH"] = "STRENGTH";
  ContentBlockContentCategory2["FLOW"] = "FLOW";
  ContentBlockContentCategory2["RESTORE"] = "RESTORE";
  return ContentBlockContentCategory2;
}({});
var ContentBlockContentCategorySchema = z20.nativeEnum(ContentBlockContentCategory);
var LessonProgressStatus = /* @__PURE__ */ function(LessonProgressStatus2) {
  LessonProgressStatus2["NOT_STARTED"] = "not_started";
  LessonProgressStatus2["IN_PROGRESS"] = "in_progress";
  LessonProgressStatus2["COMPLETED"] = "completed";
  return LessonProgressStatus2;
}({});
var LessonProgressStatusSchema = z20.nativeEnum(LessonProgressStatus);
var LessonRefSchema = z20.object({
  id: z20.string().uuid(),
  title: z20.string(),
  // Hyphenated, URL-safe slug for slug-based content URLs (unique within space).
  urlSlug: z20.string().optional().nullable(),
  position: z20.number().int().optional(),
  status: LessonStatusSchema,
  colorScheme: LessonColorSchemeSchema.optional().nullable()
});
var SECTION_TITLE_MAX = 100;
var sectionTitleSchema = z20.string().max(SECTION_TITLE_MAX, `Must be ${SECTION_TITLE_MAX} characters or less`).optional().nullable();
var DEFAULT_LESSON_EXPAND_BUTTON_TEXT = "Expand To See Lessons";
var DEFAULT_LESSON_COLLAPSE_BUTTON_TEXT = "Collapse Lessons";
var DEFAULT_LESSON_MOBILE_EXPAND_BUTTON_TEXT = "Expand";
var DEFAULT_LESSON_MOBILE_COLLAPSE_BUTTON_TEXT = "Collapse";
var CreateLessonSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  shortDescription: z20.string().max(500, "Short description must be 500 characters or less").optional(),
  longDescription: z20.string().max(1e4, "Long description is too long").optional(),
  position: z20.number().int().min(0).optional(),
  colorScheme: LessonColorSchemeSchema.optional(),
  iconScheme: LessonIconSchemeSchema.optional(),
  templateType: LessonTemplateTypeSchema.optional(),
  parentId: z20.string().uuid("Invalid parent lesson ID").optional(),
  categoryId: z20.string().uuid("Invalid category ID").optional().nullable(),
  videoSectionTitle: sectionTitleSchema,
  documentSectionTitle: sectionTitleSchema,
  quizSectionTitle: sectionTitleSchema,
  communityDiscussionTitle: z20.string().max(1e4, "Community discussion title is too long").optional().nullable(),
  additionalResources: z20.string().max(1e4, "Additional resources is too long").optional().nullable(),
  expandButtonText: sectionTitleSchema,
  collapseButtonText: sectionTitleSchema,
  mobileExpandButtonText: sectionTitleSchema,
  mobileCollapseButtonText: sectionTitleSchema,
  showProgressBar: z20.boolean().optional(),
  // Permission-based access allow-list. Empty = open; non-empty = user must hold
  // at least one of these permission ids (on top of the module's own restriction).
  requiredPermissionIds: z20.array(z20.number().int()).optional()
});
var UpdateLessonSchema = z20.object({
  title: z20.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  shortDescription: z20.string().max(500, "Short description must be 500 characters or less").optional(),
  longDescription: z20.string().max(1e4, "Long description is too long").optional(),
  position: z20.number().int().min(0).optional(),
  status: LessonStatusSchema.optional(),
  colorScheme: LessonColorSchemeSchema.optional(),
  iconScheme: LessonIconSchemeSchema.optional(),
  templateType: LessonTemplateTypeSchema.optional(),
  categoryId: z20.string().uuid("Invalid category ID").optional().nullable(),
  videoSectionTitle: sectionTitleSchema,
  documentSectionTitle: sectionTitleSchema,
  quizSectionTitle: sectionTitleSchema,
  communityDiscussionTitle: z20.string().max(1e4, "Community discussion title is too long").optional().nullable(),
  additionalResources: z20.string().max(1e4, "Additional resources is too long").optional().nullable(),
  expandButtonText: sectionTitleSchema,
  collapseButtonText: sectionTitleSchema,
  mobileExpandButtonText: sectionTitleSchema,
  mobileCollapseButtonText: sectionTitleSchema,
  showProgressBar: z20.boolean().optional(),
  requiredPermissionIds: z20.array(z20.number().int()).optional()
});
var optionalUrl = z20.string().optional();
var optionalUuid = z20.string().uuid().optional().or(z20.literal("")).transform((val) => val === "" ? void 0 : val);
var CreateContentBlockSchema = z20.object({
  blockType: ContentBlockTypeSchema,
  position: z20.number().int().min(0).optional(),
  // Publish status — defaults to published server-side when omitted.
  status: ContentStatusSchema.optional(),
  title: z20.string().max(255, "Title must be 255 characters or less").optional(),
  body: z20.string().max(5e4, "Body is too long").optional(),
  textBannerUrl: optionalUrl,
  // Vimeo fields
  vimeoId: z20.string().max(50, "Vimeo ID is too long").optional(),
  vimeoDurationSeconds: z20.number().int().min(0).optional(),
  vimeoThumbnailUrl: optionalUrl,
  instructorId: z20.string().max(50, "Instructor ID is too long").nullable().optional().or(z20.literal("")).transform((val) => val === "" ? null : val),
  isPublicViewMarkAndWatched: z20.boolean().optional(),
  contentCategory: ContentBlockContentCategorySchema.nullable().optional(),
  // PDF fields
  pdfUrl: optionalUrl,
  pdfBannerUrl: optionalUrl,
  pdfFilename: z20.string().max(255, "Filename is too long").optional(),
  pdfFileSize: z20.number().int().min(0).optional(),
  pdfPageCount: z20.number().int().min(0).optional(),
  // Quiz
  quizId: optionalUuid,
  // Form
  formId: optionalUuid,
  // Event
  eventId: optionalUuid,
  // Redirect
  redirectUrl: optionalUrl,
  // GCS Upload — config per block for external NestJS GCS uploader
  gcsBaseUrl: optionalUrl,
  gcsApiSecret: z20.string().max(255).optional().nullable(),
  gcsCallbackUrl: optionalUrl,
  gcsDriveId: z20.string().max(255).optional().nullable(),
  gcsAutoTransferToDrive: z20.boolean().optional(),
  gcsSheetUrl: optionalUrl,
  gcsSubfolder: z20.string().max(255).optional().nullable(),
  gcsOrganizeByUser: z20.boolean().optional(),
  gcsSuccessMessage: z20.string().max(500).optional().nullable(),
  resourceType: ContentBlockResourceTypeSchema.nullable().optional(),
  resourceIcon: ContentBlockResourceIconSchema.nullable().optional(),
  metadata: z20.record(z20.unknown()).optional(),
  requiredPermissionIds: z20.array(z20.number().int()).optional()
});
var UpdateContentBlockSchema = z20.object({
  blockType: ContentBlockTypeSchema.optional(),
  position: z20.number().int().min(0).optional(),
  status: ContentStatusSchema.optional(),
  title: z20.string().max(255, "Title must be 255 characters or less").optional(),
  body: z20.string().max(5e4, "Body is too long").optional(),
  textBannerUrl: optionalUrl,
  // Vimeo fields
  vimeoId: z20.string().max(50, "Vimeo ID is too long").optional(),
  vimeoDurationSeconds: z20.number().int().min(0).optional(),
  vimeoThumbnailUrl: optionalUrl,
  instructorId: z20.string().max(50, "Instructor ID is too long").nullable().optional().or(z20.literal("")).transform((val) => val === "" ? null : val),
  isPublicViewMarkAndWatched: z20.boolean().optional(),
  contentCategory: ContentBlockContentCategorySchema.nullable().optional(),
  // PDF fields
  pdfUrl: optionalUrl,
  pdfBannerUrl: optionalUrl,
  pdfFilename: z20.string().max(255, "Filename is too long").optional(),
  pdfFileSize: z20.number().int().min(0).optional(),
  pdfPageCount: z20.number().int().min(0).optional(),
  // Quiz
  quizId: optionalUuid,
  // Form
  formId: optionalUuid,
  // Event
  eventId: optionalUuid,
  // Redirect
  redirectUrl: optionalUrl,
  // GCS Upload
  gcsBaseUrl: optionalUrl,
  gcsApiSecret: z20.string().max(255).optional().nullable(),
  gcsCallbackUrl: optionalUrl,
  gcsDriveId: z20.string().max(255).optional().nullable(),
  gcsAutoTransferToDrive: z20.boolean().optional(),
  gcsSheetUrl: optionalUrl,
  gcsSubfolder: z20.string().max(255).optional().nullable(),
  gcsOrganizeByUser: z20.boolean().optional(),
  gcsSuccessMessage: z20.string().max(500).optional().nullable(),
  resourceType: ContentBlockResourceTypeSchema.nullable().optional(),
  resourceIcon: ContentBlockResourceIconSchema.nullable().optional(),
  metadata: z20.record(z20.unknown()).optional(),
  requiredPermissionIds: z20.array(z20.number().int()).optional()
});
var UpdateProgressSchema = z20.object({
  lastBlockId: z20.string().uuid("Invalid block ID").optional(),
  status: LessonProgressStatusSchema.optional(),
  logAction: z20.string().optional(),
  percentWatched: z20.number().min(0).max(100).optional()
});
var LessonBaseSchema = z20.object({
  id: z20.string().uuid(),
  spaceId: z20.string().uuid(),
  parentId: z20.string().uuid().optional().nullable(),
  categoryId: z20.string().uuid().optional().nullable(),
  title: z20.string().max(255),
  // Hyphenated, URL-safe slug for slug-based content URLs (unique within space).
  urlSlug: z20.string().optional().nullable(),
  shortDescription: z20.string().nullable(),
  longDescription: z20.string().nullable(),
  position: z20.number().int(),
  status: LessonStatusSchema,
  colorScheme: LessonColorSchemeSchema,
  iconScheme: LessonIconSchemeSchema,
  templateType: LessonTemplateTypeSchema,
  videoSectionTitle: z20.string().nullable().optional(),
  documentSectionTitle: z20.string().nullable().optional(),
  quizSectionTitle: z20.string().nullable().optional(),
  communityDiscussionTitle: z20.string().nullable().optional(),
  additionalResources: z20.string().nullable().optional(),
  expandButtonText: z20.string().nullable().optional(),
  collapseButtonText: z20.string().nullable().optional(),
  mobileExpandButtonText: z20.string().nullable().optional(),
  mobileCollapseButtonText: z20.string().nullable().optional(),
  showProgressBar: z20.boolean(),
  requiredPermissionIds: z20.array(z20.number().int()).default([]),
  createdBy: z20.string().uuid(),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date(),
  // Computed stats for lesson content
  videoCount: z20.number().int().optional(),
  pdfCount: z20.number().int().optional(),
  hasDownloadableAssets: z20.boolean().optional(),
  // Hierarchy relations (populated when loaded with relations)
  parent: LessonRefSchema.optional().nullable(),
  children: z20.array(LessonRefSchema).optional(),
  subLessonCount: z20.number().int().optional(),
  // Category relation (for sub-lessons)
  category: z20.lazy(() => LessonCategoryBaseSchema).optional().nullable(),
  // Categories relation (for parent lessons - their defined categories)
  categories: z20.lazy(() => z20.array(LessonCategoryBaseSchema)).optional()
});
var ModuleProgressSchema = z20.object({
  totalLessons: z20.number().int(),
  completedLessons: z20.number().int(),
  progressPercent: z20.number().int().min(0).max(100)
});
var ContentBlockBaseSchema = z20.object({
  id: z20.string().uuid(),
  lessonId: z20.string().uuid(),
  blockType: ContentBlockTypeSchema,
  position: z20.number().int(),
  // Publish status — members see published only; reviewers can preview drafts.
  status: ContentStatusSchema,
  title: z20.string().max(255).nullable(),
  // Hyphenated, URL-safe slug for slug-based content URLs (unique within lesson).
  urlSlug: z20.string().optional().nullable(),
  body: z20.string().nullable(),
  bodyHtml: z20.string().nullable(),
  textBannerUrl: z20.string().max(500).nullable(),
  // Vimeo fields
  vimeoId: z20.string().max(50).nullable(),
  vimeoDurationSeconds: z20.number().int().nullable(),
  vimeoThumbnailUrl: z20.string().max(500).nullable(),
  instructorId: z20.string().max(50).nullable(),
  isPublicViewMarkAndWatched: z20.boolean().nullable(),
  contentCategory: ContentBlockContentCategorySchema.nullable(),
  // PDF fields
  pdfUrl: z20.string().max(500).nullable(),
  pdfBannerUrl: z20.string().max(500).nullable(),
  pdfFilename: z20.string().max(255).nullable(),
  pdfFileSize: z20.number().int().nullable(),
  pdfPageCount: z20.number().int().nullable(),
  // Quiz
  quizId: z20.string().uuid().nullable(),
  // Form
  formId: z20.string().uuid().nullable(),
  // Event
  eventId: z20.string().uuid().nullable(),
  // Status of the linked form (server-enriched for FORM blocks). Members
  // hide non-published forms; admins surface them to keep editing them.
  formStatus: z20.enum([
    "draft",
    "published",
    "archived"
  ]).optional().nullable(),
  /**
  * Set by the API on an EVENT block whose live session is over and whose replay is
  * available. The row stays an EVENT — this says "present me as video content",
  * which is what lets the lesson template treat it like any other video while a
  * future or recurring session still renders its live card.
  */
  isReplay: z20.boolean().optional(),
  // Redirect
  redirectUrl: z20.string().max(500).nullable(),
  // GCS Upload — admin-configured per-block fields. NOTE: `gcsApiSecret` is
  // returned by the API today (no row-level filtering), so we declare it here
  // for type parity. Strip it server-side before sending to members if/when
  // the field becomes sensitive.
  gcsBaseUrl: z20.string().max(500).nullable().optional(),
  gcsApiSecret: z20.string().max(255).nullable().optional(),
  gcsCallbackUrl: z20.string().max(500).nullable().optional(),
  gcsDriveId: z20.string().max(255).nullable().optional(),
  gcsAutoTransferToDrive: z20.boolean().nullable().optional(),
  gcsSheetUrl: z20.string().max(500).nullable().optional(),
  gcsSubfolder: z20.string().max(255).nullable().optional(),
  gcsOrganizeByUser: z20.boolean().nullable().optional(),
  gcsSuccessMessage: z20.string().max(500).nullable().optional(),
  resourceType: ContentBlockResourceTypeSchema.nullable(),
  resourceIcon: ContentBlockResourceIconSchema.nullable().default(null),
  metadata: z20.record(z20.unknown()),
  requiredPermissionIds: z20.array(z20.number().int()).default([]),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date()
});
var LessonProgressBaseSchema = z20.object({
  id: z20.string().uuid(),
  lessonId: z20.string().uuid(),
  userId: z20.string().uuid(),
  status: LessonProgressStatusSchema,
  startedAt: z20.coerce.date().nullable(),
  completedAt: z20.coerce.date().nullable(),
  lastBlockId: z20.string().uuid().nullable(),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date(),
  // Computed fields for progress percentage
  progressPercent: z20.number().int().min(0).max(100).optional(),
  totalBlocks: z20.number().int().optional(),
  completedBlocks: z20.number().int().optional()
});
var VideoWatchCountsSchema = z20.record(z20.string().uuid(), z20.number().int());
var VideoPlayedBlocksSchema = z20.record(z20.string().uuid(), z20.boolean());
var LessonCategoryBaseSchema = z20.object({
  id: z20.string().uuid(),
  parentLessonId: z20.string().uuid(),
  name: z20.string().min(1).max(100),
  position: z20.number().int(),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date()
});
var CreateLessonCategorySchema = z20.object({
  name: z20.string().min(1, "Name is required").max(100, "Name must be 100 characters or less"),
  position: z20.number().int().min(0).optional()
});
var UpdateLessonCategorySchema = z20.object({
  name: z20.string().min(1).max(100).optional(),
  position: z20.number().int().min(0).optional()
});
var GcsAllowedMediaType = /* @__PURE__ */ function(GcsAllowedMediaType2) {
  GcsAllowedMediaType2["IMAGE"] = "image";
  GcsAllowedMediaType2["VIDEO"] = "video";
  GcsAllowedMediaType2["AUDIO"] = "audio";
  GcsAllowedMediaType2["PDF"] = "pdf";
  GcsAllowedMediaType2["DOCUMENT"] = "document";
  return GcsAllowedMediaType2;
}({});
var GcsAllowedMediaTypeSchema = z20.nativeEnum(GcsAllowedMediaType);
var GCS_MEDIA_TYPE_PRESETS = {
  image: {
    label: "Images",
    extensions: [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "webp",
      "svg",
      "avif"
    ],
    mimeTypes: [
      "image/*"
    ]
  },
  video: {
    label: "Videos",
    extensions: [
      "mp4",
      "mov",
      "webm",
      "avi",
      "m4v",
      "ogg"
    ],
    mimeTypes: [
      "video/*"
    ]
  },
  audio: {
    label: "Audio",
    extensions: [
      "mp3",
      "wav",
      "m4a",
      "aac",
      "ogg"
    ],
    mimeTypes: [
      "audio/*"
    ]
  },
  pdf: {
    label: "PDFs",
    extensions: [
      "pdf"
    ],
    mimeTypes: [
      "application/pdf"
    ]
  },
  document: {
    label: "Documents",
    extensions: [
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "txt",
      "csv"
    ],
    mimeTypes: [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
      "text/csv"
    ]
  }
};
var GCS_MIME_BY_EXTENSION = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  svg: "image/svg+xml",
  avif: "image/avif",
  mp4: "video/mp4",
  mov: "video/quicktime",
  webm: "video/webm",
  avi: "video/x-msvideo",
  m4v: "video/x-m4v",
  ogg: "video/ogg",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  m4a: "audio/mp4",
  aac: "audio/aac",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  txt: "text/plain",
  csv: "text/csv"
};
var gcsMimeTypeForExtension = /* @__PURE__ */ __name((extension) => {
  var _a5;
  return (_a5 = GCS_MIME_BY_EXTENSION[extension.replace(/^\./, "").toLowerCase()]) != null ? _a5 : null;
}, "gcsMimeTypeForExtension");
var GCS_ALLOWED_MEDIA_TYPE_KEYS = new Set(Object.values(GcsAllowedMediaType));
var parseAllowedMediaTypes = /* @__PURE__ */ __name((metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return [];
  }
  const raw = metadata["allowedMediaTypes"];
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.filter((v) => typeof v === "string" && GCS_ALLOWED_MEDIA_TYPE_KEYS.has(v));
}, "parseAllowedMediaTypes");
var parseGcsFilenamePrefix = /* @__PURE__ */ __name((metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return "";
  }
  const raw = metadata["filenamePrefix"];
  return typeof raw === "string" ? raw.trim() : "";
}, "parseGcsFilenamePrefix");
var BLOCK_VIDEO_COMPLETION_PERCENT_KEY = "videoCompletionPercent";
var parseBlockVideoCompletionPercent = /* @__PURE__ */ __name((metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return null;
  }
  const raw = metadata[BLOCK_VIDEO_COMPLETION_PERCENT_KEY];
  const parsed = VideoCompletionPercentSchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}, "parseBlockVideoCompletionPercent");
var resolveVideoCompletionPercent = /* @__PURE__ */ __name((blockMetadata, moduleSettings) => {
  var _a5, _b;
  return (_b = (_a5 = parseBlockVideoCompletionPercent(blockMetadata)) != null ? _a5 : getSpaceVideoCompletionPercent(moduleSettings)) != null ? _b : DEFAULT_VIDEO_COMPLETION_PERCENT;
}, "resolveVideoCompletionPercent");
var isGcsFileAllowed = /* @__PURE__ */ __name((allowed, mimeType, extension) => {
  if (allowed.length === 0) {
    return true;
  }
  const ext = extension.replace(/^\./, "").toLowerCase();
  const mime = (mimeType || "").toLowerCase();
  return allowed.some((key) => {
    const preset = GCS_MEDIA_TYPE_PRESETS[key];
    if (preset.extensions.includes(ext)) {
      return true;
    }
    return preset.mimeTypes.some((m) => m.endsWith("/*") ? mime.startsWith(m.slice(0, -1)) : mime === m);
  });
}, "isGcsFileAllowed");
var GcsUploadStatus = /* @__PURE__ */ function(GcsUploadStatus2) {
  GcsUploadStatus2["PROCESSING"] = "processing";
  GcsUploadStatus2["UPLOADED_IN_BUCKET"] = "uploaded_in_bucket";
  GcsUploadStatus2["UPLOADED_IN_DRIVE"] = "uploaded_in_drive";
  GcsUploadStatus2["FAILED"] = "failed";
  return GcsUploadStatus2;
}({});
var GcsUploadStatusSchema = z20.nativeEnum(GcsUploadStatus);
var GcsUploadRowSchema = z20.object({
  id: z20.string().uuid(),
  blockId: z20.string().uuid(),
  lessonId: z20.string().uuid(),
  userId: z20.string(),
  fileKey: z20.string(),
  fileName: z20.string(),
  fileSize: z20.string().nullable(),
  status: GcsUploadStatusSchema,
  driveLink: z20.string().nullable(),
  createdAt: z20.coerce.date(),
  updatedAt: z20.coerce.date()
});
var StartGcsUploadSchema = z20.object({
  fileExtension: z20.string().min(1).max(20),
  contentType: z20.string().min(1).max(100),
  fileSize: z20.number().int().min(1)
});
var StartGcsUploadResultSchema = z20.object({
  uploadId: z20.string().uuid(),
  uploadUrl: z20.string(),
  fileKey: z20.string(),
  fileName: z20.string()
});
var GcsUploadReportRowSchema = z20.object({
  userId: z20.string(),
  email: z20.string(),
  file_name: z20.string(),
  user_firstname: z20.string(),
  user_lastname: z20.string(),
  display_name: z20.string(),
  event_id: z20.string(),
  google_drive_link: z20.string(),
  location: z20.string(),
  occupation: z20.string(),
  file_size: z20.string(),
  uploaded_at: z20.string()
});
var ContentBlockUsageKind = /* @__PURE__ */ function(ContentBlockUsageKind2) {
  ContentBlockUsageKind2["QUIZ"] = "quiz";
  ContentBlockUsageKind2["FORM"] = "form";
  ContentBlockUsageKind2["EVENT"] = "event";
  return ContentBlockUsageKind2;
}({});
var ContentBlockUsageKindSchema = z20.nativeEnum(ContentBlockUsageKind);
var ContentBlockUsageSchema = z20.object({
  blockId: z20.string().uuid(),
  blockTitle: z20.string().nullable(),
  blockStatus: ContentStatusSchema,
  lessonId: z20.string().uuid(),
  lessonTitle: z20.string(),
  /** Set when the block's lesson is a sub-lesson. */
  parentLessonTitle: z20.string().nullable(),
  spaceId: z20.string().uuid(),
  spaceName: z20.string(),
  /** The root program above the module; null when the lesson sits on the root itself. */
  programName: z20.string().nullable()
});
var ContentBlockUsageMapSchema = z20.record(z20.string(), z20.array(ContentBlockUsageSchema));

// src/community-hub/content-urls.ts
var BLOCK_TYPE_TO_SEGMENT = {
  [ContentBlockType.VIMEO]: "video",
  [ContentBlockType.PDF]: "pdf",
  [ContentBlockType.TEXT]: "text",
  [ContentBlockType.QUIZ]: "quiz",
  [ContentBlockType.FORM]: "form",
  [ContentBlockType.EMBED]: "embed",
  [ContentBlockType.GCS_UPLOAD]: "gcs-upload",
  [ContentBlockType.EVENT]: "event"
};

// src/community-hub/engagement.ts
import { z as z21 } from "zod";
var EngagementEntityTypeValues = [
  "post",
  "comment",
  "space",
  "lesson",
  "content_block",
  "form"
];
var EngagementEntityTypeEnumObj = z21.enum(EngagementEntityTypeValues);
var EEngagementEntityType = EngagementEntityTypeEnumObj.enum;
var EngagementGroupTreatmentValues = [
  "exclude",
  "highlight"
];
var EngagementGroupTreatmentEnumObj = z21.enum(EngagementGroupTreatmentValues);
var SpaceReportingGroupTreatmentSchema = z21.object({
  userGroupId: z21.number().int(),
  treatment: EngagementGroupTreatmentEnumObj,
  /** Hex color for the `highlight` treatment (e.g. `#f8ae00`); ignored for `exclude`. */
  color: z21.string().optional().nullable()
});
var SpaceReportingConfigSchema = z21.object({
  groupTreatments: z21.array(SpaceReportingGroupTreatmentSchema).default([])
});
var EngagementReportingGroupSchema = z21.object({
  userGroupId: z21.number().int(),
  name: z21.string(),
  treatment: EngagementGroupTreatmentEnumObj,
  color: z21.string().nullable(),
  memberCount: z21.number().int().nonnegative()
});
var EngagementRowTagSchema = z21.object({
  userGroupId: z21.number().int(),
  name: z21.string(),
  color: z21.string().nullable(),
  treatment: EngagementGroupTreatmentEnumObj
});
var EngagementLogItemSchema = z21.object({
  id: z21.string(),
  userId: z21.string(),
  /** Resolved display name for the user; falls back to the raw id when unknown. */
  userName: z21.string(),
  userAvatar: z21.string().nullable(),
  action: z21.string(),
  entityType: z21.string(),
  entityId: z21.string(),
  spaceId: z21.string().nullable(),
  /** Resolved sub-space name the event happened in (best-effort). */
  spaceName: z21.string().nullable(),
  /**
  * Resolved lesson (subsection) the event belongs to — the lesson itself for a
  * lesson event, or the parent lesson for a content-block event. Null for events
  * that aren't inside a lesson (posts, comments, sub-space views).
  */
  lessonName: z21.string().nullable(),
  /** Primary content label (entity title; for a comment, the post context). */
  title: z21.string().nullable(),
  /** Secondary line, shown beneath the title (for a comment, the comment text). */
  subtitle: z21.string().nullable(),
  /** Relative members-fe deep link (canonical nested path), or null if not linkable. */
  linkPath: z21.string().nullable(),
  createdAt: z21.string(),
  /** Reporting marker for the acting user (highlight group, or an excluded group shown via the QA toggle). Null otherwise. */
  reportingTag: EngagementRowTagSchema.nullable()
});
var EngagementLogsResponseSchema = z21.object({
  items: z21.array(EngagementLogItemSchema),
  meta: MetaSchema
});
var EngagementLogsQuerySchema = z21.object({
  page: z21.coerce.number().int().positive().default(1),
  perPage: z21.coerce.number().int().positive().max(200).default(50),
  userId: z21.string().optional(),
  // action / entityType are free strings: the `ch_activity_log` table carries
  // values outside the static enums (e.g. ZOOM_JOIN, legacy `content-block`).
  // The UI builds its filter options from the live summary breakdown instead.
  action: z21.string().optional(),
  entityType: z21.string().optional(),
  /** Narrow to a single sub-space (module/feed/content). */
  subSpaceId: z21.string().uuid().optional(),
  /** Narrow to a single lesson — matches the lesson event + activity on its blocks. */
  lessonId: z21.string().uuid().optional(),
  /** ISO date-time; inclusive lower bound. */
  from: z21.string().optional(),
  /** ISO date-time; exclusive upper bound. */
  to: z21.string().optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z21.coerce.boolean().optional()
});
var EngagementSummaryQuerySchema = z21.object({
  from: z21.string().optional(),
  to: z21.string().optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z21.coerce.boolean().optional()
});
var EngagementCountSchema = z21.object({
  key: z21.string(),
  count: z21.number().int().nonnegative()
});
var EngagementSubSpaceSchema = z21.object({
  id: z21.string(),
  name: z21.string(),
  spaceType: z21.string()
});
var EngagementLessonSchema = z21.object({
  id: z21.string(),
  name: z21.string(),
  /** The sub-space (module) the lesson belongs to, so the filter can cascade. */
  spaceId: z21.string().nullable()
});
var EngagementUserSchema = z21.object({
  id: z21.string(),
  name: z21.string(),
  email: z21.string().nullable(),
  avatar: z21.string().nullable()
});
var EngagementUsersQuerySchema = z21.object({
  search: z21.string().optional(),
  limit: z21.coerce.number().int().positive().max(100).default(50)
});
var EngagementSummaryResponseSchema = z21.object({
  totalEvents: z21.number().int().nonnegative(),
  activeUsers: z21.number().int().nonnegative(),
  breakdownByAction: z21.array(EngagementCountSchema),
  breakdownByEntityType: z21.array(EngagementCountSchema),
  subSpaces: z21.array(EngagementSubSpaceSchema),
  lessons: z21.array(EngagementLessonSchema),
  /** The space's configured reporting treatments (resolved names + counts) — powers the legend / config UI. */
  reportingGroups: z21.array(EngagementReportingGroupSchema)
});
var EngagementMembersSortValues = [
  "name",
  "events",
  "lastActive"
];
var EngagementMembersSortEnumObj = z21.enum(EngagementMembersSortValues);
var EngagementMembersQuerySchema = z21.object({
  page: z21.coerce.number().int().positive().default(1),
  perPage: z21.coerce.number().int().positive().max(200).default(50),
  from: z21.string().optional(),
  to: z21.string().optional(),
  /** When true, return only members with no activity in the time frame. */
  inactiveOnly: z21.coerce.boolean().optional(),
  /** When true, return only members with activity in the time frame. */
  activeOnly: z21.coerce.boolean().optional(),
  /** Case-insensitive search over member name and email. */
  search: z21.string().optional(),
  /** Column to sort by; omitted keeps the default "least active first" order. */
  sortBy: EngagementMembersSortEnumObj.optional(),
  sortOrder: z21.enum([
    "asc",
    "desc"
  ]).optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z21.coerce.boolean().optional()
});
var EngagementMemberSchema = z21.object({
  /** Supabase auth UUID (matches ch_activity_log.user_id). */
  id: z21.string(),
  name: z21.string(),
  email: z21.string().nullable(),
  avatar: z21.string().nullable(),
  /** The member's role in the space's app (user_access.role). Null when unset. */
  role: z21.string().nullable(),
  eventCount: z21.number().int().nonnegative(),
  lastActiveAt: z21.string().nullable(),
  /** Reporting marker for this member (highlight group, or an excluded group shown via the QA toggle). Null otherwise. */
  reportingTag: EngagementRowTagSchema.nullable()
});
var EngagementMembersResponseSchema = z21.object({
  items: z21.array(EngagementMemberSchema),
  meta: MetaSchema,
  totalMembers: z21.number().int().nonnegative(),
  activeMembers: z21.number().int().nonnegative(),
  inactiveMembers: z21.number().int().nonnegative()
});
var EngagementTimelineGranularityValues = [
  "day",
  "week",
  "month"
];
var EngagementTimelineGranularityEnumObj = z21.enum(EngagementTimelineGranularityValues);
var EngagementTimelineMetricValues = [
  "users",
  "events"
];
var EngagementTimelineMetricEnumObj = z21.enum(EngagementTimelineMetricValues);
var EngagementTimelineQuerySchema = z21.object({
  from: z21.string().optional(),
  to: z21.string().optional(),
  granularity: EngagementTimelineGranularityEnumObj.default("day"),
  metric: EngagementTimelineMetricEnumObj.default("users"),
  /** Optional event / entity-type narrowing (same values as the activity feed). */
  action: z21.string().optional(),
  entityType: z21.string().optional(),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z21.coerce.boolean().optional()
});
var EngagementTimelineSeriesSchema = z21.object({
  id: z21.string(),
  name: z21.string(),
  data: z21.array(z21.number())
});
var EngagementTimelineResponseSchema = z21.object({
  granularity: EngagementTimelineGranularityEnumObj,
  metric: EngagementTimelineMetricEnumObj,
  /** ISO bucket start dates, ascending — the chart's x-axis. */
  buckets: z21.array(z21.string()),
  series: z21.array(EngagementTimelineSeriesSchema)
});
var EngagementTopContentQuerySchema = z21.object({
  from: z21.string().optional(),
  to: z21.string().optional(),
  action: z21.string().optional(),
  entityType: z21.string().optional(),
  sortBy: z21.enum([
    "events",
    "users"
  ]).default("events"),
  limit: z21.coerce.number().int().positive().max(50).default(10),
  /** QA bypass: when true, `exclude`-treatment groups are NOT filtered out (see the space's reporting config). */
  includeExcluded: z21.coerce.boolean().optional()
});
var EngagementTopContentItemSchema = z21.object({
  entityId: z21.string(),
  entityType: z21.string(),
  title: z21.string().nullable(),
  spaceName: z21.string().nullable(),
  lessonName: z21.string().nullable(),
  /** Total events (plays / opens) on this content. */
  events: z21.number().int().nonnegative(),
  /** Distinct users who engaged with this content. */
  users: z21.number().int().nonnegative()
});
var EngagementTopContentResponseSchema = z21.object({
  items: z21.array(EngagementTopContentItemSchema)
});

// src/community-hub/event.ts
import { z as z22 } from "zod";
var EventType = /* @__PURE__ */ function(EventType2) {
  EventType2["ZOOM"] = "zoom";
  return EventType2;
}({});
var EventTypeSchema = z22.nativeEnum(EventType);
var EventStatus = /* @__PURE__ */ function(EventStatus2) {
  EventStatus2["SCHEDULED"] = "scheduled";
  EventStatus2["LIVE"] = "live";
  EventStatus2["ENDED"] = "ended";
  EventStatus2["CANCELLED"] = "cancelled";
  return EventStatus2;
}({});
var EventStatusSchema = z22.nativeEnum(EventStatus);
var EventBaseSchema = z22.object({
  id: z22.string().uuid(),
  spaceId: z22.string().uuid().nullable(),
  eventType: EventTypeSchema,
  title: z22.string(),
  description: z22.string().nullable(),
  startTime: z22.string().datetime(),
  durationMinutes: z22.number().int(),
  status: EventStatusSchema,
  createdBy: z22.string(),
  zoomMeetingId: z22.string().nullable(),
  zoomMeetingUuid: z22.string().nullable(),
  hostEmail: z22.string().nullable(),
  password: z22.string().nullable(),
  joinUrl: z22.string().nullable(),
  joinWindowMinutes: z22.number().int(),
  replayNoticeMinutes: z22.number().int(),
  replayAvailableMinutes: z22.number().int(),
  settings: z22.record(z22.unknown()),
  createdAt: z22.string().datetime(),
  updatedAt: z22.string().datetime()
});
var CreateZoomEventSchema = z22.object({
  contentBlockId: z22.string().uuid().optional(),
  spaceId: z22.string().uuid().optional(),
  title: z22.string().min(1).max(200),
  description: z22.string().max(2e3).optional(),
  hostEmail: z22.string().email(),
  startTime: z22.string().datetime(),
  durationMinutes: z22.number().int().min(15).max(480),
  joinWindowMinutes: z22.number().int().min(0).max(120).default(15),
  /** Minutes after the scheduled finish before "Join" gives way to "Replay coming soon". */
  replayNoticeMinutes: z22.number().int().min(0).max(240).default(5),
  /** Minutes after the scheduled finish before the replay is offered. */
  replayAvailableMinutes: z22.number().int().min(0).max(1440).default(15),
  enableWaitingRoom: z22.boolean().default(true),
  enableRecording: z22.boolean().default(false)
});
var UpdateZoomEventSchema = CreateZoomEventSchema.omit({
  contentBlockId: true
}).partial().extend({
  /**
  * The container space (what the epic calls the "program") this session belongs
  * to. Nullable so a standalone event — office hours, an open Q&A — can exist
  * without being tied to one.
  */
  spaceId: z22.string().uuid().nullish()
});
var ZoomSignatureResponseSchema = z22.object({
  signature: z22.string(),
  meetingNumber: z22.string(),
  password: z22.string().nullable(),
  title: z22.string(),
  startTime: z22.string().datetime(),
  status: EventStatusSchema,
  customerKey: z22.string()
});
var LIVE_SESSION_SLOT_MINUTES = 30;
var LIVE_SESSION_DAY_START_HOUR = 0;
var LIVE_SESSION_DAY_END_HOUR = 24;
var LIVE_SESSION_BUFFER_MINUTES = 15;
var HostAvailabilitySlotSchema = z22.object({
  /** Slot start as a UTC instant. */
  startTime: z22.string().datetime(),
  /** ET wall-clock label for the slot, e.g. "1:30 PM". */
  label: z22.string(),
  available: z22.boolean(),
  /** Topic of the meeting blocking this slot, when it is unavailable. */
  conflictsWith: z22.string().nullable()
});
var HostAvailabilitySchema = z22.object({
  /** The ET calendar date the slots belong to, as yyyy-MM-dd. */
  date: z22.string(),
  timeZone: z22.string(),
  slots: z22.array(HostAvailabilitySlotSchema)
});
var HostUpcomingMeetingSchema = z22.object({
  id: z22.string(),
  topic: z22.string(),
  startTime: z22.string().datetime(),
  durationMinutes: z22.number().int(),
  /** True when the meeting has a matching ch_events row (created via the dashboard). */
  createdFromDashboard: z22.boolean()
});
var EventAttendanceBaseSchema = z22.object({
  id: z22.string().uuid(),
  eventId: z22.string().uuid(),
  userId: z22.string(),
  joinedAt: z22.string().datetime(),
  leftAt: z22.string().datetime().nullable(),
  durationSeconds: z22.number().int().nullable(),
  source: z22.enum([
    "sdk",
    "webhook"
  ]),
  createdAt: z22.string().datetime(),
  updatedAt: z22.string().datetime()
});
var RecordEventLeaveSchema = z22.object({
  durationSeconds: z22.number().int().min(0).optional()
});
var LIVE_SESSION_TIME_ZONE = "America/New_York";
var LiveSessionState = /* @__PURE__ */ function(LiveSessionState2) {
  LiveSessionState2["PRE_LIVE"] = "pre_live";
  LiveSessionState2["READY_TO_JOIN"] = "ready_to_join";
  LiveSessionState2["PROCESSING"] = "processing";
  LiveSessionState2["REPLAY"] = "replay";
  LiveSessionState2["CANCELLED"] = "cancelled";
  return LiveSessionState2;
}({});
var LIVE_SESSION_REPLAY_NOTICE_MINUTES = 5;
var LIVE_SESSION_REPLAY_AVAILABLE_MINUTES = 15;
var deriveLiveSessionState = /* @__PURE__ */ __name((event, now2 = /* @__PURE__ */ new Date()) => {
  var _a5, _b;
  if (event.status === "cancelled") {
    return "cancelled";
  }
  const startsAt = new Date(event.startTime).getTime();
  const endsAt = startsAt + event.durationMinutes * 6e4;
  const opensAt = startsAt - event.joinWindowMinutes * 6e4;
  const noticeMinutes = (_a5 = event.replayNoticeMinutes) != null ? _a5 : LIVE_SESSION_REPLAY_NOTICE_MINUTES;
  const availableMinutes = (_b = event.replayAvailableMinutes) != null ? _b : LIVE_SESSION_REPLAY_AVAILABLE_MINUTES;
  const noticeAt = endsAt + noticeMinutes * 6e4;
  const replayAt = endsAt + Math.max(availableMinutes, noticeMinutes) * 6e4;
  const nowMs = now2.getTime();
  if (nowMs < opensAt) {
    return "pre_live";
  }
  if (nowMs < noticeAt) {
    return "ready_to_join";
  }
  if (nowMs < replayAt) {
    return "processing";
  }
  return event.vimeoVideoId ? "replay" : "processing";
}, "deriveLiveSessionState");

// src/community-hub/feed.ts
import { z as z24 } from "zod";

// src/community-hub/tags.ts
import { z as z23 } from "zod";
var CommunityTagType = /* @__PURE__ */ function(CommunityTagType2) {
  CommunityTagType2["QUESTION"] = "question";
  CommunityTagType2["SUBSPACE"] = "subspace";
  CommunityTagType2["LESSON"] = "lesson";
  return CommunityTagType2;
}({});
var CommunityTagTypeSchema = z23.nativeEnum(CommunityTagType);
var AvailableTagSchema = z23.object({
  type: CommunityTagTypeSchema,
  value: z23.string().uuid(),
  label: z23.string(),
  category: z23.string().nullable().optional()
});
var PostTagInputSchema = z23.object({
  type: CommunityTagTypeSchema,
  value: z23.string().uuid()
});
var TagRefSchema = z23.object({
  id: z23.string().uuid(),
  type: CommunityTagTypeSchema,
  label: z23.string(),
  refId: z23.string().uuid().nullable()
});
var CommunityTagAdminRowSchema = z23.object({
  id: z23.string().uuid(),
  type: CommunityTagTypeSchema,
  label: z23.string(),
  slug: z23.string().nullable(),
  refId: z23.string().uuid().nullable(),
  category: z23.string().nullable(),
  position: z23.number().int(),
  isActive: z23.boolean(),
  // Owning spaces for grouping/scoping. A `question` tag can belong to several
  // spaces at once; an empty array = global (offered in every space).
  // `subspace` / `lesson` tags resolve to their single source container.
  // `parentSpaceNames` are the live-resolved display names, aligned by index.
  parentSpaceIds: z23.array(z23.string().uuid()),
  parentSpaceNames: z23.array(z23.string()),
  createdAt: z23.string(),
  updatedAt: z23.string()
});
var CreateCommunityTagSchema = z23.object({
  label: z23.string().trim().min(1, "Label is required").max(150),
  category: z23.string().trim().max(60).nullable().optional(),
  position: z23.number().int().min(0).optional(),
  // Spaces this tag belongs to. Empty / omitted = a global tag offered in every
  // space. The bulk-add dialog applies the same target spaces to the whole batch.
  parentSpaceIds: z23.array(z23.string().uuid()).optional()
});
var BulkCreateCommunityTagsSchema = z23.object({
  tags: z23.array(CreateCommunityTagSchema).min(1, "Add at least one tag").max(50)
});
var UpdateCommunityTagSchema = z23.object({
  label: z23.string().trim().min(1).max(150).optional(),
  category: z23.string().trim().max(60).nullable().optional(),
  position: z23.number().int().min(0).optional(),
  isActive: z23.boolean().optional(),
  // Replace the spaces a question tag belongs to. Empty array = make it global.
  parentSpaceIds: z23.array(z23.string().uuid()).optional()
}).refine((data) => Object.keys(data).length > 0, {
  message: "Nothing to update"
});
var BulkUpdateCommunityTagsSchema = z23.object({
  ids: z23.array(z23.string().uuid()).min(1, "Select at least one tag").max(200),
  patch: z23.object({
    category: z23.string().trim().max(60).nullable().optional(),
    isActive: z23.boolean().optional(),
    parentSpaceIds: z23.array(z23.string().uuid()).optional()
  }).refine((data) => Object.keys(data).length > 0, {
    message: "Nothing to update"
  })
});
var ListCommunityTagsQuerySchema = z23.object({
  search: z23.string().trim().optional(),
  type: CommunityTagTypeSchema.optional(),
  status: z23.enum([
    "active",
    "inactive"
  ]).optional(),
  // Filter by owning space. A space uuid narrows to that space's tags; the
  // literal 'global' narrows to space-less (global) tags.
  spaceId: z23.union([
    z23.string().uuid(),
    z23.literal("global")
  ]).optional()
});

// src/community-hub/feed.ts
var POST_TYPE = {
  ANNOUNCEMENT: "announcement",
  QUESTION: "question",
  INTRODUCTION: "introduction",
  MILESTONE: "milestone",
  DISCUSSION: "discussion"
};
var PostTypeSchema = z24.nativeEnum(POST_TYPE);
var POST_TYPE_DEFINITIONS = [
  {
    value: POST_TYPE.ANNOUNCEMENT,
    label: "Announcement",
    icon: "\u{1F4E3}",
    adminOnly: true,
    description: "Zoom links, upcoming calls, schedule updates"
  },
  {
    value: POST_TYPE.QUESTION,
    label: "Question",
    icon: "\u2753",
    adminOnly: false,
    description: "Asking for help with teaching, business, or tech"
  },
  {
    value: POST_TYPE.INTRODUCTION,
    label: "Introduction",
    icon: "\u{1F44B}",
    adminOnly: false,
    description: "New member intro \u2014 who you are, background, location"
  },
  {
    value: POST_TYPE.MILESTONE,
    label: "Milestone",
    icon: "\u{1F389}",
    adminOnly: false,
    description: "Sharing a success, certification progress, or client breakthrough"
  },
  {
    value: POST_TYPE.DISCUSSION,
    label: "Discussion",
    icon: "\u{1F4AC}",
    adminOnly: true,
    description: "Open-ended conversation starter, general topic"
  }
];
var ADMIN_ONLY_POST_TYPES = POST_TYPE_DEFINITIONS.filter((d) => d.adminOnly).map((d) => d.value);
var PostTypeDefinitionSchema = z24.object({
  value: PostTypeSchema,
  label: z24.string(),
  icon: z24.string(),
  adminOnly: z24.boolean(),
  description: z24.string()
});
var POST_SORT = {
  RECENT_ACTIVITY: "recent_activity",
  NEWEST: "newest",
  MOST_DISCUSSED: "most_discussed"
};
var PostSortSchema = z24.nativeEnum(POST_SORT);
var POST_SORT_DEFINITIONS = [
  {
    value: POST_SORT.RECENT_ACTIVITY,
    label: "Most recent activity"
  },
  {
    value: POST_SORT.NEWEST,
    label: "Newest first"
  }
];
var PostStatus = /* @__PURE__ */ function(PostStatus2) {
  PostStatus2["PUBLISHED"] = "published";
  PostStatus2["DRAFT"] = "draft";
  PostStatus2["SCHEDULED"] = "scheduled";
  PostStatus2["PROCESSING_MEDIA"] = "processing_media";
  PostStatus2["ARCHIVED"] = "archived";
  PostStatus2["REMOVED"] = "removed";
  return PostStatus2;
}({});
var PostStatusSchema = z24.nativeEnum(PostStatus);
var CommentStatus = /* @__PURE__ */ function(CommentStatus2) {
  CommentStatus2["PUBLISHED"] = "published";
  CommentStatus2["REMOVED"] = "removed";
  return CommentStatus2;
}({});
var CommentStatusSchema = z24.nativeEnum(CommentStatus);
var ReactionTargetType = /* @__PURE__ */ function(ReactionTargetType2) {
  ReactionTargetType2["POST"] = "post";
  ReactionTargetType2["COMMENT"] = "comment";
  return ReactionTargetType2;
}({});
var ReactionTargetTypeSchema = z24.nativeEnum(ReactionTargetType);
var REACTION_EMOJIS = {
  like: "\u{1F44D}",
  love: "\u2764\uFE0F",
  haha: "\u{1F602}",
  wow: "\u{1F62E}",
  sad: "\u{1F622}",
  angry: "\u{1F620}"
};
var ATTACHMENT_TYPES = [
  "image",
  "video",
  "file"
];
var AttachmentSchema = z24.object({
  url: z24.string().url(),
  type: z24.enum(ATTACHMENT_TYPES),
  width: z24.number().optional(),
  height: z24.number().optional(),
  name: z24.string().optional(),
  mimeType: z24.string().optional(),
  size: z24.number().optional(),
  /**
  * Playback length in seconds, videos only. Measured in the browser at pick
  * time so the composer and the presign endpoint can apply the member duration
  * cap without the server reading the file. Client-declared and therefore
  * advisory — see {@link findRejectedAttachment}.
  */
  durationSeconds: z24.number().optional(),
  /**
  * Backing `media_files` row, set for uploads that may be compressed
  * asynchronously (video / PDF). When present, readers resolve the served
  * URL from that row (`compressed` if ready, else `original`) instead of
  * trusting `url` — attachments are denormalized into post/comment JSONB,
  * so rewriting `url` in place after a transcode is not viable.
  */
  mediaId: z24.string().uuid().optional(),
  /**
  * Video poster frame, filled in at read time from the backing media row once
  * the transcoder has extracted one. Never persisted in the post JSONB.
  */
  posterUrl: z24.string().optional(),
  /**
  * Compression state of the backing media, resolved at read time (never
  * stored). Only ever set on a held post shown to its own author, so the UI
  * can badge each attachment as still processing or failed. `undefined` once
  * the media is active (the normal case).
  */
  processingStatus: z24.enum([
    "processing",
    "failed"
  ]).optional()
});
var CommentAttachmentSchema = AttachmentSchema;
var PostAttachmentSchema = AttachmentSchema;
var isPdfAttachment = /* @__PURE__ */ __name((attachment) => {
  var _a5, _b, _c;
  return ((_a5 = attachment.mimeType) == null ? void 0 : _a5.toLowerCase()) === "application/pdf" || ((_c = (_b = attachment.name) == null ? void 0 : _b.toLowerCase().endsWith(".pdf")) != null ? _c : false);
}, "isPdfAttachment");
var MEMBER_MAX_ATTACHMENT_BYTES = 100 * 1024 * 1024;
var MEMBER_MAX_VIDEO_DURATION_SEC = 60;
var MAX_NON_VIDEO_ATTACHMENT_BYTES = 10 * 1024 * 1024;
var formatBytes = /* @__PURE__ */ __name((bytes) => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}, "formatBytes");
var defaultAttachmentLimits = /* @__PURE__ */ __name((canManageSpace) => canManageSpace ? {
  maxBytes: null,
  maxDurationSec: null
} : {
  maxBytes: MEMBER_MAX_ATTACHMENT_BYTES,
  maxDurationSec: MEMBER_MAX_VIDEO_DURATION_SEC
}, "defaultAttachmentLimits");
var isVideoAttachment = /* @__PURE__ */ __name((attachment) => {
  var _a5, _b;
  return attachment.type === "video" || ((_b = (_a5 = attachment.mimeType) == null ? void 0 : _a5.toLowerCase().startsWith("video/")) != null ? _b : false);
}, "isVideoAttachment");
var maxAttachmentBytesFor = /* @__PURE__ */ __name((attachment, limits) => {
  if (isVideoAttachment(attachment)) {
    return limits.maxBytes;
  }
  return limits.maxBytes === null ? MAX_NON_VIDEO_ATTACHMENT_BYTES : Math.min(limits.maxBytes, MAX_NON_VIDEO_ATTACHMENT_BYTES);
}, "maxAttachmentBytesFor");
var findRejectedAttachment = /* @__PURE__ */ __name((attachments, limits) => {
  var _a5, _b;
  const { maxDurationSec } = limits;
  for (const attachment of attachments != null ? attachments : []) {
    const mime = (_b = (_a5 = attachment.mimeType) == null ? void 0 : _a5.toLowerCase()) != null ? _b : "";
    const isVideo = isVideoAttachment(attachment);
    const isImage = attachment.type === "image" || mime.startsWith("image/");
    if (!isVideo && !isImage && !isPdfAttachment(attachment)) {
      return {
        attachment,
        reason: "unsupported_type"
      };
    }
    const maxBytes = maxAttachmentBytesFor(attachment, limits);
    if (maxBytes !== null && typeof attachment.size === "number" && attachment.size > maxBytes) {
      return {
        attachment,
        reason: "too_large"
      };
    }
    if (isVideo && maxDurationSec !== null && typeof attachment.durationSeconds === "number" && attachment.durationSeconds > maxDurationSec) {
      return {
        attachment,
        reason: "video_too_long"
      };
    }
  }
  return null;
}, "findRejectedAttachment");
var POLL_MIN_OPTIONS = 2;
var POLL_MAX_OPTIONS = 10;
var CreatePollOptionSchema = z24.object({
  text: z24.string().min(1, "Option cannot be empty").max(200, "Option must be 200 characters or less")
});
var CreatePollSchema = z24.object({
  options: z24.array(CreatePollOptionSchema).min(POLL_MIN_OPTIONS, `Add at least ${POLL_MIN_OPTIONS} options`).max(POLL_MAX_OPTIONS, `A poll can have at most ${POLL_MAX_OPTIONS} options`),
  allowMultiple: z24.boolean().optional().default(false),
  closesAt: z24.coerce.date().optional()
});
var PollOptionSchema = z24.object({
  id: z24.string().uuid(),
  text: z24.string(),
  position: z24.number().int(),
  voteCount: z24.number().int()
});
var PollSchema = z24.object({
  id: z24.string().uuid(),
  postId: z24.string().uuid(),
  allowMultiple: z24.boolean(),
  closesAt: z24.coerce.date().nullable(),
  totalVotes: z24.number().int(),
  options: z24.array(PollOptionSchema),
  // Option IDs the current user has voted for (empty if not voted / anonymous).
  userVotedOptionIds: z24.array(z24.string().uuid()),
  createdAt: z24.coerce.date()
});
var VotePollSchema = z24.object({
  optionIds: z24.array(z24.string().uuid()).min(1, "Select at least one option")
});
var CreatePostSchema = z24.object({
  title: z24.string().max(300, "Title must be 300 characters or less").optional(),
  body: z24.string().max(5e4, "Post body is too long"),
  postType: PostTypeSchema,
  attachments: z24.array(PostAttachmentSchema).max(10).optional(),
  tags: z24.array(PostTagInputSchema).max(20).optional(),
  // When set to a future instant, the post is created as SCHEDULED and only
  // appears in the feed once due. Admin-only (enforced server-side).
  scheduledAt: z24.coerce.date().optional(),
  // Pin the post to the top of the feed on creation. Admin-only (enforced
  // server-side); ignored for non-admins.
  isPinned: z24.boolean().optional(),
  // Optional attached poll.
  poll: CreatePollSchema.optional()
}).refine((data) => data.body.trim().length > 0 || data.attachments && data.attachments.length > 0 || !!data.poll, {
  message: "Post must have text, an attachment, or a poll",
  path: [
    "body"
  ]
});
var UpdatePostSchema = z24.object({
  title: z24.string().max(300, "Title must be 300 characters or less").optional(),
  body: z24.string().min(1, "Post body is required").max(5e4, "Post body is too long").optional(),
  postType: PostTypeSchema.optional(),
  status: PostStatusSchema.optional(),
  isPinned: z24.boolean().optional(),
  // When provided, replaces the post's tags. An empty array clears all tags.
  tags: z24.array(PostTagInputSchema).max(20).optional(),
  // Reschedule (future instant) or clear scheduling (null → publish now).
  scheduledAt: z24.coerce.date().nullable().optional(),
  // Replace the post's attachments wholesale. Omit to leave unchanged; pass an
  // empty array to clear all attachments.
  attachments: z24.array(PostAttachmentSchema).max(10).optional(),
  // Reschedule the attached poll's close time. Omit to leave unchanged; pass a
  // date to (re)set the close time, or null to make the poll open-ended.
  // Ignored when the post has no poll.
  pollClosesAt: z24.coerce.date().nullable().optional(),
  // Create, replace, or remove the attached poll. Omit to leave the poll
  // unchanged; pass a poll to create it (or replace an existing one — changing
  // the option set resets existing votes); pass null to remove the poll.
  // Takes precedence over `pollClosesAt` when both are provided.
  poll: CreatePollSchema.nullable().optional()
});
var CreateCommentSchema = z24.object({
  body: z24.string().max(1e4, "Comment body is too long"),
  parentId: z24.string().uuid("Invalid parent comment ID").optional(),
  attachments: z24.array(CommentAttachmentSchema).max(4).optional()
}).refine((data) => data.body.trim().length > 0 || data.attachments && data.attachments.length > 0, {
  message: "Comment must have text or at least one image",
  path: [
    "body"
  ]
});
var UpdateCommentSchema = z24.object({
  body: z24.string().min(1, "Comment body is required").max(1e4, "Comment body is too long").optional(),
  status: CommentStatusSchema.optional()
});
var ToggleReactionSchema = z24.object({
  targetType: ReactionTargetTypeSchema,
  targetId: z24.string().uuid("Invalid target ID"),
  emoji: z24.string().min(1).max(50, "Emoji must be 50 characters or less")
});
var PostTypesCsvSchema = z24.union([
  z24.string(),
  z24.array(z24.string())
]).transform((val) => {
  const values = Array.isArray(val) ? val : val.split(",");
  const validTypes = Object.values(POST_TYPE);
  return values.map((v) => v.trim()).filter((v) => validTypes.includes(v));
});
var TagsCsvSchema = z24.union([
  z24.string(),
  z24.array(z24.string())
]).transform((val) => {
  const values = Array.isArray(val) ? val : val.split(",");
  return values.map((v) => v.trim()).filter((v) => z24.string().uuid().safeParse(v).success);
});
var BooleanParamSchema = z24.union([
  z24.boolean(),
  z24.string()
]).transform((v) => v === true || v === "true");
var GetSpacePostsQuerySchema = z24.object({
  limit: z24.coerce.number().int().min(1).max(50).default(20),
  offset: z24.coerce.number().int().min(0).default(0),
  search: z24.string().trim().max(200).optional(),
  postTypes: PostTypesCsvSchema.optional(),
  dateFrom: z24.string().date().optional(),
  dateTo: z24.string().date().optional(),
  /** Mention user id (from GET /mention/users) — resolved to authorId server-side */
  authorId: z24.string().optional(),
  /** Available-tag values (question tag id or subspace/lesson source id) — posts matching ANY resolve */
  tags: TagsCsvSchema.optional(),
  /** Only posts the current user has saved (bookmarked) */
  saved: BooleanParamSchema.optional(),
  /** Only the current user's own posts */
  mine: BooleanParamSchema.optional(),
  sort: PostSortSchema.default(POST_SORT.RECENT_ACTIVITY)
});
var ADMIN_POST_STATUS_FILTER = {
  SCHEDULED: "scheduled",
  PUBLISHED: "published"
};
var AdminPostStatusFilterSchema = z24.enum([
  ADMIN_POST_STATUS_FILTER.SCHEDULED,
  ADMIN_POST_STATUS_FILTER.PUBLISHED
]);
var AdminListPostsQuerySchema = z24.object({
  limit: z24.coerce.number().int().min(1).max(100).default(20),
  offset: z24.coerce.number().int().min(0).default(0),
  search: z24.string().trim().max(200).optional(),
  postTypes: PostTypesCsvSchema.optional(),
  dateFrom: z24.string().date().optional(),
  dateTo: z24.string().date().optional(),
  /** Mention user id (from GET /mention/users) — resolved to authorId server-side */
  authorId: z24.string().optional(),
  /** Available-tag values (question tag id or subspace/lesson source id) — posts matching ANY resolve */
  tags: TagsCsvSchema.optional(),
  /** Narrow the moderation list to upcoming-scheduled or currently-live posts. */
  status: AdminPostStatusFilterSchema.optional(),
  sort: PostSortSchema.default(POST_SORT.NEWEST)
});
var BULK_POST_TAGS_MODE = {
  ADD: "add",
  REMOVE: "remove",
  REPLACE: "replace"
};
var BulkPostTagsModeSchema = z24.nativeEnum(BULK_POST_TAGS_MODE);
var BulkUpdatePostsSchema = z24.object({
  ids: z24.array(z24.string().uuid()).min(1, "Select at least one post").max(200),
  postType: PostTypeSchema.optional(),
  tagsMode: BulkPostTagsModeSchema.optional(),
  tags: z24.array(PostTagInputSchema).max(20).optional()
}).refine((data) => data.postType !== void 0 || data.tagsMode !== void 0, {
  message: "Choose a post type or a tag change to apply",
  path: [
    "postType"
  ]
}).refine((data) => {
  var _a5, _b;
  return data.tagsMode === void 0 || data.tagsMode === BULK_POST_TAGS_MODE.REPLACE || ((_b = (_a5 = data.tags) == null ? void 0 : _a5.length) != null ? _b : 0) > 0;
}, {
  message: "Select at least one tag to add or remove",
  path: [
    "tags"
  ]
});
var BulkUpdatePostsResultSchema = z24.object({
  updated: z24.number().int()
});
var PostBaseSchema = z24.object({
  id: z24.string().uuid(),
  spaceId: z24.string().uuid(),
  authorId: z24.string().uuid(),
  title: z24.string().max(300).nullable(),
  body: z24.string(),
  bodyHtml: z24.string().nullable(),
  postType: PostTypeSchema.nullable(),
  status: PostStatusSchema,
  isPinned: z24.boolean(),
  likeCount: z24.number().int(),
  commentCount: z24.number().int(),
  attachments: z24.array(PostAttachmentSchema).nullable(),
  tags: z24.array(z24.string().uuid()),
  lastActivityAt: z24.coerce.date(),
  scheduledAt: z24.coerce.date().nullable(),
  poll: PollSchema.nullable().optional(),
  createdAt: z24.coerce.date(),
  updatedAt: z24.coerce.date()
});
var CommentBaseSchema = z24.object({
  id: z24.string().uuid(),
  postId: z24.string().uuid(),
  authorId: z24.string().uuid(),
  parentId: z24.string().uuid().nullable(),
  body: z24.string(),
  bodyHtml: z24.string().nullable(),
  status: CommentStatusSchema,
  likeCount: z24.number().int(),
  attachments: z24.array(CommentAttachmentSchema).nullable(),
  createdAt: z24.coerce.date(),
  updatedAt: z24.coerce.date()
});
var ReactionBaseSchema = z24.object({
  id: z24.string().uuid(),
  userId: z24.string().uuid(),
  targetType: ReactionTargetTypeSchema,
  targetId: z24.string().uuid(),
  emoji: z24.string().max(50),
  createdAt: z24.coerce.date()
});
var ReactionDetailsSchema = z24.object({
  summary: z24.array(z24.object({
    emoji: z24.string(),
    count: z24.number().int()
  })),
  reactions: z24.array(z24.object({
    emoji: z24.string(),
    user: z24.object({
      id: z24.string(),
      name: z24.string(),
      avatar: z24.string().nullable()
    })
  }))
});
var AuthorInfoSchema = z24.object({
  id: z24.string(),
  name: z24.string(),
  avatar: z24.string().nullable()
});
var PollOptionVotersSchema = z24.object({
  optionId: z24.string().uuid(),
  voters: z24.array(AuthorInfoSchema)
});
var PollVotersSchema = z24.object({
  pollId: z24.string().uuid(),
  options: z24.array(PollOptionVotersSchema)
});
var PostWithAuthorSchema = PostBaseSchema.extend({
  author: AuthorInfoSchema,
  userReaction: z24.string().nullable().optional(),
  isSaved: z24.boolean().optional(),
  tags: z24.array(TagRefSchema)
});
var CommentWithAuthorBaseSchema = CommentBaseSchema.extend({
  author: AuthorInfoSchema,
  replyCount: z24.number().int().optional(),
  userReaction: z24.string().nullable().optional()
});
var CommentWithAuthorSchema = CommentWithAuthorBaseSchema.extend({
  replies: z24.array(CommentWithAuthorBaseSchema).optional()
});

// src/community-hub/feed-moderation.ts
import { z as z26 } from "zod";

// src/community-hub/moderation.ts
import { z as z25 } from "zod";
var ReportReasonEnum = z25.enum([
  "spam",
  "harassment",
  "hate_speech",
  "inappropriate_content",
  "misinformation",
  "self_harm",
  "off_topic",
  "self_promotion",
  "other"
]);
var REPORT_REASON_LABELS = {
  spam: "Spam or advertising",
  harassment: "Harassment or bullying",
  hate_speech: "Hate speech or discrimination",
  inappropriate_content: "Inappropriate or offensive content",
  misinformation: "Misinformation",
  self_harm: "Self-harm or dangerous behavior",
  off_topic: "Off-topic",
  self_promotion: "Self-promotion",
  other: "Something else"
};
var REPORT_REASON_HINTS = {
  spam: "Unwanted ads, repeated links or junk.",
  harassment: "Targets or bullies someone.",
  hate_speech: "Attacks people for who they are.",
  inappropriate_content: "Not suitable for this community.",
  misinformation: "False or misleading claims.",
  self_harm: "Talks about hurting oneself.",
  off_topic: "Does not belong in this community.",
  self_promotion: "Promotes the author\u2019s own business or links.",
  other: "Something else. Tell us more below."
};
var REPORT_DESCRIPTION_MAX_LENGTH = 1e3;
var CreateReportSchema = z25.object({
  targetType: z25.enum([
    "post",
    "comment",
    "message",
    "user"
  ]),
  targetId: z25.string().uuid(),
  reason: z25.string().min(1).max(100).optional(),
  description: z25.string().max(REPORT_DESCRIPTION_MAX_LENGTH).optional()
});
var CreateContentReportSchema = z25.object({
  reason: ReportReasonEnum,
  description: z25.string().trim().max(REPORT_DESCRIPTION_MAX_LENGTH).optional()
}).refine((data) => data.reason !== "other" || !!data.description, {
  message: "Please describe the issue",
  path: [
    "description"
  ]
});
var UpdateReportStatusSchema = z25.object({
  status: z25.enum([
    "pending",
    "reviewing",
    "resolved",
    "dismissed"
  ]),
  reason: z25.string().max(500).optional()
});

// src/community-hub/feed-moderation.ts
var FeedModerationItemTypeEnum = z26.enum([
  "post",
  "reply"
]);
var csvStringToArray2 = z26.union([
  z26.string(),
  z26.array(z26.string())
]).transform((val) => {
  if (Array.isArray(val)) {
    return val.filter(Boolean);
  }
  return (val != null ? val : "").split(",").map((v) => v.trim()).filter(Boolean);
}).optional();
var queryBoolean = z26.enum([
  "true",
  "false"
]).transform((val) => val === "true").optional();
var dateString = z26.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected a yyyy-MM-dd date");
var FeedModerationItemParamsSchema = z26.object({
  itemType: FeedModerationItemTypeEnum,
  id: z26.string().uuid()
});
var AdminFeedModerationQuerySchema = z26.object({
  spaceIds: csvStringToArray2,
  itemType: FeedModerationItemTypeEnum.optional(),
  isReject: queryBoolean,
  reportedOnly: queryBoolean,
  fromDate: dateString.optional(),
  toDate: dateString.optional(),
  search: z26.string().trim().min(1).optional(),
  postTypes: csvStringToArray2,
  authorId: z26.string().optional(),
  tagIds: csvStringToArray2,
  postStatus: AdminPostStatusFilterSchema.optional(),
  page: z26.coerce.number().min(1).default(1),
  limit: z26.coerce.number().min(1).max(100).default(20)
});
var ExportFeedModerationQuerySchema = AdminFeedModerationQuerySchema.omit({
  page: true,
  limit: true
});
var FeedModerationItemSchema = z26.object({
  id: z26.string().uuid(),
  itemType: FeedModerationItemTypeEnum,
  spaceId: z26.string().uuid(),
  spaceName: z26.string().nullable(),
  postId: z26.string().uuid(),
  postTitle: z26.string().nullable(),
  parentId: z26.string().uuid().nullable(),
  body: z26.string(),
  bodyHtml: z26.string().nullable(),
  author: AuthorInfoSchema,
  isReject: z26.boolean(),
  rejectReason: ReportReasonEnum.nullable(),
  reviewedAt: z26.string().nullable(),
  reviewedById: z26.string().nullable(),
  reviewedByName: z26.string().nullable(),
  likeCount: z26.number(),
  commentCount: z26.number().default(0),
  openReportCount: z26.number(),
  reportReasons: z26.array(z26.string()),
  isPinned: z26.boolean().default(false),
  postType: PostTypeSchema.nullable().default(null),
  tags: z26.array(z26.object({
    id: z26.string().uuid(),
    label: z26.string()
  })).default([]),
  createdAt: z26.string(),
  updatedAt: z26.string()
});
var FeedModerationItemsResponseSchema = z26.object({
  items: z26.array(FeedModerationItemSchema),
  meta: z26.object({
    total: z26.number(),
    page: z26.number(),
    perPage: z26.number(),
    totalPages: z26.number()
  })
});
var FeedModerationThreadSchema = z26.object({
  post: FeedModerationItemSchema,
  replies: z26.array(FeedModerationItemSchema)
});
var FeedModerationCommunitySchema = z26.object({
  id: z26.string().uuid(),
  name: z26.string(),
  parentName: z26.string().nullable()
});
var FeedModerationCommunitiesResponseSchema = z26.array(FeedModerationCommunitySchema);
var ToggleRejectFeedItemSchema = z26.object({
  isReject: z26.boolean(),
  rejectReason: ReportReasonEnum.optional(),
  rejectNote: z26.string().trim().max(500).optional()
}).refine((data) => !data.isReject || !!data.rejectReason, {
  message: "A reject reason is required",
  path: [
    "rejectReason"
  ]
});
var FeedModerationItemStateSchema = z26.object({
  id: z26.string().uuid(),
  itemType: FeedModerationItemTypeEnum,
  isReject: z26.boolean(),
  rejectReason: ReportReasonEnum.nullable(),
  reviewedAt: z26.string().nullable(),
  reviewedById: z26.string().nullable(),
  reviewedByName: z26.string().nullable(),
  openReportCount: z26.number()
});
var FeedModerationReportedCountSchema = z26.object({
  count: z26.number()
});
var FeedModerationActivityActionEnum = z26.enum([
  "REJECTED",
  "APPROVED"
]);
var FEED_MODERATION_ACTIVITY_ACTION_LABELS = {
  REJECTED: "Rejected",
  APPROVED: "Approved"
};
var FeedModerationActivityEntrySchema = z26.object({
  id: z26.string().uuid(),
  action: FeedModerationActivityActionEnum,
  actorId: z26.string(),
  actorName: z26.string().nullable(),
  reason: z26.string().nullable(),
  note: z26.string().nullable(),
  createdAt: z26.string()
});
var FeedModerationReportEntrySchema = z26.object({
  id: z26.string().uuid(),
  reporterId: z26.string(),
  reporterName: z26.string().nullable(),
  reason: z26.string().nullable(),
  description: z26.string().nullable(),
  status: z26.enum([
    "pending",
    "reviewing",
    "resolved",
    "dismissed"
  ]),
  createdAt: z26.string(),
  resolvedAt: z26.string().nullable()
});
var FeedModerationActivityResponseSchema = z26.object({
  activity: z26.array(FeedModerationActivityEntrySchema),
  reports: z26.array(FeedModerationReportEntrySchema)
});
var FeedModerationAnalyticsFiltersSchema = z26.object({
  spaceIds: csvStringToArray2,
  itemType: FeedModerationItemTypeEnum.optional(),
  fromDate: dateString.optional(),
  toDate: dateString.optional()
});
var FeedModerationAnalyticsGranularityEnum = z26.enum([
  "daily",
  "weekly",
  "monthly"
]);
var FeedModerationAnalyticsTimelineFiltersSchema = FeedModerationAnalyticsFiltersSchema.extend({
  granularity: FeedModerationAnalyticsGranularityEnum.default("daily")
});
var FeedModerationAnalyticsOverviewSchema = z26.object({
  total: z26.number(),
  posts: z26.number(),
  replies: z26.number(),
  approved: z26.number(),
  rejected: z26.number(),
  rejectionRate: z26.number(),
  openReports: z26.number(),
  resolvedReports: z26.number(),
  dismissedReports: z26.number()
});
var FeedModerationAnalyticsCommunityRowSchema = z26.object({
  spaceId: z26.string().uuid(),
  spaceName: z26.string().nullable(),
  total: z26.number(),
  posts: z26.number(),
  replies: z26.number(),
  approved: z26.number(),
  rejected: z26.number(),
  rejectionRate: z26.number(),
  openReports: z26.number()
});
var FeedModerationAnalyticsByCommunitySchema = z26.array(FeedModerationAnalyticsCommunityRowSchema);
var FeedModerationAnalyticsTimelinePointSchema = z26.object({
  date: z26.string(),
  total: z26.number(),
  rejected: z26.number()
});
var FeedModerationAnalyticsTimelineSchema = z26.array(FeedModerationAnalyticsTimelinePointSchema);
var FeedModerationAnalyticsReasonSchema = z26.object({
  reason: z26.string().nullable(),
  count: z26.number()
});
var FeedModerationAnalyticsReasonsSchema = z26.array(FeedModerationAnalyticsReasonSchema);
var FeedModerationAnalyticsReviewerSchema = z26.object({
  reviewerId: z26.string(),
  reviewerName: z26.string().nullable(),
  approved: z26.number(),
  rejected: z26.number(),
  total: z26.number()
});
var FeedModerationAnalyticsReviewersSchema = z26.array(FeedModerationAnalyticsReviewerSchema);

// src/community-hub/form.ts
import { z as z30 } from "zod";

// src/community-hub/form-profile-mapping.ts
import { z as z29 } from "zod";

// src/community-hub/form-question-type.ts
import { z as z27 } from "zod";
var EFormQuestionType = /* @__PURE__ */ function(EFormQuestionType2) {
  EFormQuestionType2["MULTIPLE_CHOICE"] = "multiple_choice";
  EFormQuestionType2["MULTIPLE_SELECT"] = "multiple_select";
  EFormQuestionType2["TRUE_FALSE"] = "true_false";
  EFormQuestionType2["SHORT_ANSWER"] = "short_answer";
  EFormQuestionType2["ORDERING"] = "ordering";
  EFormQuestionType2["FILE_UPLOAD"] = "file_upload";
  EFormQuestionType2["ACCEPT"] = "accept";
  EFormQuestionType2["ACCEPT_WITH_SIGNATURE"] = "accept_with_signature";
  EFormQuestionType2["DROPDOWN"] = "dropdown";
  EFormQuestionType2["TEXT_BLOCK"] = "text_block";
  EFormQuestionType2["MULTIPLE_GRADING"] = "multiple_grading";
  return EFormQuestionType2;
}({});
var FormQuestionTypeSchema = z27.nativeEnum(EFormQuestionType);
var isAnswerableQuestionType = /* @__PURE__ */ __name((questionType) => questionType !== "text_block", "isAnswerableQuestionType");

// src/community-hub/quiz.ts
import { z as z28 } from "zod";
var QuizStatus = /* @__PURE__ */ function(QuizStatus2) {
  QuizStatus2["DRAFT"] = "draft";
  QuizStatus2["PUBLISHED"] = "published";
  QuizStatus2["ARCHIVED"] = "archived";
  return QuizStatus2;
}({});
var QuizStatusSchema = z28.nativeEnum(QuizStatus);
var QuestionType = /* @__PURE__ */ function(QuestionType2) {
  QuestionType2["MULTIPLE_CHOICE"] = "multiple_choice";
  QuestionType2["MULTIPLE_SELECT"] = "multiple_select";
  QuestionType2["TRUE_FALSE"] = "true_false";
  QuestionType2["SHORT_ANSWER"] = "short_answer";
  QuestionType2["ORDERING"] = "ordering";
  QuestionType2["FILE_UPLOAD"] = "file_upload";
  QuestionType2["ACCEPT"] = "accept";
  QuestionType2["ACCEPT_WITH_SIGNATURE"] = "accept_with_signature";
  QuestionType2["DROPDOWN"] = "dropdown";
  return QuestionType2;
}({});
var QuestionTypeSchema = z28.nativeEnum(QuestionType);
var AttemptStatus = /* @__PURE__ */ function(AttemptStatus2) {
  AttemptStatus2["IN_PROGRESS"] = "in_progress";
  AttemptStatus2["SUBMITTED"] = "submitted";
  AttemptStatus2["GRADED"] = "graded";
  AttemptStatus2["ABANDONED"] = "abandoned";
  return AttemptStatus2;
}({});
var AttemptStatusSchema = z28.nativeEnum(AttemptStatus);
var CreateQuizSchema = z28.object({
  title: z28.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z28.string().max(5e3, "Description is too long").optional(),
  passingScorePercent: z28.number().int().min(0).max(100).optional(),
  maxAttempts: z28.number().int().min(1).optional(),
  timeLimitSeconds: z28.number().int().min(1).max(86400, "Time limit cannot exceed 24 hours").optional(),
  shuffleQuestions: z28.boolean().optional(),
  showCorrectAnswers: z28.boolean().optional()
});
var UpdateQuizSchema = z28.object({
  spaceId: z28.string().uuid("Invalid space ID").optional(),
  title: z28.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z28.string().max(5e3, "Description is too long").optional(),
  passingScorePercent: z28.number().int().min(0).max(100).optional(),
  maxAttempts: z28.number().int().min(1).optional(),
  timeLimitSeconds: z28.number().int().min(1).max(86400, "Time limit cannot exceed 24 hours").optional(),
  shuffleQuestions: z28.boolean().optional(),
  showCorrectAnswers: z28.boolean().optional(),
  status: QuizStatusSchema.optional()
});
var CreateQuestionSchema = z28.object({
  questionType: QuestionTypeSchema,
  questionText: z28.string().min(1, "Question text is required").max(5e3),
  explanation: z28.string().max(5e3).optional(),
  points: z28.number().int().min(1).optional(),
  position: z28.number().int().min(0).optional(),
  metadata: z28.record(z28.unknown()).optional()
});
var UpdateQuestionSchema = z28.object({
  questionText: z28.string().min(1, "Question text is required").max(5e3).optional(),
  explanation: z28.string().max(5e3).optional(),
  points: z28.number().int().min(1).optional(),
  position: z28.number().int().min(0).optional(),
  metadata: z28.record(z28.unknown()).optional()
});
var CreateOptionSchema = z28.object({
  optionText: z28.string().min(1, "Option text is required").max(1e3),
  isCorrect: z28.boolean().optional(),
  position: z28.number().int().min(0).optional()
});
var UpdateOptionSchema = z28.object({
  optionText: z28.string().min(1, "Option text is required").max(1e3).optional(),
  isCorrect: z28.boolean().optional(),
  position: z28.number().int().min(0).optional()
});
var SubmitAnswerSchema = z28.object({
  questionId: z28.string().uuid("Invalid question ID"),
  selectedOptionIds: z28.array(z28.string().uuid()).optional(),
  orderingSequence: z28.array(z28.string().uuid()).optional(),
  textAnswer: z28.string().max(1e4).optional()
});
var SubmitQuizAttemptSchema = z28.object({
  answers: z28.array(SubmitAnswerSchema).min(1, "At least one answer is required")
});
var QuizBaseSchema = z28.object({
  id: z28.string().uuid(),
  spaceId: z28.string().uuid(),
  title: z28.string().max(255),
  description: z28.string().nullable(),
  passingScorePercent: z28.number().int(),
  maxAttempts: z28.number().int().nullable(),
  timeLimitSeconds: z28.number().int().nullable(),
  shuffleQuestions: z28.boolean(),
  showCorrectAnswers: z28.boolean(),
  status: QuizStatusSchema,
  createdBy: z28.string().uuid(),
  createdAt: z28.coerce.date(),
  updatedAt: z28.coerce.date()
});

// src/community-hub/form-profile-mapping.ts
var EProfileFieldKind = /* @__PURE__ */ function(EProfileFieldKind2) {
  EProfileFieldKind2["TEXT"] = "text";
  EProfileFieldKind2["URL"] = "url";
  EProfileFieldKind2["BOOLEAN"] = "boolean";
  return EProfileFieldKind2;
}({});
var MAPPABLE_PROFILE_FIELDS = [
  {
    key: "firstName",
    label: "First name",
    kind: "text"
  },
  {
    key: "lastName",
    label: "Last name",
    kind: "text"
  },
  {
    key: "displayName",
    label: "Display name",
    kind: "text"
  },
  {
    key: "occupation",
    label: "Profession",
    kind: "text"
  },
  {
    key: "bio",
    label: "Bio",
    kind: "text"
  },
  {
    key: "primaryLanguage",
    label: "Primary language",
    kind: "text"
  },
  {
    key: "phoneNumber",
    label: "Phone number",
    kind: "text"
  },
  {
    key: "zoomEmail",
    label: "Zoom email",
    kind: "text"
  },
  {
    key: "timezone",
    label: "Timezone",
    kind: "text"
  },
  {
    key: "isPrivate",
    label: "Private profile",
    kind: "boolean"
  },
  {
    key: "address.street",
    label: "Address \u2014 Street",
    kind: "text"
  },
  {
    key: "address.city",
    label: "Address \u2014 City",
    kind: "text"
  },
  {
    key: "address.state",
    label: "Address \u2014 State",
    kind: "text"
  },
  {
    key: "address.zip",
    label: "Address \u2014 Zip",
    kind: "text"
  },
  {
    key: "address.country",
    label: "Address \u2014 Country",
    kind: "text"
  },
  {
    key: "socials.facebook",
    label: "Social \u2014 Facebook",
    kind: "url"
  },
  {
    key: "socials.instagram",
    label: "Social \u2014 Instagram",
    kind: "url"
  },
  {
    key: "socials.youtube",
    label: "Social \u2014 YouTube",
    kind: "url"
  },
  {
    key: "socials.twitter",
    label: "Social \u2014 Twitter",
    kind: "url"
  },
  {
    key: "socials.linkedin",
    label: "Social \u2014 LinkedIn",
    kind: "url"
  },
  {
    key: "socials.tiktok",
    label: "Social \u2014 TikTok",
    kind: "url"
  }
];
var PROFILE_FIELD_KEYS = MAPPABLE_PROFILE_FIELDS.map((field) => field.key);
var ProfileFieldKeySchema = z29.enum(PROFILE_FIELD_KEYS);
var getProfileFieldByKey = /* @__PURE__ */ __name((key) => MAPPABLE_PROFILE_FIELDS.find((field) => field.key === key), "getProfileFieldByKey");
var getQuestionAnswerShape = /* @__PURE__ */ __name((questionType) => {
  switch (questionType) {
    case QuestionType.SHORT_ANSWER:
    case QuestionType.MULTIPLE_CHOICE:
    case QuestionType.DROPDOWN: {
      return {
        cardinality: "single",
        valueType: "string"
      };
    }
    case QuestionType.TRUE_FALSE: {
      return {
        cardinality: "single",
        valueType: "boolean"
      };
    }
    case QuestionType.MULTIPLE_SELECT:
    case QuestionType.ORDERING: {
      return {
        cardinality: "multiple",
        valueType: "string"
      };
    }
    // TEXT_BLOCK and MULTIPLE_GRADING are listed explicitly rather than left to
    // the file-upload default, which would offer them profile mapping they can
    // never satisfy: a text block produces no answer at all, and a grading answer
    // is a per-row score map.
    case QuestionType.ACCEPT:
    case QuestionType.ACCEPT_WITH_SIGNATURE:
    case EFormQuestionType.TEXT_BLOCK:
    case EFormQuestionType.MULTIPLE_GRADING: {
      return {
        cardinality: "single",
        valueType: "none"
      };
    }
    case QuestionType.FILE_UPLOAD:
    default: {
      return {
        cardinality: "multiple",
        valueType: "file"
      };
    }
  }
}, "getQuestionAnswerShape");
var isQuestionTypeMappableToFieldKind = /* @__PURE__ */ __name((questionType, kind) => {
  const shape = getQuestionAnswerShape(questionType);
  if (shape.cardinality !== "single" || shape.valueType === "file" || shape.valueType === "none") {
    return false;
  }
  if (shape.valueType === "boolean") {
    return kind === "boolean";
  }
  return kind === "text" || kind === "url";
}, "isQuestionTypeMappableToFieldKind");
var isQuestionTypeMappableToProfileFieldKey = /* @__PURE__ */ __name((questionType, profileFieldKey) => {
  const field = getProfileFieldByKey(profileFieldKey);
  return !!field && isQuestionTypeMappableToFieldKind(questionType, field.kind);
}, "isQuestionTypeMappableToProfileFieldKey");
var getMappableProfileFieldsForQuestionType = /* @__PURE__ */ __name((questionType) => MAPPABLE_PROFILE_FIELDS.filter((field) => isQuestionTypeMappableToFieldKind(questionType, field.kind)), "getMappableProfileFieldsForQuestionType");

// src/community-hub/form.ts
var FormStatus = /* @__PURE__ */ function(FormStatus2) {
  FormStatus2["DRAFT"] = "draft";
  FormStatus2["PUBLISHED"] = "published";
  FormStatus2["ARCHIVED"] = "archived";
  return FormStatus2;
}({});
var FormStatusSchema = z30.nativeEnum(FormStatus);
var SubmissionStatus = /* @__PURE__ */ function(SubmissionStatus2) {
  SubmissionStatus2["IN_PROGRESS"] = "in_progress";
  SubmissionStatus2["SUBMITTED"] = "submitted";
  return SubmissionStatus2;
}({});
var SubmissionStatusSchema = z30.nativeEnum(SubmissionStatus);
var EFormType = /* @__PURE__ */ function(EFormType2) {
  EFormType2["GENERAL"] = "general";
  EFormType2["REGISTRATION"] = "registration";
  EFormType2["FEEDBACK"] = "feedback";
  EFormType2["WORKBOOK"] = "workbook";
  EFormType2["HANDS_ON_PRACTICE"] = "hands_on_practice";
  return EFormType2;
}({});
var FormTypeSchema = z30.nativeEnum(EFormType);
var isTeacherReviewedFormType = /* @__PURE__ */ __name((formType) => formType === "hands_on_practice", "isTeacherReviewedFormType");
var CreateFormSchema = z30.object({
  title: z30.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z30.string().optional(),
  bannerUrl: z30.string().max(500, "Banner URL is too long").optional().nullable(),
  shuffleQuestions: z30.boolean().optional(),
  allowMultipleSubmissions: z30.boolean().optional(),
  formType: FormTypeSchema.optional().default("general"),
  pdfCoverEnabled: z30.boolean().optional(),
  pdfCoverKicker: z30.string().max(255, "Cover kicker is too long").optional().nullable(),
  pdfCoverSubtitle: z30.string().max(255, "Cover subtitle is too long").optional().nullable(),
  /** Hands-On Practice only: the Feedback form a teacher fills in to review a submission. */
  feedbackFormId: z30.string().uuid().optional().nullable()
});
var UpdateFormSchema = z30.object({
  title: z30.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z30.string().optional(),
  bannerUrl: z30.string().max(500, "Banner URL is too long").optional().nullable(),
  shuffleQuestions: z30.boolean().optional(),
  allowMultipleSubmissions: z30.boolean().optional(),
  status: FormStatusSchema.optional(),
  formType: FormTypeSchema.optional(),
  pdfCoverEnabled: z30.boolean().optional(),
  pdfCoverKicker: z30.string().max(255, "Cover kicker is too long").optional().nullable(),
  pdfCoverSubtitle: z30.string().max(255, "Cover subtitle is too long").optional().nullable(),
  /** Hands-On Practice only: the Feedback form a teacher fills in to review a submission. */
  feedbackFormId: z30.string().uuid().optional().nullable()
});
var CreateFormQuestionGroupSchema = z30.object({
  title: z30.string().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  description: z30.string().optional()
});
var UpdateFormQuestionGroupSchema = z30.object({
  title: z30.string().min(1, "Title is required").max(255, "Title must be 255 characters or less").optional(),
  description: z30.string().optional()
});
var CreateFormQuestionSchema = z30.object({
  questionType: FormQuestionTypeSchema,
  questionText: z30.string().min(1, "Question text is required").max(5e3),
  questionBody: z30.string().optional(),
  explanation: z30.string().max(5e3).optional(),
  position: z30.number().int().min(0).optional(),
  metadata: z30.record(z30.unknown()).optional(),
  isRequired: z30.boolean().optional().default(false),
  groupId: z30.string().uuid().nullable().optional(),
  profileFieldKey: ProfileFieldKeySchema.nullable().optional()
});
var UpdateFormQuestionSchema = z30.object({
  questionText: z30.string().min(1, "Question text is required").max(5e3).optional(),
  questionBody: z30.string().optional(),
  explanation: z30.string().max(5e3).optional(),
  position: z30.number().int().min(0).optional(),
  metadata: z30.record(z30.unknown()).optional(),
  isRequired: z30.boolean().optional(),
  groupId: z30.string().uuid().nullable().optional(),
  profileFieldKey: ProfileFieldKeySchema.nullable().optional()
});
var EQuestionInputType = /* @__PURE__ */ function(EQuestionInputType2) {
  EQuestionInputType2["TEXT"] = "text";
  EQuestionInputType2["EMAIL"] = "email";
  EQuestionInputType2["URL"] = "url";
  EQuestionInputType2["NUMBER"] = "number";
  EQuestionInputType2["PHONE"] = "phone";
  return EQuestionInputType2;
}({});
var QuestionInputTypeSchema = z30.nativeEnum(EQuestionInputType);
var getQuestionInputType = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["inputType"];
    if (typeof raw === "string" && Object.values(EQuestionInputType).includes(raw)) {
      return raw;
    }
  }
  return "text";
}, "getQuestionInputType");
var isShortAnswerValueValid = /* @__PURE__ */ __name((inputType, value) => {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return true;
  }
  switch (inputType) {
    case "email": {
      return z30.string().email().safeParse(trimmed).success;
    }
    case "url": {
      return z30.string().url().safeParse(trimmed).success;
    }
    case "number": {
      return !Number.isNaN(Number(trimmed));
    }
    case "phone": {
      return /^[+]?[\d\s()-]{6,20}$/.test(trimmed);
    }
    case "text":
    default: {
      return true;
    }
  }
}, "isShortAnswerValueValid");
var getAcceptButtonLabel = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["buttonLabel"];
    if (typeof raw === "string" && raw.trim().length > 0) {
      return raw;
    }
  }
  return "Accept";
}, "getAcceptButtonLabel");
var getAcceptCheckboxLabel = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["checkboxLabel"];
    if (typeof raw === "string" && raw.trim().length > 0) {
      return raw;
    }
  }
  return "I acknowledge the above";
}, "getAcceptCheckboxLabel");
var getDropdownOptions = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["options"];
    if (Array.isArray(raw)) {
      return raw.filter((o) => typeof o === "string" && o.trim().length > 0);
    }
  }
  return [];
}, "getDropdownOptions");
var EFormBlockBackground = /* @__PURE__ */ function(EFormBlockBackground2) {
  EFormBlockBackground2["NONE"] = "none";
  EFormBlockBackground2["BLUE"] = "blue";
  EFormBlockBackground2["PINK"] = "pink";
  EFormBlockBackground2["GREEN"] = "green";
  EFormBlockBackground2["PEACH"] = "peach";
  EFormBlockBackground2["YELLOW"] = "yellow";
  EFormBlockBackground2["PAUSE_REFLECT"] = "pause_reflect";
  EFormBlockBackground2["THINK_CRITICALLY"] = "think_critically";
  EFormBlockBackground2["IN_YOUR_PRACTICE"] = "in_your_practice";
  EFormBlockBackground2["TOUCHSTONE"] = "touchstone";
  EFormBlockBackground2["KEY_TERM"] = "key_term";
  EFormBlockBackground2["WATCH_NOTE"] = "watch_note";
  return EFormBlockBackground2;
}({});
var FORM_BLOCK_BACKGROUNDS = {
  ["none"]: {
    bg: "transparent",
    border: "transparent",
    bar: "transparent",
    ink: "#1a1a1a",
    label: "No background",
    defaultHeadline: ""
  },
  ["blue"]: {
    bg: "#eef5fa",
    border: "#d6e6f2",
    bar: "transparent",
    ink: "#1f5f7a",
    label: "Blue",
    defaultHeadline: ""
  },
  ["pink"]: {
    bg: "#fdeeee",
    border: "#f7dcdc",
    bar: "transparent",
    ink: "#c83a55",
    label: "Pink",
    defaultHeadline: ""
  },
  ["green"]: {
    bg: "#eef5ee",
    border: "#d9e8d9",
    bar: "transparent",
    ink: "#3d6b46",
    label: "Green",
    defaultHeadline: ""
  },
  ["peach"]: {
    bg: "#fdf1ea",
    border: "#f7ddcd",
    bar: "transparent",
    ink: "#a85a2a",
    label: "Peach",
    defaultHeadline: ""
  },
  ["yellow"]: {
    bg: "#f8fbef",
    border: "#e6efd3",
    bar: "transparent",
    ink: "#6d7a33",
    label: "Yellow",
    defaultHeadline: ""
  },
  ["pause_reflect"]: {
    bg: "#fdeef2",
    border: "#f6d9e1",
    bar: "#d63b64",
    ink: "#c22a54",
    label: "Pause & Reflect",
    defaultHeadline: "Pause & Reflect"
  },
  ["think_critically"]: {
    bg: "#f6edf3",
    border: "#e6d3e0",
    bar: "#8e3d6e",
    ink: "#8e3d6e",
    label: "Think Critically",
    defaultHeadline: "Think Critically"
  },
  ["in_your_practice"]: {
    bg: "#e9f2f1",
    border: "#cfe2e0",
    bar: "#1f6b6b",
    ink: "#1f6b6b",
    label: "In Your Practice",
    defaultHeadline: "In Your Practice"
  },
  ["touchstone"]: {
    bg: "#faf3e2",
    border: "#eee0bd",
    bar: "#a6812a",
    ink: "#8d6d1f",
    label: "Touchstone",
    defaultHeadline: "Touchstone"
  },
  ["key_term"]: {
    bg: "#f1eef2",
    border: "#ded7e1",
    bar: "#6f6377",
    ink: "#544a5b",
    label: "Key Term",
    defaultHeadline: "Key Term"
  },
  ["watch_note"]: {
    bg: "#f7edf3",
    border: "#e8d5e0",
    bar: "#8e3d6e",
    ink: "#8e3d6e",
    label: "Watch & Note",
    defaultHeadline: "Watch & Note"
  }
};
var getFormBlockTint = /* @__PURE__ */ __name((background) => {
  var _a5;
  return (_a5 = FORM_BLOCK_BACKGROUNDS[background]) != null ? _a5 : FORM_BLOCK_BACKGROUNDS["none"];
}, "getFormBlockTint");
var EFormBlockMediaLayout = /* @__PURE__ */ function(EFormBlockMediaLayout2) {
  EFormBlockMediaLayout2["BELOW"] = "below";
  EFormBlockMediaLayout2["BESIDE"] = "beside";
  return EFormBlockMediaLayout2;
}({});
var FormBlockMediaSchema = z30.object({
  /** Media-manager path, rendered through getMediaUrl like every other image. */
  url: z30.string().min(1),
  alt: z30.string().max(255).optional()
});
var FormTextBlockSchema = z30.object({
  /** Stable id so a block survives being reordered or edited in the builder. */
  id: z30.string().min(1),
  headline: z30.string().max(255).default(""),
  /** Rich HTML, sanitised at render time like every other question field. */
  body: z30.string().default(""),
  // `.catch` rather than plain `.default`: an unrecognised tint or layout should
  // degrade to the plain rendering, not fail the block's parse and silently drop
  // the admin's writing. A hand-edited form export is the realistic way in.
  background: z30.nativeEnum(EFormBlockBackground).catch("none"),
  media: FormBlockMediaSchema.optional().catch(void 0),
  mediaLayout: z30.nativeEnum(EFormBlockMediaLayout).catch("below")
});
var getTextBlocks = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["blocks"];
    if (Array.isArray(raw)) {
      return raw.flatMap((entry) => {
        const parsed = FormTextBlockSchema.safeParse(entry);
        return parsed.success ? [
          parsed.data
        ] : [];
      });
    }
  }
  return [];
}, "getTextBlocks");
var FormGradingRowSchema = z30.object({
  /** Stable id so a stored grade survives the row being relabelled or reordered. */
  id: z30.string().min(1),
  label: z30.string().min(1).max(500)
});
var DEFAULT_GRADING_SCALE = {
  min: 1,
  max: 5
};
var FormGradingScaleSchema = z30.object({
  min: z30.number().int().min(0).max(10).default(DEFAULT_GRADING_SCALE.min),
  max: z30.number().int().min(1).max(10).default(DEFAULT_GRADING_SCALE.max),
  minLabel: z30.string().max(60).optional(),
  maxLabel: z30.string().max(60).optional()
});
var getGradingRows = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const raw = metadata["rows"];
    if (Array.isArray(raw)) {
      return raw.flatMap((entry) => {
        const parsed = FormGradingRowSchema.safeParse(entry);
        return parsed.success ? [
          parsed.data
        ] : [];
      });
    }
  }
  return [];
}, "getGradingRows");
var getGradingScale = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const parsed = FormGradingScaleSchema.safeParse(metadata["scale"]);
    if (parsed.success && parsed.data.max > parsed.data.min) {
      return parsed.data;
    }
  }
  return __spreadValues({}, DEFAULT_GRADING_SCALE);
}, "getGradingScale");
var FormGradingOptOutSchema = z30.object({
  enabled: z30.boolean().default(false),
  label: z30.string().max(60).default("New to Me"),
  /** Shown in the legend under the table. */
  description: z30.string().max(200).optional()
});
var DEFAULT_GRADING_OPT_OUT = {
  enabled: false,
  label: "New to Me"
};
var getGradingOptOut = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const parsed = FormGradingOptOutSchema.safeParse(metadata["optOut"]);
    if (parsed.success) {
      return parsed.data;
    }
  }
  return __spreadValues({}, DEFAULT_GRADING_OPT_OUT);
}, "getGradingOptOut");
var FormGradingReflectionSchema = z30.object({
  title: z30.string().max(120),
  prompts: z30.array(z30.string().max(1e3)).max(10).default([])
});
var getGradingReflection = /* @__PURE__ */ __name((metadata) => {
  if (metadata && typeof metadata === "object") {
    const parsed = FormGradingReflectionSchema.safeParse(metadata["reflection"]);
    if (parsed.success && parsed.data.title.trim().length > 0 && parsed.data.prompts.length > 0) {
      return parsed.data;
    }
  }
  return null;
}, "getGradingReflection");
var getAnswerOptedOut = /* @__PURE__ */ __name((value) => {
  if (value && typeof value === "object") {
    const raw = value["optedOut"];
    if (Array.isArray(raw)) {
      return raw.filter((entry) => typeof entry === "string");
    }
  }
  return [];
}, "getAnswerOptedOut");
var getAnswerGrades = /* @__PURE__ */ __name((value) => {
  if (value && typeof value === "object") {
    const raw = value["grades"];
    if (raw && typeof raw === "object") {
      return Object.fromEntries(Object.entries(raw).filter((entry) => typeof entry[1] === "number"));
    }
  }
  return {};
}, "getAnswerGrades");
var isGradingAnswerComplete = /* @__PURE__ */ __name((metadata, value) => {
  const rows = getGradingRows(metadata);
  const grades = getAnswerGrades(value);
  const optedOut = new Set(getAnswerOptedOut(value));
  return rows.length > 0 && rows.every((row) => typeof grades[row.id] === "number" || optedOut.has(row.id));
}, "isGradingAnswerComplete");
var CreateFormOptionSchema = z30.object({
  optionText: z30.string().min(1, "Option text is required").max(1e3),
  position: z30.number().int().min(0).optional()
});
var UpdateFormOptionSchema = z30.object({
  optionText: z30.string().min(1, "Option text is required").max(1e3).optional(),
  position: z30.number().int().min(0).optional()
});
var SubmitFormAnswerSchema = z30.object({
  questionId: z30.string().uuid("Invalid question ID"),
  selectedOptionIds: z30.array(z30.string().uuid()).optional(),
  orderingSequence: z30.array(z30.string().uuid()).optional(),
  textAnswer: z30.string().max(1e4).optional(),
  fileUrls: z30.array(z30.string().max(1e3)).max(10).optional(),
  /**
  * Structured answer for question types whose value is neither a string, a set of
  * option ids, nor a file list — currently `multiple_grading`, whose value is
  * `{ grades: { [rowId]: number } }`. Stored in the `value` jsonb column.
  */
  value: z30.record(z30.unknown()).optional()
});
var SubmitFormSchema = z30.object({
  answers: z30.array(SubmitFormAnswerSchema).min(1, "At least one answer is required")
});
var SaveFormProgressSchema = z30.object({
  answers: z30.array(SubmitFormAnswerSchema)
});
var FormBaseSchema = z30.object({
  id: z30.string().uuid(),
  spaceId: z30.string().uuid(),
  title: z30.string().max(255),
  description: z30.string().nullable(),
  bannerUrl: z30.string().max(500).nullable(),
  shuffleQuestions: z30.boolean(),
  allowMultipleSubmissions: z30.boolean(),
  status: FormStatusSchema,
  formType: FormTypeSchema,
  /** Print a workbook title page as the first page of the submission PDF. */
  pdfCoverEnabled: z30.boolean(),
  /** Eyebrow line above the cover title, e.g. "Restore Your Core® · Professional Training". */
  pdfCoverKicker: z30.string().max(255).nullable(),
  /** The pill under the cover title, e.g. "Interactive Workbook". */
  pdfCoverSubtitle: z30.string().max(255).nullable(),
  /** Hands-On Practice only: the Feedback form a teacher fills in to review a submission. */
  feedbackFormId: z30.string().uuid().nullable().optional(),
  createdBy: z30.string().uuid(),
  createdAt: z30.coerce.date(),
  updatedAt: z30.coerce.date()
});
var FormQuestionGroupSchema = z30.object({
  id: z30.string().uuid(),
  formId: z30.string().uuid(),
  title: z30.string().max(255),
  description: z30.string().nullable(),
  createdAt: z30.coerce.date(),
  updatedAt: z30.coerce.date()
});
var FormAnalyticsUserSchema = z30.object({
  userId: z30.string(),
  name: z30.string().nullable(),
  displayName: z30.string().nullable(),
  email: z30.string().nullable(),
  avatar: z30.string().nullable(),
  // Extended profile fields — populated from the Supabase profile table.
  // Optional + nullable so the schema stays backward-compatible.
  firstName: z30.string().nullable().optional(),
  lastName: z30.string().nullable().optional(),
  occupation: z30.string().nullable().optional(),
  city: z30.string().nullable().optional(),
  state: z30.string().nullable().optional(),
  country: z30.string().nullable().optional(),
  timezone: z30.string().nullable().optional(),
  facebook: z30.string().nullable().optional(),
  instagram: z30.string().nullable().optional(),
  youtube: z30.string().nullable().optional(),
  twitter: z30.string().nullable().optional(),
  linkedin: z30.string().nullable().optional(),
  tiktok: z30.string().nullable().optional(),
  hasSubmitted: z30.boolean(),
  submissionCount: z30.number().int(),
  inProgressCount: z30.number().int(),
  lastSubmittedAt: z30.coerce.date().nullable(),
  latestSubmissionId: z30.string().uuid().nullable()
});
var FormAnalyticsSubmissionByDateSchema = z30.object({
  date: z30.string(),
  count: z30.number().int()
});
var FormAnalyticsSchema = z30.object({
  totalMembers: z30.number().int(),
  submittedCount: z30.number().int(),
  notSubmittedCount: z30.number().int(),
  totalSubmissions: z30.number().int(),
  inProgressSubmissions: z30.number().int(),
  users: z30.object({
    data: z30.array(FormAnalyticsUserSchema),
    pagination: z30.object({
      totalItems: z30.number().int(),
      totalPages: z30.number().int(),
      currentPage: z30.number().int(),
      perPage: z30.number().int()
    })
  }),
  submissionsByDate: z30.array(FormAnalyticsSubmissionByDateSchema)
});

// src/community-hub/form-review.ts
import { z as z31 } from "zod";
var ReviewSubmissionStatusValues = [
  "waiting",
  "in_progress",
  "reviewed",
  "rejected"
];
var ReviewSubmissionStatusSchema = z31.enum(ReviewSubmissionStatusValues);
var EReviewSubmissionStatus = ReviewSubmissionStatusSchema.enum;
var ReviewFilterModeSchema = z31.enum([
  "include",
  "exclude"
]);
var UNASSIGNED_TEACHER_ID = "unassigned";
var idListParam = /* @__PURE__ */ __name((item) => z31.union([
  z31.string(),
  z31.array(z31.string())
]).optional().transform((value) => (Array.isArray(value) ? value : (value != null ? value : "").split(",")).map((v) => v.trim()).filter(Boolean)).pipe(z31.array(item).max(100)), "idListParam");
var ReviewTimeStateValues = [
  "on_time",
  "due_soon",
  "overdue"
];
var ReviewTimeStateSchema = z31.enum(ReviewTimeStateValues);
var EReviewTimeState = ReviewTimeStateSchema.enum;
var ReviewTimingSchema = z31.object({
  windowDays: z31.coerce.number().int().min(1).max(90).default(7),
  dueSoonPercent: z31.coerce.number().int().min(1).max(500).default(50),
  overduePercent: z31.coerce.number().int().min(1).max(500).default(100),
  dueSoonAfterDays: z31.coerce.number().int().min(1).max(90).default(2),
  overdueAfterDays: z31.coerce.number().int().min(1).max(90).default(7),
  studentDueSoonDays: z31.coerce.number().int().min(1).max(90).default(7)
}).refine((t) => t.dueSoonPercent < t.overduePercent, {
  message: "Forms with a due date: the amber percent must be smaller than the red percent",
  path: [
    "dueSoonPercent"
  ]
}).refine((t) => t.dueSoonAfterDays < t.overdueAfterDays, {
  message: "Forms without a due date: the amber days must be fewer than the red days",
  path: [
    "dueSoonAfterDays"
  ]
});
var DEFAULT_REVIEW_TIMING = ReviewTimingSchema.parse({});
var ReviewDueStateValues = [
  "overdue",
  "due_soon",
  "not_due",
  "no_due_date"
];
var ReviewDueStateSchema = z31.enum(ReviewDueStateValues);
var EReviewDueState = ReviewDueStateSchema.enum;
var dateRangeParams = /* @__PURE__ */ __name((fields, fallback) => ({
  dateField: z31.enum(fields).default(fallback),
  dateFrom: z31.coerce.date().optional(),
  dateTo: z31.coerce.date().optional()
}), "dateRangeParams");
var ReviewQueueDateFieldValues = [
  "submitted",
  "reviewed",
  "rejected"
];
var ReviewMissingDateFieldValues = [
  "due",
  "started"
];
var ReviewBaseFiltersSchema = z31.object({
  search: z31.string().optional(),
  /** Modules = the sub-spaces the forms live in. */
  moduleIds: idListParam(z31.string().uuid()),
  moduleMode: ReviewFilterModeSchema.default("include"),
  formIds: idListParam(z31.string().uuid()),
  formMode: ReviewFilterModeSchema.default("include"),
  /** Managers only; ignored for a teacher, who sees only their own students. */
  teacherIds: idListParam(z31.union([
    z31.string().uuid(),
    z31.literal(UNASSIGNED_TEACHER_ID)
  ])),
  teacherMode: ReviewFilterModeSchema.default("include")
});
var ReviewQueueFiltersSchema = ReviewBaseFiltersSchema.extend(__spreadValues({
  status: z31.enum([
    ...ReviewSubmissionStatusValues,
    "all"
  ]).default("all"),
  /** Waiting and draft submissions against their review deadline. */
  reviewTime: idListParam(ReviewTimeStateSchema),
  reviewTimeMode: ReviewFilterModeSchema.default("include")
}, dateRangeParams(ReviewQueueDateFieldValues, "submitted")));
var ReviewQueueQuerySchema = ReviewQueueFiltersSchema.extend({
  page: z31.coerce.number().int().positive().default(1),
  perPage: z31.coerce.number().int().positive().max(100).default(20)
});
var ReviewFacetOptionSchema = z31.object({
  id: z31.string(),
  label: z31.string(),
  /** Form filter: the module the form lives in. */
  hint: z31.string().nullable(),
  avatar: z31.string().nullable(),
  count: z31.number().int().nonnegative()
});
var ReviewFacetsResponseSchema = z31.object({
  modules: z31.array(ReviewFacetOptionSchema),
  forms: z31.array(ReviewFacetOptionSchema),
  /** Null for a teacher: they see only their own students, so there is nothing to pick. */
  teachers: z31.array(ReviewFacetOptionSchema).nullable()
});
var ReviewQueueFacetsResponseSchema = ReviewFacetsResponseSchema.extend({
  reviewTime: z31.array(ReviewFacetOptionSchema)
});
var ReviewPersonSchema = z31.object({
  userUuid: z31.string().uuid(),
  name: z31.string(),
  email: z31.string().nullable(),
  avatar: z31.string().nullable()
});
var ReviewQueueItemSchema = z31.object({
  submissionId: z31.string().uuid(),
  formId: z31.string().uuid(),
  formTitle: z31.string(),
  /** The module (sub-space) the form lives in. */
  moduleName: z31.string().nullable(),
  student: ReviewPersonSchema,
  /** Shown to admins, who see every teacher's queue. */
  reviewer: ReviewPersonSchema.nullable(),
  status: ReviewSubmissionStatusSchema,
  submittedAt: z31.coerce.date(),
  feedbackSubmittedAt: z31.coerce.date().nullable(),
  feedbackUpdatedAt: z31.coerce.date().nullable(),
  rejectedAt: z31.coerce.date().nullable(),
  /** The form's due date in this space. */
  dueAt: z31.coerce.date().nullable(),
  /** Submitted after the due date. */
  isLate: z31.boolean(),
  /** Waiting and draft submissions only. */
  reviewTime: ReviewTimeStateSchema.nullable(),
  /** When the review becomes overdue. Waiting and draft submissions only. */
  reviewOverdueAt: z31.coerce.date().nullable()
});
var ReviewMissingCountsSchema = z31.object({
  students: z31.number().int().nonnegative(),
  forms: z31.number().int().nonnegative(),
  /** Students with at least one form past its due date. */
  overdueStudents: z31.number().int().nonnegative()
});
var ReviewQueueResponseSchema = z31.object({
  items: z31.array(ReviewQueueItemSchema),
  meta: MetaSchema,
  /** The forms configured on this sub-space, for the filter. */
  forms: z31.array(z31.object({
    id: z31.string().uuid(),
    title: z31.string()
  })),
  /** True when the requester sees every teacher's submissions (admin / content manager). */
  isManager: z31.boolean(),
  /** Per-status totals under the current form + search filters, for the status tabs. */
  counts: z31.record(z31.enum([
    ...ReviewSubmissionStatusValues,
    "all"
  ]), z31.number().int().nonnegative()),
  /** Waiting and draft submissions past their review deadline, under the same filters. */
  overdueReviews: z31.object({
    waiting: z31.number().int().nonnegative(),
    in_progress: z31.number().int().nonnegative()
  }),
  /** The "Not submitted" tile, under the same filters. */
  notSubmitted: ReviewMissingCountsSchema
});
var ReviewMissingProgressValues = [
  "not_started",
  "started",
  "rejected"
];
var ReviewMissingProgressSchema = z31.enum(ReviewMissingProgressValues);
var EReviewMissingProgress = ReviewMissingProgressSchema.enum;
var ReviewMissingFiltersSchema = ReviewBaseFiltersSchema.extend(__spreadValues({
  progress: idListParam(ReviewMissingProgressSchema),
  progressMode: ReviewFilterModeSchema.default("include"),
  due: idListParam(ReviewDueStateSchema),
  dueMode: ReviewFilterModeSchema.default("include")
}, dateRangeParams(ReviewMissingDateFieldValues, "due")));
var ReviewMissingQuerySchema = ReviewMissingFiltersSchema.extend({
  page: z31.coerce.number().int().positive().default(1),
  perPage: z31.coerce.number().int().positive().max(100).default(20)
});
var ReviewMissingFormSchema = z31.object({
  formId: z31.string().uuid(),
  formTitle: z31.string(),
  moduleName: z31.string().nullable(),
  progress: ReviewMissingProgressSchema,
  /** When the unsent draft was started. */
  startedAt: z31.coerce.date().nullable(),
  rejectedAt: z31.coerce.date().nullable(),
  dueAt: z31.coerce.date().nullable(),
  due: ReviewDueStateSchema,
  /** The last reminder this student got about this form from this space. */
  lastRemindedAt: z31.coerce.date().nullable()
});
var ReviewMissingItemSchema = z31.object({
  student: ReviewPersonSchema,
  /** The assigned teacher. Admins only see this. */
  teacher: ReviewPersonSchema.nullable(),
  /** Every form the student has not submitted, in scope of the module + form filters. */
  forms: z31.array(ReviewMissingFormSchema),
  /** The forms that count under the module + form filters — the "of N" in "3 of 4 missing". */
  formsInScope: z31.number().int().nonnegative(),
  /** The last reminder sent to this student from this space. */
  lastRemindedAt: z31.coerce.date().nullable()
});
var ReviewMissingResponseSchema = z31.object({
  items: z31.array(ReviewMissingItemSchema),
  meta: MetaSchema,
  counts: ReviewMissingCountsSchema
});
var ReviewMissingFacetsResponseSchema = ReviewFacetsResponseSchema.extend({
  progress: z31.array(ReviewFacetOptionSchema),
  due: z31.array(ReviewFacetOptionSchema)
});
var REVIEW_EXPORT_MAX_ROWS = 1e4;
var ReviewExportQuerySchema = z31.discriminatedUnion("view", [
  ReviewQueueFiltersSchema.extend({
    view: z31.literal("submissions")
  }),
  ReviewMissingFiltersSchema.extend({
    view: z31.literal("not_submitted")
  })
]);
var RejectReviewSubmissionSchema = z31.object({
  reason: z31.string().trim().min(1, "Tell the student why the submission is rejected").max(2e3, "Keep the reason under 2000 characters")
});
var AssignReviewTeacherSchema = z31.object({
  teacherUserUuid: z31.string().uuid("Pick a teacher")
});
var ReviewTeachersQuerySchema = z31.object({
  search: z31.string().optional()
});
var SpaceReviewFormsSchema = z31.object({
  forms: z31.array(z31.object({
    formId: z31.string().uuid(),
    dueAt: z31.coerce.date().nullable()
  })).max(100),
  timing: ReviewTimingSchema
});
var REVIEW_NOTE_MAX = 1e3;
var NotifyReviewSubmissionSchema = z31.object({
  recipient: z31.enum([
    "teacher",
    "student"
  ]),
  note: z31.string().trim().min(1, "Write the note").max(REVIEW_NOTE_MAX, `Keep the note under ${REVIEW_NOTE_MAX} characters`)
});
var ReviewSubmissionNoteSchema = z31.object({
  id: z31.string().uuid(),
  recipient: z31.enum([
    "teacher",
    "student"
  ]),
  to: ReviewPersonSchema,
  /** Null when the sender is no longer known. */
  from: ReviewPersonSchema.nullable(),
  note: z31.string(),
  sentAt: z31.coerce.date()
});
var REVIEW_REMINDER_COOLDOWN_HOURS = 24;
var REVIEW_REMINDER_NOTE_MAX = 500;
var ReviewReminderKindValues = [
  "teacher",
  "student",
  "teacher_note",
  "student_note"
];
var ReviewReminderKindSchema = z31.enum(ReviewReminderKindValues);
var EReviewReminderKind = ReviewReminderKindSchema.enum;
var reminderNote = z31.string().trim().max(REVIEW_REMINDER_NOTE_MAX, `Keep the note under ${REVIEW_REMINDER_NOTE_MAX} characters`).optional();
var RemindReviewTeachersSchema = z31.object({
  formIds: z31.array(z31.string().uuid()).max(100).optional(),
  reviewTime: z31.array(ReviewTimeStateSchema).max(ReviewTimeStateValues.length).default([]),
  /** On send: only these teacher + form pairs (the ones left ticked in the preview). */
  targets: z31.array(z31.object({
    teacherUserUuid: z31.string().uuid(),
    formId: z31.string().uuid()
  })).max(REVIEW_EXPORT_MAX_ROWS).optional(),
  note: reminderNote,
  dryRun: z31.boolean().default(false)
});
var RemindReviewStudentsSchema = z31.object({
  filters: ReviewMissingFiltersSchema,
  studentUserUuids: z31.array(z31.string().uuid()).max(500).optional(),
  formIds: z31.array(z31.string().uuid()).max(100).optional(),
  /** On send: only these student + form pairs of the matching ones (the ones left ticked in the preview). */
  targets: z31.array(z31.object({
    studentUserUuid: z31.string().uuid(),
    formId: z31.string().uuid()
  })).max(REVIEW_EXPORT_MAX_ROWS).optional(),
  note: reminderNote,
  dryRun: z31.boolean().default(false)
});
var ReviewReminderRecipientSchema = z31.object({
  person: ReviewPersonSchema,
  /** The one form this reminder is about. */
  form: z31.object({
    formId: z31.string().uuid(),
    formTitle: z31.string(),
    dueAt: z31.coerce.date().nullable(),
    /** Student reminders: the form against its due date. Null for a teacher reminder. */
    due: ReviewDueStateSchema.nullable(),
    /** Student reminders: where the student is on it. Null for a teacher reminder. */
    progress: ReviewMissingProgressSchema.nullable()
  }).nullable(),
  /** Teacher: submissions of this form waiting · student: 1. */
  itemCount: z31.number().int().nonnegative(),
  overdueCount: z31.number().int().nonnegative(),
  lastRemindedAt: z31.coerce.date().nullable(),
  /** Reminded (about this form, for a student) within the cooldown, so this one is not sent. */
  skipped: z31.boolean()
});
var ReviewReminderResultSchema = z31.object({
  recipients: z31.array(ReviewReminderRecipientSchema),
  /** How many got (or, on a dry run, would get) the reminder. */
  sent: z31.number().int().nonnegative(),
  skipped: z31.number().int().nonnegative(),
  /** Teacher reminders: matching submissions with no teacher, so nobody to remind. */
  withoutRecipient: z31.number().int().nonnegative()
});

// src/community-hub/notification.ts
import { z as z32 } from "zod";
var NotificationType = /* @__PURE__ */ function(NotificationType2) {
  NotificationType2["POST_REPLY"] = "post.reply";
  NotificationType2["POST_REACTION"] = "post.reaction";
  NotificationType2["COMMENT_REPLY"] = "comment.reply";
  NotificationType2["COMMENT_REACTION"] = "comment.reaction";
  NotificationType2["MENTION"] = "mention";
  NotificationType2["QUIZ_GRADED"] = "quiz.graded";
  NotificationType2["LESSON_ASSIGNED"] = "lesson.assigned";
  NotificationType2["SPACE_INVITE"] = "space.invite";
  NotificationType2["ACHIEVEMENT_EARNED"] = "achievement.earned";
  return NotificationType2;
}({});
var NotificationTypeSchema = z32.nativeEnum(NotificationType);
var UpdateNotificationPreferencesSchema = z32.object({
  notificationType: NotificationTypeSchema,
  enabledInApp: z32.boolean().optional(),
  enabledEmail: z32.boolean().optional(),
  enabledPush: z32.boolean().optional()
});
var MarkNotificationsAsReadSchema = z32.object({
  notificationIds: z32.array(z32.string().uuid("Invalid notification ID")).min(1, "At least one notification ID required")
});

// src/community-hub/permission.ts
import { z as z33 } from "zod";
var CreatePermissionSchema = z33.object({
  name: z33.string().min(1, "Name is required").max(50, "Name must be 50 characters or less"),
  description: z33.string().max(200, "Description must be 200 characters or less").optional()
});
var UpdatePermissionSchema = z33.object({
  name: z33.string().min(1, "Name is required").max(50, "Name must be 50 characters or less").optional(),
  description: z33.string().max(200, "Description must be 200 characters or less").optional()
});
var PermissionBaseSchema = z33.object({
  id: z33.number().int(),
  name: z33.string().min(1).max(50),
  description: z33.string().max(200).nullable()
});
var PermissionWithUsageSchema = PermissionBaseSchema.extend({
  usedByRoles: z33.number().int().min(0)
});

// src/community-hub/promo-banner.ts
import { z as z34 } from "zod";
var PromoBannerEntityType = /* @__PURE__ */ function(PromoBannerEntityType2) {
  PromoBannerEntityType2["SPACE"] = "space";
  PromoBannerEntityType2["SUB_SPACE"] = "sub_space";
  PromoBannerEntityType2["LESSON"] = "lesson";
  return PromoBannerEntityType2;
}({});
var PromoBannerEntityTypeSchema = z34.nativeEnum(PromoBannerEntityType);
var PromoBannerPosition = /* @__PURE__ */ function(PromoBannerPosition2) {
  PromoBannerPosition2["HEADER"] = "header";
  PromoBannerPosition2["MIDDLE"] = "middle";
  PromoBannerPosition2["FOOTER"] = "footer";
  PromoBannerPosition2["SIDEBAR"] = "sidebar";
  PromoBannerPosition2["RIGHT_BAR"] = "right_bar";
  return PromoBannerPosition2;
}({});
var PromoBannerPositionSchema = z34.nativeEnum(PromoBannerPosition);
var PromoBannerPositionLabels = {
  ["header"]: "Header",
  ["middle"]: "Middle",
  ["footer"]: "Footer",
  ["sidebar"]: "Sidebar",
  ["right_bar"]: "Right Bar"
};
var PromoBannerIconScheme = /* @__PURE__ */ function(PromoBannerIconScheme2) {
  PromoBannerIconScheme2["ROCKET"] = "rocket";
  PromoBannerIconScheme2["STAR"] = "star";
  PromoBannerIconScheme2["AWARD"] = "award";
  PromoBannerIconScheme2["ALERT"] = "alert";
  PromoBannerIconScheme2["BIT"] = "bit";
  PromoBannerIconScheme2["CALENDAR"] = "calendar";
  PromoBannerIconScheme2["CHRISTMAS"] = "christmas";
  PromoBannerIconScheme2["EMOJI"] = "emoji";
  PromoBannerIconScheme2["INFO"] = "info";
  PromoBannerIconScheme2["LIVE"] = "live";
  PromoBannerIconScheme2["MAIL"] = "mail";
  PromoBannerIconScheme2["MESSAGE"] = "message";
  PromoBannerIconScheme2["NEWS"] = "news";
  PromoBannerIconScheme2["TIMER"] = "timer";
  PromoBannerIconScheme2["UNLOCK"] = "unlock";
  return PromoBannerIconScheme2;
}({});
var PromoBannerIconSchemeSchema = z34.nativeEnum(PromoBannerIconScheme);
var PromoBannerType = /* @__PURE__ */ function(PromoBannerType2) {
  PromoBannerType2["DEFAULT"] = "default";
  PromoBannerType2["BANNER_WITH_LAUREN_IMAGE"] = "banner_with_lauren_image";
  PromoBannerType2["SIDEBAR_BANNER_WITH_LAUREN_IMAGE"] = "sidebar_banner_with_lauren_image";
  PromoBannerType2["CUSTOM"] = "custom";
  return PromoBannerType2;
}({});
var PromoBannerTypeSchema = z34.nativeEnum(PromoBannerType);
var PromoBannerTypeLabels = {
  ["default"]: "Default",
  ["banner_with_lauren_image"]: "Banner With Lauren Image",
  ["sidebar_banner_with_lauren_image"]: "Side Bar Banner With Lauren Image",
  ["custom"]: "Custom (HTML)"
};
var richTextField = /* @__PURE__ */ __name((label2, maxVisible) => z34.string().max(1e4, `${label2} content is too long`).superRefine((value, ctx) => {
  const length = visibleTextLength(value);
  if (length === 0) {
    ctx.addIssue({
      code: z34.ZodIssueCode.custom,
      message: `${label2} is required`
    });
    return;
  }
  if (maxVisible !== void 0 && length > maxVisible) {
    ctx.addIssue({
      code: z34.ZodIssueCode.custom,
      message: `${label2} must be ${maxVisible} characters or less`
    });
  }
}), "richTextField");
var optionalRichTextField = /* @__PURE__ */ __name((label2, maxVisible) => z34.string().max(1e4, `${label2} content is too long`).superRefine((value, ctx) => {
  if (maxVisible === void 0) {
    return;
  }
  const length = visibleTextLength(value);
  if (length > maxVisible) {
    ctx.addIssue({
      code: z34.ZodIssueCode.custom,
      message: `${label2} must be ${maxVisible} characters or less`
    });
  }
}), "optionalRichTextField");
var titleField = richTextField("Title", 200);
var descriptionField = z34.string().max(1e4, "Description content is too long");
var mobileTitleField = optionalRichTextField("Mobile title", 200);
var mobileDescriptionField = optionalRichTextField("Mobile description");
var isDescriptionActiveField = z34.boolean();
var isMobileDescriptionActiveField = z34.boolean();
var buttonLabelField = z34.string().max(100, "Button label must be 100 characters or less");
var buttonUrlField = z34.string().max(1e3, "Button URL is too long");
var PROMO_BANNER_CUSTOM_HTML_MAX_LENGTH = 5e4;
var customHtmlField = z34.string().max(PROMO_BANNER_CUSTOM_HTML_MAX_LENGTH, "Custom HTML is too long");
var backgroundColorField = z34.string().max(200);
var iconSchemeField = PromoBannerIconSchemeSchema;
var typeField = PromoBannerTypeSchema;
var buttonUrlValidator = z34.string().url();
var refinePromoBannerByType = /* @__PURE__ */ __name((data, ctx, isUpdate) => {
  var _a5, _b, _c, _d;
  const required = /* @__PURE__ */ __name((path, message) => ctx.addIssue({
    code: z34.ZodIssueCode.custom,
    path: [
      path
    ],
    message
  }), "required");
  const shouldCheck = /* @__PURE__ */ __name((value) => !isUpdate || value !== void 0, "shouldCheck");
  if (data.type === "custom") {
    if (shouldCheck(data.customHtml) && ((_a5 = data.customHtml) != null ? _a5 : "").trim().length === 0) {
      required("customHtml", "Custom HTML is required");
    }
    return;
  }
  if (shouldCheck(data.description) && visibleTextLength((_b = data.description) != null ? _b : "") === 0) {
    required("description", "Description is required");
  }
  if (shouldCheck(data.buttonLabel) && ((_c = data.buttonLabel) != null ? _c : "").trim().length === 0) {
    required("buttonLabel", "Button label is required");
  }
  if (shouldCheck(data.buttonUrl) && !buttonUrlValidator.safeParse((_d = data.buttonUrl) != null ? _d : "").success) {
    required("buttonUrl", "Button URL must be a valid URL");
  }
}, "refinePromoBannerByType");
var CreatePromoBannerSchema = z34.object({
  type: typeField.optional().default("default"),
  title: titleField,
  description: descriptionField.optional().default(""),
  mobileTitle: mobileTitleField.nullish(),
  mobileDescription: mobileDescriptionField.nullish(),
  isDescriptionActive: isDescriptionActiveField.optional().default(true),
  isMobileDescriptionActive: isMobileDescriptionActiveField.optional().default(true),
  buttonLabel: buttonLabelField.optional().default(""),
  buttonUrl: buttonUrlField.optional().default(""),
  backgroundColor: backgroundColorField.optional(),
  iconScheme: iconSchemeField.optional(),
  customHtml: customHtmlField.nullish(),
  isActive: z34.boolean().optional().default(true)
}).superRefine((data, ctx) => refinePromoBannerByType(data, ctx, false));
var UpdatePromoBannerSchema = z34.object({
  type: typeField.optional(),
  title: titleField.optional(),
  description: descriptionField.optional(),
  mobileTitle: mobileTitleField.nullish(),
  mobileDescription: mobileDescriptionField.nullish(),
  isDescriptionActive: isDescriptionActiveField.optional(),
  isMobileDescriptionActive: isMobileDescriptionActiveField.optional(),
  buttonLabel: buttonLabelField.optional(),
  buttonUrl: buttonUrlField.optional(),
  backgroundColor: backgroundColorField.optional(),
  iconScheme: iconSchemeField.optional(),
  customHtml: customHtmlField.nullish(),
  isActive: z34.boolean().optional()
}).superRefine((data, ctx) => refinePromoBannerByType(data, ctx, true));
var TogglePromoBannerSchema = z34.object({
  isActive: z34.boolean()
});
var PromoBannerPlacementSchema = z34.object({
  spaceId: z34.string().uuid().nullable(),
  lessonId: z34.string().uuid().nullable(),
  displayPosition: PromoBannerPositionSchema
});
var PromoBannerBaseSchema = z34.object({
  id: z34.string().uuid(),
  type: PromoBannerTypeSchema,
  title: z34.string(),
  description: z34.string(),
  mobileTitle: z34.string().nullable(),
  mobileDescription: z34.string().nullable(),
  isDescriptionActive: z34.boolean(),
  isMobileDescriptionActive: z34.boolean(),
  buttonLabel: z34.string(),
  buttonUrl: z34.string(),
  backgroundColor: z34.string().nullable(),
  iconScheme: iconSchemeField,
  /** Admin-authored markup for the `custom` type; null for every other type. */
  customHtml: z34.string().nullable(),
  isActive: z34.boolean(),
  placements: z34.array(PromoBannerPlacementSchema),
  createdAt: z34.coerce.date(),
  updatedAt: z34.coerce.date()
});
var PromoBannerForEntitySchema = PromoBannerBaseSchema.extend({
  displayPosition: PromoBannerPositionSchema
});
var AssignPromoBannerSchema = z34.object({
  bannerId: z34.string().uuid(),
  entityType: PromoBannerEntityTypeSchema,
  entityId: z34.string().uuid(),
  position: PromoBannerPositionSchema
});
var PromoBannerEntityQuerySchema = z34.object({
  entityType: PromoBannerEntityTypeSchema,
  entityId: z34.string().uuid()
});
var PromoBannerEntityTypeLabels = {
  ["space"]: "Space",
  ["sub_space"]: "Sub Space",
  ["lesson"]: "Lesson"
};
var PromoBannerPlacementInfoSchema = z34.object({
  entityId: z34.string().uuid(),
  entityType: PromoBannerEntityTypeSchema.nullable(),
  entityName: z34.string().nullable(),
  /** Root (top-level) space the placement lives under; null when unresolvable (deleted). */
  parentSpaceId: z34.string().uuid().nullable(),
  parentSpaceName: z34.string().nullable(),
  displayPosition: PromoBannerPositionSchema,
  assignedAt: z34.coerce.date()
});
var PromoBannerAnalyticsSchema = z34.object({
  bannerId: z34.string().uuid(),
  totalPlacements: z34.number(),
  placements: z34.array(PromoBannerPlacementInfoSchema)
});

// src/community-hub/role.ts
import { z as z35 } from "zod";
var CreateRoleSchema = z35.object({
  name: z35.string().min(1, "Name is required").max(50, "Name must be 50 characters or less"),
  description: z35.string().max(200, "Description must be 200 characters or less").optional()
});
var DuplicateRoleSchema = CreateRoleSchema;
var UpdateRoleSchema = z35.object({
  name: z35.string().min(1, "Name is required").max(50, "Name must be 50 characters or less").optional(),
  description: z35.string().max(200, "Description must be 200 characters or less").optional()
});
var AddPermissionToRoleSchema = z35.object({
  permissionId: z35.number().int().positive("Invalid permission ID")
});
var RoleBaseSchema = z35.object({
  id: z35.number().int(),
  name: z35.string().min(1).max(50),
  description: z35.string().max(200).nullable(),
  is_system: z35.boolean()
});
var RoleWithPermissionsSchema = RoleBaseSchema.extend({
  permissions: z35.array(z35.object({
    id: z35.number().int(),
    name: z35.string(),
    description: z35.string().nullable()
  }))
});
var RoleAppUsageSchema = z35.object({
  app: z35.string(),
  userCount: z35.number().int().nonnegative()
});
var RoleAppUsageMapSchema = z35.record(z35.string(), z35.array(RoleAppUsageSchema));
var RoleUserSchema = z35.object({
  userId: z35.string(),
  app: z35.string(),
  grantedAt: z35.coerce.date(),
  name: z35.string().nullable(),
  displayName: z35.string().nullable(),
  email: z35.string().nullable(),
  avatar: z35.string().nullable()
});
var RoleUsersPageSchema = z35.object({
  data: z35.array(RoleUserSchema),
  pagination: z35.object({
    totalItems: z35.number().int().nonnegative(),
    totalPages: z35.number().int().nonnegative(),
    currentPage: z35.number().int().positive(),
    perPage: z35.number().int().positive()
  })
});

// src/community-hub/slug-resolver.ts
import { z as z36 } from "zod";
var ResolvedSlugNodeSchema = z36.object({
  id: z36.string().uuid(),
  slug: z36.string(),
  name: z36.string()
});
var ForwardResolutionSchema = z36.object({
  program: ResolvedSlugNodeSchema,
  /** `spaceType` lets the module route branch (content module vs. analytics sub-space). */
  module: ResolvedSlugNodeSchema.extend({
    spaceType: SpaceTypeSchema.optional()
  }).optional(),
  lesson: ResolvedSlugNodeSchema.optional(),
  item: ResolvedSlugNodeSchema.extend({
    blockType: ContentBlockTypeSchema
  }).optional()
});
var SlugPathSchema = z36.object({
  programSlug: z36.string(),
  moduleSlug: z36.string().optional(),
  lessonSlug: z36.string().optional(),
  itemSlug: z36.string().optional(),
  blockType: ContentBlockTypeSchema.optional()
});

// src/community-hub/space-participants.ts
import { z as z37 } from "zod";
var SpaceParticipantUserSchema = z37.object({
  userUuid: z37.string().uuid(),
  name: z37.string(),
  email: z37.string().nullable(),
  avatar: z37.string().nullable()
});
var SpaceTeacherSchema = SpaceParticipantUserSchema.extend({
  studentCount: z37.number().int().nonnegative()
});
var SpaceTeachersResponseSchema = z37.object({
  items: z37.array(SpaceTeacherSchema),
  /** Students holding a student permission with no teacher yet. */
  unassignedStudentCount: z37.number().int().nonnegative(),
  /** False until the program has both teacher and student permissions configured. */
  isConfigured: z37.boolean()
});
var SpaceTeachersQuerySchema = z37.object({
  search: z37.string().optional()
});
var SpaceParticipantCandidatesQuerySchema = z37.object({
  role: SpaceParticipantRoleSchema,
  search: z37.string().optional(),
  limit: z37.coerce.number().int().positive().max(100).default(30)
});
var SpaceParticipantCandidateSchema = SpaceParticipantUserSchema.extend({
  /** Students only: the teacher they are assigned to now, if any. */
  teacher: SpaceParticipantUserSchema.nullable()
});
var SpaceTeacherStudentsQuerySchema = z37.object({
  page: z37.coerce.number().int().positive().default(1),
  perPage: z37.coerce.number().int().positive().max(200).default(50),
  search: z37.string().optional()
});
var SpaceTeacherStudentSchema = SpaceParticipantUserSchema.extend({
  assignedAt: z37.coerce.date()
});
var SpaceTeacherStudentsResponseSchema = z37.object({
  items: z37.array(SpaceTeacherStudentSchema),
  meta: MetaSchema
});
var StudentTeacherStatusSchema = z37.enum([
  "any",
  "unassigned",
  "assigned"
]);
var intListParam = z37.union([
  z37.string(),
  z37.array(z37.string())
]).optional().transform((value) => (Array.isArray(value) ? value : (value != null ? value : "").split(",")).map((v) => v.trim()).filter(Boolean).map(Number)).pipe(z37.array(z37.number().int().positive()).max(50));
var SpaceStudentsQuerySchema = z37.object({
  search: z37.string().optional(),
  teacherStatus: StudentTeacherStatusSchema.default("any"),
  /** User groups of the program's app. */
  userGroupIds: intListParam,
  userGroupMode: z37.enum([
    "include",
    "exclude"
  ]).default("include"),
  page: z37.coerce.number().int().positive().default(1),
  perPage: z37.coerce.number().int().positive().max(100).default(50),
  /** Return every matching student id instead of a page — for "select all matching". */
  idsOnly: z37.enum([
    "true",
    "false"
  ]).optional().transform((v) => v === "true")
});
var SpaceStudentSchema = SpaceParticipantCandidateSchema.extend({
  /** The program-app user groups the student is in. */
  userGroups: z37.array(z37.object({
    id: z37.number().int(),
    name: z37.string()
  }))
});
var SpaceStudentsResponseSchema = z37.object({
  items: z37.array(SpaceStudentSchema),
  meta: MetaSchema
});
var SpaceStudentIdsResponseSchema = z37.object({
  /** With each student's current teacher, so the dialog can say who will be moved. */
  students: z37.array(z37.object({
    userUuid: z37.string().uuid(),
    teacherUserUuid: z37.string().uuid().nullable()
  })),
  total: z37.number().int().nonnegative(),
  /** True when more students match than one assign call takes. */
  truncated: z37.boolean()
});
var SpaceUserGroupOptionSchema = z37.object({
  id: z37.number().int(),
  name: z37.string(),
  studentCount: z37.number().int().nonnegative()
});
var ASSIGN_STUDENTS_MAX = 500;
var AssignTeacherStudentsSchema = z37.object({
  studentUserUuids: z37.array(z37.string().uuid()).min(1, "Pick at least one student").max(ASSIGN_STUDENTS_MAX)
});

// src/community-hub/terms.ts
import { z as z38 } from "zod";
var TermsBaseSchema = z38.object({
  id: z38.string().uuid(),
  name: z38.string().min(1).max(150),
  version: z38.string().min(1).max(100),
  heading: z38.string().max(150).nullable().optional(),
  body: z38.string().min(1),
  termsUrl: z38.string().url().nullable().optional(),
  createdAt: z38.coerce.date(),
  updatedAt: z38.coerce.date()
});
var optionalUrlField = z38.string().max(500).optional().nullable().transform((value) => value && value.length > 0 ? value : void 0).pipe(z38.string().url("Invalid URL").optional());
var CreateTermsSchema = z38.object({
  name: z38.string().min(1, "Name is required").max(150),
  version: z38.string().min(1, "Version is required").max(100),
  heading: z38.string().max(150).optional(),
  body: z38.string().min(1, "Body is required"),
  termsUrl: optionalUrlField
});
var UpdateTermsSchema = z38.object({
  name: z38.string().min(1).max(150).optional(),
  version: z38.string().min(1).max(100).optional(),
  heading: z38.string().max(150).nullable().optional(),
  body: z38.string().min(1).optional(),
  termsUrl: optionalUrlField
});
var TermsAcceptanceResponseSchema = z38.object({
  requiresAcceptance: z38.boolean(),
  accepted: z38.boolean(),
  acceptedVersion: z38.string().nullable(),
  acceptedAt: z38.coerce.date().nullable(),
  terms: TermsBaseSchema.nullable()
});
var AcceptSpaceTermsSchema = z38.object({
  version: z38.string().min(1)
});

// src/community-hub/user.ts
import { z as z39 } from "zod";
var UserResponseSchema = z39.object({
  id: z39.string().uuid(),
  email: z39.string().email(),
  firstName: z39.string(),
  lastName: z39.string(),
  displayName: z39.string().optional().nullable(),
  avatar: z39.string().optional().nullable(),
  createdAt: z39.coerce.date()
});
var UpdateUserSchema = z39.object({
  email: z39.string().email("Invalid email address").optional(),
  password: z39.string().min(8, "Password must be at least 8 characters").optional(),
  firstName: z39.string().min(1, "First name is required").max(100).optional(),
  lastName: z39.string().min(1, "Last name is required").max(100).optional(),
  displayName: z39.string().max(200).optional(),
  avatar: z39.string().url("Invalid avatar URL").optional().or(z39.literal("")),
  app: z39.string().min(1, "App is required").optional(),
  roleId: z39.number().int().positive("Role is required").optional()
});

// src/community-hub/user-group.ts
import { z as z40 } from "zod";
var UserGroupStatus = /* @__PURE__ */ function(UserGroupStatus2) {
  UserGroupStatus2["ACTIVE"] = "active";
  UserGroupStatus2["INACTIVE"] = "inactive";
  return UserGroupStatus2;
}({});
var UserGroupStatusSchema = z40.nativeEnum(UserGroupStatus);
var CreateUserGroupSchema = z40.object({
  name: z40.string().min(1, "Name is required").max(100, "Name must be 100 characters or less"),
  /**
  * Free-text note explaining what the group is for, shown in the admin listing so
  * an admin can tell two similarly named groups apart. Empty is stored as NULL.
  */
  description: z40.string().max(500, "Description must be 500 characters or less").optional(),
  /**
  * Apps this group belongs to (`apps.app` slugs). Drives which groups show up in
  * the admin Users listing once that list is filtered by app. Empty = unmapped,
  * so the group only ever shows on the unfiltered listing.
  */
  apps: z40.array(z40.string().min(1)).default([])
});
var UpdateUserGroupSchema = z40.object({
  name: z40.string().min(1, "Name is required").max(100, "Name must be 100 characters or less").optional(),
  /** Omitted = description left untouched; an empty string clears it back to NULL. */
  description: z40.string().max(500, "Description must be 500 characters or less").optional(),
  /** Full replacement of the group's app mapping. Omitted = mapping left untouched. */
  apps: z40.array(z40.string().min(1)).optional()
});
var AddUserGroupMemberSchema = z40.object({
  userId: z40.string().uuid("Invalid user ID")
});
var UserGroupBaseSchema = z40.object({
  id: z40.number().int(),
  name: z40.string().min(1).max(100),
  /** Free-text note explaining what the group is for. NULL when never set or cleared. */
  description: z40.string().nullable().optional(),
  status: z40.string().max(20).optional(),
  /** App slugs this group is mapped to, from `user_group_apps`. */
  apps: z40.array(z40.string()).optional(),
  createdBy: z40.string().uuid().optional().nullable(),
  createdAt: z40.coerce.date(),
  updatedAt: z40.coerce.date().optional()
});
var UserGroupMemberBaseSchema = z40.object({
  id: z40.number().int(),
  userGroupId: z40.number().int(),
  userId: z40.string().uuid(),
  createdAt: z40.coerce.date()
});
var GrantUserGroupAccessSchema = z40.object({
  productId: z40.number().int(),
  variationId: z40.number().int().optional(),
  reason: z40.string().min(1)
});
var GrantUserGroupAccessByAppSchema = z40.object({
  app: z40.string().min(1),
  roleId: z40.number().int().optional(),
  reason: z40.string().min(1)
});
var GrantUserGroupAccessResultSchema = z40.object({
  totalMembers: z40.number().int().nonnegative(),
  usersUpdated: z40.number().int().nonnegative(),
  usersSkipped: z40.number().int().nonnegative(),
  message: z40.string()
});
var UserGroupGrantJobStatusSchema = z40.enum([
  "pending",
  "running",
  "completed",
  "failed"
]);
var UserGroupGrantResultStatusSchema = z40.enum([
  "granted",
  "updated",
  "already",
  "failed"
]);
var UserGroupGrantResultItemSchema = z40.object({
  userId: z40.string(),
  email: z40.string().nullable().optional(),
  name: z40.string().nullable().optional(),
  status: UserGroupGrantResultStatusSchema,
  detail: z40.string()
});
var UserGroupGrantJobSchema = z40.object({
  id: z40.string().uuid(),
  userGroupId: z40.number().int(),
  grantType: z40.enum([
    "product",
    "app"
  ]),
  target: z40.record(z40.string(), z40.unknown()),
  reason: z40.string().nullable(),
  status: UserGroupGrantJobStatusSchema,
  totalMembers: z40.number().int().nonnegative(),
  processedCount: z40.number().int().nonnegative(),
  grantedCount: z40.number().int().nonnegative(),
  updatedCount: z40.number().int().nonnegative(),
  alreadyCount: z40.number().int().nonnegative(),
  failedCount: z40.number().int().nonnegative(),
  error: z40.string().nullable(),
  createdBy: z40.string().nullable(),
  createdByName: z40.string().nullable().optional(),
  createdAt: z40.coerce.date(),
  updatedAt: z40.coerce.date().nullable().optional()
});
var UserGroupGrantPreviewAppSchema = z40.object({
  app: z40.string(),
  roleId: z40.number().int().nullable(),
  roleName: z40.string().nullable(),
  alreadyHave: z40.number().int().nonnegative(),
  willUpdate: z40.number().int().nonnegative(),
  willGrant: z40.number().int().nonnegative()
});
var UserGroupGrantPreviewSchema = z40.object({
  totalMembers: z40.number().int().nonnegative(),
  apps: z40.array(UserGroupGrantPreviewAppSchema)
});
var EUserGroupImportSource = /* @__PURE__ */ function(EUserGroupImportSource2) {
  EUserGroupImportSource2["ACTIVE_CAMPAIGN_TAG"] = "active_campaign_tag";
  EUserGroupImportSource2["APP_ACCESS"] = "app_access";
  EUserGroupImportSource2["CSV"] = "csv";
  EUserGroupImportSource2["EMAIL_LIST"] = "email_list";
  EUserGroupImportSource2["USER_GROUP"] = "user_group";
  return EUserGroupImportSource2;
}({});
var UserGroupImportSourceSchema = z40.nativeEnum(EUserGroupImportSource);
var UserGroupImportModeSchema = z40.enum([
  "append",
  "replace",
  "remove"
]);
var ActiveCampaignTagConfigSchema = z40.object({
  tagId: z40.string().min(1, "Tag is required"),
  tagName: z40.string().min(1)
});
var ActiveCampaignTagSchema = z40.object({
  id: z40.string(),
  name: z40.string()
});
var AppAccessConfigSchema = z40.object({
  app: z40.string().min(1, "App is required"),
  roleId: z40.number().int().optional(),
  roleName: z40.string().optional()
});
var EmailListConfigSchema = z40.object({
  emails: z40.array(z40.string()).min(1, "At least one email is required").max(5e4)
});
var UserGroupSourceConfigSchema = z40.object({
  sourceUserGroupId: z40.number().int(),
  sourceUserGroupName: z40.string().optional()
});
var UserGroupImportRequestSchema = z40.object({
  source: UserGroupImportSourceSchema,
  sourceConfig: z40.record(z40.string(), z40.unknown()),
  mode: UserGroupImportModeSchema
});
var UserGroupImportPreviewSchema = z40.object({
  sourceTotal: z40.number().int().nonnegative(),
  currentMemberCount: z40.number().int().nonnegative(),
  mode: UserGroupImportModeSchema
});
var UserGroupImportJobStatusSchema = z40.enum([
  "pending",
  "running",
  "completed",
  "failed"
]);
var UserGroupImportJobSchema = z40.object({
  id: z40.string().uuid(),
  userGroupId: z40.number().int(),
  source: UserGroupImportSourceSchema,
  sourceConfig: z40.record(z40.string(), z40.unknown()),
  mode: UserGroupImportModeSchema,
  status: UserGroupImportJobStatusSchema,
  sourceTotal: z40.number().int().nonnegative(),
  addedCount: z40.number().int().nonnegative(),
  skippedCount: z40.number().int().nonnegative(),
  removedCount: z40.number().int().nonnegative(),
  notFoundCount: z40.number().int().nonnegative(),
  error: z40.string().nullable(),
  createdBy: z40.string().nullable(),
  createdByName: z40.string().nullable().optional(),
  createdAt: z40.coerce.date(),
  updatedAt: z40.coerce.date().nullable().optional()
});

// src/community-hub/widgets.ts
import { z as z41 } from "zod";
var TrendingTagSchema = z41.object({
  value: z41.string(),
  label: z41.string(),
  count: z41.number().int()
});
var TrendingTagsResponseSchema = z41.object({
  tags: z41.array(TrendingTagSchema)
});
var CommunityStatsSchema = z41.object({
  totalMembers: z41.number().int(),
  postsThisMonth: z41.number().int()
});
var TopContributorSchema = z41.object({
  id: z41.string(),
  name: z41.string(),
  avatar: z41.string().nullable(),
  replyCount: z41.number().int()
});
var TopContributorsResponseSchema = z41.object({
  contributors: z41.array(TopContributorSchema)
});

// src/content/base.ts
import { array as array4, coerce as coerce8, lazy, object as object12, string as string12, union as union2, z as z53 } from "zod";

// src/instructor/base.ts
import { coerce as coerce5, object as object7, string as string7, z as z44 } from "zod";

// src/instructor/instructor-type.enum.ts
import { z as z42 } from "zod";
var InstructorTypeEnumValues = [
  "REGULAR",
  "GUEST"
];
var InstructorTypeEnumObj = z42.enum(InstructorTypeEnumValues);
var InstructorTypeEnum = InstructorTypeEnumObj.enum;

// src/instructor/media-type.enum.ts
import { z as z43 } from "zod";
var MediaTypeEnumValues = [
  "instagram",
  "facebook",
  "linkedin",
  "twitter",
  "website",
  "youtube",
  "tiktok"
];
var MediaTypeEnumObj = z43.enum(MediaTypeEnumValues);
var MediaTypeEnum = MediaTypeEnumObj.enum;

// src/instructor/base.ts
var SocialMedia = object7({
  mediaType: MediaTypeEnumObj,
  url: string7().url()
});
var ProfilePicture = object7({
  potrait: string7(),
  landscape: string7(),
  square: string7()
});
var InstructorProfilePictureSchema = object7({
  potrait: string7().url().nullable(),
  landscape: string7().url().nullable(),
  square: string7().url().nullable()
}).optional();
var Instructor = object7({
  id: coerce5.string(),
  firstName: string7(),
  lastName: string7(),
  email: string7().email().optional().nullable(),
  isActive: coerce5.boolean(),
  rycProfile: string7().nullable(),
  slug: string7().optional(),
  createdAt: coerce5.string(),
  updatedAt: coerce5.string(),
  profilePicture: InstructorProfilePictureSchema,
  socialMedia: SocialMedia.array().optional().nullable(),
  strongPoints: string7().array().optional().nullable(),
  role: string7().optional(),
  location: string7().optional(),
  bio: string7().optional(),
  /** Bio shown on public pages; `bio` stays the internal/members bio. */
  publicBio: string7().optional().nullable(),
  /** Role shown on public pages; falls back to `role` when empty. */
  publicRole: string7().optional().nullable(),
  type: InstructorTypeEnumObj.optional(),
  affiliateUrl: string7().optional().nullable(),
  userId: string7().optional().nullable()
});
var CreateInstructorSchema = object7({
  firstName: string7().trim().min(1, "First name is required"),
  lastName: string7().trim().min(1, "Last name is required"),
  // Generated from the name on the server when left empty.
  slug: string7().trim().optional(),
  email: string7().trim().email("Enter a valid email").optional().nullable().or(z44.literal("")),
  bio: string7().default(""),
  publicBio: string7().default(""),
  publicRole: string7().trim().default(""),
  role: string7().trim().default(""),
  location: string7().trim().default(""),
  type: InstructorTypeEnumObj.default("REGULAR"),
  isActive: z44.boolean().default(true),
  rycProfile: string7().trim().optional().nullable(),
  affiliateUrl: string7().trim().optional().nullable(),
  userId: string7().trim().optional().nullable(),
  strongPoints: string7().trim().min(1).array().default([]),
  profilePicture: ProfilePicture.default({
    potrait: "",
    landscape: "",
    square: ""
  }),
  socialMedia: SocialMedia.array().default([])
});
var UpdateInstructorSchema = CreateInstructorSchema.partial();
var PublicInstructor = Instructor.omit({
  email: true,
  userId: true
});
var InstructorAuthorSchema = object7({
  /** Null only for an instructor requested explicitly via `alsoIds` who has no linked member account. */
  userId: string7().nullable(),
  firstName: string7(),
  lastName: string7(),
  slug: string7().optional(),
  role: string7().optional(),
  avatar: string7().nullable(),
  /** The instructor's bio, for the article page's author card. */
  bio: string7().nullable(),
  /** The portrait-crop profile picture, for the author card; `avatar` is the square. */
  portrait: string7().nullable(),
  affiliateUrl: string7().nullable()
});
var InstructorRequestSchema = object7({
  type: InstructorTypeEnumObj.optional()
});
var InstructorsByIdsRequestSchema = object7({
  ids: coerce5.string().array().min(1)
});

// src/ryc/content/meta.ts
import { boolean as boolean3, coerce as coerce6, object as object9, string as string9, z as z49 } from "zod";

// src/content/category.enum.ts
import { z as z45 } from "zod";
var CategoryEnumValues = [
  "CARDIO",
  "STRENGTH",
  "FLOW",
  "RESTORE"
];
var CategoryEnumObj = z45.enum(CategoryEnumValues);
var CategoryEnum = CategoryEnumObj.enum;
var AddonCategoryEnumValues = [
  "INTRODUCTION",
  "EXERCISES",
  "WORKOUT",
  "FOUNDATION",
  "EDUCATIONAL"
];
var AddonCategoryEnumObj = z45.enum(AddonCategoryEnumValues);
var AddonCategoryEnum = AddonCategoryEnumObj.enum;
var AddonCategoryLabels = {
  INTRODUCTION: "Introduction",
  EXERCISES: "Exercises",
  WORKOUT: "Workout",
  FOUNDATION: "Foundation",
  EDUCATIONAL: "Educational"
};

// src/ryc/step/tier.ts
import { z as z46 } from "zod";
var TierValues = [
  1,
  2,
  3
];
var TiersEnumObject = z46.union([
  z46.literal(1),
  z46.literal(2),
  z46.literal(3)
]);

// src/ryc/content/category.ts
import { date, number as number4, object as object8, string as string8 } from "zod";
var RYCContentCategorySchema = object8({
  id: number4(),
  name: string8(),
  createdAt: string8().or(date()),
  updatedAt: string8().or(date())
});
var RYCContentCategoryResponseSchema = RYCContentCategorySchema.array();

// src/ryc/content/series.enum.ts
import { z as z47 } from "zod";
var RYCContentMetaSeriesEnumValues = [
  "Core",
  "Flow",
  "Standing",
  "Express",
  "Chair",
  "Fusion",
  "Scaled"
];
var RYCContentMetaSeriesEnumObject = z47.enum(RYCContentMetaSeriesEnumValues);
var ERYCContentMetaSeries = RYCContentMetaSeriesEnumObject.enum;

// src/ryc/content/type.enum.ts
import { z as z48 } from "zod";
var RYCContentMeTypeEnumValues = [
  "WORKOUT",
  "Educational",
  "Addon"
];
var RYCContentMetaTypeEnumObject = z48.enum(RYCContentMeTypeEnumValues);
var ERYCContentMetaType = RYCContentMetaTypeEnumObject.enum;

// src/ryc/content/meta.ts
var RYCContentMetaInfromationSchema = object9({
  tiers: TiersEnumObject.array().optional().default([]),
  series: RYCContentMetaSeriesEnumObject.nullable().optional(),
  stage: coerce6.number().nullable().optional(),
  type: RYCContentMetaTypeEnumObject.optional(),
  isRegular: coerce6.boolean().optional().default(false),
  isSupportive: coerce6.boolean().optional().default(false),
  category: CategoryEnumObj,
  categories: RYCContentCategorySchema.array().optional().default([]),
  pdfLink: string9().optional().nullable(),
  hasPdfAttachment: boolean3().optional()
});
var RYCContentMetaInformationBaseSchema = RYCContentMetaInfromationSchema.extend({
  id: coerce6.string().optional(),
  contentId: coerce6.string().optional(),
  createdAt: coerce6.string().or(z49.date()).optional(),
  updatedAt: coerce6.string().or(z49.date()).optional()
});

// src/content/content-type.enum.ts
import { z as z50 } from "zod";
var ContentTypeEnumValues = [
  "DOCUMENT",
  "VIDEO",
  "PDF",
  "IMAGE",
  "EVENT"
];
var ContentTypeEnumObj = z50.enum(ContentTypeEnumValues);
var ContentTypeEnum = ContentTypeEnumObj.enum;

// src/content/equipment.ts
import { number as number5, object as object10, string as string10 } from "zod";
var EquipmentIconSchema = string10().max(2e4, "Icon SVG is too large (max 20000 characters)").refine((value) => value.trim() === "" || /<svg[\s>]/i.test(value), "Icon must be valid SVG markup starting with <svg>");
var Equipment = object10({
  id: number5(),
  name: string10(),
  slug: string10(),
  icon: string10().nullable().optional()
});
var CreateEquipmentRequest = object10({
  name: string10().min(1, "name is required"),
  slug: string10().regex(SLUG_PATTERN, "Slug must contain only lowercase letters (a\u2013z), numbers, and hyphens, and cannot start or end with a hyphen (e.g. barbell-curl)"),
  icon: EquipmentIconSchema.nullable().optional()
});
var UpdateEquipmentRequest = CreateEquipmentRequest.partial();

// src/content/rating.ts
import { coerce as coerce7, object as object11, string as string11, z as z51 } from "zod";
var IndicateorsEnumValues = [
  "difficulty",
  "intensity",
  "nerdiness",
  "awesomeness"
];
var IndicatorsEnumObj = z51.enum(IndicateorsEnumValues);
var IndicatorEnum = IndicatorsEnumObj.enum;
var RatingIndicator = object11({
  [IndicatorEnum.difficulty]: coerce7.number(),
  [IndicatorEnum.intensity]: coerce7.number(),
  [IndicatorEnum.nerdiness]: coerce7.number(),
  [IndicatorEnum.awesomeness]: coerce7.number()
});
var ContentRating = object11({
  contentId: string11(),
  rating: RatingIndicator
});
var ContentRatingResponse = object11({
  contentId: string11(),
  userRating: RatingIndicator,
  averageRating: RatingIndicator
});
var RateContentSchema = object11({
  userId: string11(),
  contentId: string11(),
  ratings: RatingIndicator
});
var GetContentRatingsSchema = RateContentSchema.omit({
  ratings: true
});

// src/content/status.enum.ts
import { z as z52 } from "zod";
var StatusEnumValues = [
  "DRAFT",
  "PUBLISHED",
  "TRASH"
];
var StatusEnumObj = z52.enum(StatusEnumValues);
var StatusEnum = StatusEnumObj.enum;

// src/content/base.ts
var VimeoVideo = object12({
  vimeoVideoId: string12().min(1, "Vimeo Video Id is required"),
  bannerUrl2x: string12(),
  duration: coerce8.number().min(1, "duration is required"),
  description: string12().nullable()
});
var VimeoVideoInput = VimeoVideo.extend({
  duration: coerce8.number().min(0).optional()
});
var TrashContentVimeoVideo = object12({
  bannerUrl2x: string12(),
  duration: coerce8.number(),
  description: string12()
});
var CommonContentFields = object12({
  id: string12(),
  name: string12().min(3, "name is required"),
  category: lazy(() => CategoryEnumObj.or(AddonCategoryEnumObj)),
  instructor: lazy(() => Instructor),
  createdAt: coerce8.string(),
  updatedAt: coerce8.string(),
  watchedDate: coerce8.string().optional(),
  meta: lazy(() => RYCContentMetaInformationBaseSchema.partial().optional())
});
var BareContent = CommonContentFields.extend({
  type: lazy(() => ContentTypeEnumObj),
  status: StatusEnumObj,
  video: lazy(() => VimeoVideo),
  isAllowComment: coerce8.boolean().default(false),
  equipments: lazy(() => Equipment.array()),
  publishedDate: z53.union([
    z53.string(),
    z53.date(),
    CustomLuxonDateSchema
  ]),
  averageRating: lazy(() => RatingIndicator),
  isNew: coerce8.boolean().default(false).optional(),
  favorite: coerce8.boolean().default(false).optional(),
  instructorId: string12(),
  // this is needed for for react rendering. id is not unique in watch history response.
  uniqueId: string12().optional(),
  createdAt: coerce8.date(),
  updatedAt: coerce8.date(),
  meta: lazy(() => RYCContentMetaInformationBaseSchema.partial().optional())
});
var Content = BareContent.extend({
  parentPlaylistsIds: string12().array().default([]).optional(),
  userHasLeftRating: coerce8.boolean().default(false).optional(),
  instructor: Instructor
});
var TrashContentSchema = CommonContentFields.extend({
  status: z53.literal(StatusEnum.TRASH),
  video: lazy(() => TrashContentVimeoVideo)
});
var AllStatusContentSchema = Content.omit({
  status: true
}).extend({
  status: lazy(() => StatusEnumObj)
});
var ContentWithRatingFlagSchema = AllStatusContentSchema.extend({
  createdAt: coerce8.date(),
  updatedAt: coerce8.date(),
  publishedDate: z53.union([
    z53.string(),
    z53.date()
  ]).optional().nullable(),
  instructor: Instructor.extend({
    id: z53.union([
      coerce8.string(),
      coerce8.number()
    ]),
    createdAt: coerce8.date(),
    updatedAt: coerce8.date()
  }),
  userHasLeftRating: coerce8.boolean()
});
var ContentFindAllResponseSchema = object12({
  items: ContentWithRatingFlagSchema.array(),
  meta: object12({
    page: coerce8.number(),
    perPage: coerce8.number(),
    total: coerce8.number(),
    totalPages: coerce8.number()
  })
});
var ContentAndTrashContentUnion = z53.union([
  Content,
  TrashContentSchema
]);
var ContentWithWatchedDate = Content.extend({
  watchedDate: string12().or(CustomLuxonDateSchema).optional()
});
var ContentByDate = object12({
  id: string12(),
  activeOn: string12(),
  createdAt: coerce8.date(),
  updatedAt: coerce8.date(),
  content: Content
});
var ContentByDateResponseSchema = object12({
  items: union2([
    array4(ContentByDate),
    z53.null()
  ]),
  meta: object12({
    startDate: string12(),
    endDate: string12()
  })
});
var DateRangeQuerySchema = object12({
  startDate: string12().nullable(),
  endDate: string12().nullable(),
  page: coerce8.number().optional()
});
var UserContentRatingResponse = array4(RatingIndicator);
var WatchedStatusEnumValues = [
  "WATCHED",
  "UNWATCHED",
  "ALL"
];
var WatchedStatusEnumObj = z53.enum(WatchedStatusEnumValues);
var WatchedFilterEnum = WatchedStatusEnumObj.enum;

// src/content/content.request.ts
import { array as array5, coerce as coerce9, object as object13, string as string13 } from "zod";

// src/fit/content/recently-added.enum.ts
import { z as z54 } from "zod";
var ContentFilterTypeValues = [
  "recentlyAdded"
];
var ContentFilterTypeObj = z54.enum(ContentFilterTypeValues);
var ContentFilterTypeEnum = ContentFilterTypeObj.enum;

// src/content/content.request.ts
var ContentRequestSchema = object13({
  type: ContentFilterTypeObj.optional(),
  instructorId: string13().optional(),
  categoryId: string13().optional(),
  duration: string13().optional(),
  equipments: string13().optional(),
  difficulty: string13().optional(),
  intensity: string13().optional(),
  nerdiness: string13().optional(),
  awesomeness: string13().optional(),
  perPage: coerce9.number().optional(),
  page: coerce9.number().optional()
});
var ContentRequestBESchema = object13({
  app: AppNameEnumObj.optional(),
  query: string13().optional(),
  shuffle: CoerceBoolean.optional().default(false),
  loadAll: CoerceBoolean.optional().default(false),
  type: ContentFilterTypeObj,
  instructorIds: array5(string13()).default([]),
  categoryId: CategoryEnumObj,
  equipments: array5(string13()).default([]),
  status: StatusEnumObj.array().optional(),
  dashboard: CoerceBoolean.optional().default(false),
  durationFrom: coerce9.number().default(1),
  durationTo: coerce9.number().default(1e3),
  difficultyFrom: coerce9.number().default(1),
  difficultyTo: coerce9.number().default(5),
  intensityFrom: coerce9.number().default(1),
  intensityTo: coerce9.number().default(5),
  nerdinessFrom: coerce9.number().default(1),
  nerdinessTo: coerce9.number().default(5),
  awesomenessFrom: coerce9.number().default(1),
  awesomenessTo: coerce9.number().default(5),
  watchedStatus: WatchedStatusEnumObj,
  perPage: coerce9.number().max(150),
  page: coerce9.number(),
  sortByNewlyAdded: CoerceBoolean.optional().default(false),
  period: string13(),
  date: string13(),
  orderBy: string13().optional(),
  userTimezone: string13().optional(),
  addon: CoerceBoolean.optional().default(false),
  programId: coerce9.number().optional()
}).partial();
var contentFilterDefaultValues = {
  categoryId: "",
  difficulty: "0-5",
  duration: "1-60",
  equipments: "",
  instructorId: "",
  intensity: "0-5",
  nerdiness: "0-5",
  awesomeness: "0-5",
  page: "1",
  perPage: "15",
  type: "",
  query: "",
  shuffle: "true"
};
var contentFilterEmptyDefaultValues = {
  categoryId: "",
  difficulty: "",
  duration: "",
  equipments: "",
  instructorId: "",
  intensity: "",
  nerdiness: "",
  awesomeness: "",
  page: "",
  perPage: "",
  type: "",
  query: "",
  programId: ""
};

// src/content/content.response.ts
import { coerce as coerce10, object as object14 } from "zod";
var ContentFindByIdsResponseSchema = object14({
  items: Content.array(),
  meta: object14({
    total: coerce10.number(),
    page: coerce10.number(),
    perPage: coerce10.number(),
    totalPages: coerce10.number()
  })
});

// src/content/you-may-like.request.ts
import { coerce as coerce11, object as object15, string as string14 } from "zod";
var YouMayLikeRequestFilterSchema = object15({
  contentId: string14(),
  commentId: coerce11.number().optional().transform((val) => val == null ? void 0 : val.toString()),
  date: string14().optional(),
  category: CategoryEnumObj.or(AddonCategoryEnumObj).optional(),
  instructorId: coerce11.string().optional(),
  playlistId: coerce11.string().optional(),
  seriesId: coerce11.string().optional()
});

// src/dashboard-feed/black-friday-banner.ts
import { z as z55 } from "zod";
var BLACK_FRIDAY_BANNER_DEFAULT_CTA_URL = "/black-friday-deals";
var BLACK_FRIDAY_BANNER_ELIGIBLE_APP_KEYS = [
  EAppNameEnum.RYC,
  EAppNameEnum.FIT
];
var isBlackFridayBannerEligible = /* @__PURE__ */ __name((access) => BLACK_FRIDAY_BANNER_ELIGIBLE_APP_KEYS.some((appKey) => {
  var _a5, _b;
  return ((_b = (_a5 = access == null ? void 0 : access[appKey]) == null ? void 0 : _a5.permissions) != null ? _b : []).some((permission) => permission.name === Permissions.APP_ACTIVE);
}), "isBlackFridayBannerEligible");
var BlackFridayBannerStateSchema = z55.discriminatedUnion("isVisible", [
  z55.object({
    isVisible: z55.literal(false)
  }),
  z55.object({
    isVisible: z55.literal(true),
    ctaUrl: z55.string().min(1)
  })
]);

// src/dashboard-feed/dashboard-feed-card.ts
import { z as z56 } from "zod";
var imagePathField = z56.string().min(1, "Image is required").max(1e3, "Image path is too long");
var titleField2 = z56.string().min(1, "Title is required").max(200, "Title must be 200 characters or less");
var subtitleField = z56.string().max(200, "Subtitle must be 200 characters or less");
var descriptionField2 = z56.string().max(1e3, "Description must be 1000 characters or less");
var buttonLabelField2 = z56.string().min(1, "Button label is required").max(100, "Button label must be 100 characters or less");
var buttonUrlField2 = z56.string().min(1, "Button URL is required").max(1e3, "Button URL is too long").regex(/^(https?:\/\/|\/)/, "Button URL must be an absolute URL or a path starting with /");
var appKeyField = z56.string().max(100, "App key must be 100 characters or less");
var DashboardFeedCardVariantSchema = z56.object({
  title: titleField2,
  subtitle: subtitleField.optional().default(""),
  description: descriptionField2.optional().default(""),
  imagePath: imagePathField,
  buttonLabel: buttonLabelField2,
  buttonUrl: buttonUrlField2
});
var CreateDashboardFeedCardSchema = z56.object({
  appKey: appKeyField.nullish(),
  sortOrder: z56.number().int().optional().default(0),
  isActive: z56.boolean().optional().default(true),
  hasAccess: DashboardFeedCardVariantSchema,
  noAccess: DashboardFeedCardVariantSchema
});
var UpdateDashboardFeedCardSchema = z56.object({
  appKey: appKeyField.nullish(),
  sortOrder: z56.number().int().optional(),
  isActive: z56.boolean().optional(),
  hasAccess: DashboardFeedCardVariantSchema.optional(),
  noAccess: DashboardFeedCardVariantSchema.optional()
});
var ToggleDashboardFeedCardSchema = z56.object({
  isActive: z56.boolean()
});
var DashboardFeedCardBaseSchema = z56.object({
  id: z56.string().uuid(),
  appKey: z56.string().nullable(),
  sortOrder: z56.number().int(),
  isActive: z56.boolean(),
  hasAccess: DashboardFeedCardVariantSchema,
  noAccess: DashboardFeedCardVariantSchema,
  createdAt: z56.coerce.date(),
  updatedAt: z56.coerce.date()
});

// src/events/base.ts
import { z as z59 } from "zod";

// src/events/event.ts
import { z as z57 } from "zod";
var EventStatusEnumValues = [
  "SCHEDULED",
  "STARTED",
  "ENDED"
];
var EventStatusEnumObj = z57.enum(EventStatusEnumValues);
var EventStatusEnum = EventStatusEnumObj.enum;

// src/events/type.enum.ts
import { z as z58 } from "zod";
var EventTypeValues = [
  "CLASS",
  "LECTURE",
  "WORKSHOP",
  "MEETUP",
  "CONFERENCE"
];
var EventTypeObj = z58.enum(EventTypeValues);
var EEventTypeEnum = EventTypeObj.enum;

// src/events/base.ts
var BaseEventSchema = z59.object({
  id: z59.string(),
  title: z59.string().min(1, "title is required"),
  description: z59.string().optional(),
  instructor: Instructor,
  status: EventStatusEnumObj,
  videoStreamUrl: z59.string().url().min(1, "video stream url is required"),
  type: EventTypeObj,
  contentId: z59.coerce.string(),
  calendarLink: z59.string().optional(),
  scheduleDateTime: CustomLuxonDateSchema,
  isDataMigrated: z59.boolean().optional().default(false)
});

// src/events/be-schema.ts
import { string as string15 } from "zod";
var CreateEventSchemaBE = BaseEventSchema.pick({
  title: true,
  description: true,
  videoStreamUrl: true,
  type: true,
  calendarLink: true,
  scheduleDateTime: true,
  contentId: true
}).extend({
  instructorId: string15()
});
var UpdateEventSchemaBE = BaseEventSchema.omit({
  id: true,
  instructor: true
}).extend({
  instructorId: string15()
}).partial();

// src/events/fe-schema.ts
import { string as string16, z as z60 } from "zod";
var CreateEventSchemaFE = BaseEventSchema.pick({
  title: true,
  description: true,
  videoStreamUrl: true,
  type: true,
  calendarLink: true,
  scheduleDateTime: true
}).extend({
  instructorId: z60.coerce.string(),
  contentId: string16().min(1, "content id is required")
});
var UpdateEventSchemaFE = CreateEventSchemaFE.partial();
var defaultEventSchemaValues = {
  title: "",
  description: "",
  videoStreamUrl: "",
  calendarLink: "",
  type: EEventTypeEnum.CLASS,
  scheduleDateTime: void 0,
  instructorId: ""
};

// src/events/message.ts
import { number as number6, object as object16, string as string17, z as z61 } from "zod";
var EventMessageUserInfoSchema = object16({
  id: string17(),
  avatarUrl: string17(),
  username: string17(),
  userRoles: z61.array(string17()).optional()
});
var EventMessageSchema = z61.object({
  id: number6(),
  user: EventMessageUserInfoSchema,
  message: string17(),
  event: object16({
    id: string17()
  }),
  createdAt: string17(),
  updatedAt: string17()
});
var EventMessagePayloadSchema = object16({
  message: string17(),
  userId: string17(),
  parentId: number6().optional(),
  eventId: string17(),
  avatarUrl: string17(),
  username: string17(),
  userRoles: z61.array(string17()).optional()
});
var SendEventMessageRequestSchema = object16({
  message: string17().min(1, "Message cannot be empty"),
  parentId: number6().optional()
});

// src/events/pub-sub-event.enum.ts
import { z as z62 } from "zod";
var PubSubEventsEnumValues = [
  "VIEWER_JOINED",
  "VIEWER_LEFT",
  "EVENT_ENDED",
  "EVENT_STARTED",
  "SEND_MESSAGE",
  "REACT_TO_MESSAGE",
  "BROADCAST_MESSAGE"
];
var PubSubEventsEnumObj = z62.enum(PubSubEventsEnumValues);
var PubSubEventsEnum = PubSubEventsEnumObj.enum;

// src/events/reaction.ts
import { number as number7, object as object17, string as string18 } from "zod";
var EventReactionSchema = object17({
  id: string18().uuid(),
  eventMessage: EventMessageSchema,
  userId: string18()
});
var ReactToEventMessageSchema = object17({
  messageId: number7().positive(),
  userId: string18(),
  eventId: string18()
});

// src/events/reply.ts
import { z as z63 } from "zod";
var RepliesSchema = z63.lazy(() => EventMessageSchema.array());
var EventMessageSchemaWithReplies = EventMessageSchema.extend({
  replies: RepliesSchema,
  reactions: EventReactionSchema.array()
});

// src/events/socket-event.enum.ts
import { z as z64 } from "zod";
var SocketEventTypeEnumValues = [
  "connect",
  "disconnect",
  "USER_JOINED",
  "USER_LEFT",
  "EVENT_STARTED",
  "EVENT_FINISHED",
  "EVENT_INFO",
  "SEND_MESSAGE",
  "REACT_TO_MESSAGE",
  "MESSAGE_ERROR"
];
var SocketEventTypeEnumObj = z64.enum(SocketEventTypeEnumValues);
var SocketEventTypeEnum = SocketEventTypeEnumObj.enum;

// src/leaderboard/base.ts
import { boolean as boolean4, coerce as coerce12, number as number8, object as object18, string as string19, z as z65 } from "zod";
var LeaderBoardSchema = object18({
  id: coerce12.string().min(1),
  index: number8(),
  userId: coerce12.string().min(1),
  avatar: string19().url(),
  name: string19(),
  location: string19(),
  daysActive: string19().nullable(),
  workouts: coerce12.string(),
  points: coerce12.number(),
  isSelf: boolean4(),
  ranked: boolean4(),
  funFact: string19(),
  totalCompletedClass: number8(),
  date: string19()
});
var LeaderBoardTypeEnumValues = [
  "thisWeek",
  "lastWeek",
  "thisMonth",
  "lastMonth"
];
var LeaderBoardTypeEnumObj = z65.enum(LeaderBoardTypeEnumValues);
var LeaderBoardTypeEnum = LeaderBoardTypeEnumObj.enum;
var LeaderBoardRequestSchema = object18({
  type: LeaderBoardTypeEnumObj,
  page: coerce12.number().nullable().optional(),
  perPage: coerce12.number().nullable().optional()
});

// src/leaderboard/be-privacy-schema.ts
import { number as number9, object as object19, string as string20 } from "zod";
var UserPrivacySchemaBE = object19({
  id: number9().positive(),
  userId: string20(),
  isPrivate: CoerceBoolean,
  createdAt: string20(),
  updatedAt: string20()
});
var UserPrivacyRedisSchemaBE = UserPrivacySchemaBE.pick({
  userId: true,
  isPrivate: true
});
var UpdateUserPrivacyBESchema = UserPrivacySchemaBE.pick({
  userId: true,
  isPrivate: true
});

// src/login/base.ts
import { object as object20, string as string21 } from "zod";
var LoginSchema = object20({
  username: string21().min(3),
  password: string21().min(6)
});
var EmailLoginSchema = object20({
  password: string21().min(6),
  email: string21().email()
});

// src/login/exception.enum.ts
import { z as z66 } from "zod";
var JwtExceptionEnumValues = [
  "TokenExpired"
];
var JwtExceptionEnumObj = z66.enum(JwtExceptionEnumValues);

// src/login/password-reset.ts
import { z as z67 } from "zod";
var ForgotPasswordSchema = z67.object({
  email: z67.string().email()
});
var ResetPasswordSchema = z67.object({
  password: z67.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z67.string().min(8, "Password must be at least 8 characters")
}).refine((d) => d.password === d.confirmPassword, {
  message: "Passwords do not match",
  path: [
    "confirmPassword"
  ]
});
var SendPasswordResetSchema = z67.object({
  email: z67.string().email(),
  redirectUrl: z67.string().url(),
  expiresInHours: z67.number().int().min(1).max(8).optional()
});
var SetPasswordWithTokenSchema = z67.object({
  token: z67.string().uuid(),
  password: z67.string().min(8)
});
var AdminSetPasswordSchema = z67.object({
  email: z67.string().email(),
  password: z67.string().min(8)
});
var ADMIN_PASSWORD_MIN_LENGTH = 8;
var ADMIN_PASSWORD_MAX_LENGTH = 72;
var AdminSetUserPasswordSchema = z67.object({
  password: z67.string().min(ADMIN_PASSWORD_MIN_LENGTH, `Use at least ${ADMIN_PASSWORD_MIN_LENGTH} characters`).max(ADMIN_PASSWORD_MAX_LENGTH, `Use at most ${ADMIN_PASSWORD_MAX_LENGTH} characters`)
});
var SetPasswordWithWpTokenSchema = z67.object({
  password: z67.string().min(8, "Password must be at least 8 characters"),
  userId: z67.string().min(1, "User ID is required")
});
var ResetPasswordSearchParamsSchema = z67.object({
  token: z67.string().uuid().optional()
});

// src/notification/be-condition-json-schema.ts
import { z as z69 } from "zod";

// src/notification/notification.enum.ts
import { z as z68 } from "zod";
var RealTimeNotificationEventTypeValues = [
  "CUSTOM_NOTIFICATION",
  "FIT_COMMENT_MENTION",
  "FIT_COMMENT_REACTION",
  "FIT_INSTRUCTOR_NOTIFICATION",
  "FIT_VIDEO_COMMENT",
  "FIT_WELCOME",
  "MAGIC_LINK_LOGIN",
  "OTP_LOGIN",
  "PASSWORD_CHANGE",
  "PASSWORD_RESET",
  // Secure email-change flow
  "EMAIL_CHANGE_VERIFY",
  "EMAIL_CHANGE_SECURITY_ALERT",
  "EMAIL_CHANGE_CONFIRMED",
  // Pro Directory notifications
  "PRO_DIRECTORY_APPROVED",
  "PRO_DIRECTORY_REJECTED",
  "PRO_DIRECTORY_SUBMISSION_CONFIRMED",
  "PRO_DIRECTORY_SUBMITTED",
  // Community Hub Feed notifications
  "CH_NEW_POST",
  "CH_POST_COMMENT",
  "CH_POST_REACTION",
  "CH_COMMENT_REPLY",
  "CH_COMMENT_REACTION",
  "CH_MENTION",
  // Support ticket notifications
  "SUPPORT_NEW_TICKET",
  "SUPPORT_TICKET_REPLY",
  // Badge / trophy notifications
  "FIT_BADGE_EARNED",
  // Hands-On Practice: a teacher shared (or updated) feedback on a student's submission
  "HOP_FEEDBACK_READY",
  // Hands-On Practice: a teacher rejected a student's submission; the student may submit again
  "HOP_SUBMISSION_REJECTED",
  // Hands-On Practice: a student submitted a form that their teacher must review
  "HOP_SUBMISSION_RECEIVED",
  // Hands-On Practice: an admin reminds a teacher of submissions waiting for feedback
  "HOP_REVIEW_REMINDER",
  // Hands-On Practice: a teacher or admin reminds a student of forms not submitted yet
  "HOP_SUBMISSION_REMINDER",
  // Hands-On Practice: an admin sends a note about one submission to its teacher or its student
  "HOP_ADMIN_NOTE"
];
var CronNotificationEventTypeValues = [
  "INACTIVITY"
];
var NotificationRulesTypeValues = [
  ...CronNotificationEventTypeValues,
  ...RealTimeNotificationEventTypeValues
];
var NotificationRulesTypeEnumObject = z68.enum(NotificationRulesTypeValues);
var ENotificationRulesType = NotificationRulesTypeEnumObject.enum;
var NotificationRuleStatusValues = [
  "ACTIVE",
  "INACTIVE",
  "DRAFT"
];
var NotificationRuleStatusEnumObject = z68.enum(NotificationRuleStatusValues);
var ENotificationRuleStatus = NotificationRuleStatusEnumObject.enum;
var NotificationChannelValues = [
  "EMAIL",
  "In-App",
  "App-push"
];
var NotificationChannelEnumObject = z68.enum(NotificationChannelValues);
var ENotificationChannel = NotificationChannelEnumObject.enum;
var NotificationStatusValues = [
  "PENDING",
  "SENT",
  "FAILED",
  "SCHEDULED"
];
var NotificationStatusEnumObject = z68.enum(NotificationStatusValues);
var ENotificationStatus = NotificationStatusEnumObject.enum;
var NotificationTypeValues = [
  "CRON",
  "REALTIME"
];
var NotificationTypeEnumObject = z68.enum(NotificationTypeValues);
var ENotificationType = NotificationTypeEnumObject.enum;

// src/notification/be-condition-json-schema.ts
var BaseRuleConditionSchema = z69.object({
  type: NotificationRulesTypeEnumObject
});
var FitVideoCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.FIT_VIDEO_COMMENT)
});
var FitCommentMentionConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.FIT_COMMENT_MENTION)
});
var FitInstructorCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.FIT_INSTRUCTOR_NOTIFICATION)
});
var FitCommentLikeConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.FIT_COMMENT_REACTION)
});
var CustomNotificationConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.CUSTOM_NOTIFICATION)
});
var FitWelcomeConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.FIT_WELCOME)
});
var PasswordChangeConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.PASSWORD_CHANGE)
});
var PasswordResetConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.PASSWORD_RESET)
});
var MagicLinkLoginConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.MAGIC_LINK_LOGIN)
});
var OtpLoginConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.OTP_LOGIN)
});
var EmailChangeVerifyConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.EMAIL_CHANGE_VERIFY)
});
var EmailChangeSecurityAlertConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.EMAIL_CHANGE_SECURITY_ALERT)
});
var EmailChangeConfirmedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.EMAIL_CHANGE_CONFIRMED)
});
var ChNewPostConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.CH_NEW_POST)
});
var ChPostCommentConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.CH_POST_COMMENT)
});
var ChPostReactionConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.CH_POST_REACTION)
});
var ChCommentReplyConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.CH_COMMENT_REPLY)
});
var ChCommentReactionConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.CH_COMMENT_REACTION)
});
var ChMentionConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.CH_MENTION)
});
var SupportNewTicketConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.SUPPORT_NEW_TICKET)
});
var SupportTicketReplyConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.SUPPORT_TICKET_REPLY)
});
var FitBadgeEarnedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.FIT_BADGE_EARNED)
});
var HopFeedbackReadyConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.HOP_FEEDBACK_READY)
});
var HopSubmissionRejectedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.HOP_SUBMISSION_REJECTED)
});
var HopSubmissionReceivedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.HOP_SUBMISSION_RECEIVED)
});
var HopReviewReminderConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.HOP_REVIEW_REMINDER)
});
var HopSubmissionReminderConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.HOP_SUBMISSION_REMINDER)
});
var HopAdminNoteConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.HOP_ADMIN_NOTE)
});
var ProDirectoryApprovedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_APPROVED)
});
var ProDirectoryRejectedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_REJECTED)
});
var ProDirectorySubmittedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_SUBMITTED)
});
var ProDirectorySubmissionConfirmedConditionSchema = BaseRuleConditionSchema.extend({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.PRO_DIRECTORY_SUBMISSION_CONFIRMED)
});
var RuleConditionJsonColumnValues = [
  "daysOfInactivity",
  "postPurchase",
  "totalCheckins"
];
var RuleConditionJsonColumnObject = z69.enum(RuleConditionJsonColumnValues);
var EnumRuleConditionJsonColumnObject = RuleConditionJsonColumnObject.enum;
var InactivityRuleConditionJsonSchemaBE = z69.object({
  type: z69.literal(NotificationRulesTypeEnumObject.enum.INACTIVITY),
  daysOfInactivity: z69.coerce.number().int().positive().describe("Number of days user has been inactive").optional(),
  postPurchase: z69.tuple([
    z69.number().positive(),
    z69.number().positive()
  ]).describe("Number of days since purchase").optional(),
  totalCheckins: z69.tuple([
    z69.number(),
    z69.number()
  ]).describe("Number of checkins").optional()
});
var RuleConditionJsonSchemaBE_ = z69.discriminatedUnion("type", [
  InactivityRuleConditionJsonSchemaBE,
  CustomNotificationConditionSchema,
  FitCommentMentionConditionSchema,
  FitCommentLikeConditionSchema,
  FitInstructorCommentConditionSchema,
  FitVideoCommentConditionSchema,
  FitWelcomeConditionSchema,
  MagicLinkLoginConditionSchema,
  OtpLoginConditionSchema,
  PasswordChangeConditionSchema,
  PasswordResetConditionSchema,
  EmailChangeVerifyConditionSchema,
  EmailChangeSecurityAlertConditionSchema,
  EmailChangeConfirmedConditionSchema,
  // Community Hub Feed notifications
  ChNewPostConditionSchema,
  ChPostCommentConditionSchema,
  ChPostReactionConditionSchema,
  ChCommentReplyConditionSchema,
  ChCommentReactionConditionSchema,
  ChMentionConditionSchema,
  // Support ticket notifications
  SupportNewTicketConditionSchema,
  SupportTicketReplyConditionSchema,
  // Badge / trophy notifications
  FitBadgeEarnedConditionSchema,
  HopFeedbackReadyConditionSchema,
  HopSubmissionRejectedConditionSchema,
  HopSubmissionReceivedConditionSchema,
  HopReviewReminderConditionSchema,
  HopSubmissionReminderConditionSchema,
  HopAdminNoteConditionSchema,
  // Pro Directory notifications
  ProDirectoryApprovedConditionSchema,
  ProDirectoryRejectedConditionSchema,
  ProDirectorySubmissionConfirmedConditionSchema,
  ProDirectorySubmittedConditionSchema
]);
var RuleConditionJsonSchemaBE = RuleConditionJsonSchemaBE_.refine((data) => {
  if (data.type === "INACTIVITY") {
    return data.daysOfInactivity !== void 0 || data.postPurchase !== void 0 || data.totalCheckins !== void 0;
  }
  return true;
}, {
  message: 'For INACTIVITY, at least one of "Days of Inactivity", "Post Purchase", or "Total Checkins" must be provided.'
});
function validateRuleConditions(conditionsJson) {
  const parsed = JSON.parse(conditionsJson);
  return RuleConditionJsonSchemaBE.parse(parsed);
}
__name(validateRuleConditions, "validateRuleConditions");

// src/notification/be-request.ts
import { coerce as coerce13, object as object21, string as string22 } from "zod";
var NotificationFindAllRequestQuerySchema = object21({
  page: coerce13.number().optional().default(1).describe("Page number (default: 1)"),
  perPage: coerce13.number().optional().default(10).describe("Items per page (default: 10)"),
  isActive: coerce13.boolean().optional().describe("Filter by active status"),
  channel: NotificationChannelEnumObject.optional().describe("Filter by notification channel"),
  type: NotificationTypeEnumObject.optional().describe("Filter by notification type"),
  app: AppNameEnumObj.optional().describe("Filter by app"),
  conditionType: string22().optional().describe("Filter by conditionsJson.type value"),
  search: string22().optional().describe("Search by rule name")
});
var NotificationLogFindAllRequestQuerySchema = object21({
  page: coerce13.number().optional().default(1).describe("Page number (default: 1)"),
  perPage: coerce13.number().optional().default(10).describe("Items per page (default: 10)"),
  status: NotificationStatusEnumObject.optional().describe("Filter by notification status"),
  userId: string22().optional().describe("Filter by user ID"),
  channel: NotificationChannelEnumObject.optional().describe("Filter by notification channel"),
  ruleId: coerce13.number().optional().describe("Filter by notification rule ID"),
  scheduledAtFrom: string22().datetime().optional().describe("Filter by scheduledAt lower bound (ISO datetime)"),
  scheduledAtTo: string22().datetime().optional().describe("Filter by scheduledAt upper bound (ISO datetime)"),
  sentAtFrom: string22().datetime().optional().describe("Filter by sentAt lower bound (ISO datetime)"),
  sentAtTo: string22().datetime().optional().describe("Filter by sentAt upper bound (ISO datetime)")
});

// src/notification/be-response-schema.ts
import { boolean as boolean5, number as number10, string as string23, z as z70 } from "zod";
var TemplateResponseSchema = z70.object({
  id: number10(),
  name: string23(),
  subject: string23(),
  body: string23(),
  isEnabled: boolean5(),
  createdAt: string23(),
  updatedAt: string23(),
  redirectUrl: string23().nullable().optional(),
  iconUrl: string23().nullable().optional(),
  useBrandedTemplate: boolean5().optional(),
  renderedHtml: string23().nullable().optional()
});
var NotificationRuleResponseSchemaBE = z70.object({
  id: string23(),
  name: string23(),
  app: AppNameEnumObj,
  type: NotificationTypeEnumObject,
  conditionsJson: RuleConditionJsonSchemaBE,
  template: TemplateResponseSchema,
  channels: z70.array(NotificationChannelEnumObject).min(1),
  isActive: boolean5(),
  workflowId: string23(),
  createdBy: number10().nullable().optional(),
  updatedBy: number10().nullable().optional(),
  createdAt: string23(),
  updatedAt: string23()
});
var NotificationLogResponseSchemaBE = z70.object({
  id: string23(),
  userId: string23(),
  app: AppNameEnumObj,
  ruleId: string23(),
  templateId: string23(),
  status: NotificationStatusEnumObject,
  scheduledAt: string23().nullable().optional(),
  sentAt: string23().nullable().optional(),
  failedAt: string23().nullable().optional(),
  errorMessage: string23().nullable().optional(),
  retryCount: number10().default(0),
  maxRetries: number10().default(3),
  metadata: z70.record(z70.unknown()).nullable().optional(),
  rule: z70.object({
    id: number10(),
    name: string23(),
    type: NotificationTypeEnumObject,
    channel: NotificationChannelEnumObject,
    isActive: boolean5()
  }).nullable().optional(),
  createdAt: string23(),
  updatedAt: string23()
});

// src/notification/be-schema.ts
import { boolean as boolean6, object as object22, string as string24 } from "zod";
var CreateTemplateSchema = object22({
  name: string24().min(1, "Template name is required"),
  subject: string24().min(1, "Email subject is required"),
  body: string24().min(1, "Email body is required"),
  isEnabled: boolean6().optional().default(true),
  redirectUrl: string24().optional().nullable(),
  iconUrl: string24().optional().nullable(),
  // Email-channel only. When true, the rendered HTML body is wrapped in the
  // hardcoded branded email shell.
  useBrandedTemplate: boolean6().optional().default(false),
  // Email body (React Email JSX or raw HTML) compiled to HTML in the browser on
  // save, with `{var}` placeholders. This is what the backend sends.
  renderedHtml: string24().optional().nullable()
});

// src/notification/bulk-notification.ts
import { array as array6, boolean as boolean7, number as number11, object as object24, string as string25, z as z72 } from "zod";

// src/notification/novu-workflows.ts
import { object as object23, z as z71 } from "zod";
var NovuWorkflowValues = [
  "inactivity",
  "post-purchase",
  "welcome-notification"
];
var NovuWorkflowsEnumObject = z71.enum(NovuWorkflowValues);
var ENovuWorkflowsEnum = NovuWorkflowsEnumObject.enum;
var NovuEmailTemplateNameValues = [
  "send-inactivity-email",
  "send-post-purchase-email",
  "send-fit-welcome-email"
];
var NovuEmailTemplateNameEnumObject = z71.enum(NovuEmailTemplateNameValues);
var ENovuEmailTemplateNameEnum = NovuEmailTemplateNameEnumObject.enum;
var NovuTenantIdentifierValues = [
  "fit",
  "ryc",
  "members",
  "addon"
];
var NovuTenantIdentifierEnumObject = z71.enum(NovuTenantIdentifierValues);
var ENovuTenantIdentifierEnum = NovuTenantIdentifierEnumObject.enum;
var GenerateSubscriberIdWithTenantSchema = object23({
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  userId: z71.coerce.string()
}).transform((data) => {
  const { tenantIdentifier, userId: userId2 } = data;
  return `${tenantIdentifier}:${userId2}`;
});

// src/notification/bulk-notification.ts
var CreateBulkNotificationSchema = object24({
  appName: AppNameEnumObj,
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  /** Target every user with `user_access` for this app key (a value from the `apps` table). */
  appAccess: string25().optional(),
  selectAll: boolean7().optional(),
  userIds: array6(string25()).optional(),
  ruleIds: array6(z72.coerce.number().int().positive()).min(1, "Select at least one rule"),
  title: string25().min(1, "Title is required"),
  message: string25().min(1, "Message is required"),
  programName: string25().optional(),
  redirectUrl: string25().optional(),
  iconUrl: string25().url().optional()
});
var BulkNotificationBatchStatusSchema = object24({
  batchId: string25().uuid(),
  total: number11().int().nonnegative(),
  scheduled: number11().int().nonnegative(),
  pending: number11().int().nonnegative(),
  sent: number11().int().nonnegative(),
  failed: number11().int().nonnegative(),
  createdAt: string25().datetime().optional(),
  scheduledAt: string25().datetime().optional()
});
var CreateBulkNotificationResponseSchema = object24({
  batchId: string25().uuid(),
  logsCreated: number11().int().nonnegative(),
  inAppLogsCreated: number11().int().nonnegative().optional(),
  pushLogsCreated: number11().int().nonnegative().optional(),
  /** Users excluded from the App-push channel because they have no registered device token */
  pushSkippedNoDevice: number11().int().nonnegative().optional()
});
var MAX_BULK_RECIPIENT_IDENTIFIERS = 5e3;
var ResolveBulkRecipientsSchema = object24({
  identifiers: array6(string25().trim().min(1)).min(1, "Provide at least one identifier").max(MAX_BULK_RECIPIENT_IDENTIFIERS, `At most ${MAX_BULK_RECIPIENT_IDENTIFIERS} identifiers can be resolved at once`)
});
var ResolvedBulkRecipientSchema = object24({
  /** The identifier exactly as the admin typed it, so the UI can trace a match back to its input line. */
  identifier: string25(),
  userId: string25(),
  name: string25(),
  email: string25()
});
var ResolveBulkRecipientsResponseSchema = object24({
  resolved: array6(ResolvedBulkRecipientSchema),
  /** Identifiers that matched no profile, or were not a recognisable ID / email / UUID. */
  unresolved: array6(string25()),
  /** Identifiers dropped because an earlier identifier already resolved to the same user. */
  duplicates: array6(string25())
});
var AccessAppSchema = object24({
  app: string25(),
  name: string25(),
  type: string25().nullable().optional()
});
var AccessAppsResponseSchema = array6(AccessAppSchema);

// src/notification/device-token/register-request.ts
import { object as object25, string as string26, z as z73 } from "zod";
var RegisterDeviceTokenRequestSchema = object25({
  expoPushToken: string26(),
  platform: z73.enum([
    "ios",
    "android"
  ]).optional()
});

// src/notification/device-token/unregister-request.ts
import { object as object26, string as string27 } from "zod";
var UnregisterDeviceTokenRequestSchema = object26({
  expoPushToken: string27().min(1)
});

// src/notification/notification-log.ts
import { boolean as boolean9, number as number13, object as object29, string as string30, z as z77 } from "zod";

// src/notification/realtime-notification/be-payload.ts
import { array as array7, boolean as boolean8, coerce as coerce14, lazy as lazy2, number as number12, object as object27, string as string28, union as union3 } from "zod";
var RealtimeNotificationMetaSchemaBE = object27({
  entity: string28().describe('What produced the notification, e.g. "badge"')
}).catchall(union3([
  string28(),
  number12(),
  boolean8()
]));
var RealtimeNotificationBePayloadSchemaBE = object27({
  appName: lazy2(() => AppNameEnumObj),
  tenantIdentifier: lazy2(() => NovuTenantIdentifierEnumObject),
  type: lazy2(() => NotificationRulesTypeEnumObject),
  content: object27({
    id: string28().optional(),
    name: string28().optional()
  }).optional(),
  liker: object27({
    id: string28(),
    name: string28()
  }).optional(),
  mentioner: object27({
    id: string28(),
    name: string28()
  }).optional(),
  comment: object27({
    id: coerce14.string().optional(),
    body: string28().optional(),
    replier: object27({
      id: string28(),
      name: string28()
    }).optional(),
    commenter: object27({
      id: string28(),
      name: string28()
    }).optional()
  }).optional(),
  user: object27({
    id: string28(),
    name: string28().optional(),
    email: string28().optional()
  }).optional(),
  userIdsToNotify: array7(string28()),
  programName: string28().optional(),
  title: string28().optional(),
  message: string28().optional(),
  redirectUrl: string28().optional(),
  iconUrl: string28().url().optional(),
  meta: lazy2(() => RealtimeNotificationMetaSchemaBE).optional()
});
var WelcomeNotificationPayloadSchemaBE = object27({
  appName: lazy2(() => AppNameEnumObj),
  tenantIdentifier: lazy2(() => NovuTenantIdentifierEnumObject),
  type: lazy2(() => NotificationRulesTypeEnumObject),
  user: object27({
    id: string28(),
    name: string28().optional(),
    email: string28().optional()
  }),
  userIdsToNotify: array7(string28())
});

// src/notification/realtime-notification/device-token-payload.ts
import { array as array8, object as object28, string as string29, z as z74 } from "zod";
var DeviceTokenRegisterPayloadSchemaBE = object28({
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  userId: string29(),
  expoPushToken: string29(),
  platform: z74.enum([
    "ios",
    "android"
  ]).optional(),
  activeExpoPushTokens: array8(string29())
});
var DeviceTokenUnregisterPayloadSchemaBE = object28({
  tenantIdentifier: NovuTenantIdentifierEnumObject,
  userId: string29(),
  expoPushToken: string29(),
  activeExpoPushTokens: array8(string29())
});

// src/notification/realtime-notification/messages.enum.ts
import { z as z75 } from "zod";
var RealtimeNotificationMessageTypeValues = [
  "COMMON",
  "WELCOME",
  "DEVICE_TOKEN_REGISTER",
  "DEVICE_TOKEN_UNREGISTER"
];
var RealtimeNotificationMessageTypeEnumObject = z75.enum(RealtimeNotificationMessageTypeValues);
var ERealtimeNotificationMessageType = RealtimeNotificationMessageTypeEnumObject.enum;

// src/notification/rule-engine-communication.ts
import { z as z76 } from "zod";
var RuleConditionTypeSchema = z76.enum([
  "INACTIVITY",
  "POST_PURCHASE",
  "NEVER_LOGIN",
  "SUBSCRIPTION_EXPIRY",
  "TRIAL_ENDING",
  "DAY_STEP_CHANGE"
]);
var NotificationRuleSchema = z76.object({
  id: z76.number().describe("Unique rule identifier"),
  name: z76.string().describe("Human-readable rule name"),
  type: NotificationTypeEnumObject.describe("Rule type for categorization"),
  conditionsJson: RuleConditionJsonSchemaBE.describe("Rule conditions in structured format"),
  templateId: z76.number().describe("Associated template ID (for notification app use)"),
  isActive: z76.boolean().describe("Whether rule is currently active"),
  createdAt: z76.string().datetime().describe("Rule creation timestamp"),
  updatedAt: z76.string().datetime().describe("Rule last update timestamp")
});
var RuleEvaluationRequestSchema = z76.object({
  jobDueDate: z76.string().describe("for which date the log should be created"),
  batchId: z76.string().uuid().describe("Unique batch identifier for tracking"),
  requestedAt: z76.string().datetime().describe("When the evaluation was requested"),
  requestSource: z76.string().default("NOTIFICATION_CRON").describe("Source of the request"),
  rules: z76.array(NotificationRuleSchema).min(1).describe("Active rules to evaluate against user data"),
  metadata: z76.record(z76.any()).optional().describe("Additional request metadata")
});
var UserDataSchema = z76.object({
  userId: z76.string().describe("User identifier"),
  username: z76.string().optional().describe("User display name"),
  email: z76.string().email().optional().describe("User email address"),
  registrationDate: z76.string().datetime().optional().describe("User registration date"),
  lastLoginDate: z76.string().datetime().optional().describe("Last login timestamp"),
  lastPurchaseDate: z76.string().datetime().optional().describe("Last purchase timestamp"),
  lastCheckinDate: z76.string().datetime().optional().describe("Last checkin timestamp"),
  purchaseDate: z76.string().datetime().optional().describe("Purchase timestamp"),
  tier: z76.number().optional().describe("User tier level"),
  subscriptionStatus: z76.string().optional().describe("Current subscription status"),
  additionalData: z76.record(z76.any()).optional().describe("Additional user-specific data")
});
var RuleMatchResultSchema = z76.object({
  userId: z76.string().describe("User ID that matched the rule"),
  ruleId: z76.number().describe("Rule ID that was matched"),
  templateId: z76.number().describe("Template ID for notification app to use"),
  matchedConditions: z76.record(z76.any()).describe("Details about which conditions were matched"),
  userData: UserDataSchema.describe("User data for notification app template rendering"),
  matchedAt: z76.string().datetime().describe("When the match was identified"),
  priority: z76.number().default(3).describe("Notification priority (1=highest, 5=lowest)")
});
var RuleEvaluationResponseSchema = z76.object({
  batchId: z76.string().uuid().describe("Same batch ID from request"),
  jobDueDate: z76.string().describe("for which date the job was created"),
  processedAt: z76.string().datetime().describe("When evaluation was completed"),
  totalRulesEvaluated: z76.number().describe("Number of rules processed"),
  totalUsersMatched: z76.number().describe("Total users matched across all rules"),
  matches: z76.array(RuleMatchResultSchema).describe("Array of user-rule matches with user data"),
  processingTimeMs: z76.number().describe("Processing time in milliseconds"),
  statistics: z76.object({
    ruleBreakdown: z76.record(z76.number()).describe("Matches per rule ID"),
    conditionTypeBreakdown: z76.record(z76.number()).describe("Matches per condition type")
  }).optional().describe("Evaluation statistics"),
  metadata: z76.record(z76.any()).optional().describe("Additional response metadata")
});

// src/notification/notification-log.ts
var BasicRuleSchema = object29({
  id: string30(),
  name: string30(),
  type: NotificationTypeEnumObject,
  channels: z77.array(NotificationChannelEnumObject),
  isActive: boolean9(),
  conditionsJson: RuleConditionJsonSchemaBE,
  workflowId: string30().nullable().optional(),
  template: object29({
    name: string30(),
    subject: string30(),
    body: string30()
  }).nullable().optional()
});
var NotificationLogSchema = object29({
  id: string30(),
  userId: string30(),
  ruleId: string30(),
  templateId: string30(),
  status: NotificationStatusEnumObject,
  scheduledAt: string30().datetime().nullable().optional(),
  sentAt: string30().datetime().nullable().optional(),
  failedAt: string30().datetime().nullable().optional(),
  errorMessage: string30().nullable().optional(),
  retryCount: number13().default(0),
  maxRetries: number13().default(3),
  metadata: z77.record(z77.unknown()).optional(),
  rule: BasicRuleSchema.nullable().optional(),
  createdAt: string30().datetime()
});
var GetNotificationLogsRequestSchema = RequestSchema.extend({
  status: NotificationStatusEnumObject.optional(),
  userId: string30().optional(),
  channel: NotificationChannelEnumObject.optional(),
  ruleId: number13().optional(),
  scheduledAtFrom: string30().datetime().optional(),
  scheduledAtTo: string30().datetime().optional(),
  sentAtFrom: string30().datetime().optional(),
  sentAtTo: string30().datetime().optional()
});
var GetNotificationLogsResponseSchema = object29({
  items: z77.array(NotificationLogSchema),
  meta: object29({
    totalPages: number13(),
    page: number13(),
    perPage: number13(),
    total: number13()
  })
});
var NotificationLogMetadataSchema = object29({
  ruleName: string30(),
  ruleType: NotificationTypeEnumObject,
  conditions: RuleConditionJsonSchemaBE,
  batchId: string30().uuid(),
  userData: object29({
    userId: string30()
  }),
  matchedAt: string30().datetime(),
  requestSource: string30(),
  matchedConditions: object29({
    type: RuleConditionTypeSchema,
    daysOfInactivity: number13().int().nonnegative(),
    lastCheckinDate: string30().optional()
  }).partial(),
  totalRulesProcessed: number13().int().nonnegative(),
  averageProcessingTimePerRule: number13().nonnegative(),
  // Bulk notification fields (title/message from RealtimeNotificationBePayloadSchemaBE)
  isBulkNotification: boolean9(),
  scheduledBy: string30(),
  channels: z77.array(NotificationChannelEnumObject)
}).merge(RealtimeNotificationBePayloadSchemaBE).partial().nullable();

// src/notification/rule/be-request-schema.ts
import { coerce as coerce15, z as z78 } from "zod";

// src/notification/rule/be-schema.ts
import { array as array9, boolean as boolean11, number as number15, object as object31, string as string32 } from "zod";

// src/notification/template/be-schema.ts
import { boolean as boolean10, number as number14, object as object30, string as string31 } from "zod";
var NotificationTemplateSchemaBE = object30({
  id: number14().int().positive(),
  name: string31().min(1),
  subject: string31().min(1),
  body: string31().min(1),
  isEnabled: boolean10().optional(),
  iconUrl: string31().nullable().optional(),
  redirectUrl: string31().nullable().optional(),
  useBrandedTemplate: boolean10().optional(),
  renderedHtml: string31().nullable().optional(),
  createdAt: string31(),
  updatedAt: string31()
});

// src/notification/template/novu-workflow.ts
var NovuWorkflowTemplateSchema = NotificationTemplateSchemaBE.pick({
  body: true,
  subject: true
});

// src/notification/template/variables.ts
var cronVariables = [
  "name",
  "humanizedDate",
  "relativeDate",
  "daysOfInactivity"
];
var userProfileVariables = [
  "name",
  "firstName",
  "lastName",
  "email"
];
var TemplateVariables = {
  [ENotificationRulesType.FIT_VIDEO_COMMENT]: [
    "programName",
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "replierId",
    "replierName",
    "commenterId",
    "commenterName"
  ],
  [ENotificationRulesType.FIT_INSTRUCTOR_NOTIFICATION]: [
    "programName",
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "commenterId",
    "commenterName"
  ],
  [ENotificationRulesType.FIT_COMMENT_MENTION]: [
    "programName",
    "contentId",
    "contentName",
    "commentId",
    "commentBody",
    "mentionerId",
    "mentionerName"
  ],
  [ENotificationRulesType.FIT_COMMENT_REACTION]: [
    "programName",
    "contentId",
    "contentName",
    "commentOwner",
    "commentId",
    "commentBody",
    "likerId",
    "likerName"
  ],
  [ENotificationRulesType.CUSTOM_NOTIFICATION]: [
    "programName",
    ...userProfileVariables
  ],
  [ENotificationRulesType.INACTIVITY]: cronVariables,
  [ENotificationRulesType.FIT_WELCOME]: [
    "programName",
    ...userProfileVariables
  ],
  [ENotificationRulesType.MAGIC_LINK_LOGIN]: [
    "magicLink",
    "expiresInMinutes",
    "email"
  ],
  [ENotificationRulesType.OTP_LOGIN]: [
    "otpCode",
    "expiresInMinutes",
    "email",
    "firstName",
    "name"
  ],
  [ENotificationRulesType.PASSWORD_CHANGE]: [
    "changedAt"
  ],
  // Community Hub Feed notifications
  [ENotificationRulesType.CH_NEW_POST]: [
    "programName",
    "postAuthorId",
    "postAuthorName"
  ],
  [ENotificationRulesType.CH_POST_COMMENT]: [
    "programName",
    "postId",
    "commenterId",
    "commenterName",
    "commentBody"
  ],
  [ENotificationRulesType.CH_POST_REACTION]: [
    "programName",
    "postId",
    "reactorId",
    "reactorName",
    "emoji"
  ],
  [ENotificationRulesType.CH_COMMENT_REPLY]: [
    "programName",
    "commentId",
    "replierId",
    "replierName",
    "replyBody"
  ],
  [ENotificationRulesType.CH_COMMENT_REACTION]: [
    "programName",
    "commentId",
    "reactorId",
    "reactorName",
    "emoji"
  ],
  [ENotificationRulesType.CH_MENTION]: [
    "programName",
    "mentionerId",
    "mentionerName",
    "targetType"
  ],
  // Hands-On Practice feedback — `feedbackAction` is "shared" or "updated"
  [ENotificationRulesType.HOP_FEEDBACK_READY]: [
    "programName",
    "formTitle",
    "teacherName",
    "feedbackAction",
    "feedbackUrl",
    ...userProfileVariables
  ],
  // Hands-On Practice rejected — `formUrl` opens the form so the student can submit again
  [ENotificationRulesType.HOP_SUBMISSION_REJECTED]: [
    "programName",
    "formTitle",
    "teacherName",
    "rejectionReason",
    "formUrl",
    ...userProfileVariables
  ],
  // Hands-On Practice submitted — sent to the teacher; `reviewUrl` opens the submission in Teacher Review.
  // `submissionAction` is "submitted" or "resubmitted"; the profile variables are the teacher's.
  [ENotificationRulesType.HOP_SUBMISSION_RECEIVED]: [
    "programName",
    "formTitle",
    "studentName",
    "submissionAction",
    "reviewUrl",
    ...userProfileVariables
  ],
  // Hands-On Practice reminder to a teacher about ONE form, sent by an admin. `reviewUrl` opens their
  // Teacher Review page on that form and the admin's review times; `waitingCount` / `overdueCount` are numbers. `overdueText`
  // ("3 of them are overdue.") and `note` ("Note from Jitu: …") are full sentences, empty when not needed.
  [ENotificationRulesType.HOP_REVIEW_REMINDER]: [
    "programName",
    "formTitle",
    "waitingCount",
    "overdueCount",
    "overdueText",
    "note",
    "senderName",
    "reviewUrl",
    ...userProfileVariables
  ],
  // Hands-On Practice reminder to a student about ONE form; `formUrl` opens that form. `statusText`
  // ("You started it but did not submit it." / "Your teacher sent it back…"), `dueText` ("It is due …" /
  // "It was due … You can still submit it.") and `note` ("Note from Jitu: …") are full sentences,
  // empty when not needed. `dueDate` is the form's due date, empty when it has none.
  [ENotificationRulesType.HOP_SUBMISSION_REMINDER]: [
    "programName",
    "formTitle",
    "statusText",
    "dueDate",
    "dueText",
    "note",
    "senderName",
    "formUrl",
    ...userProfileVariables
  ],
  // Hands-On Practice note from an admin about one submission, to its teacher or its student.
  // `aboutText` names the submission for the reader ("Aimée's Hop" / "your Hop"); `openUrl` opens it
  // (the teacher's review page, or the student's form page) and `buttonText` labels that link.
  [ENotificationRulesType.HOP_ADMIN_NOTE]: [
    "programName",
    "formTitle",
    "studentName",
    "aboutText",
    "note",
    "senderName",
    "openUrl",
    "buttonText",
    ...userProfileVariables
  ],
  // Pro Directory notifications
  [ENotificationRulesType.PRO_DIRECTORY_APPROVED]: [
    "programName",
    ...userProfileVariables
  ],
  [ENotificationRulesType.PRO_DIRECTORY_REJECTED]: [
    "programName",
    "rejectionReason",
    ...userProfileVariables
  ],
  [ENotificationRulesType.PRO_DIRECTORY_SUBMISSION_CONFIRMED]: [
    "programName",
    ...userProfileVariables
  ],
  [ENotificationRulesType.PRO_DIRECTORY_SUBMITTED]: [
    "programName",
    "name",
    "email",
    "dashboardUrl",
    "revisionId"
  ],
  [ENotificationRulesType.PASSWORD_RESET]: [
    "resetUrl",
    "expiresInMinutes",
    "username",
    "firstName",
    "lastName",
    "displayName",
    "name",
    "email"
  ],
  // Secure email-change flow
  [ENotificationRulesType.EMAIL_CHANGE_VERIFY]: [
    "verifyUrl",
    "expiresInHours",
    "newEmail",
    "oldEmail",
    "firstName",
    "displayName",
    "name"
  ],
  [ENotificationRulesType.EMAIL_CHANGE_SECURITY_ALERT]: [
    "cancelUrl",
    "newEmail",
    "oldEmail",
    "requestedAt",
    "firstName",
    "displayName",
    "name"
  ],
  [ENotificationRulesType.EMAIL_CHANGE_CONFIRMED]: [
    "newEmail",
    "oldEmail",
    "changedAt",
    "firstName",
    "displayName",
    "name"
  ],
  [ENotificationRulesType.SUPPORT_NEW_TICKET]: [
    "ticketId",
    "ticketTitle",
    "userEmail",
    "product",
    "dashboardUrl"
  ],
  [ENotificationRulesType.SUPPORT_TICKET_REPLY]: [
    "ticketId",
    "ticketTitle",
    "staffName",
    "replySnippet",
    "ticketUrl"
  ],
  // Badge / trophy notifications — title & body are supplied on the payload; these are for template-editing completeness
  [ENotificationRulesType.FIT_BADGE_EARNED]: [
    "badgeName",
    ...userProfileVariables
  ]
};

// src/notification/rule/be-schema.ts
var NotificationRuleSchemaBE = object31({
  id: number15().positive().int().min(1),
  name: string32().min(1),
  app: AppNameEnumObj,
  type: NotificationTypeEnumObject,
  conditionsJson: RuleConditionJsonSchemaBE,
  template: NotificationTemplateSchemaBE,
  workflowId: string32().min(1, "Workflow ID is required").describe("novu workflow identifier. (e.g post-purchase)"),
  channels: array9(NotificationChannelEnumObject).min(1, "Select at least one channel"),
  isActive: boolean11().optional(),
  createdBy: number15().nullable(),
  updatedBy: number15().nullable(),
  createdAt: string32(),
  updatedAt: string32()
});

// src/notification/rule/be-request-schema.ts
var APP_PUSH_INVALID_CHARS = /[<>\u0000-\u0008\u000B\u000C\u000E-\u001F]/;
var APP_PUSH_PLAIN_TEXT_MESSAGE = "App-push templates must be plain text \u2014 HTML tags and special characters are not allowed";
var validateRuleChannels = /* @__PURE__ */ __name((data, ctx) => {
  if (data.channels.includes(ENotificationChannel.EMAIL) && data.channels.length > 1) {
    ctx.addIssue({
      code: z78.ZodIssueCode.custom,
      path: [
        "channels"
      ],
      message: "EMAIL cannot be combined with other channels \u2014 create a separate rule for email"
    });
    return;
  }
  const isPushOnly = data.channels.includes(ENotificationChannel["App-push"]) && !data.channels.includes(ENotificationChannel["In-App"]);
  if (!isPushOnly) {
    return;
  }
  if (APP_PUSH_INVALID_CHARS.test(data.template.subject)) {
    ctx.addIssue({
      code: z78.ZodIssueCode.custom,
      path: [
        "template",
        "subject"
      ],
      message: APP_PUSH_PLAIN_TEXT_MESSAGE
    });
  }
  if (APP_PUSH_INVALID_CHARS.test(data.template.body)) {
    ctx.addIssue({
      code: z78.ZodIssueCode.custom,
      path: [
        "template",
        "body"
      ],
      message: APP_PUSH_PLAIN_TEXT_MESSAGE
    });
  }
}, "validateRuleChannels");
var CreateNotificationRuleObjectSchemaBE = NotificationRuleSchemaBE.pick({
  name: true,
  app: true,
  type: true,
  conditionsJson: true,
  workflowId: true,
  channels: true,
  isActive: true
}).extend({
  template: CreateTemplateSchema
});
var CreateNotificationRuleSchemaBE = CreateNotificationRuleObjectSchemaBE.superRefine(validateRuleChannels);
var UpdateNotificationRuleSchemaBE = CreateNotificationRuleObjectSchemaBE.extend({
  template: CreateTemplateSchema.extend({
    id: coerce15.number()
  })
}).superRefine(validateRuleChannels);

// src/notification/rule/export-schema.ts
import { array as array10, boolean as boolean12, literal, number as number16, object as object32, string as string33 } from "zod";
var RULE_EXPORT_VERSION = "1.1";
var NotificationRuleExportItemSchemaBE = CreateNotificationRuleObjectSchemaBE.omit({
  isActive: true
}).superRefine(validateRuleChannels);
var NotificationRuleExportSchemaBE = object32({
  version: literal(RULE_EXPORT_VERSION),
  exportedAt: string33(),
  rules: array10(NotificationRuleExportItemSchemaBE).min(1, "Export must contain at least one rule")
});
var ImportNotificationRulesSchemaBE = NotificationRuleExportSchemaBE.extend({
  overwrite: boolean12().optional().default(false).describe("Rewrite rules that already exist instead of skipping them")
});
var NotificationRuleExportQuerySchema = NotificationFindAllRequestQuerySchema.omit({
  page: true,
  perPage: true
});
var NotificationRuleImportResultSchemaBE = object32({
  created: array10(object32({
    id: number16(),
    name: string33()
  })),
  updated: array10(object32({
    id: number16(),
    name: string33()
  })),
  skipped: array10(object32({
    name: string33(),
    reason: string33()
  }))
});

// src/notification/user-management/get-users-request.ts
import { coerce as coerce16, object as object33, string as string34 } from "zod";
var GetNotificationUsersRequestBESchema = object33({
  tierInfo: coerce16.number().optional(),
  subscriptionsType: AppNameEnumObj.array(),
  limit: coerce16.number().max(100),
  page: coerce16.number(),
  query: string34().optional()
});

// src/playlist/base.ts
import { coerce as coerce26, number as number21, object as object47, string as string43, z as z101 } from "zod";

// src/fit/challenge/base.ts
import { z as z83 } from "zod";

// src/fit/challenge-content/base.ts
import { z as z81 } from "zod";

// src/fit/content/schema.ts
import { array as array11, boolean as boolean13, coerce as coerce17, lazy as lazy3, object as object34, string as string35, union as union4, z as z79 } from "zod";
var FITCommonContentFields = object34({
  id: string35(),
  name: string35().min(3, "name is required"),
  category: CategoryEnumObj,
  instructor: Instructor,
  watchedDate: coerce17.string().optional(),
  createdAt: coerce17.date(),
  updatedAt: coerce17.date()
});
var FITBareContent = FITCommonContentFields.extend({
  type: lazy3(() => ContentTypeEnumObj),
  status: StatusEnumObj,
  video: VimeoVideo,
  isAllowComment: coerce17.boolean().default(false),
  equipments: lazy3(() => Equipment.array()),
  publishedDate: z79.union([
    z79.string(),
    z79.date(),
    CustomLuxonDateSchema
  ]),
  averageRating: lazy3(() => RatingIndicator),
  isNew: coerce17.boolean().default(false).optional(),
  favorite: coerce17.boolean().default(false).optional(),
  instructorId: string35(),
  // this is needed for for react rendering. id is not unique in watch history response.
  uniqueId: string35().optional()
});
var FITContent = FITBareContent.extend({
  parentPlaylistsIds: string35().array().default([]).optional(),
  userHasLeftRating: coerce17.boolean().default(false).optional(),
  instructor: Instructor
});
var FITTrashContentSchema = FITCommonContentFields.extend({
  status: z79.literal(StatusEnum.TRASH),
  video: lazy3(() => TrashContentVimeoVideo)
});
var FITContentWithRatingFlagSchema = FITContent.extend({
  createdAt: coerce17.date(),
  updatedAt: coerce17.date(),
  publishedDate: z79.union([
    z79.string(),
    z79.date()
  ]).optional().nullable(),
  instructor: Instructor.extend({
    id: z79.union([
      coerce17.string(),
      coerce17.number()
    ]),
    createdAt: coerce17.date(),
    updatedAt: coerce17.date()
  }),
  userHasLeftRating: coerce17.boolean()
});
var FITContentFindAllResponseSchema = object34({
  items: FITContentWithRatingFlagSchema.array(),
  meta: object34({
    page: coerce17.number(),
    perPage: coerce17.number(),
    total: coerce17.number(),
    totalPages: coerce17.number()
  })
});
var FITContentAndTrashContentUnion = z79.union([
  FITContent,
  FITTrashContentSchema
]);
var FITContentWithWatchedDate = FITContent.extend({
  watchedDate: string35().or(CustomLuxonDateSchema)
});
var FITContentByDate = object34({
  id: string35(),
  activeOn: string35(),
  createdAt: coerce17.date(),
  updatedAt: coerce17.date(),
  content: FITContent
});
var FITContentResponseSchema = object34({
  items: FITContent.array().nullable(),
  // Computed from the requesting user's profile/subscription so the client can
  // lock cards straight from this response — no separate permissions request.
  hasAccess: boolean13().optional(),
  meta: object34({
    total: coerce17.number(),
    page: coerce17.number(),
    perPage: coerce17.number(),
    totalPages: coerce17.number()
  })
});
var FITContentByDateResponseSchema = object34({
  items: union4([
    array11(FITContentByDate),
    z79.null()
  ]),
  meta: object34({
    startDate: string35(),
    endDate: string35()
  })
});
var FITDateRangeQuerySchema = object34({
  startDate: string35().nullable(),
  endDate: string35().nullable(),
  page: coerce17.number().optional()
});
var FITUserContentRatingResponse = array11(RatingIndicator);
var FITWatchedStatusEnumValues = [
  "WATCHED",
  "UNWATCHED",
  "ALL"
];
var FITWatchedStatusEnumObj = z79.enum(FITWatchedStatusEnumValues);
var FITWatchedFilterEnum = FITWatchedStatusEnumObj.enum;

// src/fit/challenge-content/type.enum.ts
import { z as z80 } from "zod";
var FitChallengeContentTypeValues = [
  "event",
  "content"
];
var FitChallengeContentTypeEnumObject = z80.enum(FitChallengeContentTypeValues);
var EFitChallengeContentType = FitChallengeContentTypeEnumObject.enum;

// src/fit/challenge-content/base.ts
var BaseFitChallengeContentSchema = z81.object({
  id: z81.number().int().positive(),
  contentId: z81.string().max(36),
  type: FitChallengeContentTypeEnumObject,
  dayIndex: z81.number().int().min(1),
  createdAt: z81.date(),
  updatedAt: z81.date(),
  content: z81.lazy(() => FITContent.passthrough()).optional(),
  event: z81.lazy(() => BaseEventSchema.passthrough()).optional()
});

// src/fit/challenge/maintained-by.ts
import { z as z82 } from "zod";
var FitChallengeMaintainedBySchema = z82.record(z82.string().datetime(), z82.string());

// src/fit/challenge/base.ts
var BaseFitChallengeSchema = z83.object({
  id: z83.number().int().positive(),
  title: z83.string().max(255),
  description: z83.string().max(255).nullable().optional(),
  isActive: z83.boolean(),
  startDate: z83.string().datetime(),
  createdAt: z83.string(),
  updatedAt: z83.string(),
  maintainedBy: FitChallengeMaintainedBySchema,
  contents: z83.lazy(() => z83.array(BaseFitChallengeContentSchema.passthrough()).optional()),
  isChallengeRunning: z83.boolean().optional().transform((value) => value != null ? value : false),
  isChallengeFinished: z83.boolean().optional().transform((value) => value != null ? value : false),
  isChallengeStarted: z83.boolean().optional().transform((value) => value != null ? value : false),
  bufferDays: z83.number().int().optional(),
  isWithinOfficialChallengeDates: z83.boolean().optional().transform((value) => value != null ? value : false)
});

// src/fit/challenge/fe-schema.ts
import { z as z84 } from "zod";
var ChallengeFormContentSchemaFE = BaseFitChallengeContentSchema.pick({
  type: true,
  dayIndex: true
}).extend({
  contentId: z84.string().min(1, "Select a content or event").max(36)
});
var ChallengeFormSchemaFE = BaseFitChallengeSchema.pick({
  title: true,
  description: true
}).extend({
  title: z84.string().trim().min(1, "Title is required").max(255),
  description: z84.string().trim().max(255).nullable().optional(),
  startDate: z84.coerce.date(),
  bufferDays: z84.coerce.number().int().min(0).default(0),
  contents: z84.array(ChallengeFormContentSchemaFE).min(1, "Add at least one day")
});

// src/fit/challenge/status.ts
import { boolean as boolean14, object as object35 } from "zod";
var ChallengeCompletionStatusSchema = object35({
  earnedDailyDedication: boolean14().describe("Given if daily dedication badge is already earned!"),
  earnedChallengeChampion: boolean14().describe("Given if challenge champion badge is already earned!"),
  canEarnDailyDedication: boolean14().describe("Given if all day badges are earned!"),
  canEarnChallengeChampion: boolean14().describe("Given if all video badges are earned!")
}).strict();

// src/fit/community-updates/activity.ts
import { z as z85 } from "zod";
var CommunityActivityTypeEnum = {
  COMMENT: "COMMENT",
  REACTION: "REACTION"
};
var CommunityUpdatesEventPattern = {
  ADD_ACTIVITY: "community-updates.add",
  REMOVE_ACTIVITY: "community-updates.remove"
};
var CommunityActivitySchema = z85.object({
  id: z85.string(),
  type: z85.enum([
    CommunityActivityTypeEnum.COMMENT,
    CommunityActivityTypeEnum.REACTION
  ]),
  contentId: z85.string(),
  contentName: z85.string(),
  contentCategory: CategoryEnumObj,
  instructorName: z85.string(),
  parentPlaylistsIds: z85.array(z85.string()).default([]),
  user: z85.object({
    id: z85.string(),
    name: z85.string(),
    avatarUrl: z85.string().nullable().optional()
  }),
  commentText: z85.string().nullable().optional(),
  hasRating: z85.boolean(),
  createdAt: z85.string()
});
var CommunityActivityResponseSchema = z85.object({
  activities: z85.array(CommunityActivitySchema)
});

// src/fit/community-updates/namespace.ts
var CommunityUpdatesNamespace = "community-updates";
var COMMUNITY_UPDATES_MAX_ITEMS = 5;

// src/fit/content/be-schema.ts
import { coerce as coerce19, lazy as lazy5, object as object37, string as string36, z as z87 } from "zod";

// src/fit/content/fe-schema.ts
import { coerce as coerce18, lazy as lazy4, object as object36, z as z86 } from "zod";
var CreateContentBasicSchemaFE = FITContent.omit({
  id: true,
  video: true,
  instructor: true,
  createdAt: true,
  updatedAt: true,
  isNew: true,
  status: true
}).extend({
  instructorId: coerce18.string(),
  equipments: coerce18.number().array().min(1, "Please select at least one equipment"),
  isAllowComment: coerce18.boolean().default(false),
  status: lazy4(() => StatusEnumObj),
  publishedDate: z86.string().or(CustomLuxonDateSchema).optional()
});
var CreateContentVideoSchemaFE = object36({
  video: VimeoVideoInput
});
var CreateContentSchemaFE = CreateContentBasicSchemaFE.omit({
  averageRating: true
}).merge(CreateContentVideoSchemaFE).refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var CreateContentSchemaFEWithoutValidation = CreateContentBasicSchemaFE.omit({
  averageRating: true
}).merge(CreateContentVideoSchemaFE);
var UpdateContentSchemaFE = CreateContentSchemaFEWithoutValidation.partial();
var FITDashboardUpdateContentSchemaFE = UpdateContentSchemaFE;
var FITDashboardCreateContentSchemaFEWithoutValidation = CreateContentSchemaFEWithoutValidation;
var FITDashboardCreateContentSchemaFE = CreateContentSchemaFE;
var defaultContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  isAllowComment: false,
  type: "VIDEO",
  favorite: false,
  category: "STRENGTH",
  status: "PUBLISHED",
  publishedDate: void 0
};

// src/fit/content/be-schema.ts
var CreateContentSchemaBEBase = CreateContentSchemaFEWithoutValidation.extend({
  category: lazy5(() => CategoryEnumObj),
  app: AppNameEnumObj,
  equipments: object37({
    id: coerce19.number().min(1, "id is required")
  }).array().min(1, "Please select at least one equipment"),
  video: VimeoVideoInput,
  publishedDate: z87.string().or(CustomLuxonDateSchema).optional().nullable(),
  id: string36().optional(),
  instructorId: string36().optional()
});
var CreateContentSchemaBE = CreateContentSchemaBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var UpdateContentSchemaBE = CreateContentSchemaBEBase.partial();

// src/fit/content/complete-content-action.enum.ts
import { z as z88 } from "zod";
var CompleteContentActionValues = [
  "1min_before_finish",
  "2min_watch",
  "5min_watch"
];
var CompleteContentActionEnumObject = z88.enum(CompleteContentActionValues);
var ECompleteContentAction = CompleteContentActionEnumObject.enum;

// src/fit/content/complete-content.request.ts
import { object as object42, string as string40 } from "zod";

// src/tracking/user-log/action.enum.ts
import { z as z89 } from "zod";
var UserLogActionValues = [
  "CHECKIN",
  "WATCH_COMPLETE",
  "ATTENDING_LIVE",
  "PURCHASE",
  "PURCHASE_FAILED",
  "PURCHASE_CANCELLED",
  "PURCHASE_REFUND",
  "PURCHASE_PROCESSING",
  "PURCHASE_PENDING",
  "PURCHASE_ON_HOLD",
  "PURCHASE_PROCESSING",
  "VIDEO_PLAY",
  "PURCHASE_PENDING_CANCEL",
  "PURCHASE_EXPIRED",
  // Community hub — navigation
  "LESSON_VIEW",
  "MODULE_VIEW",
  "SPACE_VIEW",
  "COMMUNITY_VIEW",
  // Community hub — content block views
  "VIDEO_VIEW",
  "PDF_VIEW",
  "QUIZ_VIEW",
  "EMBED_VIEW",
  "FORM_VIEW",
  "GCS_UPLOAD_VIEW",
  "TEXT_VIEW",
  // Community hub — video lifecycle
  "VIDEO_COMPLETE",
  "VIDEO_PROGRESS_25",
  "VIDEO_PROGRESS_50",
  "VIDEO_PROGRESS_75",
  "VIDEO_PROGRESS_100",
  // Community hub — form submission states
  "FORM_SUBMISSION_IN_PROGRESS",
  "FORM_SUBMITTED",
  // Hands-On Practice review — logged for the student (it is their progress), with
  // the teacher, submission and Teacher Review space in meta. Written from the
  // Teacher Review service; the form's own submit stays FORM_SUBMITTED.
  "HOP_FEEDBACK_SENT",
  "HOP_FEEDBACK_UPDATED",
  "HOP_SUBMISSION_REJECTED",
  // Community hub — quiz completion states. Written to user_log from
  // GradingService (mirroring the form actions) and also recorded in
  // ch_quiz_attempts, which analytics reads for historical attempts.
  "QUIZ_SUBMITTED",
  "QUIZ_PASSED",
  // Community hub — GCS upload status transitions
  "GCS_UPLOAD_STARTED",
  "GCS_UPLOAD_IN_BUCKET",
  "GCS_UPLOAD_IN_DRIVE",
  "GCS_UPLOAD_FAILED",
  // Community hub — social feed
  "POST_VIEW",
  "POST_CREATE",
  "COMMENT_CREATE",
  "REACTION_ADD",
  // Events — join/leave tracking (standalone, not tied to spaces)
  "EVENT_JOIN",
  "EVENT_LEAVE",
  // Admin actions
  "ADMIN_GIVEN_ACCESS",
  // Admin granted product/app access to every member of a user group (one
  // summary record per operation, logged against the admin; each member also
  // gets its own ADMIN_GIVEN_ACCESS row carrying the group context in meta).
  "ADMIN_GROUP_GIVEN_ACCESS"
];
var UserLogActionEnumObj = z89.enum(UserLogActionValues);
var EUserLogActionEnum = UserLogActionEnumObj.enum;

// src/tracking/user-log/base.ts
import { coerce as coerce20, object as object38, string as string37, z as z90 } from "zod";
var UserLogBaseSchema = object38({
  id: coerce20.number().min(1, "id is required"),
  action: UserLogActionEnumObj,
  // Optional at the base level: purchase rows carry no app name (they have
  // productId instead). Non-purchase writes tighten this to required via
  // CreateUserLogSchemaBE.
  appName: string37().min(1).optional(),
  appTrackingId: string37().nullable().optional(),
  productId: string37().nullable().optional(),
  contentId: string37().min(1, "content id is required").nullable().optional(),
  contentTitle: string37().min(1, "content title is required").nullable().optional(),
  createdAt: string37().or(CustomLuxonDateSchema).or(z90.instanceof(Date)),
  ipAddress: string37().min(1, "ip address is required").nullable().optional(),
  userId: string37().min(1, "user id is required"),
  meta: z90.record(z90.any()).nullable().optional(),
  skipAddWatchPoint: z90.boolean().optional()
});
var UserLogBaseSchemaWithFullContent = UserLogBaseSchema.extend({
  content: Content
});

// src/tracking/user-log/be-schema.ts
import { coerce as coerce22, z as z94 } from "zod";

// src/emailer/be-schema.ts
import { coerce as coerce21, number as number17, object as object39, string as string38, z as z92 } from "zod";

// src/emailer/send-reason.enum.ts
import { z as z91 } from "zod";
var EmailSentReasonValues = [
  "COMPLETED_STEP_5",
  "COMPLETED_STEP_6_DAY_2",
  "COMPLETED_STEP_8",
  "COMPLETED_STEP_9_DAY_2",
  "COMPLETED_STEP_2",
  "COMPLETED_STEP_3_DAY_2",
  "IMMEDIATELY_AFTER_PURCHASE",
  "THREE_DAYS_AFTER_PURCHASE",
  "EIGHT_DAYS_AFTER_PURCHASE",
  "FIFTEEN_DAYS_AFTER_PURCHASE",
  "TWENTY_FIVE_DAYS_AFTER_PURCHASE",
  "NINE_DAYS_AFTER_PURCHASE_WITH_SEVEN_DAYS_LOGIN",
  "FIFTEEN_DAYS_AFTER_PURCHASE_WITH_THIRTEEN_DAYS_LOGIN",
  "DID_NOT_TRY_PROGRAM_AFTER_SEVEN_DAYS",
  "THIRTEEN_DAYS_AFTER_PURCHASE",
  "DID_NOT_TRY_PROGRAM_AFTER_FOURTEEN_DAYS",
  "DID_NOT_TRY_PROGRAM_AFTER_TWENTY_FOUR_DAYS",
  "NOT_LOGGED_IN_FOR_SEVEN_DAYS",
  "NOT_LOGGED_IN_FOR_FOURTEEN_DAYS",
  "THIRTY_DAYS_AFTER_PURCHASE_NO_LOGIN",
  "PURCHASE_OVER_EIGHT_DAYS_LOGIN_SIX_DAYS"
];
var EmailSendReasonObj = z91.enum(EmailSentReasonValues);
var EEmailSentReason = EmailSendReasonObj.enum;

// src/emailer/be-schema.ts
var SendEmailSchema = object39({
  email: string38().email(),
  emailType: EmailSendReasonObj,
  context: object39({
    name: string38(),
    userId: coerce21.string(),
    tier: number17()
  })
});
var EmailMetaSchema = object39({
  email: string38().email(),
  body: string38(),
  context: object39({
    name: string38(),
    userId: coerce21.string(),
    subject: string38()
  })
});
var SendStepAndDayCompletionSchema = object39({
  email: string38().email(),
  name: string38(),
  step: number17(),
  day: number17()
});
var EImmediateAfterPurchaseSchema = SendEmailSchema.omit({
  emailType: true
});
var SendTransactionalEmailSchema = object39({
  to: string38().email(),
  ruleName: string38(),
  context: z92.record(string38(), string38()),
  userId: string38().optional(),
  replyTo: string38().email().optional()
});

// src/emailer/email-status.enum.ts
import { z as z93 } from "zod";
var EmailSentStatusValues = [
  "COMPLETED",
  "SCHEDULED",
  "FAILED"
];
var EmailSentStatusObj = z93.enum(EmailSentStatusValues);
var EEmailSentStatus = EmailSentStatusObj.enum;

// src/emailer/send-email-response.ts
import { boolean as boolean15, number as number18, object as object40, string as string39 } from "zod";
var EmailReturnResponse = object40({
  to: string39().email(),
  subject: string39(),
  body: string39(),
  status: string39(),
  persistInDb: boolean15()
});
var EmailResponse = object40({
  accepted: string39().array(),
  rejected: string39().array(),
  ehlo: string39().array(),
  envelopeTime: number18(),
  messageTime: number18(),
  messageSize: number18(),
  response: string39(),
  envelope: object40({
    from: string39(),
    to: string39().array()
  }),
  messageId: string39()
});

// src/tracking/user-log/be-schema.ts
var PurchaseProductSchema = z94.object({
  product_id: z94.number().int(),
  variation_id: z94.number().int().nullable().optional(),
  subscription_id: z94.number().int().nullable().optional(),
  product_name: z94.string().optional(),
  tier: z94.number().optional(),
  price: z94.number().optional(),
  quantity: z94.number().int().optional()
});
var CreateUserLogSchemaBE = UserLogBaseSchema.omit({
  id: true,
  createdAt: true
}).extend({
  appName: z94.string().min(1, "app name is required")
});
var CreatePurchaseLogSchemaBE = UserLogBaseSchema.omit({
  id: true,
  createdAt: true,
  action: true,
  contentId: true,
  appName: true
}).extend({
  email: z94.string().email("Invalid email format")
});
var UserDayChangeSchemaBe = z94.object({
  email: z94.string().email(),
  eventType: EmailSendReasonObj,
  appName: AppNameEnumObj,
  tier: z94.number(),
  userId: z94.string().min(1, "user id is required"),
  name: z94.string().min(1, "name is required")
});
var AfterPurchaseRequestDtoBe = z94.object({
  appName: z94.string().optional(),
  productId: z94.string().optional(),
  userId: z94.string().min(1, "user id is required"),
  name: z94.string().min(1, "name is required"),
  action: UserLogActionEnumObj,
  // Purchase identifiers live inside `meta` — they're stored in the
  // `meta_information` jsonb column on user_log, not as first-class columns.
  // `.passthrough()` keeps other keys (email, tier, wpUserId, etc.) intact.
  meta: z94.object({
    orderId: z94.number().int().nullable().optional(),
    subscriptionId: z94.number().int().nullable().optional(),
    status: z94.string().max(30).nullable().optional(),
    tier: TiersEnumObject.optional(),
    email: z94.string().email().optional(),
    wpUserId: z94.string().optional(),
    product: PurchaseProductSchema.optional()
  }).passthrough().optional()
});
var UserLogFilterDtoBe = z94.object({
  page: coerce22.number(),
  perPage: coerce22.number().max(150),
  userId: z94.string().min(1, "user id is required"),
  appName: AppNameEnumObj,
  actions: UserLogActionEnumObj.array().optional()
});
var FindOneUserLogSchemaBe = z94.object({
  userId: z94.string().min(1)
});
var GetEventAttendeesSchemaBe = z94.string().min(1);
var FindUserLogSchemaBe = z94.object({
  userId: z94.string().optional(),
  appName: z94.string(),
  perPage: coerce22.number().optional(),
  page: coerce22.number().optional(),
  period: z94.string().optional(),
  date: z94.string().optional(),
  month: z94.string().optional(),
  // Inclusive ISO date (yyyy-MM-dd) range, resolved in the user's timezone.
  // Takes precedence over period/date/month when supplied.
  startDate: z94.string().optional(),
  endDate: z94.string().optional(),
  contentIds: z94.array(z94.string()).optional(),
  action: z94.array(UserLogActionEnumObj)
});
var UserCheckInSchemaBe = z94.object({
  appName: z94.string(),
  userId: z94.string(),
  page: z94.number(),
  perPage: z94.number()
});
var UserLastCheckInSchemaBe = z94.object({
  userId: z94.string(),
  appName: z94.string()
});

// src/tracking/user-log/purchase-request.ts
import { z as z95 } from "zod";
var PurchaseStatusValues = [
  "active",
  "expired",
  "cancelled",
  "completed",
  "failed",
  "refunded",
  "processing",
  "on-hold",
  "pending",
  "pending-cancel"
];
var PurchaseStatusEnum = z95.enum(PurchaseStatusValues);
var EPurchaseStatusEnum = PurchaseStatusEnum.enum;
var PurchaseRequestSchema = z95.object({
  appName: AppNameEnumObj.optional(),
  productId: z95.string().min(1, "product id is required"),
  userId: z95.string().min(1, "user id is required"),
  name: z95.string().min(1, "name is required"),
  email: z95.string().email("Invalid email format"),
  status: PurchaseStatusEnum,
  meta: z95.record(z95.any()).optional()
});

// src/tracking/watch-history/base.ts
import { coerce as coerce23, object as object41 } from "zod";
var WatchHistoryBaseSchema = object41({
  id: coerce23.number(),
  userId: coerce23.string().min(1, "user id is required"),
  contentId: coerce23.string().min(1, "content id is required"),
  seriesId: coerce23.number().nullable().optional(),
  createdAt: coerce23.string().or(CustomLuxonDateSchema)
});

// src/tracking/watch-history/be-schema.ts
import { z as z96 } from "zod";
var CreateWatchHistoryBeSchema = WatchHistoryBaseSchema.omit({
  id: true,
  createdAt: true
}).extend({
  email: z96.string().email("Invalid email format").optional()
});
var UpdateWatchHistoryBeSchema = CreateWatchHistoryBeSchema.partial();
var GetActivityDatesByMonthBeSchema = z96.object({
  appName: AppNameEnumObj,
  userId: z96.string(),
  timezone: z96.string(),
  month: z96.number(),
  year: z96.number()
});
var FindAllWatchHistoryBeSchema = z96.object({
  userId: z96.string().optional(),
  appName: z96.string(),
  perPage: z96.coerce.number().optional(),
  page: z96.coerce.number().optional(),
  period: z96.string().optional(),
  date: z96.string().optional(),
  month: z96.string().optional(),
  contentIds: z96.array(z96.string()).optional()
});
var FindAllByContentIdBeSchema = z96.object({
  contentId: z96.string().min(1),
  appName: z96.string().min(1),
  perPage: z96.coerce.number().optional(),
  page: z96.coerce.number().optional()
});
var FindOneWatchHistoryBeSchema = z96.object({
  id: z96.number().optional(),
  userId: z96.string().optional(),
  contentId: z96.string().optional(),
  appName: z96.string().min(1)
}).refine((data) => data.id !== void 0 || data.userId !== void 0 && data.contentId !== void 0, {
  message: "Either id or both userId and contentId must be provided"
});
var DeleteWatchHistoryBeSchema = z96.object({
  userId: z96.string(),
  appName: z96.string()
});

// src/fit/content/complete-content.request.ts
var CompleteContentRequestSchema = object42({
  contentId: string40(),
  action: UserLogActionEnumObj,
  app: AppNameEnumObj
});

// src/fit/onboarding/base.ts
import { coerce as coerce25, object as object44, string as string41 } from "zod";

// src/fit/onboarding/step.ts
import { coerce as coerce24, object as object43, z as z98 } from "zod";

// src/fit/onboarding/step.enum.ts
import { z as z97 } from "zod";
var FitOnboardingStepValues = [
  "WELCOME",
  "MILESTONE_NAV"
];
var FitOnboardingStepEnumObject = z97.enum(FitOnboardingStepValues);
var EFitOnboardingStep = FitOnboardingStepEnumObject.enum;

// src/fit/onboarding/step.ts
var FitOnboardingStepSchema = object43({
  id: coerce24.number().int().positive(),
  name: FitOnboardingStepEnumObject,
  isCompleted: CoerceBoolean,
  updatedAt: coerce24.string().date()
});
var CreateFitOnboardingStepSchemaBE = FitOnboardingStepSchema.extend({
  isCompleted: z98.boolean()
});
var UpdateFitOnboardingStepSchemaBE = object43({
  step: FitOnboardingStepEnumObject,
  timezone: z98.string().optional()
});

// src/fit/onboarding/base.ts
var FitOnboardingProgressSchema = object44({
  onboarding: FitOnboardingStepSchema.array(),
  tour: FitOnboardingStepSchema.array()
});
var BaseFitOnboardingSchema = object44({
  id: coerce25.number(),
  progress: FitOnboardingProgressSchema,
  userId: string41(),
  createdAt: coerce25.string().date(),
  updatedAt: coerce25.string().date()
});

// src/fit/onboarding/be-schema.ts
var CreateFitOnboardingSchemaBE = CreateFitOnboardingStepSchemaBE.array();

// src/fit/user-online/namespace.ts
var UserOnlineNamespace = "i-am-online";

// src/fit/user-online/pub-sub.ts
import { lazy as lazy7, z as z99 } from "zod";

// src/fit/user-online/user.ts
import { boolean as boolean16, lazy as lazy6, number as number19, object as object45, string as string42 } from "zod";
var UserOnlineLastWatchedContentSchema = BareContent.pick({
  id: true,
  name: true
}).extend({
  instructor: Instructor.pick({
    id: true,
    firstName: true,
    lastName: true
  }).nullable().optional()
});
var OnlineUserSchema = object45({
  id: string42(),
  avatarUrl: string42(),
  name: string42(),
  username: string42(),
  isPrivate: boolean16(),
  isActive: boolean16(),
  app: string42(),
  lastWatchedContent: lazy6(() => UserOnlineLastWatchedContentSchema.nullable().optional()),
  timestamp: number19()
});

// src/fit/user-online/pub-sub.ts
var USER_ONLINE_REDIS_CHANNEL = "USER_ONLINE";
var UserOnlinePubSubValues = [
  "UPDATE_LAST_WATCHED_CONTENT"
];
var UserOnlinePubSubEnumObject = z99.enum(UserOnlinePubSubValues);
var EUserOnlinePubSub = UserOnlinePubSubEnumObject.enum;
var UpadateUserOnlineLastWatchedContentSchema = z99.object({
  type: z99.literal(EUserOnlinePubSub.UPDATE_LAST_WATCHED_CONTENT),
  userId: z99.string(),
  lastWatchedContent: lazy7(() => UserOnlineLastWatchedContentSchema)
});
var UserOnlinePubSubSchema = z99.discriminatedUnion("type", [
  UpadateUserOnlineLastWatchedContentSchema
]);
var UserOnlinePubSubSchemaStringifiedSchema = UserOnlinePubSubSchema.transform((data) => JSON.stringify(data));
var stringifyUserOnlinePubSubSchema = /* @__PURE__ */ __name((data) => {
  return UserOnlinePubSubSchemaStringifiedSchema.parse(data);
}, "stringifyUserOnlinePubSubSchema");

// src/fit/user-online/response.ts
import { number as number20, object as object46 } from "zod";
var OnlineUsersResponseSchema = object46({
  users: OnlineUserSchema.array(),
  meta: MetaSchema
});
var HeartbeatResponseSchema = object46({
  users: OnlineUserSchema.array(),
  totalUsers: number20(),
  disconnectTimeoutMs: number20()
});

// src/fit/user-online/topics.enum.ts
import { z as z100 } from "zod";
var UserOnlineTopicValues = [
  "JOIN",
  "USER_JOINED",
  "LEAVE",
  "GET_NEXT_PAGE_USERS",
  "GET_PREVIOUS_PAGE_USERS",
  "GET_INITIAL_PUBLIC_USERS",
  "GET_ALL_USERS",
  "REFRESH_USERS",
  "REFRESH_ONLINE_PUBLIC_USERS",
  "NEW_USER"
];
var UserOnlineTopicEnumObject = z100.enum(UserOnlineTopicValues);
var EUserOnlineTopicEnum = UserOnlineTopicEnumObject.enum;

// src/playlist/base.ts
var PlaylistStatusEnumValues = [
  "ACTIVE",
  "DELETED"
];
var PlaylistStatusEnumObj = z101.enum(PlaylistStatusEnumValues);
var PlaylistStatusEnum = PlaylistStatusEnumObj.enum;
var PlaylistItem = object47({
  id: number21(),
  order: number21().int().positive(),
  content: FITContent
});
var PlaylistItemReorder = object47({
  id: number21().optional(),
  order: number21().int().positive(),
  content: object47({
    id: string43()
  })
});
var Playlist = object47({
  id: coerce26.string(),
  name: string43(),
  isFavorite: coerce26.boolean(),
  status: PlaylistStatusEnumObj,
  items: PlaylistItem.array(),
  createdAt: coerce26.string(),
  updatedAt: coerce26.string()
});
var PlaylistFormSchema = Playlist.omit({
  status: true,
  items: true,
  createdAt: true,
  updatedAt: true
});
var CreatePlaylistSchema = Playlist.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdatePlaylistSchema = Playlist.partial().omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  items: true
});
var PlaylistResponseSchema = object47({
  items: Playlist
});
var PlaylistsResponseSchema = object47({
  items: Playlist.array(),
  meta: object47({
    total: z101.number().int().nonnegative(),
    page: z101.number().int().positive(),
    perPage: z101.number().int().positive(),
    totalPages: z101.number().int().nonnegative()
  })
});

// src/playlist/playlist-type.enum.ts
import { z as z102 } from "zod";
var PlaylistTypeValues = [
  "playlist",
  "series"
];
var PlaylistTypeObj = z102.enum(PlaylistTypeValues);
var PlaylistTypeEnum = PlaylistTypeObj.enum;

// src/playlist/requests.schema.ts
import { coerce as coerce27, number as number22, object as object48, string as string44 } from "zod";
var Name = string44().min(1).max(100).trim();
var userId = coerce27.string();
var playlistId = coerce27.number().int().positive();
var id = coerce27.number().int().positive();
var CreatePlaylistRequestSchema = object48({
  name: Name,
  contentId: coerce27.string().optional()
});
var CreatePlaylistBeRequestSchema = CreatePlaylistRequestSchema.extend({
  userId
});
var UpdatePlaylistRequestSchema = object48({
  playlistId,
  name: Name.optional()
});
var ReorderPlaylistRequestSchema = object48({
  items: object48({
    id: number22(),
    order: number22(),
    content: object48({
      id: string44()
    })
  }).array(),
  id
});
var UpdatePlaylistBeRequestSchema = UpdatePlaylistRequestSchema.extend({
  userId
});
var ReorderPlaylistRequestSchemaBE = ReorderPlaylistRequestSchema.extend({
  userId
});
var InsertContentInPlaylistRequestSchema = object48({
  playlistId: playlistId.min(1),
  contentId: string44()
});
var DeleteContentFromPlaylistRequestSchema = object48({
  playlistId: playlistId.min(1),
  itemId: id.min(1)
});
var MovePlaylistContentRequestSchema = object48({
  currentPlaylistId: playlistId.min(1),
  newPlaylistId: playlistId.min(1),
  itemId: id.min(1)
});
var MovePlaylistContentRequestSchemaBE = MovePlaylistContentRequestSchema.extend({
  userId: userId.min(1)
});
var DeleteContentFromPlaylistBeRequestSchema = DeleteContentFromPlaylistRequestSchema.extend({
  userId
});
var InsertContentInPlaylistBeRequestSchema = InsertContentInPlaylistRequestSchema.extend({
  userId
});
var GetFavoriteContentBeRequestSchema = RequestSchema.omit({
  isHidden: true
}).extend({
  userId: string44()
});
var GetPlaylistsRequestSchema = object48({
  page: coerce27.number().int().positive().optional(),
  perPage: coerce27.number().int().positive().max(100).optional()
});
var GetPlaylistsBeRequestSchema = GetPlaylistsRequestSchema.extend({
  userId
});
var GetSinglePlaylistRequestSchema = object48({
  playlistId
});
var GetSinglePlaylistBeRequestSchema = GetSinglePlaylistRequestSchema.extend({
  userId
});
var RemovePlaylistRequestSchema = object48({
  playlistId
});
var RemovePlaylistBeRequestSchema = RemovePlaylistRequestSchema.extend({
  userId
});

// src/playlist/series-type.enum.ts
import { z as z103 } from "zod";
var SeriesTypeValues = [
  "collections",
  "mini-programs"
];
var SeriesTypeObj = z103.enum(SeriesTypeValues);
var SeriesTypeEnum = SeriesTypeObj.enum;

// src/playlist/settings.schema.ts
import { object as object49, string as string45 } from "zod";
var PlaylistSettingsSchema = object49({
  resourceBtnLabel: string45(),
  resourceBtnSubLabel: string45().optional(),
  resourceBtnUrl: string45(),
  resourceBtnLabel2: string45().optional(),
  resourceBtnSubLabel2: string45().optional(),
  resourceBtnUrl2: string45().optional(),
  resourceBtnLabel3: string45().optional(),
  resourceBtnSubLabel3: string45().optional(),
  resourceBtnUrl3: string45().optional()
});

// src/series/base.ts
import { array as array13, coerce as coerce29, number as number24, object as object51, string as string47, z as z105 } from "zod";

// src/series/group-schema.ts
import { array as array12, coerce as coerce28, number as number23, object as object50, string as string46 } from "zod";
var SeriesGroup = object50({
  id: coerce28.string(),
  title: string46().min(1, "Title is required"),
  description: string46().nullable().optional().default(""),
  order: coerce28.number().int().nonnegative().default(0),
  isHidden: CoerceBoolean.default(false).optional()
});
var SeriesGroupResponse = SeriesGroup.extend({
  // Number of visible series assigned to this group. Rendered as the "(8)"
  // next to the group heading.
  seriesCount: coerce28.number().int().nonnegative().default(0).optional()
});
var SeriesGroupListResponseSchema = object50({
  items: SeriesGroupResponse.array(),
  meta: object50({
    total: number23().int().nonnegative(),
    page: number23().int().positive(),
    perPage: number23().int().positive(),
    totalPages: number23().int().nonnegative()
  })
});
var CreateSeriesGroupSchemaFE = SeriesGroup.omit({
  id: true
});
var UpdateSeriesGroupSchemaFE = CreateSeriesGroupSchemaFE.extend({
  id: coerce28.number().int().positive()
});
var defaultSeriesGroupValues = {
  title: "",
  description: "",
  order: 0,
  isHidden: false
};
var ReorderSeriesGroupsSchema = object50({
  ids: array12(coerce28.number().int().positive()).min(1, "At least one group is required")
});
var SeriesGroupSeriesItemSchema = object50({
  id: coerce28.number().int().positive(),
  name: string46(),
  isHidden: CoerceBoolean.default(false),
  groupOrder: coerce28.number().int().nullable()
});
var SeriesGroupSeriesListResponseSchema = object50({
  items: SeriesGroupSeriesItemSchema.array()
});
var ReorderSeriesGroupSeriesSchema = object50({
  seriesIds: array12(coerce28.number().int().positive()).min(1, "At least one series is required")
});

// src/series/section-schema.ts
import { z as z104 } from "zod";
var SeriesSectionInput = z104.object({
  // Stable key used to link items to sections within a single create/update
  // payload. For sections loaded from the DB this is the stringified id; for
  // sections newly added in the dashboard it is a client-generated key. The
  // backend resolves it to the real section id when persisting items.
  key: z104.string(),
  // Present when the section already exists in the DB; absent for new ones.
  id: z104.coerce.number().int().positive().optional().nullable(),
  // Free-text heading shown on the member page (e.g. "Introduction", "Workouts").
  title: z104.string().min(1, "Section title is required"),
  description: z104.string().nullable().optional().default(""),
  order: z104.coerce.number().int().nonnegative()
});
var SeriesSectionResponse = z104.object({
  id: z104.coerce.number(),
  title: z104.string().optional(),
  description: z104.string().nullable().optional().default(""),
  order: z104.coerce.number()
});

// src/series/base.ts
var Series = object51({
  id: coerce29.string(),
  // Slug must look like "example-slug-name": lowercase letters, digits, single
  // dashes between segments, no leading/trailing dashes. Optional at the base
  // level so non-addon series (fit/ryc) keep working unchanged.
  slug: string47().regex(SLUG_PATTERN, "Slug must be lowercase letters, digits and single dashes (e.g. example-slug-name)").optional(),
  classCount: number24().default(0).optional(),
  isFavorite: coerce29.boolean(),
  name: string47(),
  description: string47().nullable().default(""),
  imageUrl: coerce29.string().optional(),
  imageUrl2x: coerce29.string().optional(),
  badgeIcon: z105.string().nullable().optional(),
  isHidden: coerce29.boolean().default(false).optional(),
  requireSequentialCompletion: coerce29.boolean().default(false).optional(),
  settings: PlaylistSettingsSchema.optional(),
  seriesType: z105.preprocess((val) => val === "" ? null : val, SeriesTypeObj.nullable().default(null)),
  // publishDate: string(),
  order: coerce29.number().optional().nullable(),
  startButtonText: string47().optional().nullable(),
  // Top-level grouping on the FIT series page. Null for ungrouped series,
  // which still render in a trailing group. The empty string is normalised to
  // null because the dashboard's "None" option submits `''`, which would
  // otherwise coerce to 0 and fail the positive check.
  groupId: z105.preprocess((val) => val === "" ? null : val, coerce29.number().int().positive().nullable()).optional().default(null),
  // Position inside the group row. Managed from the groups dialog, not the
  // series form — series assigned to a group are appended at the end.
  groupOrder: coerce29.number().int().nullable().optional(),
  // First time the series became visible to members. Null only for a series
  // created hidden and never shown yet.
  publishedAt: coerce29.string().nullable().optional(),
  createdAt: coerce29.string().optional(),
  updatedAt: coerce29.string().optional()
});
var SingleSeries = Series.extend({
  contents: array13(FITContent)
});
var SeriesResponseItem = PlaylistItem.extend({
  section: SeriesSectionResponse.nullable().optional()
});
var SeriesResponseSchema = Series.extend({
  sections: SeriesSectionResponse.array().optional().default([]),
  items: SeriesResponseItem.array(),
  // Hydrated group, present when the series is assigned to one.
  group: SeriesGroupResponse.nullable().optional()
});
var SeriesListResponseSchema = object51({
  items: SeriesResponseSchema.array(),
  meta: object51({
    total: z105.number().int().nonnegative(),
    page: z105.number().int().positive(),
    perPage: z105.number().int().positive(),
    totalPages: z105.number().int().nonnegative()
  })
});
var PublicSeriesSchema = object51({
  id: coerce29.string(),
  name: string47(),
  description: string47().nullable().default(""),
  imageUrl: coerce29.string().optional(),
  imageUrl2x: coerce29.string().optional(),
  classCount: number24().default(0).optional(),
  seriesType: z105.preprocess((val) => val === "" ? null : val, SeriesTypeObj.nullable().default(null)),
  instructorName: string47().nullable().optional()
});
var PublicSeriesListResponseSchema = object51({
  items: PublicSeriesSchema.array(),
  // True when the instructor has no visible series of their own and `items`
  // holds only the newest series across all instructors. (Fewer than three
  // own series are topped up with those too, but that is not flagged.)
  isFallback: z105.boolean().optional().default(false)
});
var SeriesVisibilityStatusValues = [
  "published",
  "scheduled",
  "unpublished",
  "hidden"
];
var SeriesVisibilityStatusEnum = z105.enum(SeriesVisibilityStatusValues);
var SeriesInstructorReportRowSchema = object51({
  seriesId: coerce29.string(),
  seriesName: string47(),
  // Lead instructor: the one with the most published classes in the series.
  // Null when the series has no published class.
  instructorId: string47().nullable(),
  instructorName: string47().nullable(),
  publishedAt: string47().nullable(),
  createdAt: string47(),
  status: SeriesVisibilityStatusEnum,
  classCount: number24(),
  // In the three newest visible series of its lead instructor.
  isDisplayedOnInstructorPage: z105.boolean(),
  // In the three newest visible series overall — what fills the empty slots
  // on the pages of instructors with fewer than three series of their own.
  isGlobalFallback: z105.boolean()
});
var SeriesInstructorReportResponseSchema = object51({
  items: SeriesInstructorReportRowSchema.array(),
  generatedAt: string47()
});
var SeriesGroupWithSeriesSchema = SeriesGroupResponse.extend({
  series: SeriesResponseSchema.array()
});
var GroupedSeriesResponseSchema = object51({
  items: SeriesGroupWithSeriesSchema.array(),
  // Series in no group. Rendered in a trailing row so nothing silently
  // disappears from the page when an admin forgets to assign a series.
  ungrouped: SeriesResponseSchema.array().default([])
});

// src/series/be-schema.ts
import { coerce as coerce30, z as z107 } from "zod";

// src/series/fe-schema.ts
import { array as array14, string as string48, z as z106 } from "zod";
var SeriesFormItem = PlaylistItem.extend({
  sectionKey: string48().nullable().optional()
});
var CreateSeriesSchemaFE = Series.omit({
  id: true,
  isFavorite: true,
  classCount: true,
  imageUrl: true,
  imageUrl2x: true,
  badgeIcon: true,
  settings: true
}).extend({
  imageUrl: string48().optional(),
  imageUrl2x: string48().optional(),
  badgeIcon: string48().optional(),
  // Admin-controlled publication date (drives "newest first" on the instructor
  // sales page; a future date keeps the series off the public site until then).
  // The date picker yields a Luxon DateTime; the API receives the JSON-serialised
  // ISO string. Empty = stamped when the series is first shown.
  publishedAt: z106.union([
    string48().datetime({
      offset: true
    }),
    CustomLuxonDateSchema
  ]).nullable().optional(),
  items: array14(SeriesFormItem),
  // Ordered, per-series list of free-text sections (mini-programs type only).
  sections: array14(SeriesSectionInput).default([]),
  resourceBtnLabel: string48().optional(),
  resourceBtnSubLabel: string48().optional(),
  resourceBtnUrl: string48().optional(),
  resourceBtnLabel2: string48().optional(),
  resourceBtnSubLabel2: string48().optional(),
  resourceBtnUrl2: string48().optional(),
  resourceBtnLabel3: string48().optional(),
  resourceBtnSubLabel3: string48().optional(),
  resourceBtnUrl3: string48().optional()
});
var CreateSeriesFormSchemaFE = CreateSeriesSchemaFE.superRefine((data, ctx) => {
  if (data.sections.length > 0) {
    const sectionKeys = new Set(data.sections.map((section) => section.key));
    data.items.forEach((item, index) => {
      if (item.sectionKey && !sectionKeys.has(item.sectionKey)) {
        ctx.addIssue({
          code: z106.ZodIssueCode.custom,
          path: [
            "items",
            index,
            "sectionKey"
          ],
          message: "This section no longer exists \u2014 pick another one or leave it unassigned"
        });
      }
    });
  }
});
var defaultSeriesSchemaValues = {
  name: "",
  slug: void 0,
  imageUrl: "",
  imageUrl2x: "",
  badgeIcon: "",
  description: "",
  isHidden: false,
  publishedAt: null,
  requireSequentialCompletion: false,
  seriesType: null,
  groupId: null,
  items: [],
  sections: [],
  resourceBtnLabel: "",
  resourceBtnSubLabel: "",
  resourceBtnUrl: "",
  resourceBtnLabel2: "",
  resourceBtnSubLabel2: "",
  resourceBtnUrl2: "",
  resourceBtnLabel3: "",
  resourceBtnSubLabel3: "",
  resourceBtnUrl3: "",
  startButtonText: null
};

// src/series/be-schema.ts
var SeriesItemReorder = PlaylistItemReorder.extend({
  sectionKey: z107.string().nullable().optional()
});
var SeriesSectionFieldsBE = {
  items: SeriesItemReorder.array(),
  sections: SeriesSectionInput.array().optional().default([])
};
var CreateSeriesSchemaBE = CreateSeriesSchemaFE.extend(__spreadValues({}, SeriesSectionFieldsBE));
var CreateSeriesRequestSchemaBE = CreateSeriesSchemaBE.extend({
  userId: coerce30.string()
});
var SeriesItemsRequestSchemaFE = z107.object({
  id: coerce30.number().int().positive(),
  items: SeriesItemReorder.array()
});
var UpdateSeriesRequestSchemaFE = CreateSeriesSchemaFE.merge(SeriesItemsRequestSchemaFE).extend({
  sections: SeriesSectionInput.array().optional().default([])
});

// src/fit/slideshow/badge.ts
import { coerce as coerce31, object as object52, string as string49, z as z108 } from "zod";
var SlideBadgeImagePositionValues = [
  "top-left",
  "top-right",
  "top-center",
  "bottom-left",
  "bottom-right",
  "bottom-center",
  "center"
];
var SlideBadgeImagePositionEnumObj = z108.enum(SlideBadgeImagePositionValues);
var ESlideBadgeImagePositionEnum = SlideBadgeImagePositionEnumObj.enum;
var SlideBadgeDeviceSizesSchema = object52({
  mobile: coerce31.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300"),
  tablet: coerce31.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300"),
  desktop: coerce31.number().min(20, "Size must be at least 20").max(300, "Size must be at most 300")
});
var SlideBadgeDevicePositionsSchema = object52({
  mobile: SlideBadgeImagePositionEnumObj.optional().nullable(),
  tablet: SlideBadgeImagePositionEnumObj.optional().nullable(),
  desktop: SlideBadgeImagePositionEnumObj.optional().nullable()
});
var SlideBadgeSchema = object52({
  image: string49().optional().nullable(),
  positions: SlideBadgeDevicePositionsSchema.optional().nullable(),
  sizes: SlideBadgeDeviceSizesSchema.optional()
});

// src/fit/slideshow/base.ts
import { coerce as coerce32, never as never2, object as object54, string as string51 } from "zod";

// src/fit/slideshow/enums/app.ts
import { z as z109 } from "zod";
var SlideshowAppValues = [
  "fit"
];
var SlideshowAppEnumObj = z109.enum(SlideshowAppValues);
var ESlideshowAppEnum = SlideshowAppEnumObj.enum;

// src/fit/slideshow/enums/type.ts
import { z as z110 } from "zod";
var SlideshowTypeValues = [
  "content",
  "event",
  "series",
  "regular",
  "video"
];
var SlideshowTypeEnumObj = z110.enum(SlideshowTypeValues);
var ESlideshowTypeEnum = SlideshowTypeEnumObj.enum;

// src/fit/slideshow/union.ts
import { lazy as lazy8, literal as literal2, never, object as object53, string as string50, z as z111 } from "zod";
var NeverSchema = never().optional().nullable();
var ImageSchema = string50().min(1, "image url is required");
var ButtonLabelSchema = string50().min(3, "button label is required");
var ButtonUrlSchema = string50().url().min(1, "button url is required");
var BaseDiscriminatedUnion = z111.discriminatedUnion("type", [
  object53({
    type: literal2(ESlideshowTypeEnum.event),
    content: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    event: lazy8(() => BaseEventSchema)
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.content),
    event: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    content: lazy8(() => FITContent)
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.series),
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    series: lazy8(() => Playlist)
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.regular),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    buttonLabel: ButtonLabelSchema,
    buttonUrl: ButtonUrlSchema
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.video),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: string50().min(1, "vimeo video id is required"),
    image: string50().optional().nullable(),
    buttonLabel: string50().optional().nullable(),
    buttonUrl: string50().url().optional().nullable()
  })
]);
var FEDiscriminatedUnion = z111.discriminatedUnion("type", [
  object53({
    type: literal2(ESlideshowTypeEnum.event),
    content: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    event: object53({
      id: string50().min(1, "event id is required")
    })
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.content),
    event: NeverSchema,
    buttonLabel: NeverSchema,
    buttonUrl: NeverSchema,
    series: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    content: object53({
      id: string50().min(1, "content id is required")
    })
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.series),
    event: NeverSchema,
    content: NeverSchema,
    buttonUrl: NeverSchema,
    buttonLabel: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    series: lazy8(() => PlaylistFormSchema)
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.regular),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    vimeoVideoId: NeverSchema,
    image: ImageSchema,
    buttonLabel: ButtonLabelSchema,
    buttonUrl: ButtonUrlSchema
  }),
  object53({
    type: literal2(ESlideshowTypeEnum.video),
    series: NeverSchema,
    event: NeverSchema,
    content: NeverSchema,
    image: string50().optional().nullable(),
    buttonLabel: string50().optional().nullable(),
    buttonUrl: ButtonUrlSchema.optional().nullable(),
    vimeoVideoId: string50().min(1, "vimeo video id is required")
  })
]);

// src/fit/slideshow/base.ts
var EventContentSchema = object54({
  event: never2().optional(),
  content: never2().optional()
});
var FromToDateSchema = object54({
  fromDate: coerce32.string().date().or(CustomLuxonDateSchema).or(string51()),
  toDate: coerce32.string().date().or(CustomLuxonDateSchema).or(string51())
});
var FromToDateNeverSchema = FromToDateSchema.extend({
  fromDate: never2().nullable().optional(),
  toDate: never2().nullable().optional()
});
var FromToDateORSchema = FromToDateSchema.or(FromToDateNeverSchema);
var BaseSlideshowSchemaWithoutUnion = object54({
  id: string51().min(1, "id is required"),
  title: coerce32.string().min(3, "Title is required"),
  image: string51().optional().nullable(),
  vimeoVideoId: string51().optional().nullable(),
  isActive: coerce32.boolean().default(true),
  subtitle: string51().optional().nullable(),
  description: string51().optional().nullable(),
  type: SlideshowTypeEnumObj.default("event"),
  badge: SlideBadgeSchema.optional().nullable().default(null),
  createdAt: coerce32.date(),
  updatedAt: coerce32.date()
});
var BaseSlideshowSchema = BaseSlideshowSchemaWithoutUnion.and(BaseDiscriminatedUnion).and(FromToDateORSchema);

// src/fit/slideshow/fe-schema.ts
var CreateSlideshowSchemaFE = BaseSlideshowSchemaWithoutUnion.omit({
  id: true,
  isActive: true,
  image: true,
  updatedAt: true,
  createdAt: true
}).and(FEDiscriminatedUnion).and(FromToDateORSchema).refine((data) => {
  const hasFromDate = !!data.fromDate;
  const hasToDate = !!data.toDate;
  if (!hasFromDate && !hasToDate) {
    return true;
  }
  if (hasFromDate && hasToDate) {
    const fromDate = DateTime.fromISO(data == null ? void 0 : data.fromDate.toString());
    const toDate = DateTime.fromISO(data == null ? void 0 : data.toDate.toString());
    return toDate > fromDate;
  }
  return true;
}, {
  message: "To date must be greater than From date",
  path: [
    "toDate"
  ]
});
var UpdateSlideshowSchemaFE = BaseSlideshowSchemaWithoutUnion.omit({
  id: true
}).partial().and(FEDiscriminatedUnion).and(FromToDateORSchema);
var defaultSlideshowSchemaValues = {
  title: "",
  type: ESlideshowTypeEnum.content,
  image: "",
  subtitle: "",
  description: "",
  buttonUrl: null,
  buttonLabel: null,
  badge: {
    image: null,
    positions: {
      mobile: ESlideBadgeImagePositionEnum["top-right"],
      tablet: ESlideBadgeImagePositionEnum["top-right"],
      desktop: ESlideBadgeImagePositionEnum["top-right"]
    },
    sizes: {
      mobile: 50,
      tablet: 70,
      desktop: 100
    }
  }
};

// src/fit/slideshow/filters.ts
import { z as z112 } from "zod";
var SlideshowFiltersSchema = BaseSlideshowSchemaWithoutUnion.pick({
  isActive: true
}).merge(RequestSchema.omit({
  isHidden: true
}).extend({
  isDashboard: z112.coerce.boolean().optional()
})).partial();

// src/user/change-password.ts
import { z as z113 } from "zod";
var ChangePasswordSchema = z113.object({
  currentPassword: z113.string().min(1, "Current password is required"),
  newPassword: z113.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z113.string().min(1, "Please confirm your new password")
}).refine((data) => data.newPassword !== data.currentPassword, {
  message: "New password must be different from your current password",
  path: [
    "newPassword"
  ]
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: "Passwords don't match",
  path: [
    "confirmPassword"
  ]
});
var ChangePasswordApiSchema = z113.object({
  currentPassword: z113.string().min(1),
  newPassword: z113.string().min(8)
});

// src/user/check-in.ts
import { number as number25, object as object55, string as string52, z as z114 } from "zod";
var CheckInSchema = object55({
  id: number25().min(1, "id is required"),
  userId: string52().min(1, "user id is required"),
  appName: AppNameEnumObj,
  action: UserLogActionEnumObj,
  contentId: string52().nullable().default(null),
  ipAddress: string52().min(1, "ip address is required").nullable().optional(),
  createdAt: string52().or(z114.instanceof(Date)).or(CustomLuxonDateSchema)
});

// src/user/email-change.ts
import { z as z115 } from "zod";
var RequestEmailChangeSchema = z115.object({
  newEmail: z115.string().email("Must be a valid email"),
  currentPassword: z115.string().min(1, "Current password is required"),
  /** FE base URL the new-email activation link points at, e.g. https://app/auth/verify-email-change */
  verifyRedirectUrl: z115.string().url(),
  /** FE base URL the old-email cancel link points at, e.g. https://app/auth/cancel-email-change */
  cancelRedirectUrl: z115.string().url()
});
var ConfirmEmailChangeSchema = z115.object({
  token: z115.string().uuid()
});
var CancelEmailChangeSchema = z115.object({
  token: z115.string().uuid(),
  /**
  * FE base URL for the password-reset page. Cancelling a request also forces a
  * password reset on the old address as a "this wasn't me" safety net, and the
  * reset email needs a redirect target.
  */
  resetRedirectUrl: z115.string().url()
});
var EmailChangeSearchParamsSchema = z115.object({
  token: z115.string().uuid().optional()
});

// src/user/update-pro-directory.ts
import { z as z117 } from "zod";

// src/supabase/pro-directory.ts
import { z as z116 } from "zod";
var TeachingFormatSchema = z116.string().transform((v) => v.toLowerCase()).pipe(z116.enum([
  "in_person",
  "online",
  "both"
]));
var ProDirectorySocialsSchema = z116.object({
  facebook: z116.string().nullable().optional(),
  instagram: z116.string().nullable().optional(),
  youtube: z116.string().nullable().optional(),
  twitter: z116.string().nullable().optional(),
  linkedin: z116.string().nullable().optional(),
  tiktok: z116.string().nullable().optional()
}).nullable().optional();
var ProDirectoryRowSchema = z116.object({
  id: z116.coerce.number(),
  slug: z116.string().nullable().optional(),
  is_active: z116.boolean().default(false),
  bio: z116.string().nullable().optional(),
  profession: z116.array(z116.string()).nullable().optional(),
  other_profession: z116.string().nullable().optional(),
  company_name: z116.string().nullable().optional(),
  company_email: z116.string().nullable().optional(),
  professional_website: z116.string().nullable().optional(),
  offerings: z116.array(z116.string()).nullable().optional(),
  teaching_format: TeachingFormatSchema.nullable().optional(),
  expertise: z116.array(z116.string()).nullable().optional(),
  languages_taught: z116.array(z116.string()).nullable().optional(),
  casual_image: z116.string().nullable().optional(),
  landscape_image: z116.string().nullable().optional(),
  full_name: z116.string().nullable().optional(),
  title: z116.string().nullable().optional(),
  phone: z116.string().nullable().optional(),
  business_street: z116.string().nullable().optional(),
  business_country_id: z116.number().nullable().optional(),
  business_state_id: z116.number().nullable().optional(),
  business_city_id: z116.number().nullable().optional(),
  certificates: z116.string().nullable().optional(),
  socials: ProDirectorySocialsSchema,
  created_at: z116.string(),
  updated_at: z116.string()
});
var ProDirectorySchema = ProDirectoryRowSchema.transform((values) => {
  var _a5, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  return {
    id: values.id,
    slug: (_a5 = values.slug) != null ? _a5 : null,
    isActive: values.is_active,
    bio: (_b = values.bio) != null ? _b : null,
    profession: (_c = values.profession) != null ? _c : [],
    otherProfession: (_d = values.other_profession) != null ? _d : null,
    companyName: (_e = values.company_name) != null ? _e : null,
    companyEmail: (_f = values.company_email) != null ? _f : null,
    professionalWebsite: (_g = values.professional_website) != null ? _g : null,
    offerings: (_h = values.offerings) != null ? _h : [],
    teachingFormat: (_i = values.teaching_format) != null ? _i : null,
    expertise: (_j = values.expertise) != null ? _j : [],
    languagesTaught: (_k = values.languages_taught) != null ? _k : [],
    casualImage: (_l = values.casual_image) != null ? _l : null,
    landscapeImage: (_m = values.landscape_image) != null ? _m : null,
    fullName: (_n = values.full_name) != null ? _n : null,
    title: (_o = values.title) != null ? _o : null,
    phone: (_p = values.phone) != null ? _p : null,
    businessStreet: (_q = values.business_street) != null ? _q : null,
    businessCountryId: (_r = values.business_country_id) != null ? _r : null,
    businessStateId: (_s = values.business_state_id) != null ? _s : null,
    businessCityId: (_t = values.business_city_id) != null ? _t : null,
    certificates: (_u = values.certificates) != null ? _u : null,
    socials: (_v = values.socials) != null ? _v : null,
    createdAt: values.created_at,
    updatedAt: values.updated_at
  };
});
var ProDirectoryRevisionStatusSchema = z116.enum([
  "pending",
  "approved",
  "rejected",
  "draft"
]);
var offeringsField = z116.union([
  z116.array(z116.string()),
  z116.string().transform((v) => v.split(",").map((s2) => s2.trim()).filter(Boolean))
]).nullable().optional();
var ProDirectoryDataSchema = z116.object({
  bio: z116.string().nullable().optional(),
  profession: z116.array(z116.string()).nullable().optional(),
  other_profession: z116.string().nullable().optional(),
  company_name: z116.string().nullable().optional(),
  company_email: z116.string().nullable().optional(),
  professional_website: z116.string().nullable().optional(),
  offerings: offeringsField,
  teaching_format: TeachingFormatSchema.nullable().optional(),
  expertise: z116.array(z116.string()).nullable().optional(),
  languages_taught: z116.array(z116.string()).nullable().optional(),
  casual_image: z116.string().nullable().optional(),
  landscape_image: z116.string().nullable().optional(),
  full_name: z116.string().nullable().optional(),
  title: z116.string().nullable().optional(),
  phone: z116.string().nullable().optional(),
  business_street: z116.string().nullable().optional(),
  business_country_id: z116.number().nullable().optional(),
  business_state_id: z116.number().nullable().optional(),
  business_city_id: z116.number().nullable().optional(),
  certificates: z116.string().nullable().optional(),
  socials: ProDirectorySocialsSchema,
  slug: z116.string().nullable().optional()
});
var ProDirectoryRevisionRowSchema = z116.object({
  id: z116.coerce.number(),
  pro_directory_id: z116.coerce.number().nullable(),
  user_id: z116.coerce.number(),
  status: ProDirectoryRevisionStatusSchema,
  data: ProDirectoryDataSchema,
  approved_on: z116.string().nullable(),
  rejected_on: z116.string().nullable(),
  reviewed_by: z116.string().nullable(),
  rejection_reason: z116.string().nullable().optional(),
  created_at: z116.string()
});
var ProDirectoryRevisionSchema = ProDirectoryRevisionRowSchema.transform((r) => {
  var _a5;
  return {
    id: r.id,
    proDirectoryId: r.pro_directory_id,
    userId: r.user_id,
    status: r.status,
    data: r.data,
    approvedOn: r.approved_on,
    rejectedOn: r.rejected_on,
    reviewedBy: r.reviewed_by,
    rejectionReason: (_a5 = r.rejection_reason) != null ? _a5 : null,
    createdAt: r.created_at
  };
});
var ProDirectoryRevisionWithProSchema = z116.object({
  id: z116.coerce.number(),
  proDirectoryId: z116.coerce.number().nullable(),
  userId: z116.coerce.number(),
  status: ProDirectoryRevisionStatusSchema,
  data: ProDirectoryDataSchema,
  approvedOn: z116.string().nullable(),
  rejectedOn: z116.string().nullable(),
  reviewedBy: z116.string().nullable(),
  rejectionReason: z116.string().nullable().optional(),
  createdAt: z116.string(),
  proName: z116.string().nullable(),
  proAvatar: z116.string().nullable(),
  proEmail: z116.string().nullable(),
  proUserUUID: z116.string().nullable(),
  currentSlug: z116.string().nullable(),
  currentData: ProDirectoryDataSchema.nullable(),
  isSubscribed: z116.boolean(),
  isProCollective: z116.boolean()
});
var ApproveProDirectoryRevisionSchema = z116.object({
  slug: z116.string().min(1).regex(SLUG_PATTERN, "Slug must contain only English letters (a\u2013z), numbers, and hyphens, and cannot start or end with a hyphen (e.g. jane-doe)")
});
var ListProDirectoryRevisionsQuerySchema = z116.object({
  status: ProDirectoryRevisionStatusSchema.optional(),
  // z.coerce.boolean() would coerce the string "false" to true (Boolean('false') === true) — query
  // params always arrive as strings, so compare against the literal instead.
  isSubscribed: z116.union([
    z116.boolean(),
    z116.enum([
      "true",
      "false"
    ])
  ]).transform((v) => v === true || v === "true").optional(),
  /** Matches the pro's name or email (case-insensitive, substring). */
  search: z116.string().trim().min(1).optional(),
  page: z116.coerce.number().int().positive().default(1),
  limit: z116.coerce.number().int().positive().max(100).default(20)
});
var RejectProDirectoryRevisionSchema = z116.object({
  reason: z116.string().min(1, "Reason is required").max(1500, "Reason must be 1500 characters or less"),
  sendNotification: z116.boolean().default(true)
});

// src/user/update-pro-directory.ts
var optionalUrl2 = z117.string().url("Must be a valid URL").or(z117.literal("")).nullable().optional();
var optionalEmail = z117.string().email("Must be a valid email").or(z117.literal("")).nullable().optional();
var DOMAIN_PATTERN = /^(https?:\/\/)?(www\.)?[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+(:\d+)?(\/\S*)?$/i;
var optionalWebsite = z117.string().regex(DOMAIN_PATTERN, "Enter a valid website, e.g. example.com").or(z117.literal("")).nullable().optional();
var UpdateProDirectorySchema = z117.object({
  isDraft: z117.boolean().optional(),
  slug: z117.string().regex(SLUG_PATTERN, "Slug must contain only English letters (a\u2013z), numbers, and hyphens, and cannot start or end with a hyphen (e.g. jane-doe)").nullable().optional(),
  bio: z117.string().max(BIO_MAX_RAW_CHARS, "Bio is too long").refine((v) => bioVisibleTextLength(v) <= BIO_MAX_VISIBLE_CHARS, `Bio must be ${BIO_MAX_VISIBLE_CHARS} characters or fewer`).nullable().optional(),
  profession: z117.array(z117.string()).max(10, "Select up to 10 professions").nullable().optional(),
  otherProfession: z117.string().nullable().optional(),
  companyName: z117.string().nullable().optional(),
  companyEmail: optionalEmail,
  professionalWebsite: optionalWebsite,
  offerings: z117.array(z117.string()).nullable().optional(),
  teachingFormat: TeachingFormatSchema.nullable().optional(),
  expertise: z117.array(z117.string()).max(10, "Select up to 10 conditions").nullable().optional(),
  languagesTaught: z117.array(z117.string()).nullable().optional(),
  casualImage: z117.string().nullable().optional(),
  landscapeImage: z117.string().nullable().optional(),
  fullName: z117.string().nullable().optional(),
  title: z117.string().nullable().optional(),
  phone: z117.string().nullable().optional(),
  businessStreet: z117.string().nullable().optional(),
  businessCountryId: z117.number().nullable().optional(),
  businessStateId: z117.number().nullable().optional(),
  businessCityId: z117.number().nullable().optional(),
  certificates: z117.string().nullable().optional(),
  socials: z117.object({
    facebook: optionalUrl2,
    instagram: optionalUrl2,
    youtube: optionalUrl2,
    twitter: optionalUrl2,
    linkedin: optionalUrl2,
    tiktok: optionalUrl2
  }).nullable().optional()
});

// src/user/update-profile.ts
import { z as z118 } from "zod";
var optionalUrl3 = z118.string().url("Must be a valid URL").or(z118.literal("")).nullable().optional();
var USERNAME_REGEX = /^[a-z0-9._]{3,30}$/;
var UsernameSchema = z118.string().trim().min(3, "Username must be at least 3 characters").max(30, "Username must be at most 30 characters").regex(USERNAME_REGEX, "Use lowercase letters, numbers, period and underscore only");
var UpdateProfileSchema = z118.object({
  firstName: z118.string().min(1, "First name is required"),
  lastName: z118.string().optional(),
  email: z118.string().email("Must be a valid email").optional().or(z118.literal("")),
  displayName: z118.string().optional(),
  username: UsernameSchema.optional(),
  occupation: z118.string().optional(),
  timezone: z118.string().min(1, "Timezone is required"),
  isPrivate: z118.boolean().default(false),
  bio: z118.string().nullable().optional(),
  primaryLanguage: z118.string().min(1, "Primary language is required"),
  phoneNumber: z118.string().nullable().optional(),
  zoomEmail: z118.string().email("Must be a valid email").optional().or(z118.literal("")),
  address: z118.object({
    street: z118.string().nullable().optional(),
    city: z118.string().nullable().optional(),
    state: z118.string().nullable().optional(),
    zip: z118.string().nullable().optional(),
    country: z118.string().nullable().optional(),
    countryId: z118.coerce.number().nullable().optional(),
    stateId: z118.coerce.number().nullable().optional(),
    cityId: z118.coerce.number().nullable().optional()
  }).nullable().optional(),
  socials: z118.object({
    facebook: optionalUrl3,
    instagram: optionalUrl3,
    youtube: optionalUrl3,
    twitter: optionalUrl3,
    linkedin: optionalUrl3,
    tiktok: optionalUrl3
  }).nullable().optional()
});
var ProfileFormSchema = UpdateProfileSchema.extend({
  avatar: z118.string().optional(),
  lastName: z118.string().min(1, "Last name is required"),
  email: z118.string().email("Must be a valid email").min(1, "Email is required"),
  displayName: z118.string().min(1, "Display name is required"),
  occupation: z118.string().min(1, "Profession is required"),
  phoneNumber: z118.string().nullable().optional(),
  address: z118.object({
    city: z118.string().nullable().optional(),
    state: z118.string().nullable().optional(),
    country: z118.string().nullable().optional(),
    street: z118.string().nullable().optional(),
    countryId: z118.coerce.number().nullable().optional(),
    stateId: z118.coerce.number().nullable().optional(),
    cityId: z118.coerce.number().nullable().optional()
  })
});
var UpdatePrivacySchema = z118.object({
  isPrivate: z118.boolean()
});

// src/wp-jwt/base.ts
import { array as array15, object as object56, string as string53, z as z119 } from "zod";
var UserJwtSchema = z119.object({
  wp_token: z119.string(),
  data: object56({
    user_apps: array15(z119.number()).optional(),
    user_email: string53(),
    user_id: z119.number(),
    user_uuid: z119.string().optional(),
    role: string53().array().default([
      "user"
    ])
  })
}).required();

// src/service-response/index.ts
import { coerce as coerce33, object as object57, z as z120 } from "zod";
var ServiceResponseErrorSchema = object57({
  message: z120.string(),
  code: z120.number()
});
var ServiceResponseDescriminatedUnionSchema = /* @__PURE__ */ __name((dataType) => {
  return z120.discriminatedUnion("status", [
    object57({
      status: z120.literal("ok"),
      items: dataType,
      meta: z120.object({
        total: coerce33.number(),
        page: coerce33.number(),
        perPage: coerce33.number(),
        totalPages: coerce33.number()
      })
    }),
    object57({
      status: z120.literal("error"),
      error: ServiceResponseErrorSchema
    })
  ]);
}, "ServiceResponseDescriminatedUnionSchema");

// src/settings/base.ts
import { coerce as coerce34, object as object58, union as union5, z as z121 } from "zod";
var FeaturedSeriesSettingSchema = object58({
  title: coerce34.string().min(5, "Title is required"),
  subtitle: coerce34.string().min(5, "Subtitle is required"),
  body: coerce34.string().min(5, "Description is required"),
  button_label: coerce34.string().min(3, "Button label is required"),
  video_badge: coerce34.string().min(3, "Video badge is required"),
  isEnable: CoerceBoolean.default(false).optional(),
  seriesId: coerce34.number().optional()
});
var ChallengeBannerSettingSchema = object58({
  isEnable: CoerceBoolean.default(false)
});
var ChallengePageSettingSchema = ChallengeBannerSettingSchema;
var OnboardingSettingSchema = ChallengeBannerSettingSchema;
var UpcomingLiveBannerSettingSchema = ChallengeBannerSettingSchema;
var BadgeConfigKeyValues = [
  "DAILY_DEDICATION",
  "CHALLENGE_CHAMPION",
  "WORKOUTS",
  "COMMENTS",
  "LIVE_CLASS",
  "CHALLENGE_VIDEO",
  "CHALLENGE_DAY",
  "SERIES_COMPLETED"
];
var BadgeConfigKeyEnumObj = z121.enum(BadgeConfigKeyValues);
var BadgeConfigLabels = {
  DAILY_DEDICATION: "Daily Dedication",
  CHALLENGE_CHAMPION: "Challenge Champion",
  WORKOUTS: "Workouts",
  COMMENTS: "Comments",
  LIVE_CLASS: "Live Class",
  CHALLENGE_VIDEO: "Challenge Video",
  CHALLENGE_DAY: "Challenge Day",
  SERIES_COMPLETED: "Series Completed"
};
var BadgeTogglesSchema = object58({
  DAILY_DEDICATION: CoerceBoolean.default(true),
  CHALLENGE_CHAMPION: CoerceBoolean.default(true),
  WORKOUTS: CoerceBoolean.default(true),
  COMMENTS: CoerceBoolean.default(true),
  LIVE_CLASS: CoerceBoolean.default(true),
  CHALLENGE_VIDEO: CoerceBoolean.default(true),
  CHALLENGE_DAY: CoerceBoolean.default(true),
  SERIES_COMPLETED: CoerceBoolean.default(true)
});
var BadgeSettingSchema = object58({
  // Master: gates ALL in-app badge notification delivery (checked in fit-api before emit).
  notificationsEnabled: CoerceBoolean.default(true),
  // Master: gates ALL on-screen badge-unlock pop-ups (fit-fe).
  popupEnabled: CoerceBoolean.default(true),
  // Per-badge on/off — one switch per badge, gating both its notification and its pop-up.
  badges: BadgeTogglesSchema.default({
    DAILY_DEDICATION: true,
    CHALLENGE_CHAMPION: true,
    WORKOUTS: true,
    COMMENTS: true,
    LIVE_CLASS: true,
    CHALLENGE_VIDEO: true,
    CHALLENGE_DAY: true,
    SERIES_COMPLETED: true
  })
});
var DEFAULT_BADGE_SETTINGS = BadgeSettingSchema.parse({});
var ContentDefaultTabEnum = z121.enum([
  "ABOUT",
  "COMMENTS"
]);
var ContentSettingSchema = object58({
  defaultTab: ContentDefaultTabEnum.default("COMMENTS")
});
var BaseSettingSchema = union5([
  ContentSettingSchema,
  FeaturedSeriesSettingSchema,
  ChallengeBannerSettingSchema,
  OnboardingSettingSchema,
  UpcomingLiveBannerSettingSchema,
  BadgeSettingSchema
]);

// src/settings/be-schema.ts
import { object as object60, z as z124 } from "zod";

// src/settings/fe-schema.ts
import { z as z123 } from "zod";

// src/settings/global-settings-schema.ts
import { coerce as coerce35, object as object59, z as z122 } from "zod";
var ContactFormSettingSchema = object59({
  iframeUrl: coerce35.string().url("Must be a valid URL")
});
var isInAppPath = /* @__PURE__ */ __name((value) => /^\/(?!\/)/.test(value), "isInAppPath");
var isHttpUrl = /* @__PURE__ */ __name((value) => {
  if (!/^https?:\/\//.test(value)) {
    return false;
  }
  try {
    new URL(value);
    return true;
  } catch (e) {
    return false;
  }
}, "isHttpUrl");
var BlackFridayBannerSettingSchema = object59({
  isEnabled: z122.boolean(),
  ctaUrl: z122.string().trim().min(1, "CTA URL is required").max(1e3, "CTA URL is too long").refine((value) => isInAppPath(value) || isHttpUrl(value), "CTA URL must be an in-app path (/black-friday-deals) or start with http:// or https://")
});
var GlobalSettingsValue = z122.union([
  ContactFormSettingSchema,
  BlackFridayBannerSettingSchema
]);
var GlobalSettingsTypeEnumValues = [
  "CONTACT_FORM_IFRAME_URL",
  "BLACK_FRIDAY_BANNER"
];
var GlobalSettingsTypeEnumObj = z122.enum(GlobalSettingsTypeEnumValues);
var GlobalSettingsTypeEnum = GlobalSettingsTypeEnumObj.enum;
var GLOBAL_SETTING_VALUE_SCHEMAS = {
  [GlobalSettingsTypeEnum.CONTACT_FORM_IFRAME_URL]: ContactFormSettingSchema,
  [GlobalSettingsTypeEnum.BLACK_FRIDAY_BANNER]: BlackFridayBannerSettingSchema
};
var PUBLIC_GLOBAL_SETTING_TYPES = [
  GlobalSettingsTypeEnum.CONTACT_FORM_IFRAME_URL
];
var GlobalSettingsSchema = object59({
  id: GlobalSettingsTypeEnumObj,
  values: GlobalSettingsValue
});

// src/settings/fe-schema.ts
var UpdateContentScheduleSettingsFE = FeaturedSeriesSettingSchema;
var CreateFeatureSeriesContentSchemaFE = FeaturedSeriesSettingSchema.omit({
  subtitle: true,
  body: true,
  button_label: true,
  video_badge: true
}).extend({
  seriesId: z123.coerce.number().min(1, "Please select series")
});
var CreateFitChallengeSchemaFE = CreateFeatureSeriesContentSchemaFE.omit({
  title: true,
  seriesId: true
}).extend({
  isEnable: CoerceBoolean.default(false)
});
var defaultFeatureSeriesContentValues = {
  title: "",
  isEnable: false,
  seriesId: 0
};
var defaultFitChallengeValues = {
  isEnable: false
};
var OnboardingSettingSchemaFE = z123.object({
  isEnable: CoerceBoolean.default(false)
});
var defaultOnboardingSettingValues = {
  isEnable: false
};
var UpcomingLiveBannerSettingSchemaFE = UpcomingLiveBannerSettingSchema;
var defaultUpcomingLiveBannerSettingValues = {
  isEnable: false
};
var ContactFormSettingSchemaFE = ContactFormSettingSchema;
var defaultContactFormSettingValues = {
  iframeUrl: ""
};
var ContentSettingSchemaFE = ContentSettingSchema;
var defaultContentSettingValues = {
  defaultTab: "COMMENTS"
};

// src/settings/be-schema.ts
var UpdateContentScheduleSettingsSchemaBE = FeaturedSeriesSettingSchema.pick({
  title: true,
  subtitle: true,
  body: true,
  button_label: true,
  video_badge: true
}).extend({
  id: z124.coerce.string(),
  seriesId: z124.coerce.number().optional(),
  isHidden: CoerceBoolean.optional()
});
var CreateFeatureSeriesContentSchemaBE = CreateFeatureSeriesContentSchemaFE.extend({
  id: z124.coerce.string()
});
var CreateFitChallengeSchemaBE = CreateFitChallengeSchemaFE.extend({
  id: z124.coerce.string()
});
var OnboardingSettingSchemaBE = OnboardingSettingSchemaFE.extend({
  id: z124.coerce.string()
});
var UpcomingLiveBannerSettingSchemaBE = UpcomingLiveBannerSettingSchemaFE.extend({
  id: z124.coerce.string()
});
var ContentSettingSchemaBE = ContentSettingSchemaFE.extend({
  id: z124.coerce.string()
});
var ContactFormSettingSchemaBE = ContactFormSettingSchemaFE.extend({
  id: z124.coerce.string()
});
var CreateBadgeSettingSchemaBE = BadgeSettingSchema.extend({
  id: z124.coerce.string()
});
var SettingBEResponseSchema = object60({
  FEATURED_SERIES: FeaturedSeriesSettingSchema,
  FEATURED_SERIES_CONTENTS: FeaturedSeriesSettingSchema,
  FIT_CHALLENGE_BANNER: ChallengeBannerSettingSchema,
  FIT_CHALLENGE_PAGE: ChallengePageSettingSchema,
  ONBOARDING: OnboardingSettingSchema,
  UPCOMING_LIVE_BANNER: UpcomingLiveBannerSettingSchema,
  CONTENT_SETTINGS: ContentSettingSchema.optional(),
  CONTACT_FORM_IFRAME_URL: ContactFormSettingSchema,
  BADGE_SETTINGS: BadgeSettingSchema
});
var GlobalSettingBEResponseSchema = object60({
  CONTACT_FORM_IFRAME_URL: ContactFormSettingSchema,
  BLACK_FRIDAY_BANNER: BlackFridayBannerSettingSchema.optional()
});

// src/settings/feature-series/be-schema.ts
import { z as z126 } from "zod";

// src/settings/feature-series/fe-schema.ts
import { z as z125 } from "zod";
var CreateFeatureSeriesSchemaFE = FeaturedSeriesSettingSchema.omit({
  title: true,
  subtitle: true,
  body: true,
  video_badge: true
}).extend({
  seriesId: z125.coerce.number().min(1, "Please select series")
});
var defaultSettingsValues = {
  button_label: "",
  isEnable: false,
  seriesId: 0
};

// src/settings/feature-series/be-schema.ts
var CreateFeatureSeriesSchemaBE = CreateFeatureSeriesSchemaFE.extend({
  id: z126.coerce.string()
});

// src/settings/settings-schema.ts
import { object as object61, z as z127 } from "zod";
var SettingsTypeEnumValues = [
  "FEATURED_SERIES",
  "FEATURED_SERIES_CONTENTS",
  "FIT_CHALLENGE_BANNER",
  "FIT_CHALLENGE_PAGE",
  "ONBOARDING",
  "UPCOMING_LIVE_BANNER",
  "CONTENT_SETTINGS",
  "CONTACT_FORM_IFRAME_URL",
  "BADGE_SETTINGS"
];
var SettingsTypeEnumObj = z127.enum(SettingsTypeEnumValues);
var SettingsTypeEnum = SettingsTypeEnumObj.enum;
var SettingsSchema = object61({
  id: SettingsTypeEnumObj,
  values: BaseSettingSchema
});

// src/help-center/app-names.ts
import { z as z128 } from "zod";
var HelpCenterAppNameValues = [
  "FIT",
  "RYC",
  "BUMP"
];
var HelpCenterAppNameEnumObj = z128.enum(HelpCenterAppNameValues);
var EHelpCenterAppNameEnum = HelpCenterAppNameEnumObj.enum;

// src/help-center/article-base.ts
import { array as array16, coerce as coerce37, lazy as lazy9, number as number26, object as object63, string as string55, z as z129 } from "zod";

// src/help-center/taxonomy-base.ts
import { coerce as coerce36, object as object62, string as string54 } from "zod";
var BaseTaxonomySchema = object62({
  id: coerce36.number(),
  title: string54(),
  slug: string54(),
  createdAt: coerce36.string().date(),
  updatedAt: coerce36.string().date()
});
var BaseTopicTaxonomySchema = BaseTaxonomySchema.extend({
  categoryId: coerce36.number()
});

// src/help-center/article-base.ts
var HelpCenterArticle = object63({
  id: string55(),
  question: string55(),
  answer: string55(),
  category: lazy9(() => HelpCenterArticleCategory),
  createdAt: coerce37.string(),
  topics: lazy9(() => HelpCenterArticleTopic.array()),
  updatedAt: coerce37.string(),
  sourceTicketId: number26().nullable().optional()
});
var HelpCenterArticleDetails = object63({
  details: lazy9(() => HelpCenterArticle),
  category: lazy9(() => HelpCenterArticleCategory),
  topics: lazy9(() => HelpCenterArticleTopic.array())
});
var HelpCenterArticleCategory = object63({
  id: string55(),
  title: string55(),
  slug: string55(),
  topics: lazy9(() => HelpCenterArticleTopic.array()),
  createdAt: coerce37.string(),
  updatedAt: coerce37.string()
});
var HelpCenterArticleTopic = object63({
  id: string55(),
  title: string55(),
  slug: string55(),
  createdAt: coerce37.string(),
  updatedAt: coerce37.string()
});
var HelpCenterArticleTopicWithCategory = object63({
  id: string55(),
  title: string55(),
  slug: string55(),
  category: lazy9(() => HelpCenterArticleCategory),
  createdAt: coerce37.string(),
  updatedAt: coerce37.string()
});
var HelpCenterArticleSearchResponse = object63({
  didYouMean: string55().optional(),
  items: HelpCenterArticle.array(),
  topics: HelpCenterArticleTopic.array().optional()
});
var ArticleStatusValues = [
  "DRAFT",
  "PUBLISHED",
  "ARCHIVED"
];
var ArticleStatusEnumObj = z129.enum(ArticleStatusValues);
var EArticleStatus = ArticleStatusEnumObj.enum;
var BaseHelpCenterArticleSchema = object63({
  id: coerce37.number(),
  question: string55(),
  answer: string55(),
  topics: BaseTaxonomySchema.array(),
  category: BaseTaxonomySchema,
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  sourceTicketId: number26().nullable().optional(),
  createdAt: coerce37.string().date(),
  updatedAt: coerce37.string().date()
});
var HelpCenterArticleCreationPayloadSchema = object63({
  id: coerce37.number(),
  question: string55(),
  answer: string55(),
  topicIds: array16(number26()),
  categorySlug: string55(),
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  sourceTicketId: number26().optional(),
  createdAt: coerce37.string().date(),
  updatedAt: coerce37.string().date()
});

// src/help-center/article-be-schema.ts
var CreateHelpCenterArticleSchemaBE = BaseHelpCenterArticleSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var CreateArticleSchemaBE = HelpCenterArticleCreationPayloadSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdateHelpCenterArticleSchemaBE = CreateArticleSchemaBE;
var defaultHelpCenterSchemaValues = {
  question: "",
  answer: "",
  topicIds: [],
  categorySlug: "",
  appNames: [],
  status: "DRAFT"
};

// src/help-center/article-edit-history.ts
import { z as z130 } from "zod";
var HelpCenterArticleEditHistoryDataSchema = z130.object({
  question: z130.string(),
  answer: z130.string(),
  topicIds: z130.array(z130.number()),
  categorySlug: z130.string(),
  appNames: HelpCenterAppNameEnumObj.array(),
  status: ArticleStatusEnumObj,
  category: BaseTaxonomySchema.optional(),
  topics: BaseTaxonomySchema.array().optional()
});
var HelpCenterArticleEditHistorySchema = z130.object({
  id: z130.number(),
  articleId: z130.number(),
  data: HelpCenterArticleEditHistoryDataSchema,
  createdBy: z130.string(),
  createdByName: z130.string(),
  createdOn: z130.coerce.string()
});
var HelpCenterArticleEditHistoryListSchema = z130.array(HelpCenterArticleEditHistorySchema);

// src/help-center/article-filter.ts
import { coerce as coerce38, object as object64 } from "zod";
var HelpCenterArticlesFiltersSchema = object64({
  categorySlug: coerce38.string().optional(),
  topicId: coerce38.number().optional(),
  topicSlug: coerce38.string().optional(),
  app: HelpCenterAppNameEnumObj.optional(),
  perPage: coerce38.number().optional(),
  page: coerce38.number().optional(),
  query: coerce38.string().optional(),
  enabled: coerce38.boolean().optional(),
  status: ArticleStatusEnumObj.optional()
}).partial();

// src/help-center/taxonomy-be-schema.ts
var CreateHelpCenterCategoryTaxonomySchemaBE = BaseTaxonomySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  appNames: HelpCenterAppNameEnumObj.array().min(1)
});
var CreateHelpCenterTopicTaxonomySchemaBE = BaseTopicTaxonomySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  appNames: HelpCenterAppNameEnumObj.array().min(1)
});
var UpdateHelpCenterTopicTaxonomySchemaBE = CreateHelpCenterTopicTaxonomySchemaBE;
var UpdateHelpCenterCategoryTaxonomySchemaBE = CreateHelpCenterCategoryTaxonomySchemaBE;

// src/ryc/addon-content/addon-content-type.enum.ts
import { z as z131 } from "zod";
var AddonContentTypeValues = [
  "BONUS",
  "ADDON"
];
var AddonContentTypeObject = z131.enum(AddonContentTypeValues);
var EAddonContentType = AddonContentTypeObject.enum;

// src/ryc/addon-content/base.ts
import { coerce as coerce41, object as object67, string as string56 } from "zod";

// src/ryc/user/base.ts
import { coerce as coerce39, object as object65 } from "zod";
var BaseUserSchema = object65({
  id: coerce39.string(),
  electiveContents: coerce39.number().array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/user/select-elective-contents.ts
import { coerce as coerce40, object as object66 } from "zod";
var SelectElectiveContentsSchema = object66({
  contentIds: coerce40.number().array().max(3).min(1)
});

// src/ryc/user/user-manage-item-type.enum.ts
import { z as z132 } from "zod";
var UserManageItemTypeValues = [
  "USER_INFORMATION",
  "INSTRUCTION",
  "ACTIVITY",
  "CHECK_IN",
  "BONUS_VIDEOS",
  "JOURNEY",
  "ONBOARDING",
  "SIMULATION",
  "CUSTOM_NOTIFICATION",
  "NOTIFICATION_HISTORY"
];
var UserManageItemTypeObj = z132.enum(UserManageItemTypeValues);
var UserManageItemTypeEnum = UserManageItemTypeObj.enum;

// src/ryc/addon-content/base.ts
var UserMetaSchema = BaseUserSchema.omit({
  electiveContents: true
});
var AddonContentBaseSchema = object67({
  id: coerce41.number(),
  contentId: string56(),
  type: AddonContentTypeObject,
  createdAt: coerce41.date(),
  userMeta: UserMetaSchema
});

// src/ryc/content/base.ts
import { array as array17, boolean as boolean17, coerce as coerce42, number as number27, object as object68, string as string57, union as union6, z as z134 } from "zod";

// src/ryc/content/path.enum.ts
import { z as z133 } from "zod";
var RYCContentPathValues = [
  "REGULAR_PATH",
  "SUPPORTIVE_PATH"
];
var RYCContentPathEnumObject = z133.enum(RYCContentPathValues);
var ERYCContentPath = RYCContentPathEnumObject.enum;

// src/ryc/content/base.ts
var RYCContent = Content.omit({
  category: true
}).extend({
  category: CategoryEnumObj
});
var BaseRYCContentWitMetaInformation = Content;
var RYCContentTypeValues = [
  "CONTENT",
  "JOURNAL"
];
var RYCContentTypeEnumObject = z134.enum(RYCContentTypeValues);
var ERYCContentType = RYCContentTypeEnumObject.enum;
var BaseRYCContentSchema = z134.object({
  id: coerce42.string(),
  contentId: string57(),
  order: coerce42.number().min(1),
  type: RYCContentTypeEnumObject,
  path: RYCContentPathEnumObject,
  createdAt: z134.string(),
  updatedAt: z134.string()
});
var CreateRYCContentSchemaFE = BaseRYCContentSchema.omit({
  id: true,
  path: true,
  type: true,
  contentId: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: number27().optional(),
  path: string57().optional(),
  content: RYCContent
});
var CreateRYCContentSchemaBE = BaseRYCContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
});
var UpdateRYCContentSchemaBE = BaseRYCContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: coerce42.number().optional()
});
var ContentResponseSchema = object68({
  items: Content.array().nullable(),
  meta: object68({
    total: coerce42.number(),
    page: coerce42.number(),
    perPage: coerce42.number(),
    totalPages: coerce42.number()
  })
});
var CalendarStateResponse = object68({
  id: number27(),
  stage: number27(),
  level: number27(),
  days: object68({
    day: number27(),
    items: array17(string57()),
    isRest: union6([
      boolean17(),
      z134.null()
    ]),
    checked: union6([
      boolean17(),
      z134.null()
    ])
  }).array()
});

// src/ryc/content/be-schema.ts
import { coerce as coerce43, lazy as lazy10, object as object69, string as string58, z as z135 } from "zod";
var CreateRYCContentBEBase = object69({
  name: string58().min(3, "name is required"),
  instructorId: coerce43.string(),
  status: lazy10(() => StatusEnumObj),
  equipments: object69({
    id: coerce43.number().min(1, "id is required")
  }).array().min(1, "Please select at least one equipment"),
  video: VimeoVideo,
  publishedDate: z135.string().or(CustomLuxonDateSchema).optional().nullable(),
  id: string58().optional(),
  meta: lazy10(() => RYCContentMetaInformationBaseSchema.omit({
    id: true,
    contentId: true,
    createdAt: true,
    updatedAt: true
  }).extend({
    type: RYCContentMetaTypeEnumObject.default("WORKOUT"),
    category: lazy10(() => CategoryEnumObj),
    categories: coerce43.number().array().optional().default([])
  }).partial({
    category: true,
    categories: true,
    series: true,
    stage: true,
    isRegular: true,
    isSupportive: true,
    tiers: true,
    pdfLink: true
  }).optional())
});
var CreateRYCContentWithMetaSchemaBE = CreateRYCContentBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var UpdateRYCContentWithMetaSchemaBE = CreateRYCContentBEBase.partial();

// src/ryc/content/fe-schema.ts
import { coerce as coerce44, lazy as lazy11, object as object70, z as z136 } from "zod";
var RYCDashboardCreateContentSchemaFEBase = object70({
  name: z136.string().min(3, "name is required"),
  instructorId: coerce44.string(),
  equipments: coerce44.number().array().min(1, "Please select at least one equipment"),
  status: lazy11(() => StatusEnumObj),
  publishedDate: z136.string().or(CustomLuxonDateSchema).optional().nullable(),
  video: VimeoVideoInput,
  meta: object70({
    type: RYCContentMetaTypeEnumObject.default("WORKOUT"),
    category: CategoryEnumObj,
    categories: coerce44.number().array().optional().default([]),
    tiers: TiersEnumObject.array().optional().default([]),
    series: z136.preprocess((v) => v === "" ? void 0 : v, RYCContentMetaSeriesEnumObject.optional()),
    stage: z136.preprocess((v) => v === "" ? void 0 : v, coerce44.number().optional().nullable()),
    isRegular: coerce44.boolean().optional().default(false),
    isSupportive: coerce44.boolean().optional().default(false),
    pdfLink: z136.string().optional().nullable()
  }).optional()
});
var RYCDashboardCreateContentSchemaFEWithoutValidation = RYCDashboardCreateContentSchemaFEBase;
var RYCDashboardCreateContentSchemaFE = RYCDashboardCreateContentSchemaFEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var RYCDashboardUpdateContentSchemaFE = RYCDashboardCreateContentSchemaFEWithoutValidation.partial();
var defaultRYCContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  status: "PUBLISHED",
  publishedDate: void 0,
  meta: {
    type: "WORKOUT",
    category: "RESTORE",
    categories: [],
    tiers: [],
    isRegular: false,
    isSupportive: false
  }
};

// src/ryc/content/request.ts
import { array as array18, coerce as coerce45, object as object71, string as string59 } from "zod";
var CreateRYCContentRequestWithMetaSchema = CreateRYCContentWithMetaSchemaBE;
var UpdateRYCContentRequestWithMetaSchema = UpdateRYCContentWithMetaSchemaBE;
var RYCContentRequestBESchema = object71({
  app: AppNameEnumObj.optional(),
  query: string59().optional(),
  shuffle: CoerceBoolean.optional().default(false),
  loadAll: CoerceBoolean.optional().default(false),
  stage: coerce45.number().optional(),
  series: RYCContentMetaSeriesEnumObject.optional(),
  path: string59().optional(),
  type: RYCContentMetaTypeEnumObject,
  skipTypeFilter: coerce45.boolean().optional().default(false),
  categoryIds: array18(string59()).default([]),
  instructorIds: array18(coerce45.string()).default([]),
  status: StatusEnumObj.array().optional(),
  durationFrom: coerce45.number().default(1),
  durationTo: coerce45.number().default(1e3),
  perPage: coerce45.number().max(150),
  page: coerce45.number()
}).partial();
var rycContentFilterDefaultValues = {
  categoryIds: "",
  duration: "1-60",
  stage: "",
  series: "",
  page: "1",
  path: "",
  perPage: "15",
  type: "",
  query: ""
};
var rycContentFilterEmptyDefaultValues = {
  categoryIds: "",
  duration: "",
  stage: "",
  series: "",
  path: "",
  type: "",
  instructorIds: "",
  page: "",
  perPage: "",
  query: ""
};
var DownloadPdfRequestBESchema = object71({
  contentId: string59()
});

// src/ryc/instruction/base.ts
import { array as array19, coerce as coerce46, number as number28, object as object72, string as string60, z as z138 } from "zod";

// src/ryc/instruction/plan-type.enum.ts
import { z as z137 } from "zod";
var PlanTypeValues = [
  "TEXT",
  "PLAN"
];
var PlanTypeObj = z137.enum(PlanTypeValues);
var PlanTypeEnum = PlanTypeObj.enum;

// src/ryc/instruction/base.ts
var InstructionPlanItemResponseSchema = object72({
  id: coerce46.number().optional(),
  day: number28(),
  order: coerce46.number(),
  content: Content.optional(),
  isRestDay: z138.boolean().default(false).optional()
});
var InstructionPlanItemSchema = object72({
  id: coerce46.number().optional(),
  day: number28(),
  order: coerce46.number(),
  contentId: string60().optional(),
  isRestDay: z138.boolean().default(false).optional()
});
var instructionSchema = object72({
  id: coerce46.number(),
  userId: string60(),
  message: string60().optional(),
  type: PlanTypeObj,
  plan: array19(InstructionPlanItemResponseSchema).optional(),
  createdBy: Instructor,
  createdAt: coerce46.string(),
  updatedAt: coerce46.string()
});
var CreateInstructionSchema = instructionSchema.omit({
  id: true,
  plan: true,
  createdBy: true,
  createdAt: true,
  updatedAt: true
}).extend({
  plan: array19(InstructionPlanItemSchema).optional()
});
var UpdateInstructionSchema = CreateInstructionSchema.extend({
  id: coerce46.number()
});

// src/ryc/journal/base.ts
import { array as array20, coerce as coerce50, object as object76, string as string62, z as z142 } from "zod";

// src/ryc/step/content.ts
import { coerce as coerce47, object as object73, string as string61 } from "zod";
var BaseStepContentSchema = object73({
  id: UnsignedIDSchema,
  isMandatory: coerce47.boolean().optional().default(false),
  hasAlternatives: coerce47.boolean().optional().default(false),
  contentId: string61(),
  order: coerce47.number().min(1),
  path: RYCContentPathEnumObject,
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var UpdateStepContentSchemaBE = BaseStepContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: UnsignedIDSchema.optional(),
  rycContent: UpdateRYCContentSchemaBE
});
var UpdateStepContentSchemaFE = BaseStepContentSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  id: UnsignedIDSchema.optional()
}).merge(CreateRYCContentSchemaFE).extend({
  path: RYCContentPathEnumObject
});
var UpdateStepContentsSchemaBE = object73({
  stepContents: object73({
    // step content id (primary column value)
    id: coerce47.number().optional(),
    // ryc content id (primary column value)
    // rycContentId: coerce.number().optional(),
    // content id from content service
    contentId: coerce47.string(),
    order: coerce47.number().min(1),
    path: RYCContentPathEnumObject,
    type: RYCContentTypeEnumObject,
    isMandatory: coerce47.boolean().optional().default(false),
    hasAlternatives: coerce47.boolean().optional().default(false)
  }).array()
});

// src/ryc/step/day.ts
import { coerce as coerce48, object as object74 } from "zod";
var BaseStepDaySchema = object74({
  id: coerce48.number().int().nonnegative(),
  day: coerce48.number().int().nonnegative().nullable(),
  stepContents: BaseStepContentSchema.array(),
  electiveContents: BaseStepContentSchema.array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var BaseStepContentSchemaWithContentInfo = BaseStepContentSchema.extend({
  content: RYCContent.extend({
    instructor: Instructor
  })
});
var BaseStepDayWithContentsSchema = BaseStepDaySchema.extend({
  stepContents: BaseStepContentSchemaWithContentInfo.array(),
  electiveContents: BaseStepContentSchemaWithContentInfo.array()
});
var UpdateStepDaySchemaBE = object74({
  stepContents: UpdateStepContentSchemaBE.array()
});

// src/ryc/step/step.ts
import { coerce as coerce49, object as object75, z as z141 } from "zod";

// src/ryc/step/stage.ts
import { z as z139 } from "zod";
var Stages = [
  "STAGE_1",
  "STAGE_2",
  "STAGE_3",
  "STAGE_4"
];
var StagesEnumObject = z139.enum(Stages);
var EStagesEnum = StagesEnumObject.enum;

// src/ryc/step/step-type.ts
import { z as z140 } from "zod";
var StepType = [
  "REGULAR",
  "BONUS"
];
var StepTypeEnumObject = z140.enum(StepType);
var EStepTypeEnum = StepTypeEnumObject.enum;

// src/ryc/step/step.ts
var Steps = [
  "STEP_1",
  "STEP_2",
  "STEP_3",
  "STEP_4"
];
var StepsEnumObject = z141.enum(Steps);
var EStepsEnum = StepsEnumObject.enum;
var BaseStepSchema = object75({
  id: coerce49.number(),
  adjustedStepId: coerce49.number(),
  tier: TiersEnumObject,
  stage: StagesEnumObject,
  days: BaseStepDaySchema.array().nullable(),
  stepType: StepTypeEnumObject.optional(),
  bonusVideos: z141.array(BaseStepContentSchema).nullable(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});
var BaseStepSchemaWithContents = BaseStepSchema.extend({
  contents: Content.array()
});
var BonusSchemaWithContent = BaseStepContentSchema.extend({
  content: RYCContent.extend({
    instructor: Instructor
  })
});
var BaseStepSchemaWithBonusVideos = BaseStepSchema.extend({
  bonusVideos: BonusSchemaWithContent.array()
});

// src/ryc/step/fe-schema.ts
var CreateStepSchemaFE = BaseStepSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true
}).extend({
  contents: CreateRYCContentSchemaFE.array()
});
var UpdateStepSchemaFE = BaseStepSchema.partial();
var UpdateStepSchemaBE = BaseStepSchema.omit({
  createdAt: true,
  updatedAt: true
}).extend({
  contents: CreateRYCContentSchemaBE.array()
});

// src/ryc/journal/base.ts
var BaseJournalSchema = object76({
  id: coerce50.string(),
  userId: coerce50.string(),
  content: coerce50.string(),
  path: RYCContentPathEnumObject.nullable(),
  dayNumber: coerce50.number(),
  link: coerce50.string().optional(),
  stepDay: BaseStepDaySchema,
  journey: object76({
    id: coerce50.number()
  }),
  skipJournal: coerce50.boolean().optional().nullable(),
  contents: array20(RYCContentMetaInformationBaseSchema).nullable(),
  createdAt: coerce50.string(),
  updatedAt: coerce50.string()
});
var CreateJournalSchemaBE = BaseJournalSchema.pick({
  content: true,
  path: true,
  link: true,
  skipJournal: true
}).partial();
var SkipJournalSchemaBE = object76({
  journeyId: coerce50.number().or(z142.literal(void 0))
});
var RYCJournalRequestBESchema = object76({
  stage: StagesEnumObject.optional(),
  series: array20(RYCContentMetaSeriesEnumObject).optional(),
  types: array20(RYCContentMetaTypeEnumObject).optional(),
  query: string62().optional(),
  byDate: string62().optional(),
  perPage: coerce50.number().max(150),
  page: coerce50.number()
}).partial();
var rycJournalFilterDefaultValues = {
  byDate: void 0,
  stage: "STAGE_1",
  series: [],
  page: 1,
  perPage: 15,
  types: [],
  query: ""
};
var FindVideoTagsRequestSchema = object76({
  contentIds: array20(string62())
});
var JournalEntryDatesRequestSchema = object76({
  month: coerce50.number().int().min(1).max(12),
  year: coerce50.number().int().min(2e3).max(2100)
});

// src/ryc/journey/base.ts
import { coerce as coerce53, object as object79, string as string63, z as z144 } from "zod";

// src/ryc/journey/elective-content.ts
import { coerce as coerce51, object as object77 } from "zod";
var ElectiveContentSchema = object77({
  id: coerce51.number(),
  userId: coerce51.string(),
  electiveContents: coerce51.number().array(),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/journey/user-activity.ts
import { coerce as coerce52, object as object78 } from "zod";

// src/ryc/journey/user-activity-type.ts
import { z as z143 } from "zod";
var UserActivityTypeValues = [
  "CONTENT_WATCH",
  "JOURNAl_SAVED",
  "STAGE_COMPLETE",
  "STEP_COMPLETE",
  "BONUS_CLAIMED",
  "PATH_SWITCH_TO_REGULAR",
  "PATH_SWITCH_TO_SUPPORTIVE",
  "JOURNAL_SKIPPED",
  "NEW_DAY",
  "PROGRAM_COMPLETE",
  "RESET",
  "START_JOURNEY",
  "RESTART_JOURNEY",
  "SPECIAL_JOURNAL",
  "JOINED_ELECTIVE",
  "CHECKIN"
];
var UserActivityTypeEnumObject = z143.enum(UserActivityTypeValues);
var EUserActivityTypeEnum = UserActivityTypeEnumObject.enum;

// src/ryc/journey/user-activity.ts
var ActivityJourneySchema = object78({
  id: coerce52.number(),
  stage: StagesEnumObject,
  stepId: coerce52.number(),
  currentDay: coerce52.number(),
  tier: TiersEnumObject
});
var UserActivitySchema = object78({
  id: coerce52.number(),
  userId: coerce52.string(),
  type: UserActivityTypeEnumObject,
  exerciseId: coerce52.string().nullable(),
  exercisePath: RYCContentPathEnumObject,
  stepId: coerce52.number().nullable(),
  adjustedStepId: coerce52.number().nullable(),
  stepDay: coerce52.number().nullable(),
  dayNumber: coerce52.number().min(1).max(7).nullable(),
  content: Content.optional().nullable(),
  isMandatory: coerce52.boolean().nullable(),
  createdAt: coerce52.string(),
  journey: ActivityJourneySchema.nullable().optional()
});
var UserActivityItemSchema = UserActivitySchema.extend({
  content: Content.optional()
});
var JourneyUserActivitiesSchema = object78({
  items: UserActivityItemSchema.array()
});
var JourniesUserActivitiesSchema = JourneyUserActivitiesSchema.array();

// src/ryc/journey/base.ts
var JourneyAlreadyClaimedBonusValues = z144.union([
  z144.literal("t"),
  z144.literal("f"),
  z144.literal(null)
]);
var BaseJourneySchema = object79({
  id: coerce53.number(),
  userId: string63(),
  tier: TiersEnumObject,
  stage: StagesEnumObject,
  path: RYCContentPathEnumObject,
  journals: BaseJournalSchema.array(),
  userActivities: UserActivitySchema.array(),
  dayDiffInMS: coerce53.number().optional().default(0),
  currentElectiveDay: coerce53.number().default(0),
  currentElectiveContentId: coerce53.number().nullable().default(null),
  lastElectiveContentSelectedTime: CommonCustomDateSchema,
  electiveContent: ElectiveContentSchema,
  stepId: coerce53.number(),
  adjustedStepId: coerce53.number(),
  currentDay: coerce53.number(),
  isComplete: coerce53.boolean(),
  isCurrent: coerce53.boolean(),
  joinedElective: coerce53.boolean().optional().default(false),
  showBonusSelection: coerce53.boolean(),
  alreadyClaimedBonus: JourneyAlreadyClaimedBonusValues,
  nextStep: BaseStepSchema.optional().nullable(),
  selectElectiveContent: coerce53.boolean().optional().default(false),
  createdAt: CommonCustomDateSchema,
  updatedAt: CommonCustomDateSchema
});

// src/ryc/journey/filters.ts
import { coerce as coerce54, object as object80 } from "zod";
var JourneyFiltersSchema = object80({
  perPage: coerce54.number().optional(),
  page: coerce54.number().optional()
});
var CurrentJourneyFiltersSchema = object80({
  withNextRestore: CoerceBoolean.optional().default(false)
});

// src/ryc/journey/select-bonus-content.request.ts
import { object as object81, string as string64 } from "zod";
var SelectBonusContentRequestSchema = object81({
  contentIds: string64().array().min(1, "Select at least 1 content").max(3, "Maximum 3 contents allowed")
});

// src/ryc/onboarding/base.ts
import { coerce as coerce57, object as object84, string as string66, z as z148 } from "zod";

// src/ryc/onboarding/step.ts
import { coerce as coerce56, object as object83, z as z147 } from "zod";

// src/ryc/onboarding/step.enum.ts
import { z as z145 } from "zod";
var OnboardingStepValues = [
  "WELCOME",
  "INTRO",
  "UPDATE_PROFILE_INFORMATION",
  "EXPECTATION"
];
var OnboardingStepEnumObject = z145.enum(OnboardingStepValues);
var EOnboardingStep = OnboardingStepEnumObject.enum;

// src/ryc/onboarding/video.ts
import { coerce as coerce55, object as object82, string as string65, z as z146 } from "zod";
var OnboardingVideoSchema = object82({
  id: coerce55.number(),
  title: string65(),
  isWatched: CoerceBoolean,
  thumbnail: string65(),
  type: string65().optional(),
  videoId: string65()
});
var CreateOnboardingVideoSchemaBE = OnboardingVideoSchema.extend({
  isWatched: z146.boolean()
});

// src/ryc/onboarding/step.ts
var OnboardingStepSchema = object83({
  name: OnboardingStepEnumObject,
  isCompleted: CoerceBoolean,
  videos: OnboardingVideoSchema.array(),
  updatedAt: coerce56.string().date()
});
var CreateOnboardingStepSchemaBE = OnboardingStepSchema.extend({
  isCompleted: z147.boolean(),
  videos: CreateOnboardingVideoSchemaBE.array()
});
var UpdateOnboardingStepVideoWatchedSchemaBE = OnboardingStepSchema.extend({
  videoId: coerce56.string().optional(),
  step: OnboardingStepEnumObject
});

// src/ryc/onboarding/base.ts
var BaseOnboardingSchema = object84({
  id: coerce57.number(),
  tier: TiersEnumObject,
  isComplete: z148.boolean(),
  currentProgressStep: OnboardingStepEnumObject,
  isCompleted: coerce57.boolean(),
  progress: OnboardingStepSchema.array(),
  userId: string66(),
  createdAt: coerce57.string().date(),
  updatedAt: coerce57.string().date()
});

// src/ryc/onboarding/be-schema.ts
var CreateOnboardingSchemaBE = CreateOnboardingStepSchemaBE.array();

// src/ryc/todays-workout/fe-schema.ts
import { coerce as coerce58, object as object85 } from "zod";
var TodaysWorkoutSchemaFE = object85({
  step: coerce58.number(),
  completedClass: coerce58.number(),
  classes: BaseRYCContentSchema.array()
});

// src/ryc/user-management/get-users-assigned-instructors-request.ts
import { array as array21, object as object86, string as string67 } from "zod";
var GetAssignedInstructorsWidthUserIdsBESchema = object86({
  userIds: array21(string67())
});

// src/ryc/user-management/get-users-request.ts
import { coerce as coerce60, object as object88, string as string69 } from "zod";

// src/user-activity/get-users-request.ts
import { coerce as coerce59, object as object87, string as string68, z as z149 } from "zod";
var UserSourceEnum = z149.enum([
  "wordpress",
  "supabase"
]);
var GetUsersRequestBESchema = object87({
  limit: coerce59.number().max(100),
  page: coerce59.number(),
  name: string68().optional().transform((v) => v || void 0),
  email: string68().optional().transform((v) => v || void 0),
  source: UserSourceEnum.default("wordpress")
});

// src/ryc/user-management/get-users-request.ts
var GetSubscribedUsersRequestBESchema = object88({
  tierInfo: coerce60.number().optional(),
  limit: coerce60.number().max(100),
  page: coerce60.number(),
  name: string69().optional(),
  email: string69().optional(),
  source: UserSourceEnum.default("wordpress")
});

// src/ryc/user-management/user-type.ts
import { array as array22, number as number29, object as object89, string as string70, z as z154 } from "zod";

// src/supabase/pro-directory-cache.ts
import { z as z150 } from "zod";
var ProDirectoryCacheEntrySchema = z150.object({
  key: z150.string(),
  type: z150.enum([
    "listable",
    "geography"
  ]),
  ttlSeconds: z150.number(),
  sizeBytes: z150.number()
});
var ProDirectoryCacheStatusSchema = z150.object({
  totalKeys: z150.number(),
  totalSizeBytes: z150.number(),
  entries: z150.array(ProDirectoryCacheEntrySchema)
});
var ProDirectoryRecacheJobSchema = z150.object({
  jobId: z150.string(),
  state: z150.string(),
  failedReason: z150.string().nullable().optional()
});

// src/supabase/pro-directory-expertise.ts
import { z as z151 } from "zod";
var ExpertiseItemSchema = z151.object({
  id: z151.number(),
  name: z151.string(),
  parentId: z151.number().nullable()
});

// src/supabase/pro-directory-profession.ts
import { z as z152 } from "zod";
var ProfessionSchema = z152.object({
  id: z152.number(),
  name: z152.string(),
  parentId: z152.number().nullable()
});

// src/supabase/pro-public-profile.ts
import { z as z153 } from "zod";
var SocialsSchema = z153.object({
  facebook: z153.string().nullable().optional(),
  instagram: z153.string().nullable().optional(),
  youtube: z153.string().nullable().optional(),
  twitter: z153.string().nullable().optional(),
  linkedin: z153.string().nullable().optional(),
  tiktok: z153.string().nullable().optional()
}).nullable().optional();
var ProPublicProfileSchema = z153.object({
  proDirectoryId: z153.number(),
  isActive: z153.boolean().default(true),
  slug: z153.string().nullable().optional(),
  bio: z153.string().nullable().optional(),
  profession: z153.array(z153.object({
    id: z153.number(),
    name: z153.string()
  })).default([]),
  companyName: z153.string().nullable().optional(),
  companyEmail: z153.string().nullable().optional(),
  professionalWebsite: z153.string().nullable().optional(),
  offerings: z153.array(z153.string()).default([]),
  teachingFormat: TeachingFormatSchema.nullable().optional(),
  expertise: z153.array(z153.string()).default([]),
  languagesTaught: z153.array(z153.string()).default([]),
  casualImage: z153.string().nullable().optional(),
  landscapeImage: z153.string().nullable().optional(),
  fullName: z153.string().nullable().optional(),
  title: z153.string().nullable().optional(),
  phone: z153.string().nullable().optional(),
  businessStreet: z153.string().nullable().optional(),
  businessCountry: z153.object({
    id: z153.number(),
    name: z153.string()
  }).nullable().optional(),
  businessState: z153.object({
    id: z153.number(),
    name: z153.string()
  }).nullable().optional(),
  businessCity: z153.object({
    id: z153.number(),
    name: z153.string()
  }).nullable().optional(),
  certificates: z153.string().nullable().optional(),
  directorySocials: SocialsSchema,
  sortOrder: z153.number().nullable().optional()
});
var ProDirectoryPaginationSchema = z153.object({
  totalItems: z153.number().int().nonnegative(),
  totalPages: z153.number().int().nonnegative(),
  currentPage: z153.number().int().positive(),
  perPage: z153.number().int().positive()
});
var ProDirectoryListResponseSchema = z153.object({
  data: z153.array(ProPublicProfileSchema),
  pagination: ProDirectoryPaginationSchema
});
var EProSpecialtyValues = [
  "Low back pain",
  "SIJ pain",
  "Pelvic organ prolapse",
  "Pelvic floor",
  "Yoga",
  "Prenatal",
  "Hip pain",
  "Incontinence",
  "Diastasis recti",
  "SPD",
  "Postpartum",
  "Other"
];
var EProSpecialtyEnum = z153.enum(EProSpecialtyValues);
var TEACHER_DIRECTORY_DEFAULT_PAGE = 1;
var TEACHER_DIRECTORY_DEFAULT_PER_PAGE = 20;
var TEACHER_DIRECTORY_MAX_PER_PAGE = 100;
var ListProQuerySchema = z153.object({
  page: z153.coerce.number().int().positive().default(TEACHER_DIRECTORY_DEFAULT_PAGE),
  perPage: z153.coerce.number().int().positive().max(TEACHER_DIRECTORY_MAX_PER_PAGE).default(TEACHER_DIRECTORY_DEFAULT_PER_PAGE),
  countryId: z153.coerce.number().int().positive().optional(),
  stateId: z153.coerce.number().int().positive().optional(),
  cityId: z153.coerce.number().int().positive().optional(),
  specialty: EProSpecialtyEnum.optional(),
  includeInactive: z153.string().transform((v) => v === "true").optional().default("false").pipe(z153.boolean())
});
var ListProQueryWithSearchSchema = ListProQuerySchema.extend({
  q: z153.string().max(200).optional()
});
var SearchProQuerySchema = ListProQueryWithSearchSchema;

// src/ryc/user-management/user-type.ts
var SingleUserSchema = z154.object({
  userid: number29(),
  name: string70(),
  avatar: string70(),
  email: string70().email(),
  subscriptionType: AppNameEnumObj.array(),
  subscription: array22(Subscription),
  timezone: timezoneSchema.optional()
});
var SubscribedUserSchema = z154.object({
  userid: z154.string(),
  name: z154.string(),
  avatar: z154.string(),
  email: z154.string().email(),
  subscriptionType: z154.array(AppNameEnumObj),
  subscription: z154.array(Subscription)
});
var UserWatchedAContentSchema = SingleUserSchema.extend({
  createdAt: z154.date()
});
var SubscribedUserResponseSchema = z154.object({
  data: SubscribedUserSchema.array(),
  pagination: object89({
    totalItems: z154.number(),
    totalPages: z154.number(),
    currentPage: z154.number(),
    perPage: z154.number()
  })
});

// src/ryc/user-progress/base.ts
import { coerce as coerce61, object as object90 } from "zod";
var BaseUserProgressSchema = object90({
  totalCompletedClasses: coerce61.number(),
  totalTimeSpentInMin: coerce61.number()
});

// src/plan/base.ts
import { array as array23, coerce as coerce62, number as number30, object as object91, string as string71, z as z155 } from "zod";
var PlanItemContent = Content.omit({
  averageRating: true,
  publishedDate: true,
  type: true
}).extend({
  type: z155.union([
    RYCContentMetaTypeEnumObject,
    ContentTypeEnumObj
  ])
});
var Plan = object91({
  id: coerce62.string(),
  classCount: number30().default(0).optional(),
  name: string71()
});
var SinglePlan = Plan.extend({
  contents: array23(Content)
});
var PlanItem = object91({
  id: number30(),
  order: number30().int().positive(),
  day: coerce62.number().int().positive(),
  content: PlanItemContent.optional(),
  isRestDay: z155.boolean().optional()
});
var PlanItemReorder = object91({
  id: number30().optional(),
  order: number30().int().positive(),
  day: number30().int().positive(),
  contentId: string71().optional(),
  isRestDay: z155.boolean().optional()
});
var PlanResponseSchema = Plan.extend({
  items: PlanItem.array()
});
var PlansResponseSchema = object91({
  items: Plan.array(),
  meta: object91({
    total: z155.number().int().nonnegative(),
    page: z155.number().int().positive(),
    perPage: z155.number().int().positive(),
    totalPages: z155.number().int().nonnegative()
  })
});

// src/plan/be-schema.ts
import { coerce as coerce63, z as z156 } from "zod";

// src/plan/fe-schema.ts
import { array as array24 } from "zod";
var CreatePlanSchemaFE = Plan.omit({
  id: true,
  classCount: true
}).extend({
  items: array24(PlanItem)
});
var defaultPlanSchemaValues = {
  name: "",
  items: []
};

// src/plan/be-schema.ts
var CreatePlanSchemaBE = CreatePlanSchemaFE.extend({
  items: PlanItemReorder.array()
});
var CreatePlanRequestSchemaBE = CreatePlanSchemaBE.extend({
  userId: coerce63.string().min(1)
});
var PlanItemsRequestSchemaFE = z156.object({
  id: coerce63.number().int().positive(),
  items: PlanItemReorder.array()
});
var UpdatePlanRequestSchemaFE = CreatePlanSchemaFE.merge(PlanItemsRequestSchemaFE);

// src/user-activity/base.ts
import { object as object92, string as string72 } from "zod";
var UserSchema = object92({
  userid: string72(),
  name: string72(),
  email: string72()
});

// src/user-activity/manual-complete-content.request.ts
import { object as object93, string as string73 } from "zod";
var ManualCompleteContentRequestSchema = object93({
  userId: string73(),
  contentId: string73()
});

// src/user-activity/query.ts
import { coerce as coerce64, object as object94, z as z157 } from "zod";
var UserActivityQuerySchema = object94({
  page: coerce64.number().int().positive().default(1),
  perPage: coerce64.number().int().positive().default(15),
  excludeTypes: z157.preprocess((val) => typeof val === "string" ? val.split(",") : val, z157.array(UserActivityTypeEnumObject).optional())
});

// src/user-activity/time-period-filter.enum.ts
import { z as z158 } from "zod";
var TimePeriodEnumValues = [
  "WEEK",
  "MONTH",
  "YEAR"
];
var TimePeriodEnumObj = z158.enum(TimePeriodEnumValues);
var TimePeriodEnum = TimePeriodEnumObj.enum;

// src/user-activity/user-activity-type.enum.ts
import { z as z159 } from "zod";
var UserActivitiesTypeValues = [
  "USER_ACTIVITY",
  "USER_INFORMATION",
  "PURCHASE_HISTORY",
  "VIDEO_WATCHED",
  "CHECK_IN",
  "TROPHIES",
  "OWNERSHIP",
  "SIMULATION"
];
var UserActivitiesTypeObj = z159.enum(UserActivitiesTypeValues);
var UserActivitiesTypeEnum = UserActivitiesTypeObj.enum;

// src/user-activity/user-ownership.ts
import { z as z160 } from "zod";
var UserOwnershipSummarySchema = z160.object({
  comments: z160.number().int().nonnegative(),
  replies: z160.number().int().nonnegative(),
  contentsCommentedOn: z160.number().int().nonnegative(),
  likesReceived: z160.number().int().nonnegative(),
  likesGiven: z160.number().int().nonnegative(),
  pendingReview: z160.number().int().nonnegative(),
  rejected: z160.number().int().nonnegative(),
  deleted: z160.number().int().nonnegative(),
  firstActivityAt: z160.string().nullable(),
  lastActivityAt: z160.string().nullable()
});

// src/user-progress/base.ts
import { coerce as coerce65, object as object95 } from "zod";
var UserTotalWatchedByCategory = object95({
  cardio: coerce65.number(),
  strength: coerce65.number(),
  flow: coerce65.number(),
  restore: coerce65.number()
});
var AddonUserTotalWatchedByCategory = object95({
  introduction: coerce65.number(),
  exercises: coerce65.number(),
  workout: coerce65.number(),
  foundation: coerce65.number()
});
var BaseFitUserProgressSchema = object95({
  totalCompletedClasses: coerce65.number(),
  totalWatchedMin: coerce65.number(),
  activeDays: coerce65.number(),
  watchedCategory: UserTotalWatchedByCategory
});
var BaseAddonUserProgressSchema = object95({
  totalCompletedClasses: coerce65.number(),
  totalWatchedMin: coerce65.number(),
  activeDays: coerce65.number(),
  watchedCategory: AddonUserTotalWatchedByCategory
});

// src/user-progress/get-watch-history-date.ts
import { coerce as coerce66, z as z161 } from "zod";
var UserWatchHistoryDates = z161.array(coerce66.string());

// src/class-of-the-day-theme/base.ts
import { array as array25, coerce as coerce67, number as number31, object as object96, string as string74 } from "zod";
var contentSchema = FITContent.omit({
  averageRating: true
});
var ClassOfTheDayTheme = object96({
  id: coerce67.string(),
  title: string74().min(1),
  description: string74().optional(),
  month: number31().int().min(1).max(12),
  year: number31().int().min(2e3).max(2100),
  buttonLabel: string74().nullable()
});
var SingleContentSchedule = ClassOfTheDayTheme.extend({
  contents: array25(FITContent)
});
var ContentScheduleItemWithContent = object96({
  id: number31(),
  day: coerce67.number().int().positive(),
  content: contentSchema
});
var ContentScheduleItem = object96({
  id: number31().optional(),
  day: coerce67.number().int().positive(),
  contentId: string74().optional()
});
var ContentScheduleResponseSchema = ClassOfTheDayTheme.extend({
  items: ContentScheduleItemWithContent.array()
});

// src/class-of-the-day-theme/be-schema.ts
import { coerce as coerce68, object as object97, string as string75 } from "zod";
var CODPayloadItem = object97({
  contentId: string75(),
  day: coerce68.number().int().positive()
});
var CreateCODThemeSchemaBE = ClassOfTheDayTheme.omit({
  id: true
}).merge(object97({
  items: CODPayloadItem.array()
}));
var UpdateCODThemeSchemaBE = ClassOfTheDayTheme.merge(object97({
  items: CODPayloadItem.array()
}));

// src/class-of-the-day-theme/fe-schema.ts
import { array as array26 } from "zod";
var ClassOfTheDayThemeSchemaFE = ClassOfTheDayTheme.omit({
  id: true
}).extend({
  items: array26(ContentScheduleItemWithContent)
});
var currentDate = /* @__PURE__ */ new Date();
var defaultClassOfTheDayThemeSchemaValues = {
  title: "",
  description: "",
  items: [],
  buttonLabel: null,
  month: currentDate.getMonth() + 1,
  year: currentDate.getFullYear()
};

// src/ws-url.ts
import { string as string76 } from "zod";
var WsUrl = string76().refine((url) => url.startsWith("//") || /^wss?:\/\//.test(url) || /^https?:\/\//.test(url), {
  message: "Must be a valid URL or protocol-relative URL (//host)"
});

// src/user-meta/get-user-ids-request.ts
import { array as array27, object as object98, string as string77 } from "zod";
var GetUserIdsBESchema = object98({
  userIds: array27(string77())
});

// src/version.ts
import { z as z162 } from "zod";
var VersionInfoSchema = z162.object({
  timestamp: z162.number(),
  buildDate: z162.string(),
  version: z162.string()
});

// src/user-management/admin-change-email.schema.ts
import { object as object99, string as string78 } from "zod";
var AdminChangeUserEmailSchema = object99({
  email: string78().email("Enter a valid email address")
});

// src/user-management/update-timezone.schema.ts
import { object as object100, string as string79 } from "zod";
var UpdateTimezoneSchema = object100({
  timezone: string79().min(1, "Timezone is required").refine((tz) => {
    try {
      Intl.DateTimeFormat(void 0, {
        timeZone: tz
      });
      return true;
    } catch (e) {
      return false;
    }
  }, {
    message: "Invalid IANA timezone"
  })
});

// src/search/global-search.schema.ts
import { array as array28, number as number32, object as object101, string as string80 } from "zod";
var GlobalSearchRequestSchema = object101({
  q: string80().min(2)
});
var SearchContentItemSchema = object101({
  id: string80(),
  title: string80(),
  instructorName: string80().nullable().optional(),
  banner: string80().nullable().optional(),
  duration: number32()
});
var SearchContentSchema = object101({
  contents: array28(SearchContentItemSchema),
  total: number32()
});
var SearchTextItemSchema = object101({
  id: string80(),
  title: string80(),
  videoCount: number32()
});
var SearchCategoryItemSchema = object101({
  name: string80()
});
var SearchInstructorItemSchema = object101({
  id: string80(),
  name: string80(),
  avatar: string80().nullable().optional()
});
var GlobalSearchResultSchema = object101({
  content: SearchContentSchema,
  playlists: array28(SearchTextItemSchema),
  series: array28(SearchTextItemSchema),
  categories: array28(SearchCategoryItemSchema),
  instructors: array28(SearchInstructorItemSchema)
});

// src/billing/index.ts
import { z as z163 } from "zod";
var GetOrdersSchema = z163.object({
  page: z163.coerce.number().int().positive().default(1),
  perPage: z163.coerce.number().int().positive().default(10)
});
var OrderProductSchema = z163.object({
  productId: z163.number(),
  productName: z163.string(),
  price: z163.number(),
  quantity: z163.number()
});
var OrderSchema = z163.object({
  orderNo: z163.number(),
  date: z163.string(),
  status: z163.string(),
  paymentUrl: z163.string().url().nullable().optional(),
  products: z163.array(OrderProductSchema),
  subtotal: z163.number(),
  discount: z163.number(),
  total: z163.number(),
  currency: z163.string()
});
var OrdersResponseSchema = z163.object({
  totalPages: z163.number(),
  page: z163.number(),
  perPage: z163.number(),
  total: z163.number(),
  items: z163.array(OrderSchema)
});
var BillingSubscriptionSchema = z163.object({
  subscriptionNo: z163.number(),
  status: z163.string(),
  nextPaymentOn: z163.string(),
  products: z163.array(OrderProductSchema),
  subtotal: z163.number(),
  discount: z163.number(),
  total: z163.number(),
  currency: z163.string(),
  orderIds: z163.array(z163.number())
});
var SubscriptionsResponseSchema = z163.object({
  totalPages: z163.number(),
  page: z163.number(),
  perPage: z163.number(),
  total: z163.number(),
  items: z163.array(BillingSubscriptionSchema)
});
var PaymentPlanSchema = z163.object({
  paymentPlanId: z163.number(),
  status: z163.string(),
  nextPaymentOn: z163.string(),
  products: z163.array(OrderProductSchema),
  subtotal: z163.number(),
  discount: z163.number(),
  total: z163.number(),
  currency: z163.string(),
  orderIds: z163.array(z163.number())
});
var PaymentPlansResponseSchema = z163.object({
  totalPages: z163.number(),
  page: z163.number(),
  perPage: z163.number(),
  total: z163.number(),
  items: z163.array(PaymentPlanSchema)
});

// src/site-monitor/base.ts
import { coerce as coerce69, z as z164 } from "zod";
var EPageSpeedStrategy = /* @__PURE__ */ function(EPageSpeedStrategy2) {
  EPageSpeedStrategy2["MOBILE"] = "mobile";
  EPageSpeedStrategy2["DESKTOP"] = "desktop";
  return EPageSpeedStrategy2;
}({});
var EPageSpeedReportStatus = /* @__PURE__ */ function(EPageSpeedReportStatus2) {
  EPageSpeedReportStatus2["SUCCESS"] = "success";
  EPageSpeedReportStatus2["FAILED"] = "failed";
  return EPageSpeedReportStatus2;
}({});
var CronExpressionSchema = z164.string().regex(/^(\*|[0-9,\-*/]+)\s+(\*|[0-9,\-*/]+)\s+(\*|[0-9,\-*/]+)\s+(\*|[0-9,\-*/]+)\s+(\*|[0-9,\-*/]+)$/, "Must be a valid unix cron expression (5 fields)");
var LinkGroupBaseSchema = z164.object({
  id: z164.string().uuid(),
  name: z164.string().min(1).max(150),
  scheduleCron: CronExpressionSchema,
  isActive: z164.boolean().default(true),
  createdBy: z164.string().max(36).nullable().optional(),
  createdAt: z164.date().or(z164.string()),
  updatedAt: z164.date().or(z164.string()),
  deletedAt: z164.date().or(z164.string()).nullable().optional()
});
var CreateLinkGroupSchema = z164.object({
  name: z164.string().min(1).max(150),
  scheduleCron: CronExpressionSchema,
  isActive: z164.boolean().default(true)
});
var UpdateLinkGroupSchema = CreateLinkGroupSchema.partial();
var MonitoredLinkBaseSchema = z164.object({
  id: z164.string().uuid(),
  groupId: z164.string().uuid(),
  url: z164.string().url(),
  label: z164.string().max(150).nullable().optional(),
  isActive: z164.boolean().default(true),
  createdAt: z164.date().or(z164.string()),
  updatedAt: z164.date().or(z164.string()),
  deletedAt: z164.date().or(z164.string()).nullable().optional()
});
var CreateMonitoredLinkSchema = z164.object({
  url: z164.string().url(),
  label: z164.string().max(150).nullable().optional(),
  isActive: z164.boolean().default(true)
});
var UpdateMonitoredLinkSchema = CreateMonitoredLinkSchema.partial();
var BulkLinkEntrySchema = z164.object({
  label: z164.string().max(150).nullable().optional(),
  url: z164.string().min(1)
});
var BulkCreateMonitoredLinkSchema = z164.object({
  links: z164.array(BulkLinkEntrySchema).min(1).max(200)
});
var PageSpeedReportBaseSchema = z164.object({
  id: z164.string().uuid(),
  linkId: z164.string().uuid(),
  strategy: z164.nativeEnum(EPageSpeedStrategy),
  status: z164.nativeEnum(EPageSpeedReportStatus),
  errorMessage: z164.string().nullable().optional(),
  performanceScore: coerce69.number().min(0).max(100).nullable().optional(),
  accessibilityScore: coerce69.number().min(0).max(100).nullable().optional(),
  bestPracticesScore: coerce69.number().min(0).max(100).nullable().optional(),
  seoScore: coerce69.number().min(0).max(100).nullable().optional(),
  lcpMs: coerce69.number().nullable().optional(),
  cls: coerce69.number().nullable().optional(),
  tbtMs: coerce69.number().nullable().optional(),
  fcpMs: coerce69.number().nullable().optional(),
  speedIndexMs: coerce69.number().nullable().optional(),
  screenshotKey: z164.string().max(512).nullable().optional(),
  checkedAt: z164.date().or(z164.string())
});
var ReportQueryFiltersSchema = z164.object({
  groupId: z164.string().uuid().optional(),
  linkId: z164.string().uuid().optional(),
  strategy: z164.nativeEnum(EPageSpeedStrategy).optional(),
  fromDate: z164.string().optional(),
  toDate: z164.string().optional(),
  page: coerce69.number().int().positive().default(1).optional(),
  perPage: coerce69.number().int().positive().default(20).optional()
});
var EQueuedPageState = /* @__PURE__ */ function(EQueuedPageState2) {
  EQueuedPageState2["PROCESSING"] = "processing";
  EQueuedPageState2["QUEUED"] = "queued";
  return EQueuedPageState2;
}({});
var QueuedPageSchema = z164.object({
  id: z164.string().uuid(),
  url: z164.string(),
  label: z164.string().nullable().optional(),
  state: z164.nativeEnum(EQueuedPageState)
});
var QueuedPagesResponseSchema = z164.object({
  status: z164.enum([
    "active",
    "waiting"
  ]).nullable(),
  // Checks = links x strategies (mobile + desktop) of the run in flight.
  totalChecks: z164.number().int(),
  pendingChecks: z164.number().int(),
  pages: z164.array(QueuedPageSchema)
});

// src/upload/index.ts
import { z as z166 } from "zod";

// src/media/base.ts
import { coerce as coerce70, z as z165 } from "zod";
var EMediaFileStatus = /* @__PURE__ */ function(EMediaFileStatus2) {
  EMediaFileStatus2["ACTIVE"] = "active";
  EMediaFileStatus2["SOFT_DELETED"] = "soft_deleted";
  EMediaFileStatus2["PROCESSING"] = "processing";
  EMediaFileStatus2["FAILED"] = "failed";
  return EMediaFileStatus2;
}({});
var EImageVariant = /* @__PURE__ */ function(EImageVariant2) {
  EImageVariant2["w90"] = "w90";
  EImageVariant2["w230x280"] = "w230x280";
  EImageVariant2["w400"] = "w400";
  EImageVariant2["w715x500"] = "w715x500";
  EImageVariant2["w800"] = "w800";
  EImageVariant2["w1060x280"] = "w1060x280";
  EImageVariant2["w1070"] = "w1070";
  EImageVariant2["w1200"] = "w1200";
  EImageVariant2["w1375"] = "w1375";
  EImageVariant2["w1920x768"] = "w1920x768";
  EImageVariant2["w1986x558"] = "w1986x558";
  EImageVariant2["w2400"] = "w2400";
  EImageVariant2["w730x410"] = "w730x410";
  EImageVariant2["original"] = "original";
  EImageVariant2["compressed"] = "compressed";
  EImageVariant2["poster"] = "poster";
  return EImageVariant2;
}({});
var MediaCdnUrlsSchema = z165.record(z165.nativeEnum(EImageVariant), z165.string());
var MediaFileBaseSchema = z165.object({
  id: z165.string().uuid(),
  userId: z165.string().max(36),
  originalName: z165.string().max(255),
  cdnUrls: MediaCdnUrlsSchema,
  mimeType: z165.string().max(100),
  sizeBytes: coerce70.number().int(),
  altText: z165.string().max(500).nullable().optional(),
  status: z165.nativeEnum(EMediaFileStatus).default("active"),
  isSystem: z165.boolean().default(false),
  createdAt: z165.date().or(z165.string()),
  updatedAt: z165.date().or(z165.string()),
  deletedAt: z165.date().or(z165.string()).nullable().optional()
});
var CreateMediaFileSchema = z165.object({
  originalName: z165.string().min(1).max(255),
  cdnUrls: MediaCdnUrlsSchema,
  mimeType: z165.string().min(1).max(100),
  sizeBytes: z165.number().int().positive(),
  altText: z165.string().max(500).nullable().optional(),
  isSystem: z165.boolean().optional().default(false),
  // Callers that upload a compressible asset (video / PDF) create the row as
  // PROCESSING so the transcoder has something to flip to ACTIVE when done.
  status: z165.nativeEnum(EMediaFileStatus).optional()
});
var UpdateMediaFileSchema = z165.object({
  altText: z165.string().max(500).nullable().optional(),
  status: z165.nativeEnum(EMediaFileStatus).optional()
});
var MediaFileFiltersSchema = z165.object({
  mimeType: z165.string().optional(),
  status: z165.nativeEnum(EMediaFileStatus).optional(),
  isSystem: CoerceBoolean.optional(),
  /** Case-insensitive match on the file name. */
  search: z165.string().trim().max(100).optional(),
  page: coerce70.number().int().min(1).optional().default(1),
  limit: coerce70.number().int().min(1).max(100).optional().default(24)
});
var MediaFilePageSchema = z165.object({
  data: z165.array(MediaFileBaseSchema),
  total: z165.number().int(),
  page: z165.number().int(),
  limit: z165.number().int()
});
var MediaMonthlyStatSchema = z165.object({
  month: z165.string(),
  count: z165.number().int(),
  totalBytes: z165.number()
});
var MediaUserStatsSchema = z165.object({
  totalCount: z165.number().int(),
  totalBytes: z165.number(),
  monthly: z165.array(MediaMonthlyStatSchema)
});
var MediaUploadLimitSchema = z165.object({
  maxMonthlyBytes: z165.number().int().positive(),
  isCustom: z165.boolean()
});
var UpdateMediaUploadLimitSchema = z165.object({
  maxMonthlyBytes: z165.number().int().positive()
});

// src/upload/index.ts
var PresignedUploadResultSchema = z166.object({
  uploadUrl: z166.string(),
  publicUrl: z166.string().nullable()
});
var PresignedUploadRequestSchema = z166.object({
  key: z166.string().min(1),
  contentType: z166.string().min(1),
  sizeBytes: z166.coerce.number().int().positive(),
  durationSeconds: z166.coerce.number().nonnegative().optional()
});
var UploadedFileSchema = z166.object({
  key: z166.string(),
  publicUrl: z166.string().nullable(),
  /** All available size variant URLs. Undefined for files uploaded before multi-size support. */
  cdnUrls: z166.record(z166.nativeEnum(EImageVariant), z166.string()).optional(),
  filename: z166.string(),
  size: z166.number(),
  lastModified: z166.date().or(z166.string()),
  mimeType: z166.string(),
  /** Supabase auth_user_id of the uploader */
  uploadedBy: z166.string().optional()
});

// src/media/storage-analytics.ts
import { coerce as coerce71, z as z167 } from "zod";
var EStorageSortField = /* @__PURE__ */ function(EStorageSortField2) {
  EStorageSortField2["total"] = "total";
  EStorageSortField2["image"] = "image";
  EStorageSortField2["file"] = "file";
  EStorageSortField2["video"] = "video";
  EStorageSortField2["lastUpload"] = "lastUpload";
  return EStorageSortField2;
}({});
var EStorageSortOrder = /* @__PURE__ */ function(EStorageSortOrder2) {
  EStorageSortOrder2["asc"] = "asc";
  EStorageSortOrder2["desc"] = "desc";
  return EStorageSortOrder2;
}({});
var StorageAnalyticsFiltersSchema = z167.object({
  /** Partial match on user id (numeric profile id), name, email or display name. */
  search: z167.string().trim().max(200).optional(),
  /** ISO date — include uploads created on/after this instant. */
  startDate: z167.string().datetime({
    offset: true
  }).or(z167.string().date()).optional(),
  /** ISO date — include uploads created on/before this instant. */
  endDate: z167.string().datetime({
    offset: true
  }).or(z167.string().date()).optional(),
  sortBy: z167.nativeEnum(EStorageSortField).optional().default("total"),
  sortOrder: z167.nativeEnum(EStorageSortOrder).optional().default("desc"),
  page: coerce71.number().int().min(1).optional().default(1),
  limit: coerce71.number().int().min(1).max(100).optional().default(20)
});
var StorageAnalyticsUserRowSchema = z167.object({
  userId: z167.string(),
  name: z167.string(),
  email: z167.string(),
  displayName: z167.string().optional(),
  avatar: z167.string().optional(),
  imageBytes: z167.number(),
  fileBytes: z167.number(),
  videoBytes: z167.number(),
  totalBytes: z167.number(),
  imageCount: z167.number().int(),
  fileCount: z167.number().int(),
  videoCount: z167.number().int(),
  totalCount: z167.number().int(),
  lastUploadAt: z167.string().nullable(),
  /** Monthly upload cap in bytes — the per-user value from user_meta, or the server default. */
  maxMonthlyBytes: z167.number().int(),
  /** True when the user has a per-user limit stored in user_meta (vs the server default). */
  isCustomLimit: z167.boolean()
});
var StorageAnalyticsSummarySchema = z167.object({
  totalBytes: z167.number(),
  imageBytes: z167.number(),
  fileBytes: z167.number(),
  videoBytes: z167.number(),
  imageCount: z167.number().int(),
  fileCount: z167.number().int(),
  videoCount: z167.number().int(),
  totalCount: z167.number().int(),
  userCount: z167.number().int()
});
var StorageAnalyticsResponseSchema = z167.object({
  summary: StorageAnalyticsSummarySchema,
  data: z167.array(StorageAnalyticsUserRowSchema),
  pagination: z167.object({
    totalItems: z167.number().int(),
    totalPages: z167.number().int(),
    currentPage: z167.number().int(),
    perPage: z167.number().int()
  })
});

// src/media/transcode.ts
import { z as z168 } from "zod";
var EMediaProcessingKind = /* @__PURE__ */ function(EMediaProcessingKind2) {
  EMediaProcessingKind2["video"] = "video";
  return EMediaProcessingKind2;
}({});
var resolveProcessingKind = /* @__PURE__ */ __name((mimeType) => {
  if (mimeType.startsWith("video/")) {
    return "video";
  }
  return null;
}, "resolveProcessingKind");
var TranscodeJobSchema = z168.object({
  mediaId: z168.string().uuid(),
  /** R2 object key of the uploaded original, e.g. `uploads/2026-07-21/<name>.mp4`. */
  key: z168.string().min(1),
  mimeType: z168.string().min(1),
  kind: z168.nativeEnum(EMediaProcessingKind)
});
var TranscodeOutputSchema = z168.object({
  variant: z168.nativeEnum(EImageVariant),
  key: z168.string(),
  url: z168.string(),
  sizeBytes: z168.number().int().nonnegative()
});
var TranscodeResultSchema = z168.object({
  mediaId: z168.string().uuid(),
  outputs: z168.array(TranscodeOutputSchema),
  /** Size of the source object, so callers can log the compression ratio. */
  originalSizeBytes: z168.number().int().nonnegative(),
  durationMs: z168.number().int().nonnegative(),
  /**
  * True when compression ran but the result was no smaller than the source,
  * so the original was kept and no `compressed` output was produced.
  */
  skipped: z168.boolean().default(false),
  /**
  * True when the source object was deleted from R2 because a verified
  * compressed derivative replaced it. Callers must then drop `original` from
  * `cdnUrls`, or the record would point at an object that no longer exists.
  */
  originalDeleted: z168.boolean().default(false)
});
var TranscodeResultEventSchema = z168.discriminatedUnion("status", [
  z168.object({
    status: z168.literal("ok"),
    result: TranscodeResultSchema
  }),
  z168.object({
    status: z168.literal("unprocessable"),
    mediaId: z168.string().uuid(),
    error: z168.string()
  })
]);

// src/support/comment.ts
import { z as z169 } from "zod";
var CreateTicketCommentSchema = z169.object({
  content: z169.string().min(1),
  attachmentPaths: z169.array(z169.string()).optional()
});
var TicketCommentSchema = z169.object({
  id: z169.string().uuid(),
  ticketId: z169.number(),
  authorEmail: z169.string(),
  content: z169.string(),
  isAdmin: z169.boolean(),
  isSystem: z169.boolean(),
  seenAt: z169.string().nullable(),
  createdAt: z169.string(),
  attachments: z169.array(z169.object({
    id: z169.string().uuid(),
    path: z169.string(),
    originalName: z169.string(),
    mimeType: z169.string(),
    sizeBytes: z169.number()
  })).optional()
});

// src/support/issue-category.ts
import { z as z170 } from "zod";
var CreateIssueCategorySchema = z170.object({
  name: z170.string().min(1),
  parentId: z170.string().uuid().nullable().optional(),
  allowPublic: z170.boolean().default(false),
  order: z170.number().int().default(0),
  icon: z170.string().nullable().optional(),
  description: z170.string().nullable().optional()
});
var UpdateIssueCategorySchema = CreateIssueCategorySchema.partial();
var IssueCategorySchema = z170.lazy(() => z170.object({
  id: z170.string().uuid(),
  name: z170.string(),
  parentId: z170.string().uuid().nullable(),
  allowPublic: z170.boolean(),
  order: z170.number(),
  icon: z170.string().nullable(),
  description: z170.string().nullable(),
  createdAt: z170.string(),
  updatedAt: z170.string(),
  children: IssueCategorySchema.array().optional()
}));

// src/support/rbac.ts
import { z as z171 } from "zod";
var SupportPermissionKeyValues = [
  "help.ticket.view_all",
  "help.ticket.reply",
  "help.ticket.update_status",
  "help.ticket.delete",
  "help.chat.view",
  "help.chat.join",
  "help.chat.close",
  "help.chat.takeover",
  "help.issue_category.manage",
  "help.role.manage",
  "help.staff.manage",
  "help.settings.ai"
];
var SupportPermissionKeyEnum = z171.enum(SupportPermissionKeyValues);
var AssignRoleSchema = z171.object({
  userUuid: z171.string().uuid(),
  roleId: z171.number().int().positive()
});
var SupportRoleSchema = z171.object({
  id: z171.number(),
  name: z171.string(),
  description: z171.string().nullable(),
  isSystem: z171.boolean(),
  createdAt: z171.string()
});
var SupportStaffMemberSchema = z171.object({
  userUuid: z171.string(),
  wpUserId: z171.string().nullable().optional(),
  email: z171.string().nullable(),
  name: z171.string().nullable(),
  roleId: z171.number(),
  roleName: z171.string()
});

// src/support/support-settings.ts
import { z as z172 } from "zod";
var SlackNotificationEventValues = [
  "ticket_created",
  "customer_replied",
  "staff_replied",
  "ai_draft_generated",
  "ai_draft_approved",
  "ai_draft_dismissed",
  "status_changed",
  "assigned"
];
var SlackNotificationEventEnum = z172.enum(SlackNotificationEventValues);
var DEFAULT_AI_SYSTEM_PROMPT = `You are {agentName}, a helpful support agent. Use the knowledge base articles below to answer the customer's question. Be concise and friendly. If the answer is not in the knowledge base, acknowledge the question and let the customer know the team will follow up.

CRITICAL RULES \u2014 never break these:
- NEVER invent or estimate timeframes (e.g. "24-48 hours", "within a day", "soon"). If you do not know when something will happen, do not guess \u2014 simply say the team will follow up.
- NEVER make promises or guarantees about outcomes, fixes, or timelines.
- NEVER fabricate information not present in the knowledge base or conversation history.

IMPORTANT: Format your entire response as valid HTML. Use <p> for paragraphs, <strong> for bold, <a href="..."> for links, <ol>/<ul>/<li> for lists. Do NOT use Markdown syntax (no **, no #, no backticks, no [text](url) syntax). Output only the inner HTML content \u2014 no <html>, <head>, or <body> tags.`;
var DEFAULT_ARTICLE_SYSTEM_PROMPT = `You are an expert technical writer. Your job is to turn a resolved support ticket conversation into a polished, reusable knowledge base article that helps future customers solve the same problem themselves.

Guidelines:
- Write for a general audience \u2014 assume the reader has the same problem but has never seen this ticket.
- The "question" should be the most natural way a customer would search for this problem (plain text, no HTML, no punctuation at the end except "?").
- The "answer" should be a self-contained solution: explain the cause briefly, then provide clear step-by-step instructions or information. Omit personal details, ticket numbers, and back-and-forth pleasantries.
- Use <p> for paragraphs, <ol>/<li> for numbered steps, <ul>/<li> for unordered lists, <strong> for key terms. No markdown.
- Be concise but complete \u2014 aim for 100\u2013300 words in the answer.

Return a JSON object with exactly two keys:
- "question": article title as a natural search query (plain text)
- "answer": article body as valid inner HTML

Output only the raw JSON object \u2014 no markdown code fences, no extra text before or after.`;
var SupportSettingsSchema = z172.object({
  aiAgentName: z172.string().default("Support Bot"),
  aiEnabled: z172.boolean().default(false),
  aiAvatarUrl: z172.string().nullable().default(null),
  aiSystemPrompt: z172.string().default(DEFAULT_AI_SYSTEM_PROMPT),
  articleSystemPrompt: z172.string().default(DEFAULT_ARTICLE_SYSTEM_PROMPT),
  slackEnabledEvents: z172.array(SlackNotificationEventEnum).default([
    ...SlackNotificationEventValues
  ])
});
var UpdateSupportSettingsSchema = SupportSettingsSchema.partial();

// src/support/ticket.ts
import { z as z173 } from "zod";
var TicketStatusValues = [
  "open",
  "customer_reply",
  "replied",
  "closed"
];
var TicketStatusEnum = z173.enum(TicketStatusValues);
var CreateTicketSchema = z173.object({
  title: z173.string().min(1),
  description: z173.string().min(1),
  product: z173.string().optional(),
  issueCategoryId: z173.string().uuid().optional(),
  userEmail: z173.string().email().optional(),
  attachmentPaths: z173.array(z173.string()).optional()
});
var UpdateTicketStatusSchema = z173.object({
  status: TicketStatusEnum
});
var TicketFiltersSchema = z173.object({
  status: TicketStatusEnum.optional(),
  search: z173.string().optional(),
  userId: z173.string().optional(),
  dateFrom: z173.string().optional(),
  dateTo: z173.string().optional(),
  issueCategoryId: z173.string().uuid().optional(),
  page: z173.coerce.number().int().min(1).default(1),
  perPage: z173.coerce.number().int().min(1).max(100).default(20)
});
var AssignTicketSchema = z173.object({
  assignedTo: z173.string().nullable()
});
var TicketSchema = z173.object({
  id: z173.number(),
  userEmail: z173.string().nullable(),
  userId: z173.string().nullable(),
  title: z173.string(),
  description: z173.string(),
  status: TicketStatusEnum,
  product: z173.string().nullable(),
  issueCategoryId: z173.string().uuid().nullable(),
  assignedTo: z173.string().nullable(),
  assignedToName: z173.string().nullable().optional(),
  accessToken: z173.string().nullable().optional(),
  sourceArticleId: z173.number().nullable().optional(),
  createdAt: z173.string(),
  updatedAt: z173.string()
});

// src/support/ticket-event.ts
import { z as z174 } from "zod";
var TicketEventTypeValues = [
  "created",
  "status_changed",
  "assigned",
  "unassigned",
  "staff_replied",
  "customer_replied"
];
var TicketEventTypeEnum = z174.enum(TicketEventTypeValues);
var TicketEventSchema = z174.object({
  id: z174.number(),
  ticketId: z174.number(),
  actorEmail: z174.string().nullable(),
  actorId: z174.string().nullable().optional(),
  eventType: TicketEventTypeEnum,
  metadata: z174.record(z174.unknown()).nullable(),
  createdAt: z174.string()
});

// src/addon/content/be-schema.ts
import { coerce as coerce72, object as object102, string as string81, z as z175 } from "zod";
var AddonCreateContentSchemaBEBase = object102({
  app: AppNameEnumObj,
  id: string81().optional(),
  name: string81().min(3, "name is required"),
  category: AddonCategoryEnumObj,
  type: ContentTypeEnumObj,
  status: StatusEnumObj,
  // Equipments are optional for the addon app — provided as optional sets, not mandatory.
  equipments: object102({
    id: coerce72.number().min(1, "id is required")
  }).array().optional().default([]),
  instructorId: coerce72.string().min(1, "Please select instructor"),
  video: VimeoVideoInput,
  isAllowComment: coerce72.boolean().default(false),
  publishedDate: z175.string().or(CustomLuxonDateSchema).optional().nullable(),
  favorite: CoerceBoolean.optional().default(false)
});
var AddonCreateContentSchemaBE = AddonCreateContentSchemaBEBase.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var AddonUpdateContentSchemaBE = AddonCreateContentSchemaBEBase.partial();

// src/addon/content/fe-schema.ts
import { coerce as coerce73, lazy as lazy12, object as object103, z as z176 } from "zod";
var AddonContent = Content.extend({
  category: AddonCategoryEnumObj
});
var AddonAllStatusContentSchema = AllStatusContentSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonTrashContentSchema = TrashContentSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonContentAndTrashContentUnion = z176.union([
  AddonContent,
  AddonTrashContentSchema
]);
var AddonContentWithRatingFlagSchema = ContentWithRatingFlagSchema.extend({
  category: AddonCategoryEnumObj
});
var AddonContentFindAllResponseSchema = object103({
  items: AddonContentWithRatingFlagSchema.array(),
  meta: object103({
    page: coerce73.number(),
    perPage: coerce73.number(),
    total: coerce73.number(),
    totalPages: coerce73.number()
  })
});
var AddonDashboardCreateContentSchemaFEWithoutValidation = CreateContentSchemaFEWithoutValidation.extend({
  category: lazy12(() => CategoryEnumObj.or(AddonCategoryEnumObj)),
  // Equipments are optional for the addon app — provided as optional sets, not mandatory.
  equipments: coerce73.number().array().optional().default([])
});
var AddonDashboardCreateContentSchemaFE = AddonDashboardCreateContentSchemaFEWithoutValidation.refine((data) => {
  if (data.status === StatusEnum.PUBLISHED) {
    return !!data.publishedDate;
  }
  return true;
}, {
  message: "Published date is required when status is PUBLISHED",
  path: [
    "publishedDate"
  ]
});
var AddonDashboardUpdateContentSchemaFE = AddonDashboardCreateContentSchemaFEWithoutValidation.partial();
var defaultAddonContentSchemaValues = {
  video: {
    bannerUrl2x: "",
    description: "",
    vimeoVideoId: ""
  },
  name: "",
  instructorId: "",
  equipments: [],
  isAllowComment: false,
  type: "VIDEO",
  favorite: false,
  category: AddonCategoryEnum.EXERCISES,
  status: "PUBLISHED",
  publishedDate: void 0
};

// src/addon/program/base.ts
import { z as z178 } from "zod";

// src/addon/program/section-schema.ts
import { z as z177 } from "zod";
var ProgramSectionInput = z177.object({
  // Stable key used to link items to sections within a single create/update
  // payload. For sections loaded from the DB this is the stringified id; for
  // sections newly added in the dashboard it is a client-generated key. The
  // backend resolves it to the real section id when persisting items.
  key: z177.string(),
  // Present when the section already exists in the DB; absent for new ones.
  id: z177.coerce.number().int().positive().optional().nullable(),
  // The content category this section represents (drives the section heading).
  category: AddonCategoryEnumObj,
  description: z177.string().nullable().optional().default(""),
  order: z177.coerce.number().int().nonnegative()
});
var ProgramSectionResponse = z177.object({
  id: z177.coerce.number(),
  category: AddonCategoryEnumObj,
  description: z177.string().nullable().optional().default(""),
  order: z177.coerce.number()
});

// src/addon/program/base.ts
var Program = Series;
var SingleProgram = SingleSeries;
var ProgramResponseItem = PlaylistItem.extend({
  section: ProgramSectionResponse.nullable().optional()
});
var ProgramResponseSchema = SeriesResponseSchema.extend({
  salesPageUrl: z178.string().nullable().optional(),
  published: z178.coerce.boolean().default(true),
  // Whether non-owners see the locked Members Panel card (with the Unlock
  // button). Off by default — programs not currently sold stay hidden.
  showLockedCard: z178.coerce.boolean().default(false),
  sections: ProgramSectionResponse.array().optional().default([]),
  items: ProgramResponseItem.array()
});
var ProgramListResponseSchema = z178.object({
  items: ProgramResponseSchema.array(),
  meta: z178.object({
    total: z178.number().int().nonnegative(),
    page: z178.number().int().positive(),
    perPage: z178.number().int().positive(),
    totalPages: z178.number().int().nonnegative()
  })
});
var MiniProgramCatalogItemSchema = z178.object({
  id: z178.coerce.number(),
  slug: z178.string(),
  name: z178.string(),
  imageUrl: z178.string().nullable().optional(),
  imageUrl2x: z178.string().nullable().optional(),
  salesPageUrl: z178.string().nullable().optional(),
  showLockedCard: z178.coerce.boolean().default(false)
});

// src/addon/program/be-schema.ts
import { z as z180 } from "zod";

// src/addon/program/fe-schema.ts
import { array as array29, number as number33, object as object104, z as z179 } from "zod";
var ProgramReorderItem = object104({
  id: number33(),
  order: number33().int().positive(),
  content: AddonContent,
  // Links this item to one of the program's sections (by section key). Optional
  // so a program with no sections defined yet keeps working.
  sectionKey: z179.string().nullable().optional()
});
var CreateProgramSchemaFE = CreateSeriesSchemaFE.omit({
  groupId: true,
  groupOrder: true,
  publishedAt: true
}).extend({
  items: array29(ProgramReorderItem),
  // Ordered, per-program list of sections with editable helper text.
  sections: array29(ProgramSectionInput).default([]),
  // Where non-owners are sent to purchase from the Members Panel card. Without
  // it, only owners see the card.
  salesPageUrl: z179.string().url("Enter a valid URL").or(z179.literal("")).nullable().optional(),
  // Single visibility toggle — published programs show in the programs app and
  // as Members Panel cards; unpublished stay hidden from members without explicit access.
  published: CoerceBoolean.default(true),
  // When on, non-owners see the locked Members Panel card with the Unlock
  // button (requires a Sales Page URL). Off = the card is hidden from non-owners.
  showLockedCard: CoerceBoolean.default(false)
});
var CreateProgramFormSchemaFE = CreateProgramSchemaFE.superRefine((data, ctx) => {
  const seenCategories = /* @__PURE__ */ new Map();
  data.sections.forEach((section, index) => {
    if (seenCategories.has(section.category)) {
      ctx.addIssue({
        code: z179.ZodIssueCode.custom,
        path: [
          "sections",
          index,
          "category"
        ],
        message: "Each category can be used by only one section"
      });
    } else {
      seenCategories.set(section.category, index);
    }
  });
  if (data.sections.length > 0) {
    const sectionKeys = new Set(data.sections.map((section) => section.key));
    data.items.forEach((item, index) => {
      if (!item.sectionKey || !sectionKeys.has(item.sectionKey)) {
        ctx.addIssue({
          code: z179.ZodIssueCode.custom,
          path: [
            "items",
            index,
            "sectionKey"
          ],
          message: "Assign this video to a section"
        });
      }
    });
  }
});
var defaultProgramSchemaValues = {
  name: "",
  slug: void 0,
  imageUrl: "",
  imageUrl2x: "",
  description: "",
  isHidden: false,
  requireSequentialCompletion: false,
  seriesType: null,
  items: [],
  sections: [],
  resourceBtnLabel: "",
  resourceBtnSubLabel: "",
  resourceBtnUrl: "",
  resourceBtnLabel2: "",
  resourceBtnSubLabel2: "",
  resourceBtnUrl2: "",
  resourceBtnLabel3: "",
  resourceBtnSubLabel3: "",
  resourceBtnUrl3: "",
  startButtonText: null,
  salesPageUrl: "",
  published: true,
  showLockedCard: false
};

// src/addon/program/be-schema.ts
var MembersPanelFieldsBE = {
  salesPageUrl: z180.string().url().or(z180.literal("")).nullable().optional(),
  published: CoerceBoolean.default(true),
  // Locked-card upsell toggle: non-owners only see the card (with the Unlock
  // button) when this is on and a sales page URL exists.
  showLockedCard: CoerceBoolean.default(false)
};
var AddonProgramItemReorder = PlaylistItemReorder.extend({
  sectionKey: z180.string().nullable().optional()
});
var ProgramSectionFieldsBE = {
  items: AddonProgramItemReorder.array(),
  sections: ProgramSectionInput.array().optional().default([])
};
var CreateProgramSchemaBE = CreateSeriesSchemaBE.omit({
  groupId: true,
  groupOrder: true
}).extend(__spreadValues(__spreadValues({}, MembersPanelFieldsBE), ProgramSectionFieldsBE));
var CreateProgramRequestSchemaBE = CreateProgramSchemaBE.extend({
  userId: z180.coerce.string()
});
var UpdateAddonProgramRequestSchemaFE = CreateProgramSchemaFE.merge(SeriesItemsRequestSchemaFE).omit({
  seriesType: true,
  slug: true
}).extend(ProgramSectionFieldsBE);
var ToggleProgramPublishSchema = z180.object({
  id: z180.coerce.number(),
  published: CoerceBoolean
});

// src/geography/index.ts
import { z as z181 } from "zod";
var CountrySchema = z181.object({
  id: z181.number(),
  name: z181.string(),
  flag: z181.string().nullable().optional(),
  phonecode: z181.string().nullable().optional(),
  is_active: z181.boolean().optional().default(true)
});
var StateSchema = z181.object({
  id: z181.number(),
  name: z181.string()
});
var CitySchema = z181.object({
  id: z181.number(),
  name: z181.string()
});
var GeographyCacheEntrySchema = z181.object({
  key: z181.string(),
  type: z181.enum([
    "countries",
    "states",
    "cities"
  ]),
  referenceId: z181.number().nullable(),
  itemCount: z181.number(),
  sizeBytes: z181.number()
});
var GeographyCacheStatusSchema = z181.object({
  totalKeys: z181.number(),
  totalSizeBytes: z181.number(),
  entries: z181.array(GeographyCacheEntrySchema)
});
var GeographyCacheEntryDetailSchema = z181.object({
  key: z181.string(),
  data: z181.array(z181.object({
    id: z181.number(),
    name: z181.string()
  }).passthrough()).nullable()
});

// src/product/access-config.ts
import { z as z182 } from "zod";
var AccessConfigRoleSchema = z182.object({
  trial: z182.string().nullable().optional(),
  subscriber: z182.string().min(1, "Subscriber role is required"),
  unsubscriber: z182.string().min(1, "Unsubscriber role is required")
});
var AccessConfigEntrySchema = z182.object({
  app: z182.string(),
  role: AccessConfigRoleSchema.optional(),
  variation: z182.number().optional(),
  variation_title: z182.string().nullable().optional(),
  access_group: z182.string().nullable().optional(),
  // Higher number = higher-ranked product. Gates whether a purchase may
  // overwrite an existing user_access row (only a higher priority upgrades).
  // Nullable/optional: null or missing → treated as the column default (1) by
  // the consumer (webhook), so entries at the base priority can leave it blank.
  product_priority: z182.coerce.number().int().min(1, "Priority must be at least 1").nullable().optional(),
  // Optional user group the buyer joins when this entry actually grants access
  // (a completed/active purchase resolving to a real role). Membership is
  // additive only — a later cancellation or refund does not remove it, so an
  // admin's manual assignment is never undone by the purchase webhook.
  user_group_id: z182.coerce.number().int().nullable().optional()
});

// src/product/grant-access.ts
import { z as z183 } from "zod";
var GrantUserAccessSchema = z183.object({
  userId: z183.string().uuid(),
  productId: z183.number().int(),
  variationId: z183.number().int().optional(),
  reason: z183.string().min(1)
});
var GrantUserAccessByAppSchema = z183.object({
  userId: z183.string().uuid(),
  app: z183.string().min(1),
  roleId: z183.number().int().optional(),
  reason: z183.string().min(1)
});
var BulkGrantUserAccessSchema = z183.object({
  userIds: z183.array(z183.string().uuid()).min(1, "Select at least one user").max(100),
  productId: z183.number().int(),
  variationId: z183.number().int().optional(),
  reason: z183.string().min(1)
});
var BulkGrantUserAccessByAppSchema = z183.object({
  userIds: z183.array(z183.string().uuid()).min(1, "Select at least one user").max(100),
  app: z183.string().min(1),
  roleId: z183.number().int().optional(),
  reason: z183.string().min(1)
});

// src/product/product.ts
import { z as z184 } from "zod";
var ProductSchema = z184.object({
  product_id: z184.number().int(),
  product_title: z184.string().nullable(),
  access_config: z184.array(AccessConfigEntrySchema).nullable(),
  created_at: z184.string(),
  is_enabled: z184.boolean().default(true)
});
var CreateProductSchema = z184.object({
  product_id: z184.number().int().positive("Product ID must be a positive integer"),
  product_title: z184.string().min(1, "Product title is required"),
  access_config: z184.array(AccessConfigEntrySchema).optional().default([])
});
var ProductFiltersSchema = z184.object({
  search: z184.string().optional()
});

// src/product/wp-product.ts
import { z as z185 } from "zod";
var WpProductSchema = z185.object({
  id: z185.number(),
  name: z185.string(),
  type: z185.string(),
  status: z185.string(),
  sku: z185.string().nullable().optional(),
  price: z185.string().nullable().optional(),
  regular_price: z185.string().nullable().optional(),
  is_variation: z185.boolean(),
  parent_id: z185.number().nullable().optional(),
  variation_ids: z185.array(z185.number()).optional(),
  attributes: z185.record(z185.string()).optional(),
  date_created: z185.string().optional(),
  featured_image: z185.string().nullable().optional()
});
var WpProductSearchResponseSchema = z185.object({
  success: z185.boolean(),
  data: z185.array(WpProductSchema)
});
var WpProductDetailResponseSchema = z185.object({
  success: z185.boolean(),
  data: WpProductSchema
});

// src/analytics/be-catalog-schema.ts
import { boolean as boolean18, object as object105, string as string82 } from "zod";

// src/analytics/source.enum.ts
import { z as z186 } from "zod";
var AnalyticsSourceValues = [
  "FIT",
  "RYC",
  "PROGRAMS",
  "SPACES"
];
var AnalyticsSourceEnumObj = z186.enum(AnalyticsSourceValues);
var EAnalyticsSourceEnum = AnalyticsSourceEnumObj.enum;
var AnalyticsSourceLabels = {
  FIT: "FIT",
  RYC: "RYC",
  PROGRAMS: "Programs",
  SPACES: "Spaces"
};
var SourceAllowedActions = {
  // FIT/RYC/PROGRAMS emit WATCH_COMPLETE + VIDEO_PLAY (both carry the content UUID);
  // FIT additionally emits ATTENDING_LIVE. They do NOT emit VIDEO_PROGRESS_* /
  // VIDEO_COMPLETE — those come only from SPACES (community-hub).
  FIT: [
    EUserLogActionEnum.WATCH_COMPLETE,
    EUserLogActionEnum.VIDEO_PLAY,
    EUserLogActionEnum.ATTENDING_LIVE
  ],
  RYC: [
    EUserLogActionEnum.WATCH_COMPLETE,
    EUserLogActionEnum.VIDEO_PLAY
  ],
  PROGRAMS: [
    EUserLogActionEnum.WATCH_COMPLETE,
    EUserLogActionEnum.VIDEO_PLAY
  ],
  SPACES: [
    // lesson / space navigation
    EUserLogActionEnum.LESSON_VIEW,
    EUserLogActionEnum.MODULE_VIEW,
    EUserLogActionEnum.COMMUNITY_VIEW,
    EUserLogActionEnum.CHECKIN,
    // content-block engagement (mirrors user-progress ACTION_ENTITY_TYPE, the
    // canonical action → entity map). Vimeo blocks emit VIDEO_PLAY (+ milestones).
    EUserLogActionEnum.VIDEO_PLAY,
    EUserLogActionEnum.VIDEO_VIEW,
    EUserLogActionEnum.VIDEO_COMPLETE,
    EUserLogActionEnum.VIDEO_PROGRESS_25,
    EUserLogActionEnum.VIDEO_PROGRESS_50,
    EUserLogActionEnum.VIDEO_PROGRESS_75,
    EUserLogActionEnum.VIDEO_PROGRESS_100,
    EUserLogActionEnum.PDF_VIEW,
    EUserLogActionEnum.QUIZ_VIEW,
    EUserLogActionEnum.EMBED_VIEW,
    EUserLogActionEnum.TEXT_VIEW,
    EUserLogActionEnum.GCS_UPLOAD_VIEW,
    // GCS upload lifecycle — emitted to user_log against the block id by
    // gcs-upload.service (STARTED → started, IN_BUCKET → member confirmed the
    // file landed, IN_DRIVE → post-processed to Drive). FAILED is defined but
    // never emitted, so it is intentionally not selectable.
    EUserLogActionEnum.GCS_UPLOAD_STARTED,
    EUserLogActionEnum.GCS_UPLOAD_IN_BUCKET,
    EUserLogActionEnum.GCS_UPLOAD_IN_DRIVE,
    EUserLogActionEnum.FORM_VIEW,
    // forms — the submit events also sit on the form content block; the compute
    // service bridges the block id to the form id (ch_form_submissions).
    EUserLogActionEnum.FORM_SUBMITTED,
    EUserLogActionEnum.FORM_SUBMISSION_IN_PROGRESS,
    // quizzes — on the quiz content block; compute bridges the block id to the
    // quiz id (ch_quiz_attempts).
    EUserLogActionEnum.QUIZ_SUBMITTED,
    EUserLogActionEnum.QUIZ_PASSED,
    // event blocks (e.g. a Zoom meeting) — attendance on the block id
    EUserLogActionEnum.EVENT_JOIN,
    EUserLogActionEnum.EVENT_LEAVE,
    // forum / feed
    EUserLogActionEnum.POST_VIEW,
    EUserLogActionEnum.POST_CREATE,
    EUserLogActionEnum.COMMENT_CREATE,
    EUserLogActionEnum.REACTION_ADD
  ]
};
var AnalyticsCompositeEventValues = [
  "EVENT_ATTENDED"
];
var AnalyticsCompositeEventEnumObj = z186.enum(AnalyticsCompositeEventValues);
var AnalyticsConditionEventSchema = z186.union([
  UserLogActionEnumObj,
  AnalyticsCompositeEventEnumObj
]);
var AnalyticsCompositeEventParts = {
  EVENT_ATTENDED: [
    {
      event: EUserLogActionEnum.EVENT_JOIN,
      target: "event"
    },
    {
      event: EUserLogActionEnum.VIDEO_COMPLETE,
      target: "block"
    }
  ]
};
var isAnalyticsCompositeEvent = /* @__PURE__ */ __name((event) => AnalyticsCompositeEventValues.includes(event), "isAnalyticsCompositeEvent");
var AnalyticsEventLabels = {
  EVENT_ATTENDED: "Joined live or watched replay",
  EVENT_JOIN: "Joined live",
  EVENT_LEAVE: "Left live session"
};
var analyticsEventLabel = /* @__PURE__ */ __name((event) => {
  const label2 = AnalyticsEventLabels[event];
  if (label2) {
    return label2;
  }
  const words = event.toLowerCase().replace(/_/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}, "analyticsEventLabel");
var isActionAllowedForSource = /* @__PURE__ */ __name((source, action) => isAnalyticsCompositeEvent(action) ? source === "SPACES" : SourceAllowedActions[source].includes(action), "isActionAllowedForSource");
var AnalyticsSpacesTargetKindValues = [
  "forum",
  "content_block",
  "lesson",
  "space",
  "form",
  "quiz"
];
var AnalyticsSpacesTargetKindEnumObj = z186.enum(AnalyticsSpacesTargetKindValues);
var EAnalyticsSpacesTargetKindEnum = AnalyticsSpacesTargetKindEnumObj.enum;
var SpacesEventTargetKind = {
  // composite
  EVENT_ATTENDED: "content_block",
  // forum / feed
  POST_CREATE: "forum",
  POST_VIEW: "forum",
  COMMENT_CREATE: "forum",
  REACTION_ADD: "forum",
  COMMUNITY_VIEW: "forum",
  // lesson
  LESSON_VIEW: "lesson",
  // content blocks
  VIDEO_PLAY: "content_block",
  VIDEO_VIEW: "content_block",
  VIDEO_COMPLETE: "content_block",
  VIDEO_PROGRESS_25: "content_block",
  VIDEO_PROGRESS_50: "content_block",
  VIDEO_PROGRESS_75: "content_block",
  VIDEO_PROGRESS_100: "content_block",
  PDF_VIEW: "content_block",
  QUIZ_VIEW: "content_block",
  EMBED_VIEW: "content_block",
  TEXT_VIEW: "content_block",
  GCS_UPLOAD_VIEW: "content_block",
  GCS_UPLOAD_STARTED: "content_block",
  GCS_UPLOAD_IN_BUCKET: "content_block",
  GCS_UPLOAD_IN_DRIVE: "content_block",
  FORM_VIEW: "content_block",
  // Form/quiz submit + event attendance are selected on the content block (the
  // condition carries the block id); the compute service bridges the block id to
  // the form/quiz id for the submission/attempt tables.
  FORM_SUBMITTED: "content_block",
  FORM_SUBMISSION_IN_PROGRESS: "content_block",
  QUIZ_SUBMITTED: "content_block",
  QUIZ_PASSED: "content_block",
  EVENT_JOIN: "content_block",
  EVENT_LEAVE: "content_block",
  // sub-space navigation
  MODULE_VIEW: "space",
  CHECKIN: "space"
};
var spacesTargetKindForEvent = /* @__PURE__ */ __name((event) => {
  var _a5;
  return (_a5 = SpacesEventTargetKind[event]) != null ? _a5 : "content_block";
}, "spacesTargetKindForEvent");
var allowedTargetKindsForEvent = /* @__PURE__ */ __name((event) => {
  const primary = spacesTargetKindForEvent(event);
  if (event === "FORM_SUBMITTED" || event === "FORM_SUBMISSION_IN_PROGRESS") {
    return [
      primary,
      "form"
    ];
  }
  if (event === "QUIZ_SUBMITTED" || event === "QUIZ_PASSED") {
    return [
      primary,
      "quiz"
    ];
  }
  return [
    primary
  ];
}, "allowedTargetKindsForEvent");
var SpacesTargetKindEvents = AnalyticsSpacesTargetKindValues.reduce((acc, kind) => {
  acc[kind] = SourceAllowedActions.SPACES.filter((event) => spacesTargetKindForEvent(event) === kind);
  return acc;
}, {});
var eventsForTargetKinds = /* @__PURE__ */ __name((kinds) => {
  const seen = /* @__PURE__ */ new Set();
  kinds.forEach((kind) => {
    var _a5;
    return (_a5 = SpacesTargetKindEvents[kind]) == null ? void 0 : _a5.forEach((event) => seen.add(event));
  });
  return [
    ...seen
  ];
}, "eventsForTargetKinds");
var ContentBlockTypeEvents = {
  text: [
    EUserLogActionEnum.TEXT_VIEW
  ],
  vimeo: [
    EUserLogActionEnum.VIDEO_PLAY,
    EUserLogActionEnum.VIDEO_VIEW,
    EUserLogActionEnum.VIDEO_COMPLETE,
    EUserLogActionEnum.VIDEO_PROGRESS_25,
    EUserLogActionEnum.VIDEO_PROGRESS_50,
    EUserLogActionEnum.VIDEO_PROGRESS_75,
    EUserLogActionEnum.VIDEO_PROGRESS_100
  ],
  pdf: [
    EUserLogActionEnum.PDF_VIEW
  ],
  quiz: [
    EUserLogActionEnum.QUIZ_VIEW,
    EUserLogActionEnum.QUIZ_SUBMITTED,
    EUserLogActionEnum.QUIZ_PASSED
  ],
  form: [
    EUserLogActionEnum.FORM_VIEW,
    EUserLogActionEnum.FORM_SUBMITTED,
    EUserLogActionEnum.FORM_SUBMISSION_IN_PROGRESS
  ],
  embed: [
    EUserLogActionEnum.EMBED_VIEW
  ],
  gcs_upload: [
    EUserLogActionEnum.GCS_UPLOAD_VIEW,
    EUserLogActionEnum.GCS_UPLOAD_STARTED,
    EUserLogActionEnum.GCS_UPLOAD_IN_BUCKET,
    EUserLogActionEnum.GCS_UPLOAD_IN_DRIVE
  ],
  // A live session counts by attendance, by watching the replay, or by either.
  event: [
    "EVENT_ATTENDED",
    EUserLogActionEnum.EVENT_JOIN,
    EUserLogActionEnum.VIDEO_COMPLETE,
    EUserLogActionEnum.EVENT_LEAVE
  ]
};
var eventsForBlockType = /* @__PURE__ */ __name((blockType) => blockType && ContentBlockTypeEvents[blockType] ? [
  ...ContentBlockTypeEvents[blockType]
] : [
  ...SpacesTargetKindEvents.content_block
], "eventsForBlockType");

// src/analytics/be-catalog-schema.ts
var AnalyticsCatalogItemSchemaBE = object105({
  /** Raw id, written straight into the condition's contentRef. */
  id: string82(),
  label: string82(),
  /** Human-readable type, e.g. 'Forum' | 'Module' | 'Lesson' | 'Video' | 'Form'. */
  typeLabel: string82(),
  /**
  * Target kinds this item can serve. A `feed` sub-space carries both 'forum'
  * and 'space'. Empty for FIT / RYC / PROGRAMS, which have no target kinds.
  */
  kinds: AnalyticsSpacesTargetKindEnumObj.array(),
  /**
  * Ancestor names, materialized server-side. Essential under search: matching
  * blocks are returned without their parents, so this is the only thing that
  * gives "Module › Lesson › <block>" context.
  */
  path: string82().array(),
  /**
  * Archived content is still listed rather than hidden — live rules reference
  * archived items (rule 4 targets an archived forum), and dropping them would
  * make an existing condition invisible and unremovable. The table renders
  * these muted with a chip.
  */
  isArchived: boolean18(),
  /**
  * Id of this row's parent in the SPACES content tree, or null for a top-level
  * row. A lesson points at its module (null when it hangs directly off the
  * container), a content block points at its lesson; modules, forums and forms
  * are always top-level. Lets the tree view nest rows without re-deriving the
  * hierarchy from `sort_path`. Omitted for FIT / RYC / PROGRAMS, which are flat.
  */
  parentId: string82().nullish()
});

// src/analytics/be-content-ref-schema.ts
import { z as z187 } from "zod";
var FitContentRefSchemaBE = z187.object({
  source: z187.literal("FIT"),
  contentType: z187.enum([
    "content",
    "playlist"
  ]),
  contentId: z187.string().min(1, "Select a content item")
});
var RycContentRefSchemaBE = z187.object({
  source: z187.literal("RYC"),
  contentId: z187.string().min(1, "Select a content item")
});
var AddonContentRefSchemaBE = z187.object({
  source: z187.literal("PROGRAMS"),
  contentId: z187.string().min(1, "Select a content item")
});
var SpacesContentRefSchemaBE = z187.object({
  source: z187.literal("SPACES"),
  // The target depends on the condition's event (see SpacesEventTargetKind):
  // forum → feed space id; content_block → block id; lesson → lesson id;
  // space → sub-space id; form → form id; quiz → quiz id.
  targetKind: z187.enum([
    "forum",
    "content_block",
    "lesson",
    "space",
    "form",
    "quiz"
  ]),
  targetId: z187.string().uuid("Select a target")
});
var AnalyticsContentRefSchemaBE = z187.discriminatedUnion("source", [
  FitContentRefSchemaBE,
  RycContentRefSchemaBE,
  AddonContentRefSchemaBE,
  SpacesContentRefSchemaBE
]);

// src/analytics/be-member-schema.ts
import { boolean as boolean19, number as number36, object as object108, string as string84, z as z190 } from "zod";

// src/analytics/be-node-schema.ts
import { number as number34, object as object106, z as z188 } from "zod";
var AnalyticsOperatorValues = [
  "AND",
  "OR"
];
var AnalyticsOperatorEnumObj = z188.enum(AnalyticsOperatorValues);
var EAnalyticsOperatorEnum = AnalyticsOperatorEnumObj.enum;
var AnalyticsConditionSchemaBE = object106({
  type: z188.literal("condition"),
  contentRef: AnalyticsContentRefSchemaBE,
  event: AnalyticsConditionEventSchema,
  requiredCount: number34().int().min(1),
  /**
  * The content's name as it read when the item was selected, kept so the
  * builder's ordering list can name a condition without resolving the whole
  * catalog for every source. Display only and possibly stale — every
  * authoritative label still comes from the plan at run time. Absent on rules
  * saved before this field existed.
  */
  label: z188.string().optional(),
  /**
  * Optional due date (YYYY-MM-DD). When set, the event only counts toward this
  * condition if the user did it on or before the end of that day — someone who
  * completes the content later does not satisfy the rule. Unset = any time.
  */
  dueDate: z188.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Due date must be YYYY-MM-DD").optional()
});
var AnalyticsRuleRefSchemaBE = object106({
  type: z188.literal("rule"),
  ruleId: number34().int().positive("Select a rule")
});
var AnalyticsGroupSchemaBE = z188.lazy(() => object106({
  type: z188.literal("group"),
  operator: AnalyticsOperatorEnumObj,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  children: z188.array(AnalyticsNodeSchemaBE)
}));
var AnalyticsNodeSchemaBE = z188.lazy(() => z188.union([
  AnalyticsGroupSchemaBE,
  AnalyticsConditionSchemaBE,
  AnalyticsRuleRefSchemaBE
]));

// src/analytics/be-snapshot-schema.ts
import { number as number35, object as object107, record as record2, string as string83, z as z189 } from "zod";
var AnalyticsRunStatusValues = [
  "pending",
  "computing",
  "completed",
  "failed"
];
var AnalyticsRunStatusEnumObj = z189.enum(AnalyticsRunStatusValues);
var EAnalyticsRunStatusEnum = AnalyticsRunStatusEnumObj.enum;
var AnalyticsUserStatusValues = [
  "completed",
  "partial",
  "not_started"
];
var AnalyticsUserStatusEnumObj = z189.enum(AnalyticsUserStatusValues);
var EAnalyticsUserStatusEnum = AnalyticsUserStatusEnumObj.enum;
var ANALYTICS_NO_USER_GROUP = "none";
var AnalyticsContentSideValues = [
  "completed",
  "completed_late",
  "not_completed"
];
var AnalyticsContentSideEnumObj = z189.enum(AnalyticsContentSideValues);
var isCellOnTime = /* @__PURE__ */ __name((cell) => {
  var _a5;
  return ((_a5 = cell.onTimeValue) != null ? _a5 : cell.value) >= cell.target;
}, "isCellOnTime");
var isCellCompletedLate = /* @__PURE__ */ __name((cell) => cell.value >= cell.target && !isCellOnTime(cell), "isCellCompletedLate");
var serializeUserGroupFilters = /* @__PURE__ */ __name((filters) => filters && filters.length > 0 ? filters.join(",") : void 0, "serializeUserGroupFilters");
var parseUserGroupFilters = /* @__PURE__ */ __name((raw) => {
  if (!raw) {
    return void 0;
  }
  const parsed = raw.split(",").map((part) => part.trim()).filter(Boolean).flatMap((part) => {
    if (part === ANALYTICS_NO_USER_GROUP) {
      return [
        ANALYTICS_NO_USER_GROUP
      ];
    }
    const id2 = Number(part);
    return Number.isInteger(id2) && id2 > 0 ? [
      id2
    ] : [];
  });
  const unique = [
    ...new Set(parsed)
  ];
  return unique.length > 0 ? unique : void 0;
}, "parseUserGroupFilters");
var userGroupAppliesToApp = /* @__PURE__ */ __name((groupApps, app) => {
  const apps = groupApps != null ? groupApps : [];
  return apps.length === 0 || apps.includes(app);
}, "userGroupAppliesToApp");
var AnalyticsColumnKindValues = [
  "overall",
  "condition",
  "rule"
];
var AnalyticsColumnKindEnumObj = z189.enum(AnalyticsColumnKindValues);
var AnalyticsColumnSchemaBE = object107({
  key: string83(),
  label: string83(),
  kind: AnalyticsColumnKindEnumObj,
  ruleId: number35().int().positive().optional(),
  /**
  * The tracked action this column counts — set when kind = 'condition'. The
  * label is the content name, which alone doesn't say what was measured.
  * Optional because snapshots computed before this field existed lack it.
  */
  event: string83().optional(),
  /**
  * Due date (YYYY-MM-DD) applied to this condition, when set. The event only
  * counted for users who did it on or before this date. Rendered on its own
  * line in the View header. Optional — most conditions have no due date.
  */
  dueDate: string83().optional(),
  /**
  * The module (sub-space) this condition's content belongs to — set for SPACES
  * rules so the View can group/filter conditions by module. Undefined for
  * items that sit directly under the space, for non-SPACES sources, and for
  * snapshots computed before this field existed.
  */
  module: string83().optional(),
  /**
  * The lesson this condition's content belongs to — set for SPACES rules so the
  * View can narrow conditions below the module level. Undefined for targets that
  * aren't under a lesson (modules, forums, space-level forms), for non-SPACES
  * sources, and for snapshots computed before this field existed.
  */
  lesson: string83().optional()
});
var AnalyticsJobStateValues = [
  "waiting",
  "active",
  "delayed",
  "failed",
  "completed",
  "unknown"
];
var AnalyticsJobStateEnumObj = z189.enum(AnalyticsJobStateValues);
var AnalyticsJobStatusSchemaBE = object107({
  state: AnalyticsJobStateEnumObj,
  attemptsMade: number35().int().nonnegative(),
  failedReason: string83().nullable()
});
var AnalyticsRuleSnapshotSchemaBE = object107({
  id: number35().int().positive(),
  ruleId: number35().int().positive(),
  status: AnalyticsRunStatusEnumObj,
  totalUsers: number35().int().nonnegative(),
  matchedCount: number35().int().nonnegative(),
  computedAt: string83().nullable(),
  createdAt: string83(),
  error: string83().nullable(),
  columns: AnalyticsColumnSchemaBE.array(),
  /** Live queue state, when a job for this rule still exists. */
  job: AnalyticsJobStatusSchemaBE.nullable().optional(),
  /**
  * The snapshot says it is running but the queue has no live job for it — the
  * worker died or the job was dropped. Without this the row polls forever and
  * looks identical to "queued".
  */
  isStuck: z189.boolean().optional()
});
var AnalyticsSnapshotListItemSchemaBE = object107({
  id: number35().int().positive(),
  status: AnalyticsRunStatusEnumObj,
  totalUsers: number35().int().nonnegative(),
  matchedCount: number35().int().nonnegative(),
  computedAt: string83().nullable(),
  createdAt: string83(),
  error: string83().nullable(),
  /** Enqueue → finish, in ms. Null while still running. */
  durationMs: number35().int().nonnegative().nullable(),
  /** True for the run whose per-user results are still retained. */
  isCurrent: z189.boolean()
});
var AnalyticsCellProgressSchemaBE = object107({
  completed: number35().int().nonnegative(),
  total: number35().int().nonnegative()
});
var AnalyticsCellSchemaBE = object107({
  /**
  * Times the user did it, whenever they did it. A due date no longer bounds
  * this — it only splits the result into on-time and overdue (see
  * `onTimeValue`), so someone who finishes late still counts as having done it.
  */
  value: number35().int().nonnegative(),
  target: number35().int().nonnegative(),
  /**
  * Times the user did it on or before the condition's due date. Set only for
  * conditions that have one — and absent on snapshots computed before due
  * dates stopped bounding `value`, where `value` was already the on-time count.
  * Callers fall back to `value`, which reads such rows as on time.
  */
  onTimeValue: number35().int().nonnegative().optional(),
  /**
  * ISO time of the latest counted event. Set only when the caller collected it
  * (the member "My Analytics" view); absent on admin snapshots.
  */
  lastDoneAt: string83().optional(),
  /**
  * Set only on referenced-rule cells, so the View can show that rule's progress
  * instead of a bare pass/fail tick. Absent on content-condition cells (their
  * own value/target already say it) and on snapshots computed before this field
  * existed — callers must fall back to the tick.
  */
  progress: AnalyticsCellProgressSchemaBE.optional()
});
var AnalyticsUserGroupRefSchemaBE = object107({
  id: number35().int(),
  name: string83()
});
var AnalyticsUserRolesSchemaBE = object107({
  audience: string83().array().default([]),
  tracking: string83().array().default([])
});
var EMPTY_ANALYTICS_USER_ROLES = {
  audience: [],
  tracking: []
};
var ANALYTICS_NO_ROLE = "\u2014";
var formatAnalyticsUserRoles = /* @__PURE__ */ __name((roles, options = {}) => {
  var _a5, _b;
  const audience = (_a5 = roles == null ? void 0 : roles.audience) != null ? _a5 : [];
  const tracking = (_b = roles == null ? void 0 : roles.tracking) != null ? _b : [];
  const left = audience.length > 0 ? audience.join(", ") : ANALYTICS_NO_ROLE;
  if (options.sameApp) {
    return left;
  }
  const right = tracking.length > 0 ? tracking.join(", ") : ANALYTICS_NO_ROLE;
  return `${left} / ${right}`;
}, "formatAnalyticsUserRoles");
var AnalyticsResultRowSchemaBE = object107({
  userId: string83(),
  // profile.user_uuid — the key admin notes attach to. Resolved from the row's
  // auth id at read time (not stored on the results), so it works for any snapshot.
  userUuid: string83().nullable(),
  name: string83().nullable(),
  email: string83().nullable(),
  /**
  * Groups the user was in when the run was computed, scoped to the rule's
  * audience app — snapshotted alongside name/email so the view, the filter and
  * the exports all read the same thing. Empty on runs computed before this
  * existed; those show no groups until the rule is re-run.
  */
  userGroups: AnalyticsUserGroupRefSchemaBE.array().default([]),
  /**
  * Roles in the rule's audience and tracking apps, snapshotted for the same
  * reason as `userGroups`: they live in Supabase while these rows live here.
  * Empty on runs computed before this existed — those show no roles until the
  * rule is re-run.
  */
  roles: AnalyticsUserRolesSchemaBE.default(EMPTY_ANALYTICS_USER_ROLES),
  cells: record2(string83(), AnalyticsCellSchemaBE)
});
var AnalyticsAggregateSchemaBE = object107({
  /** Users who met the column, on time or late. */
  matched: number35().int().nonnegative(),
  /** Of those, the ones who met it by the due date. Absent on older snapshots. */
  onTimeMatched: number35().int().nonnegative().optional(),
  total: number35().int().nonnegative()
});

// src/analytics/be-member-schema.ts
var AnalyticsMyPlacementNodeSchemaBE = object108({
  id: string84().uuid(),
  name: string84(),
  slug: string84().nullable()
});
var AnalyticsMyRequirementSchemaBE = object108({
  /** Same leaf key as the admin snapshot column ('L0'…), so the two views can be cross-checked. */
  key: string84(),
  kind: AnalyticsColumnKindEnumObj.exclude([
    "overall"
  ]),
  label: string84(),
  /** Tracked action (kind = 'condition'). */
  event: string84().optional(),
  /** YYYY-MM-DD — the event must have happened on or before this day. */
  dueDate: string84().optional(),
  /** Times done / times required. */
  value: number36().int().nonnegative(),
  target: number36().int().nonnegative(),
  met: boolean19(),
  /** Not met and the due date has passed. */
  overdue: boolean19(),
  /** ISO time the requirement was (last) done — the latest counted event; null when nothing counted yet. */
  lastDoneAt: string84().nullable(),
  /** Which app owns the content (kind = 'condition'). Drives where the link goes. */
  source: AnalyticsSourceEnumObj.optional(),
  /** The content / target id the condition counts against (kind = 'condition'). */
  contentId: string84().optional(),
  /** FIT only: a class or a playlist. */
  contentType: z190.enum([
    "content",
    "playlist"
  ]).optional(),
  targetKind: AnalyticsSpacesTargetKindEnumObj.optional(),
  module: AnalyticsMyPlacementNodeSchemaBE.nullable(),
  /**
  * The lesson that directly owns the content. When the content sits under a
  * sub-lesson this IS the sub-lesson; `parentLesson` then names the lesson it
  * hangs from, and is null for a top-level lesson. The two together are what
  * let My Activity nest requirements the way the content tree does.
  */
  lesson: AnalyticsMyPlacementNodeSchemaBE.nullable(),
  parentLesson: AnalyticsMyPlacementNodeSchemaBE.nullable(),
  /**
  * Members-app path to the content (SPACES only). Null for other sources —
  * the members app builds the FIT / RYC link from `source` + `contentId`
  * with its own environment URLs.
  */
  href: string84().nullable(),
  /** Referenced rule (kind = 'rule'). */
  ruleId: number36().int().positive().optional(),
  progress: object108({
    completed: number36().int().nonnegative(),
    total: number36().int().nonnegative()
  }).optional()
});
var AnalyticsMyRuleSchemaBE = object108({
  ruleId: number36().int().positive(),
  name: string84(),
  /** Root operator — "all of the following" vs "any of the following". */
  operator: AnalyticsOperatorEnumObj,
  passed: boolean19(),
  /** Requirements met / requirements total (same denominator as the admin Result column). */
  completed: number36().int().nonnegative(),
  total: number36().int().nonnegative(),
  percent: number36().int().min(0).max(100),
  /** Distinct modules the requirements span, in program order. */
  modules: AnalyticsMyPlacementNodeSchemaBE.extend({
    position: number36().int()
  }).array(),
  /** In leaf order (L0…Ln). */
  requirements: AnalyticsMyRequirementSchemaBE.array()
});
var AnalyticsCertificateStatusValues = [
  "coming_soon",
  "locked",
  "available"
];
var AnalyticsCertificateStatusEnumObj = z190.enum(AnalyticsCertificateStatusValues);
var AnalyticsMyAnalyticsSchemaBE = object108({
  /** The analytics sub-space that was asked for. */
  spaceId: string84().uuid(),
  /** The program (container space) the rules are authored against. */
  programId: string84().uuid(),
  programSlug: string84(),
  computedAt: string84(),
  rules: AnalyticsMyRuleSchemaBE.array(),
  certificate: object108({
    status: AnalyticsCertificateStatusEnumObj
  })
});

// src/analytics/be-request-schema.ts
import { z as z192 } from "zod";

// src/analytics/be-schema.ts
import { boolean as boolean20, number as number37, object as object109, string as string85, z as z191 } from "zod";
var AnalyticsRuleSchemaBE = object109({
  id: number37().positive().int().min(1),
  name: string85().min(1),
  // The user population: members of this app (from Supabase user_access).
  audienceApp: string85().min(1, "Audience app is required"),
  // The app whose activity is measured (resolved to tracking_id from Supabase apps).
  trackingApp: string85().min(1, "Tracking app is required"),
  source: AnalyticsSourceEnumObj,
  // Rule-level space (only used when source is SPACES) — content rules pick a
  // lesson / content block within this space.
  spaceId: string85().uuid().nullable().optional(),
  // User groups whose members are excluded from this rule's audience.
  excludedUserGroupIds: z191.array(number37().int().positive()).optional(),
  // User groups to restrict the audience to — when non-empty, only members of
  // these groups are included (still limited to the audience app, and exclusions
  // apply on top). Empty/unset means no restriction.
  includedUserGroupIds: z191.array(number37().int().positive()).optional(),
  isActive: boolean20().optional(),
  contentTree: AnalyticsGroupSchemaBE,
  createdBy: string85().nullable(),
  updatedBy: string85().nullable(),
  createdAt: string85(),
  updatedAt: string85()
});
var AnalyticsRuleResponseSchemaBE = AnalyticsRuleSchemaBE;

// src/analytics/be-request-schema.ts
var MAX_TREE_DEPTH = 12;
var validateNode = /* @__PURE__ */ __name((node, source, ctx, path, depth) => {
  if (depth > MAX_TREE_DEPTH) {
    ctx.addIssue({
      code: z192.ZodIssueCode.custom,
      path,
      message: "Grouping is nested too deeply"
    });
    return;
  }
  if (node.type === "group") {
    node.children.forEach((child, index) => validateNode(child, source, ctx, [
      ...path,
      "children",
      index
    ], depth + 1));
    return;
  }
  if (node.type === "rule") {
    return;
  }
  if (node.contentRef.source !== source) {
    ctx.addIssue({
      code: z192.ZodIssueCode.custom,
      path: [
        ...path,
        "contentRef",
        "source"
      ],
      message: `Content reference source "${node.contentRef.source}" does not match rule source "${source}"`
    });
  }
  if (!isActionAllowedForSource(source, node.event)) {
    ctx.addIssue({
      code: z192.ZodIssueCode.custom,
      path: [
        ...path,
        "event"
      ],
      message: `Event "${node.event}" is not allowed for source "${source}"`
    });
  }
  if (source === "SPACES" && node.contentRef.source === "SPACES") {
    const allowed = allowedTargetKindsForEvent(node.event);
    if (!allowed.includes(node.contentRef.targetKind)) {
      ctx.addIssue({
        code: z192.ZodIssueCode.custom,
        path: [
          ...path,
          "contentRef",
          "targetKind"
        ],
        message: `Target kind "${node.contentRef.targetKind}" does not match event "${node.event}" (expected "${allowed.join('" or "')}")`
      });
    }
  }
}, "validateNode");
var CreateAnalyticsRuleSchemaBE = AnalyticsRuleSchemaBE.pick({
  name: true,
  audienceApp: true,
  trackingApp: true,
  source: true,
  spaceId: true,
  excludedUserGroupIds: true,
  includedUserGroupIds: true,
  isActive: true,
  contentTree: true
}).superRefine((data, ctx) => {
  if (data.source === "SPACES" && !data.spaceId) {
    ctx.addIssue({
      code: z192.ZodIssueCode.custom,
      path: [
        "spaceId"
      ],
      message: "Select a space"
    });
  }
  validateNode(data.contentTree, data.source, ctx, [
    "contentTree"
  ], 0);
});
var UpdateAnalyticsRuleSchemaBE = CreateAnalyticsRuleSchemaBE;

// src/analytics/be-space-config-schema.ts
import { boolean as boolean21, number as number38, object as object110, string as string86, z as z193 } from "zod";
var AnalyticsSpaceRuleConfigItemSchemaBE = object110({
  ruleId: number38().int().positive(),
  /** Empty = every member of the space. */
  userGroupIds: number38().int().positive().array().default([])
});
var UpdateAnalyticsSpaceConfigSchemaBE = object110({
  items: AnalyticsSpaceRuleConfigItemSchemaBE.array().max(50).superRefine((items, ctx) => {
    const seen = /* @__PURE__ */ new Set();
    items.forEach((item, index) => {
      if (seen.has(item.ruleId)) {
        ctx.addIssue({
          code: z193.ZodIssueCode.custom,
          path: [
            index,
            "ruleId"
          ],
          message: "Each rule can only be added once"
        });
      }
      seen.add(item.ruleId);
    });
  })
});
var AnalyticsSpaceRuleConfigSchemaBE = AnalyticsSpaceRuleConfigItemSchemaBE.extend({
  position: number38().int().nonnegative(),
  ruleName: string86(),
  ruleIsActive: boolean21()
});
var AnalyticsSpaceConfigSchemaBE = object110({
  spaceId: string86().uuid(),
  items: AnalyticsSpaceRuleConfigSchemaBE.array()
});

// src/analytics/content-key.ts
var analyticsContentKey = /* @__PURE__ */ __name((ref) => {
  switch (ref.source) {
    case "FIT": {
      return `FIT:${ref.contentType}:${ref.contentId}`;
    }
    case "RYC": {
      return `RYC:${ref.contentId}`;
    }
    case "PROGRAMS": {
      return `PROGRAMS:${ref.contentId}`;
    }
    case "SPACES": {
      return `SPACES:${ref.targetId}`;
    }
  }
}, "analyticsContentKey");
var analyticsCatalogKey = /* @__PURE__ */ __name((source, id2, fitContentType = "content") => source === "FIT" ? `FIT:${fitContentType}:${id2}` : `${source}:${id2}`, "analyticsCatalogKey");

// src/analytics/export-schema.ts
import { array as array30, boolean as boolean22, number as number39, object as object111, string as string87 } from "zod";
var AnalyticsRuleExportItemSchemaBE = object111({
  originalId: number39().int().positive().optional(),
  name: string87().min(1),
  audienceApp: string87().min(1),
  trackingApp: string87().min(1),
  source: AnalyticsSourceEnumObj,
  spaceId: string87().uuid().nullable().optional(),
  excludedUserGroupIds: array30(number39().int().positive()).optional(),
  includedUserGroupIds: array30(number39().int().positive()).optional(),
  isActive: boolean22().optional(),
  contentTree: AnalyticsGroupSchemaBE
});
var AnalyticsRulesExportSchemaBE = object111({
  version: number39().int(),
  exportedAt: string87(),
  rules: array30(AnalyticsRuleExportItemSchemaBE)
});
var AnalyticsRulesImportSchemaBE = object111({
  version: number39().int().optional(),
  rules: array30(AnalyticsRuleExportItemSchemaBE).min(1, "The file has no rules to import")
});

// src/analytics/flatten.ts
var collect = /* @__PURE__ */ __name((node, rootOperator, acc, isRoot) => {
  if (node.type !== "group") {
    acc.leaves.push(node);
    return;
  }
  if (!isRoot) {
    acc.hadNesting = true;
    if (node.operator !== rootOperator) {
      acc.mixedOperators = true;
    }
  }
  node.children.forEach((child) => collect(child, rootOperator, acc, false));
}, "collect");
var flattenContentTree = /* @__PURE__ */ __name((root) => {
  const acc = {
    leaves: [],
    hadNesting: false,
    mixedOperators: false
  };
  collect(root, root.operator, acc, true);
  const seenContent = /* @__PURE__ */ new Set();
  const seenRules = /* @__PURE__ */ new Set();
  const conditions = [];
  const ruleRefs = [];
  let droppedDuplicates = 0;
  acc.leaves.forEach((leaf) => {
    if (leaf.type === "condition") {
      const key = analyticsContentKey(leaf.contentRef);
      if (seenContent.has(key)) {
        droppedDuplicates += 1;
        return;
      }
      seenContent.add(key);
      conditions.push(leaf);
      return;
    }
    if (seenRules.has(leaf.ruleId)) {
      droppedDuplicates += 1;
      return;
    }
    seenRules.add(leaf.ruleId);
    ruleRefs.push(leaf);
  });
  return {
    tree: {
      type: "group",
      operator: root.operator,
      children: [
        ...conditions,
        ...ruleRefs
      ]
    },
    changed: acc.mixedOperators || droppedDuplicates > 0,
    hadNesting: acc.hadNesting,
    mixedOperators: acc.mixedOperators,
    droppedDuplicates
  };
}, "flattenContentTree");

// src/vimeo/search.ts
import { array as array31, number as number40, object as object112, string as string88 } from "zod";
var VimeoSearchResultItemSchema = object112({
  id: string88(),
  name: string88(),
  /**
  * Duration in seconds, present when the row came from the account's video listing (which
  * returns it inline). Absent for results resolved by a direct id lookup. Optional so the
  * dashboard picker, which only reads id/name, is unaffected.
  */
  duration: number40().optional()
});
var VimeoSearchResultsSchema = array31(VimeoSearchResultItemSchema);

// src/vimeo/video-info.ts
import { nullable, number as number41, object as object113, record as record3, string as string89 } from "zod";
var VimeoVideoInfoSchema = object113({
  uri: string89(),
  name: string89(),
  description: nullable(string89()).optional(),
  duration: number41()
});
var VimeoVideoDurationsSchema = record3(string89(), number41());

// src/notes/entity.ts
import { z as z194 } from "zod";
var NOTE_ENTITY_TYPE = {
  USER: "user"
};
var NoteAuthorSchema = z194.object({
  profileId: z194.string(),
  userUUID: z194.string().nullable(),
  name: z194.string().nullable(),
  avatar: z194.string().nullable()
}).nullable();
var NoteSchema = z194.object({
  id: z194.string().uuid(),
  entityType: z194.string().min(1, "An entity type is required"),
  entityId: z194.string(),
  body: z194.string(),
  createdBy: z194.string().nullable(),
  updatedBy: z194.string().nullable(),
  createdAt: z194.string(),
  updatedAt: z194.string(),
  author: NoteAuthorSchema
});
var CreateNoteSchema = z194.object({
  entityType: z194.string().min(1, "An entity type is required"),
  entityId: z194.string().min(1, "A target is required"),
  body: z194.string().min(1, "A note body is required")
});
var UpdateNoteSchema = z194.object({
  body: z194.string().min(1, "A note body is required")
});

// src/user-block/entity.ts
import { z as z195 } from "zod";
var BlockUserBodySchema = z195.object({
  authUserId: z195.string().uuid().optional(),
  mentionId: z195.string().uuid().optional()
}).refine((v) => !!v.authUserId !== !!v.mentionId, {
  message: "Provide exactly one of authUserId or mentionId"
});
var BlockedUserSchema = z195.object({
  authUserId: z195.string(),
  profileId: z195.string().nullable(),
  name: z195.string(),
  username: z195.string().nullable(),
  avatar: z195.string().nullable()
});

// src/ryc-website/active-campaign.ts
import { z as z196 } from "zod";
var ActiveCampaignStatusSchema = z196.object({
  enabled: z196.boolean(),
  connected: z196.boolean()
});
var ActiveCampaignFieldSchema = z196.object({
  id: z196.string(),
  title: z196.string(),
  /** `contact` = AC's built-in Email / First Name / Last Name / Phone (non-numeric id); `custom` = a custom field. */
  group: z196.enum([
    "contact",
    "custom"
  ])
});
var ActiveCampaignFieldsResponseSchema = z196.object({
  fields: z196.array(ActiveCampaignFieldSchema)
});
var ActiveCampaignFieldsParamsSchema = z196.object({
  listId: z196.string().optional()
});
var ActiveCampaignListSchema = z196.object({
  id: z196.string(),
  name: z196.string()
});
var ActiveCampaignListsResponseSchema = z196.object({
  lists: z196.array(ActiveCampaignListSchema)
});

// src/ryc-website/article.ts
import { z as z201 } from "zod";

// src/ryc-website/article-prefix.ts
import { z as z198 } from "zod";

// src/ryc-website/category.ts
import { z as z197 } from "zod";
var RycWebsiteCategoryStatusValues = [
  "draft",
  "published",
  "archived"
];
var RycWebsiteCategoryStatusSchema = z197.enum(RycWebsiteCategoryStatusValues);
var ERycWebsiteCategoryStatus = RycWebsiteCategoryStatusSchema.enum;
var RycWebsiteCategoryStatusLabels = {
  [ERycWebsiteCategoryStatus.draft]: "Draft",
  [ERycWebsiteCategoryStatus.published]: "Published",
  [ERycWebsiteCategoryStatus.archived]: "Archived"
};
var RycWebsiteCategoryStatusDescriptions = {
  [ERycWebsiteCategoryStatus.draft]: "Being set up \u2014 hidden on the website",
  [ERycWebsiteCategoryStatus.published]: "Live on the website",
  [ERycWebsiteCategoryStatus.archived]: "Retired from the website but kept"
};
var RycWebsiteCategorySchema = z197.object({
  id: z197.string().uuid(),
  title: z197.string(),
  slug: z197.string(),
  /** Category description — plain text, may be empty. */
  body: z197.string().nullable(),
  /** Only `published` categories are shown on the website and its Learn page. */
  status: RycWebsiteCategoryStatusSchema,
  /** `attachments.id` on the website API — resolved to a URL via the attachment endpoint. */
  imageId: z197.string().uuid().nullable(),
  /** SEO overrides for the public category page — also used as its OG / Twitter title and description. */
  metaTitle: z197.string().nullish(),
  metaDescription: z197.string().nullish(),
  /** Form-builder form shown in the public page's opt-in grid cell; null means the website's default form. */
  formId: z197.string().uuid().nullish(),
  createdAt: z197.string(),
  updatedAt: z197.string()
});
var RycWebsiteCategoryFormSchema = z197.object({
  title: z197.string().trim().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  slug: z197.string().trim().max(255, "Slug must be 255 characters or less").refine((value) => value === "" || SLUG_PATTERN.test(value), SLUG_PATTERN_MESSAGE),
  body: z197.string().trim().max(5e3, "Description must be 5000 characters or less"),
  status: RycWebsiteCategoryStatusSchema,
  /** Optional — `nullish` so a category the API returns without an image still validates. */
  imageId: z197.string().uuid().nullish(),
  metaTitle: z197.string().trim().max(255, "Meta title must be 255 characters or less"),
  metaDescription: z197.string().trim().max(500, "Meta description must be 500 characters or less"),
  formId: z197.string().uuid().nullish()
});
var CreateRycWebsiteCategorySchema = z197.object({
  title: z197.string().min(1).max(255),
  slug: SlugSchema.max(255).optional(),
  body: z197.string().optional(),
  /** Omitted, the website API defaults a new category to `draft`. */
  status: RycWebsiteCategoryStatusSchema.optional(),
  imageId: z197.string().uuid().nullish(),
  /** Empty or null clears the override; the website then uses its default copy. */
  metaTitle: z197.string().max(255).nullish(),
  metaDescription: z197.string().max(500).nullish(),
  /** Null clears the pick; the website then shows its default opt-in form. */
  formId: z197.string().uuid().nullish()
});
var UpdateRycWebsiteCategorySchema = CreateRycWebsiteCategorySchema.partial();

// src/ryc-website/article-prefix.ts
var RycWebsiteArticlePrefixStatusSchema = RycWebsiteCategoryStatusSchema;
var ERycWebsiteArticlePrefixStatus = RycWebsiteArticlePrefixStatusSchema.enum;
var RycWebsiteArticlePrefixStatusDescriptions = {
  [ERycWebsiteArticlePrefixStatus.draft]: "Being set up \u2014 articles keep their normal URL",
  [ERycWebsiteArticlePrefixStatus.published]: "Live \u2014 articles using it move under the prefix",
  [ERycWebsiteArticlePrefixStatus.archived]: "Retired \u2014 articles go back to their normal URL"
};
var RycWebsiteArticlePrefixSchema = z198.object({
  id: z198.string().uuid(),
  title: z198.string(),
  /** The URL segment, e.g. `pros`. */
  slug: z198.string(),
  /** Only a `published` prefix changes an article's public URL. */
  status: RycWebsiteArticlePrefixStatusSchema,
  createdAt: z198.string(),
  updatedAt: z198.string()
});
var RycWebsiteArticlePrefixFormSchema = z198.object({
  title: z198.string().trim().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  slug: z198.string().trim().max(64, "Slug must be 64 characters or less").refine((value) => value === "" || SLUG_PATTERN.test(value), SLUG_PATTERN_MESSAGE),
  status: RycWebsiteArticlePrefixStatusSchema
});
var CreateRycWebsiteArticlePrefixSchema = z198.object({
  title: z198.string().min(1).max(255),
  slug: SlugSchema.max(64).optional(),
  /** Omitted, the website API defaults a new prefix to `draft`. */
  status: RycWebsiteArticlePrefixStatusSchema.optional()
});
var UpdateRycWebsiteArticlePrefixSchema = CreateRycWebsiteArticlePrefixSchema.partial();

// src/ryc-website/attachment.ts
import { z as z199 } from "zod";
var RycWebsiteAttachmentStatusSchema = z199.enum([
  "pending",
  "ready"
]);
var RycWebsiteAttachmentSchema = z199.object({
  id: z199.string().uuid(),
  key: z199.string(),
  filename: z199.string(),
  contentType: z199.string(),
  sizeBytes: z199.number().int(),
  publicUrl: z199.string().nullable(),
  /** Pixel size of the image; null for files uploaded without it. */
  width: z199.number().int().nullish(),
  height: z199.number().int().nullish(),
  /**
  * Widths of the resized webp copies stored beside the original, named
  * `<key without extension>-<width>.webp`. Null when there are none.
  */
  variantWidths: z199.array(z199.number().int()).nullish(),
  status: RycWebsiteAttachmentStatusSchema,
  createdAt: z199.string(),
  updatedAt: z199.string()
});
var RycWebsiteAttachmentVariantSchema = z199.object({
  width: z199.number().int().positive(),
  sizeBytes: z199.number().int().positive()
});
var CreateRycWebsiteAttachmentSchema = z199.object({
  filename: z199.string().min(1).max(255),
  contentType: z199.string().min(1),
  sizeBytes: z199.number().int().positive(),
  width: z199.number().int().positive().optional(),
  height: z199.number().int().positive().optional(),
  variants: z199.array(RycWebsiteAttachmentVariantSchema).optional()
});
var RycWebsitePresignedAttachmentSchema = z199.object({
  attachment: RycWebsiteAttachmentSchema,
  uploadUrl: z199.string(),
  /** One PUT URL per requested variant; empty or absent for an upload without variants. */
  variantUploads: z199.array(z199.object({
    width: z199.number().int(),
    uploadUrl: z199.string()
  })).optional()
});
var CreateRycWebsiteMediaUploadSchema = z199.object({
  filename: z199.string().min(1).max(255),
  contentType: z199.string().min(1)
});
var RycWebsitePresignedMediaSchema = z199.object({
  key: z199.string(),
  uploadUrl: z199.string()
});

// src/ryc-website/author.ts
import { z as z200 } from "zod";
var RycWebsiteAuthorSchema = z200.object({
  id: z200.number().int(),
  name: z200.string(),
  slug: z200.string(),
  avatar: z200.string().nullable(),
  role: z200.string().nullable(),
  bio: z200.string().nullable(),
  /** The author's profile page, linked from the article byline. */
  link: z200.string().nullable(),
  affiliateUrl: z200.string().nullable(),
  affiliateId: z200.string().nullable(),
  /** The linked members-api member-account id, kept for legacy article references. Optional. */
  userId: z200.string().nullable(),
  createdAt: z200.string(),
  updatedAt: z200.string()
});
var AUTHOR_LINK_PATTERN = /^(?:https?:\/\/\S+|\/\S*)$/i;
var AUTHOR_LINK_MESSAGE = "Enter a full http(s) link or a site path starting with /";
var ROLE_FORBIDDEN_TAG = /<\/?(?!(?:sup|sub)\b)[a-z!][^>]*>/i;
var RycWebsiteAuthorFormSchema = z200.object({
  name: z200.string().trim().min(1, "Name is required").max(255, "Name must be 255 characters or less"),
  slug: z200.string().trim().max(255, "Slug must be 255 characters or less").refine((value) => value === "" || SLUG_PATTERN.test(value), SLUG_PATTERN_MESSAGE),
  /** Plain text; `<sup>` and `<sub>` are the only tags allowed. */
  role: z200.string().trim().max(255, "Role must be 255 characters or less").refine((value) => !ROLE_FORBIDDEN_TAG.test(value), "Only <sup> and <sub> tags are allowed in the role"),
  bio: z200.string().max(2e4, "Bio is too long"),
  avatar: z200.string(),
  link: z200.string().trim().max(2048, "Link is too long").refine((value) => value === "" || AUTHOR_LINK_PATTERN.test(value), AUTHOR_LINK_MESSAGE),
  affiliateUrl: z200.string().trim().max(2048, "Affiliate URL is too long"),
  affiliateId: z200.string().trim().max(255, "Affiliate ID must be 255 characters or less"),
  userId: z200.string().trim().max(255, "Member account ID must be 255 characters or less")
});
var CreateRycWebsiteAuthorSchema = z200.object({
  name: z200.string().min(1).max(255),
  slug: SlugSchema.max(255).optional(),
  role: z200.string().max(255).nullish(),
  bio: z200.string().max(2e4).nullish(),
  avatar: z200.string().max(2048).nullish(),
  link: z200.string().max(2048).nullish(),
  affiliateUrl: z200.string().max(2048).nullish(),
  affiliateId: z200.string().max(255).nullish(),
  userId: z200.string().max(255).nullish()
});
var UpdateRycWebsiteAuthorSchema = CreateRycWebsiteAuthorSchema.partial();

// src/ryc-website/article.ts
var RycWebsiteArticleFaqSchema = z201.object({
  question: z201.string().trim().min(1, "Question is required").max(300, "Question must be 300 characters or less"),
  answer: z201.string().trim().min(1, "Answer is required").max(3e3, "Answer must be 3000 characters or less")
});
var RycWebsiteArticleReferenceSchema = z201.object({
  label: z201.string().trim().min(1, "Label is required").max(500, "Label must be 500 characters or less"),
  url: z201.string().trim().max(2e3, "URL is too long").refine((value) => value === "" || z201.string().url().safeParse(value).success, "Enter a valid URL (including https://)").optional(),
  description: z201.string().trim().max(500, "Note must be 500 characters or less").optional()
});
var RycWebsiteArticleStatusValues = [
  "draft",
  "published",
  "archived"
];
var RycWebsiteArticleStatusSchema = z201.enum(RycWebsiteArticleStatusValues);
var ERycWebsiteArticleStatus = RycWebsiteArticleStatusSchema.enum;
var RycWebsiteArticleStatusLabels = {
  [ERycWebsiteArticleStatus.draft]: "Draft",
  [ERycWebsiteArticleStatus.published]: "Published",
  [ERycWebsiteArticleStatus.archived]: "Archived"
};
var RycWebsiteArticleCategorySchema = z201.object({
  id: z201.string().uuid(),
  title: z201.string(),
  slug: z201.string()
});
var RycWebsiteArticlePrefixTagSchema = z201.object({
  id: z201.string().uuid(),
  title: z201.string(),
  slug: z201.string(),
  status: RycWebsiteArticlePrefixStatusSchema
});
var RYC_WEBSITE_TWITTER_CARD_OPTIONS = [
  "summary",
  "summary_large_image"
];
var RycWebsiteArticleSeoSchema = z201.object({
  metaTitle: z201.string().nullish(),
  metaDescription: z201.string().nullish(),
  canonicalUrl: z201.string().nullish(),
  twitterCard: z201.string().nullish(),
  keywords: z201.string().nullish(),
  focusKeyphrase: z201.string().nullish(),
  /** Comma-separated alternate phrases that also count for the keyphrase checks. */
  synonyms: z201.string().nullish(),
  noindex: z201.boolean().nullish()
});
var RycWebsiteArticleSeoFormSchema = z201.object({
  metaTitle: z201.string().trim().max(255, "SEO title must be 255 characters or less"),
  metaDescription: z201.string().trim().max(500, "Meta description must be 500 characters or less"),
  canonicalUrl: z201.string().trim().refine((value) => value === "" || z201.string().url().safeParse(value).success, "Enter a valid URL"),
  twitterCard: z201.enum(RYC_WEBSITE_TWITTER_CARD_OPTIONS),
  keywords: z201.string().trim().max(500, "Keywords must be 500 characters or less"),
  focusKeyphrase: z201.string().trim().max(255, "Focus keyphrase must be 255 characters or less"),
  synonyms: z201.string().trim().max(500, "Synonyms must be 500 characters or less"),
  noindex: z201.boolean()
});
var RycWebsiteArticleSeoPayloadSchema = z201.object({
  metaTitle: z201.string().max(255).nullish(),
  metaDescription: z201.string().max(500).nullish(),
  canonicalUrl: z201.string().url().nullish(),
  twitterCard: z201.string().max(50).nullish(),
  keywords: z201.string().max(500).nullish(),
  focusKeyphrase: z201.string().max(255).nullish(),
  synonyms: z201.string().max(500).nullish(),
  noindex: z201.boolean().optional()
}).partial();
var RycWebsiteArticleSchema = z201.object({
  id: z201.string().uuid(),
  title: z201.string(),
  slug: z201.string(),
  /** Markdown source. The public site compiles it; the dashboard edits it. */
  body: z201.string(),
  /** `attachments.id` on the website API — resolved to a URL via the attachment endpoint. */
  featuredImageId: z201.string().uuid().nullable(),
  /** Card-sized crop; falls back to `featuredImageId` on the public site when unset. */
  thumbnailImageId: z201.string().uuid().nullable(),
  /** The resolved attachments for the two ids above, as the website API returns them on article responses. */
  featuredImage: RycWebsiteAttachmentSchema.nullish(),
  thumbnailImage: RycWebsiteAttachmentSchema.nullish(),
  /** The URL prefix the article sits under (`/<prefix>/learn/...`); null for none. */
  prefixId: z201.string().uuid().nullish(),
  prefix: RycWebsiteArticlePrefixTagSchema.nullish(),
  /**
  * The categories the article sits in (many-to-many). `categoryIds` is derived
  * in the service hook from `categories`; `categories` is the resolved list the
  * API returns, used for the list column and the preview chips.
  */
  categoryIds: z201.array(z201.string().uuid()),
  categories: z201.array(RycWebsiteArticleCategorySchema).optional(),
  status: RycWebsiteArticleStatusSchema,
  /**
  * The author's id in the website API's `authors` table; `author` is the
  * resolved profile the API returns for display. Null only for an article the
  * authors backfill has not reached yet.
  */
  authorId: z201.number().int().nullable(),
  author: RycWebsiteAuthorSchema.nullable().optional(),
  /** SEO / social metadata, or null when the article has no `article_seo` row. */
  seo: RycWebsiteArticleSeoSchema.nullable().optional(),
  /** FAQ section. Optional until the RYC website API returns it. */
  faqs: z201.array(RycWebsiteArticleFaqSchema).optional(),
  /** References / citations list. Optional until the RYC website API returns it. */
  references: z201.array(RycWebsiteArticleReferenceSchema).optional(),
  /**
  * Form ids (`forms.id`) to render in the public page's left/right sidebar and
  * just before the footer, in the order selected. Optional until the RYC
  * website API returns them.
  */
  leftSidebarFormIds: z201.array(z201.string().uuid()).optional(),
  rightSidebarFormIds: z201.array(z201.string().uuid()).optional(),
  beforeFooterFormIds: z201.array(z201.string().uuid()).optional(),
  publishedAt: z201.string().nullable(),
  createdAt: z201.string(),
  updatedAt: z201.string()
});
var RycWebsiteArticleFormSchema = z201.object({
  title: z201.string().trim().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  slug: z201.string().trim().max(255, "Slug must be 255 characters or less").refine((value) => value === "" || SLUG_PATTERN.test(value), SLUG_PATTERN_MESSAGE),
  body: z201.string().max(2e5, "Body content is too long").refine((value) => visibleTextLength(value) > 0, "Body is required"),
  /** Optional — `nullish` so an article the API returns without an image still validates. */
  featuredImageId: z201.string().uuid().nullish(),
  /** Optional — `nullish` so an article the API returns without a thumbnail still validates. */
  thumbnailImageId: z201.string().uuid().nullish(),
  /** Optional URL prefix; null/empty leaves the article at its normal URL. */
  prefixId: z201.string().uuid().nullish(),
  /** The categories the article sits in; an empty list leaves it uncategorised. */
  categoryIds: z201.array(z201.string().uuid()),
  status: RycWebsiteArticleStatusSchema,
  /** `null` until an author is picked; the refine below turns that into a form error. */
  authorId: z201.number().int().nullable().refine((value) => value !== null, "Author is required"),
  /**
  * The article's FAQ section — an ordered list of question/answer pairs. Held
  * in the form and sent on save: the RYC website API stores it
  * (`article_faqs`), same shape as `references`.
  */
  faqs: z201.array(RycWebsiteArticleFaqSchema),
  /**
  * The article's References section — an ordered list of labelled links. Held
  * in the form and, unlike `faqs`, sent on save: the RYC website API stores it
  * (`article_references`). See `docs/dashboard-references.md` in `ryc-site`.
  */
  references: z201.array(RycWebsiteArticleReferenceSchema).max(30, "An article can have at most 30 references"),
  /**
  * Forms (from the RYC Website form builder) to render alongside the article
  * on the public site — the left sidebar, the right sidebar, and just before
  * the footer. Each is an ordered list of `forms.id`; multiple forms are
  * allowed per slot.
  */
  leftSidebarFormIds: z201.array(z201.string().uuid()),
  rightSidebarFormIds: z201.array(z201.string().uuid()),
  beforeFooterFormIds: z201.array(z201.string().uuid()),
  seo: RycWebsiteArticleSeoFormSchema
});
var CreateRycWebsiteArticleSchema = z201.object({
  title: z201.string().min(1).max(255),
  slug: SlugSchema.max(255).optional(),
  body: z201.string().min(1),
  featuredImageId: z201.string().uuid().nullish(),
  thumbnailImageId: z201.string().uuid().nullish(),
  prefixId: z201.string().uuid().nullish(),
  categoryIds: z201.array(z201.string().uuid()).optional(),
  status: RycWebsiteArticleStatusSchema,
  authorId: z201.number().int().positive(),
  seo: RycWebsiteArticleSeoPayloadSchema.optional(),
  references: z201.array(RycWebsiteArticleReferenceSchema).max(30).optional(),
  faqs: z201.array(RycWebsiteArticleFaqSchema).optional(),
  leftSidebarFormIds: z201.array(z201.string().uuid()).optional(),
  rightSidebarFormIds: z201.array(z201.string().uuid()).optional(),
  beforeFooterFormIds: z201.array(z201.string().uuid()).optional()
});
var UpdateRycWebsiteArticleSchema = CreateRycWebsiteArticleSchema.partial();
var RycWebsiteArticleListParamsSchema = z201.object({
  status: RycWebsiteArticleStatusSchema.optional(),
  /** Category id or slug. */
  category: z201.string().optional()
});

// src/ryc-website/article-revision.ts
import { z as z202 } from "zod";
var RycWebsiteArticleRevisionSchema = z202.object({
  id: z202.string().uuid(),
  articleId: z202.string().uuid(),
  revisionNumber: z202.number().int(),
  title: z202.string(),
  slug: z202.string(),
  body: z202.string(),
  status: RycWebsiteArticleStatusSchema,
  editedBy: z202.string().nullable(),
  createdAt: z202.coerce.string()
});
var RycWebsiteArticleRevisionListSchema = z202.array(RycWebsiteArticleRevisionSchema);
var RestoreRycWebsiteArticleRevisionSchema = z202.object({
  editedBy: z202.string().nullish()
});

// src/ryc-website/cache.ts
import { z as z203 } from "zod";
var RycWebsiteCacheEntrySchema = z203.object({
  keys: z203.array(z203.string()),
  cachedAt: z203.number(),
  value: z203.unknown()
});
var RycWebsiteArticleListCacheEntrySchema = RycWebsiteCacheEntrySchema.extend({
  value: z203.array(RycWebsiteArticleSchema)
});
var RycWebsiteArticleDetailCacheEntrySchema = RycWebsiteCacheEntrySchema.extend({
  value: RycWebsiteArticleSchema
});
var RycWebsiteCategoryListCacheEntrySchema = RycWebsiteCacheEntrySchema.extend({
  value: z203.array(RycWebsiteCategorySchema)
});
var RycWebsiteCategoryDetailCacheEntrySchema = RycWebsiteCacheEntrySchema.extend({
  value: RycWebsiteCategorySchema
});

// src/ryc-website/cloudflare-cache.ts
import { z as z204 } from "zod";
var RycWebsiteCacheRegionSchema = z204.enum([
  "us",
  "de"
]);
var RycWebsiteCloudflareCacheStatusSchema = z204.object({
  enabled: z204.boolean(),
  /** The US warm runs on members-api, so it needs the M2M secret as well. */
  usEnabled: z204.boolean(),
  /** False when page caching is switched off (`EDGE_CACHE_ENABLED`); older APIs omit it, so it defaults to on. */
  cacheEnabled: z204.boolean().default(true)
});
var RycWebsiteCloudflareStaticPageSchema = z204.object({
  path: z204.string(),
  title: z204.string()
});
var RycWebsiteCloudflarePurgeSchema = z204.union([
  z204.object({
    paths: z204.array(z204.string()).min(1)
  }),
  z204.object({
    all: z204.literal(true)
  })
]);
var RycWebsiteCloudflareWarmStateSchema = z204.object({
  running: z204.boolean(),
  startedAt: z204.string().nullable(),
  finishedAt: z204.string().nullable(),
  /** Pages this run requests. 0 until the sitemap has been read. */
  total: z204.number(),
  /** Pages finished, whatever the outcome. */
  done: z204.number(),
  /** First request was already a cache HIT. */
  alreadyWarm: z204.number(),
  /** First request filled the cache and the second confirmed a HIT. */
  warmedNow: z204.number(),
  /** Loaded, but Cloudflare did not cache it. */
  notCached: z204.number(),
  failed: z204.number(),
  /** Why the run could not start or finish. */
  error: z204.string().nullable()
});
var RycWebsiteCloudflareWarmUrlsSchema = z204.object({
  urls: z204.array(z204.string().url()).min(1).max(5e3)
});

// src/ryc-website/form-builder.ts
import { z as z205 } from "zod";
var FieldTypeSchema = z205.enum([
  "text",
  /** Single-line text that must be an email address — always email-validated, mapped to the AC Email contact field by default. */
  "email",
  "textarea",
  "number",
  "date",
  "select",
  "autocomplete",
  "radio",
  "checkbox",
  "toggleCheckbox",
  "switch",
  "merged",
  "hidden",
  "button",
  "textBlock",
  "image"
]);
var MarginConfigSchema = z205.object({
  top: z205.number(),
  right: z205.number(),
  bottom: z205.number(),
  left: z205.number()
});
var ButtonConfigSchema = z205.object({
  variant: z205.enum([
    "contained",
    "outlined",
    "text",
    "soft"
  ]),
  color: z205.enum([
    "primary",
    "secondary",
    "success",
    "error",
    "info",
    "warning"
  ]),
  position: z205.enum([
    "left",
    "center",
    "right"
  ]),
  /** Named export from `react-icons/md`, e.g. `"MdSend"`. Undefined = no icon. */
  iconName: z205.string().optional(),
  iconPosition: z205.enum([
    "start",
    "end"
  ]).optional(),
  fullWidth: z205.boolean().optional(),
  /** Explicit width (px) — ignored when fullWidth is true. Undefined = content-based width. */
  width: z205.number().optional(),
  /** Border radius (px). Undefined = theme default. */
  borderRadius: z205.number().optional()
});
var OptionsLayoutSchema = z205.enum([
  "horizontal",
  "vertical"
]);
var OptionSchema = z205.object({
  id: z205.string(),
  label: z205.string(),
  value: z205.string()
});
var ValidationRulesSchema = z205.object({
  required: z205.boolean().optional(),
  minLength: z205.number().optional(),
  maxLength: z205.number().optional(),
  min: z205.number().optional(),
  max: z205.number().optional(),
  integer: z205.boolean().optional(),
  regex: z205.string().optional(),
  email: z205.boolean().optional(),
  oneOfOptions: z205.boolean().optional(),
  message: z205.string().optional(),
  customZod: z205.string().optional()
});
var ConditionOperatorSchema = z205.enum([
  "is",
  "isNot",
  "isAnyOf",
  "isEmpty",
  "isNotEmpty",
  "contains",
  "gt",
  "lt"
]);
var ConditionClauseSchema = z205.object({
  fieldId: z205.string(),
  operator: ConditionOperatorSchema,
  value: z205.union([
    z205.string(),
    z205.array(z205.string())
  ]).optional()
});
var RuleActionSchema = z205.enum([
  "show",
  "hide",
  "makeRequired",
  "makeOptional"
]);
var RuleSchema = z205.object({
  id: z205.string(),
  ownerFieldId: z205.string(),
  clauses: z205.array(ConditionClauseSchema),
  combinator: z205.enum([
    "AND",
    "OR"
  ]),
  action: RuleActionSchema,
  targetFieldIds: z205.array(z205.string()),
  order: z205.number(),
  enabled: z205.boolean()
});
var MergedValueConfigSchema = z205.object({
  template: z205.string(),
  onEmptyToken: z205.enum([
    "skipToken",
    "emptyString",
    "literal"
  ]),
  onEmptyLiteral: z205.string().optional(),
  recomputeOn: z205.enum([
    "change",
    "submit"
  ])
});
var FieldVisibilitySchema = z205.union([
  z205.object({
    mode: z205.literal("always")
  }),
  z205.object({
    mode: z205.literal("conditional")
  })
]);
var FormFieldSchema = z205.object({
  id: z205.string(),
  key: z205.string(),
  label: z205.string(),
  helpText: z205.string().optional(),
  type: FieldTypeSchema,
  placeholder: z205.string().optional(),
  /** Hide the label above the control on the rendered form (the label stays as the control's accessible name). */
  hideLabel: z205.boolean().optional(),
  options: z205.array(OptionSchema).optional(),
  /** Only meaningful for 'radio' | 'checkbox' (group) — undefined defaults to vertical. */
  layout: OptionsLayoutSchema.optional(),
  /**
  * Only meaningful for 'select' | 'autocomplete'. True lets the visitor pick
  * more than one option; the answer is then an array of option values (the
  * same shape a 'checkbox' group stores). Undefined defaults to single choice.
  */
  multiple: z205.boolean().optional(),
  defaultValue: z205.unknown().optional(),
  validation: ValidationRulesSchema,
  visibility: FieldVisibilitySchema,
  activeCampaignFieldId: z205.string().nullable().optional(),
  merged: MergedValueConfigSchema.optional(),
  buttonConfig: ButtonConfigSchema.optional(),
  /** Tiptap JSON doc — only meaningful for 'textBlock'. */
  textBlockContent: z205.record(z205.string(), z205.unknown()).optional(),
  /** CDN path of the uploaded image — only meaningful for 'image'. */
  imageUrl: z205.string().optional(),
  /** Border radius (px) applied to the rendered image — only meaningful for 'image'. */
  imageBorderRadius: z205.number().optional(),
  /** Stretch the image to fill its container width instead of its natural size — only meaningful for 'image'. */
  imageFullWidth: z205.boolean().optional(),
  margin: MarginConfigSchema.optional(),
  order: z205.number()
});
var BoxShadowConfigSchema = z205.object({
  offsetX: z205.number().optional(),
  offsetY: z205.number().optional(),
  blur: z205.number().optional(),
  spread: z205.number().optional(),
  color: z205.string().optional(),
  opacity: z205.number().optional()
});
var WidgetStyleSchema = z205.object({
  borderWidth: z205.number().optional(),
  borderColor: z205.string().optional(),
  backgroundColor: z205.string().optional(),
  borderRadius: z205.number().optional(),
  boxShadow: BoxShadowConfigSchema.optional()
});
var GridLayoutSchema = z205.object({
  source: z205.string()
});
var MULTI_SELECT_FIELD_TYPES = [
  "select",
  "autocomplete"
];
var isMultiValueField = /* @__PURE__ */ __name((field) => field.type === "checkbox" || MULTI_SELECT_FIELD_TYPES.includes(field.type) && field.multiple === true, "isMultiValueField");
var WELCOME_PAGE_REDIRECT_FIELD_TYPES = [
  "select",
  "autocomplete",
  "radio"
];
var isWelcomePageRedirectField = /* @__PURE__ */ __name((field) => WELCOME_PAGE_REDIRECT_FIELD_TYPES.includes(field.type) && !isMultiValueField(field), "isWelcomePageRedirectField");
var WelcomePageRedirectSchema = z205.object({
  fieldId: z205.string(),
  urlsByOptionId: z205.record(z205.string(), z205.string())
});
var FormDefinitionSchema = z205.object({
  id: z205.string(),
  name: z205.string(),
  fields: z205.array(FormFieldSchema),
  rules: z205.array(RuleSchema),
  status: z205.enum([
    "draft",
    "published",
    "archived"
  ]),
  /** Present on rows the API returns; never sent back on create/update. */
  createdAt: z205.string().optional(),
  /** Member-account ids of who created / last edited the form — set by the API from the caller's token. */
  createdBy: z205.string().nullable().optional(),
  updatedBy: z205.string().nullable().optional(),
  updatedAt: z205.string(),
  customCss: z205.string().optional(),
  widgetStyle: WidgetStyleSchema.optional(),
  gridLayout: GridLayoutSchema.optional(),
  /** Optional. When set, a successful submission redirects the visitor here (with `?submissionId=<id>` appended) instead of just showing a confirmation. */
  welcomePageUrl: z205.string().nullable().optional(),
  /** Optional. Per-answer welcome page URLs — takes precedence over `welcomePageUrl` when the chosen option has one. */
  welcomePageRedirect: WelcomePageRedirectSchema.nullable().optional()
});
var resolveWelcomePageUrl = /* @__PURE__ */ __name((definition, answers, visible) => {
  var _a5, _b, _c;
  const redirect = definition.welcomePageRedirect;
  const field = redirect && definition.fields.find((f) => f.id === redirect.fieldId);
  if (redirect && field && visible[field.id] && isWelcomePageRedirectField(field)) {
    const answer = answers[field.id];
    const option = typeof answer === "string" ? (_a5 = field.options) == null ? void 0 : _a5.find((o) => o.value === answer) : void 0;
    const url = option ? (_b = redirect.urlsByOptionId[option.id]) == null ? void 0 : _b.trim() : void 0;
    if (url) {
      return url;
    }
  }
  return ((_c = definition.welcomePageUrl) == null ? void 0 : _c.trim()) || void 0;
}, "resolveWelcomePageUrl");
var CreateFormDefinitionSchema = FormDefinitionSchema.omit({
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true
});
var UpdateFormDefinitionSchema = CreateFormDefinitionSchema.partial();
var FormSubmissionSchema = z205.object({
  id: z205.string(),
  formId: z205.string(),
  answers: z205.record(z205.string(), z205.unknown()),
  activeCampaignContactId: z205.string().nullable(),
  activeCampaignSyncError: z205.string().nullable(),
  /** When the AffiliateWP opt-in lead was accepted by the members site. Optional: absent from APIs older than the column. */
  affiliateLeadSentAt: z205.string().nullable().optional(),
  affiliateLeadError: z205.string().nullable().optional(),
  submittedIp: z205.string().nullable(),
  createdAt: z205.string()
});
var FormExportItemSchema = CreateFormDefinitionSchema.extend({
  id: z205.string().optional(),
  createdAt: z205.string().optional(),
  createdBy: z205.string().nullable().optional(),
  updatedAt: z205.string().optional(),
  updatedBy: z205.string().nullable().optional()
});
var FormExportFileSchema = z205.object({
  type: z205.literal("ryc-website-forms"),
  version: z205.literal(1),
  exportedAt: z205.string(),
  forms: z205.array(FormExportItemSchema)
});
var FormPageUsageSchema = z205.record(z205.string(), z205.array(z205.object({
  path: z205.string(),
  title: z205.string()
})));

// src/ryc-website/form-option-values.ts
var OPTION_VALUE_PREFIX = "option_";
var GENERATED_VALUE_PATTERN = /^option_(\d+)$/;
var isBlank = /* @__PURE__ */ __name((value) => value.trim() === "", "isBlank");
var maxGeneratedNumber = /* @__PURE__ */ __name((options) => options.reduce((max, option) => {
  const match2 = GENERATED_VALUE_PATTERN.exec(option.value);
  return match2 ? Math.max(max, Number(match2[1])) : max;
}, 0), "maxGeneratedNumber");
var createValueAllocator = /* @__PURE__ */ __name((options) => {
  const used = new Set(options.map((option) => option.value).filter((value) => !isBlank(value)));
  let counter = maxGeneratedNumber(options);
  return () => {
    let candidate;
    do {
      counter += 1;
      candidate = `${OPTION_VALUE_PREFIX}${counter}`;
    } while (used.has(candidate));
    used.add(candidate);
    return candidate;
  };
}, "createValueAllocator");
var nextOptionValue = /* @__PURE__ */ __name((options) => createValueAllocator(options)(), "nextOptionValue");
var findDuplicateOptionValues = /* @__PURE__ */ __name((options) => {
  const seen = /* @__PURE__ */ new Set();
  const duplicates = /* @__PURE__ */ new Set();
  options.forEach((option) => {
    if (seen.has(option.value)) {
      duplicates.add(option.value);
    }
    seen.add(option.value);
  });
  return [
    ...duplicates
  ];
}, "findDuplicateOptionValues");
var dedupeOptionValues = /* @__PURE__ */ __name((options) => {
  const allocate = createValueAllocator(options);
  const seen = /* @__PURE__ */ new Set();
  let changed = false;
  const next = options.map((option) => {
    if (!isBlank(option.value) && !seen.has(option.value)) {
      seen.add(option.value);
      return option;
    }
    changed = true;
    const value = allocate();
    seen.add(value);
    return __spreadProps(__spreadValues({}, option), {
      value
    });
  });
  return changed ? next : options;
}, "dedupeOptionValues");
var resetOptionValues = /* @__PURE__ */ __name((options) => options.map((option, index) => __spreadProps(__spreadValues({}, option), {
  value: `${OPTION_VALUE_PREFIX}${index + 1}`
})), "resetOptionValues");
var mapOptionValues = /* @__PURE__ */ __name((before, after) => {
  const map = /* @__PURE__ */ new Map();
  before.forEach((option, index) => {
    if (!map.has(option.value)) {
      map.set(option.value, after[index].value);
    }
  });
  return map;
}, "mapOptionValues");
var remapOptionValue = /* @__PURE__ */ __name((value, map) => {
  var _a5;
  if (typeof value === "string") {
    return (_a5 = map.get(value)) != null ? _a5 : value;
  }
  if (Array.isArray(value)) {
    return value.map((entry) => {
      var _a6;
      return typeof entry === "string" ? (_a6 = map.get(entry)) != null ? _a6 : entry : entry;
    });
  }
  return value;
}, "remapOptionValue");
var ensureUniqueFieldOptionValues = /* @__PURE__ */ __name((field) => {
  var _a5;
  if (!((_a5 = field.options) == null ? void 0 : _a5.length)) {
    return field;
  }
  const options = dedupeOptionValues(field.options);
  return options === field.options ? field : __spreadProps(__spreadValues({}, field), {
    options
  });
}, "ensureUniqueFieldOptionValues");
var ensureUniqueOptionValues = /* @__PURE__ */ __name((definition) => {
  let changed = false;
  const fields = definition.fields.map((field) => {
    const next = ensureUniqueFieldOptionValues(field);
    changed || (changed = next !== field);
    return next;
  });
  return changed ? __spreadProps(__spreadValues({}, definition), {
    fields
  }) : definition;
}, "ensureUniqueOptionValues");

// src/ryc-website/redirect.ts
import { z as z206 } from "zod";
var RycWebsiteRedirectStatusCodeValues = [
  301,
  302
];
var RycWebsiteRedirectStatusCodeSchema = z206.union([
  z206.literal(301),
  z206.literal(302)
]);
var RycWebsiteRedirectStatusCodeLabels = {
  301: "301 \u2014 Permanent",
  302: "302 \u2014 Temporary"
};
var RycWebsiteRedirectMatchTypeValues = [
  "exact",
  "prefix"
];
var RycWebsiteRedirectMatchTypeSchema = z206.enum(RycWebsiteRedirectMatchTypeValues);
var RycWebsiteRedirectMatchTypeLabels = {
  exact: "Exact",
  prefix: "Starts with"
};
var isRycWebsiteRedirectPathUnder = /* @__PURE__ */ __name((path, prefix) => {
  const target = path.toLowerCase();
  const base = prefix.toLowerCase();
  return target === base || target.startsWith(`${base}/`);
}, "isRycWebsiteRedirectPathUnder");
var REDIRECT_PATH_FORMAT = /^\/(?:[a-z0-9\-._~%]+(?:\/[a-z0-9\-._~%]+)*)?$/i;
var RycWebsiteRedirectPathSchema = z206.string().trim().min(1, "Path is required").max(500, "Path must be 500 characters or less").refine((value) => value.startsWith("/"), "Path must start with /").transform((value) => value.length > 1 && value.endsWith("/") ? value.slice(0, -1) : value).refine((value) => REDIRECT_PATH_FORMAT.test(value), "Use letters, numbers, hyphens, underscores, dots and slashes only \u2014 no spaces or special characters");
var isRycWebsiteRedirectExternalTarget = /* @__PURE__ */ __name((target) => /^https?:\/\//i.test(target.trim()), "isRycWebsiteRedirectExternalTarget");
var REDIRECT_EXTERNAL_TARGET_FORMAT = /^https?:\/\/[^\s?#@/]+(?:\/[^\s?#]*)?$/i;
var RycWebsiteRedirectTargetSchema = z206.string().transform((value, ctx) => {
  if (!isRycWebsiteRedirectExternalTarget(value)) {
    const result = RycWebsiteRedirectPathSchema.safeParse(value);
    if (result.success) {
      return result.data;
    }
    result.error.issues.forEach((issue) => ctx.addIssue({
      code: z206.ZodIssueCode.custom,
      message: issue.message
    }));
    return z206.NEVER;
  }
  const url = value.trim();
  if (url.length > 2e3 || !REDIRECT_EXTERNAL_TARGET_FORMAT.test(url)) {
    ctx.addIssue({
      code: z206.ZodIssueCode.custom,
      message: "Enter a full URL such as https://example.com/page \u2014 no query string or #"
    });
    return z206.NEVER;
  }
  return url;
});
var RycWebsiteRedirectSchema = z206.object({
  id: z206.string().uuid(),
  /** Rows sharing a `groupId` are one rule with several source URLs; a rule with one source has `groupId === id`. */
  groupId: z206.string().uuid(),
  fromPath: z206.string(),
  matchType: RycWebsiteRedirectMatchTypeSchema,
  toPath: z206.string(),
  statusCode: RycWebsiteRedirectStatusCodeSchema,
  isActive: z206.boolean(),
  note: z206.string().nullable(),
  /** The member-account id of whoever created it. Null for a row with no resolvable caller. */
  createdBy: z206.string().nullable(),
  createdAt: z206.string(),
  updatedAt: z206.string()
});
var RYC_WEBSITE_REDIRECT_NOTE_FORM_MAX_LENGTH = 300;
var RYC_WEBSITE_REDIRECT_MAX_SOURCES = 50;
var RycWebsiteRedirectFromPathsSchema = z206.array(RycWebsiteRedirectPathSchema).min(1, "Add at least one From path").max(RYC_WEBSITE_REDIRECT_MAX_SOURCES, `A redirect can have at most ${RYC_WEBSITE_REDIRECT_MAX_SOURCES} From paths`);
var RycWebsiteRedirectFormSchema = z206.object({
  fromPaths: RycWebsiteRedirectFromPathsSchema,
  matchType: RycWebsiteRedirectMatchTypeSchema,
  toPath: RycWebsiteRedirectTargetSchema,
  statusCode: RycWebsiteRedirectStatusCodeSchema,
  isActive: z206.boolean(),
  note: z206.string().trim().max(RYC_WEBSITE_REDIRECT_NOTE_FORM_MAX_LENGTH, `Note must be ${RYC_WEBSITE_REDIRECT_NOTE_FORM_MAX_LENGTH} characters or less`)
}).superRefine((data, ctx) => {
  if (typeof data.toPath !== "string") {
    return;
  }
  const target = data.toPath.toLowerCase();
  if (data.matchType !== "prefix" && data.fromPaths.some((fromPath) => fromPath.toLowerCase() === target)) {
    ctx.addIssue({
      code: z206.ZodIssueCode.custom,
      message: "A redirect cannot point to itself",
      path: [
        "toPath"
      ]
    });
  } else if (data.matchType === "prefix" && data.fromPaths.some((fromPath) => fromPath.toLowerCase() !== target && isRycWebsiteRedirectPathUnder(data.toPath, fromPath))) {
    ctx.addIssue({
      code: z206.ZodIssueCode.custom,
      message: 'A "Starts with" redirect cannot point to a path under its own From path',
      path: [
        "toPath"
      ]
    });
  }
});
var CreateRycWebsiteRedirectSchema = z206.object({
  fromPaths: RycWebsiteRedirectFromPathsSchema,
  matchType: RycWebsiteRedirectMatchTypeSchema.optional(),
  toPath: RycWebsiteRedirectTargetSchema,
  statusCode: RycWebsiteRedirectStatusCodeSchema.optional(),
  isActive: z206.boolean().optional(),
  note: z206.string().max(1e3).optional()
});
var UpdateRycWebsiteRedirectSchema = CreateRycWebsiteRedirectSchema.partial();
var RycWebsiteRedirectResolveSchema = z206.object({
  toPath: z206.string(),
  statusCode: RycWebsiteRedirectStatusCodeSchema
}).nullable();
var RycWebsiteRedirectLiveProbeSchema = z206.object({
  status: z206.number(),
  location: z206.string().nullable()
});
var RycWebsiteRedirectBulkImportRowResultSchema = z206.object({
  fromPath: z206.string(),
  ok: z206.boolean(),
  error: z206.string().optional()
});
var BulkImportRycWebsiteRedirectRowSchema = z206.object({
  fromPath: RycWebsiteRedirectPathSchema,
  matchType: RycWebsiteRedirectMatchTypeSchema.optional(),
  toPath: RycWebsiteRedirectTargetSchema,
  statusCode: RycWebsiteRedirectStatusCodeSchema.optional(),
  isActive: z206.boolean().optional(),
  note: z206.string().max(1e3).optional()
});
var BulkImportRycWebsiteRedirectsSchema = z206.object({
  rows: z206.array(BulkImportRycWebsiteRedirectRowSchema).min(1).max(1e3)
});
var groupRycWebsiteRedirects = /* @__PURE__ */ __name((rows) => {
  const groups = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const existing = groups.get(row.groupId);
    if (!existing) {
      groups.set(row.groupId, {
        id: row.groupId,
        rowId: row.id,
        fromPaths: [
          row.fromPath
        ],
        matchType: row.matchType,
        toPath: row.toPath,
        statusCode: row.statusCode,
        isActive: row.isActive,
        note: row.note,
        createdBy: row.createdBy,
        createdAt: row.createdAt,
        updatedAt: row.updatedAt
      });
      continue;
    }
    existing.fromPaths.push(row.fromPath);
    if (row.createdAt < existing.createdAt) {
      existing.createdAt = row.createdAt;
    }
    if (row.updatedAt > existing.updatedAt) {
      existing.updatedAt = row.updatedAt;
    }
  }
  return [
    ...groups.values()
  ].map((group) => __spreadProps(__spreadValues({}, group), {
    fromPaths: [
      ...group.fromPaths
    ].sort((a, b) => a.localeCompare(b))
  })).sort((a, b) => a.fromPaths[0].localeCompare(b.fromPaths[0]));
}, "groupRycWebsiteRedirects");

// src/ryc-website/redirect-audit.ts
var MAX_HOPS = 10;
var normalize = /* @__PURE__ */ __name((path) => {
  const lowered = path.toLowerCase();
  return lowered.length > 1 && lowered.endsWith("/") ? lowered.slice(0, -1) : lowered;
}, "normalize");
var matchRycWebsiteRedirect = /* @__PURE__ */ __name((rows, path) => {
  const target = normalize(path);
  let best = null;
  for (const row of rows) {
    if (!row.isActive) {
      continue;
    }
    if (row.matchType === "exact" && row.fromPath === target) {
      return row;
    }
    if (row.matchType === "prefix" && isRycWebsiteRedirectPathUnder(target, row.fromPath) && (!best || row.fromPath.length > best.fromPath.length)) {
      best = row;
    }
  }
  return best && best.toPath.toLowerCase() === best.fromPath && target === best.fromPath ? null : best;
}, "matchRycWebsiteRedirect");
var buildRycWebsiteRedirectProbes = /* @__PURE__ */ __name((rows) => rows.filter((row) => row.isActive).map((row) => {
  var _a5;
  const sample = row.matchType === "prefix" ? `${row.fromPath}/audit-probe` : row.fromPath;
  const expected = (_a5 = matchRycWebsiteRedirect(rows, sample)) != null ? _a5 : row;
  return {
    groupId: row.groupId,
    fromPath: row.fromPath,
    sample,
    expectedToPath: expected.toPath,
    expectedStatusCode: expected.statusCode
  };
}).sort((a, b) => a.fromPath.localeCompare(b.fromPath)), "buildRycWebsiteRedirectProbes");
var stripTrailingSlash = /* @__PURE__ */ __name((path) => path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path, "stripTrailingSlash");
var liveProbeMatches = /* @__PURE__ */ __name((expected, actual) => {
  if (actual.status !== expected.statusCode || !actual.location) {
    return false;
  }
  const location = actual.location.trim();
  const target = stripTrailingSlash(expected.toPath.trim());
  if (stripTrailingSlash(location) === target) {
    return true;
  }
  try {
    const url = new URL(location);
    const pathname = stripTrailingSlash(url.pathname);
    return pathname === target || `${pathname}${url.search}` === target;
  } catch (e) {
    return false;
  }
}, "liveProbeMatches");
var label = /* @__PURE__ */ __name((group) => group.fromPaths.length === 1 ? group.fromPaths[0] : `${group.fromPaths[0]} (+${group.fromPaths.length - 1})`, "label");
var auditRycWebsiteRedirects = /* @__PURE__ */ __name((rows) => {
  const groups = groupRycWebsiteRedirects(rows);
  const activeGroups = groups.filter((group) => group.isActive);
  const groupById = new Map(groups.map((group) => [
    group.id,
    group
  ]));
  const findings = [];
  const reportedLoops = /* @__PURE__ */ new Set();
  for (const group of activeGroups) {
    const hops = [];
    const seen = /* @__PURE__ */ new Set([
      group.id
    ]);
    let path = group.toPath;
    let looped = false;
    for (let i = 0; i < MAX_HOPS; i += 1) {
      const match2 = matchRycWebsiteRedirect(rows, path);
      if (!match2) {
        break;
      }
      const next = groupById.get(match2.groupId);
      if (!next) {
        break;
      }
      if (seen.has(next.id)) {
        looped = true;
        break;
      }
      seen.add(next.id);
      hops.push(next);
      path = next.toPath;
    }
    if (looped) {
      const key = [
        ...seen
      ].sort().join("|");
      if (!reportedLoops.has(key)) {
        reportedLoops.add(key);
        const members = [
          group,
          ...hops
        ];
        findings.push({
          id: `loop:${key}`,
          severity: "error",
          kind: "loop",
          title: "Redirect loop",
          detail: `${members.map(label).join(" \u2192 ")} \u2192 back to ${label(group)}. Visitors never reach a page.`,
          paths: members.map((member) => member.fromPaths[0])
        });
      }
    } else if (hops.length > 0) {
      findings.push({
        id: `chain:${group.id}`,
        severity: "warning",
        kind: "chain",
        title: "Redirect chain",
        detail: `${label(group)} \u2192 ${group.toPath} is itself redirected, ending at ${path}. Point it at ${path} directly.`,
        paths: [
          group.fromPaths[0],
          group.toPath,
          path
        ]
      });
    }
  }
  for (const prefixGroup of activeGroups.filter((group) => group.matchType === "prefix")) {
    for (const other of activeGroups) {
      if (other.id === prefixGroup.id || other.toPath === prefixGroup.toPath) {
        continue;
      }
      const overridden = other.fromPaths.filter((path) => prefixGroup.fromPaths.some((prefix) => isRycWebsiteRedirectPathUnder(path, prefix)));
      if (overridden.length > 0) {
        findings.push({
          id: `overlap:${prefixGroup.id}:${other.id}`,
          severity: "info",
          kind: "overlap",
          title: 'Rule overrides a "Starts with" rule',
          detail: `${overridden.join(", ")} sit under ${prefixGroup.fromPaths.join(", ")} but go to ${other.toPath} instead of ${prefixGroup.toPath}. The more specific rule wins, which is usually intended.`,
          paths: [
            ...prefixGroup.fromPaths,
            ...overridden
          ]
        });
      }
    }
  }
  const stats = {
    rules: groups.length,
    sources: rows.length,
    active: activeGroups.length,
    paused: groups.length - activeGroups.length,
    prefixRules: groups.filter((group) => group.matchType === "prefix").length
  };
  const order = {
    error: 0,
    warning: 1,
    info: 2
  };
  findings.sort((a, b) => order[a.severity] - order[b.severity]);
  return {
    findings,
    stats
  };
}, "auditRycWebsiteRedirects");

// src/ryc-website/top-banner.ts
import { z as z207 } from "zod";
var RycWebsiteTopBannerTargetTypeValues = [
  "global",
  "all_articles",
  "exact_route",
  "route_prefix"
];
var RycWebsiteTopBannerTargetTypeSchema = z207.enum(RycWebsiteTopBannerTargetTypeValues);
var ERycWebsiteTopBannerTargetType = RycWebsiteTopBannerTargetTypeSchema.enum;
var RycWebsiteTopBannerTargetTypeLabels = {
  [ERycWebsiteTopBannerTargetType.global]: "Every page",
  [ERycWebsiteTopBannerTargetType.all_articles]: "All article pages",
  [ERycWebsiteTopBannerTargetType.exact_route]: "Exact route",
  [ERycWebsiteTopBannerTargetType.route_prefix]: "Route prefix"
};
var isRycWebsiteTopBannerRouteTargetType = /* @__PURE__ */ __name((targetType) => targetType === ERycWebsiteTopBannerTargetType.exact_route || targetType === ERycWebsiteTopBannerTargetType.route_prefix, "isRycWebsiteTopBannerRouteTargetType");
var RycWebsiteTopBannerRowTargetTypeValues = [
  ERycWebsiteTopBannerTargetType.global,
  ERycWebsiteTopBannerTargetType.exact_route,
  ERycWebsiteTopBannerTargetType.route_prefix
];
var RycWebsiteTopBannerPriorityValues = [
  0,
  1,
  2,
  3
];
var RycWebsiteTopBannerPrioritySchema = z207.union([
  z207.literal(0),
  z207.literal(1),
  z207.literal(2),
  z207.literal(3)
]);
var RycWebsiteTopBannerPriorityLabels = {
  0: "Low",
  1: "Medium",
  2: "High",
  3: "Highest"
};
var RycWebsiteTopBannerPriorityByTargetType = {
  [ERycWebsiteTopBannerTargetType.exact_route]: 3,
  [ERycWebsiteTopBannerTargetType.route_prefix]: 2,
  [ERycWebsiteTopBannerTargetType.all_articles]: 1,
  [ERycWebsiteTopBannerTargetType.global]: 0
};
var RycWebsiteTopBannerAssignmentSchema = z207.object({
  targetType: RycWebsiteTopBannerTargetTypeSchema,
  targetValue: z207.string().max(500).nullable()
}).superRefine((data, ctx) => {
  var _a5;
  if (!isRycWebsiteTopBannerRouteTargetType(data.targetType)) {
    if (data.targetValue) {
      ctx.addIssue({
        code: z207.ZodIssueCode.custom,
        path: [
          "targetValue"
        ],
        message: "A global or all-article-pages assignment must not set a route"
      });
    }
    return;
  }
  if (!((_a5 = data.targetValue) == null ? void 0 : _a5.startsWith("/"))) {
    ctx.addIssue({
      code: z207.ZodIssueCode.custom,
      path: [
        "targetValue"
      ],
      message: "Route must start with /"
    });
  }
});
var RYC_WEBSITE_TOP_BANNER_ALL_ARTICLES_ASSIGNMENT = {
  targetType: ERycWebsiteTopBannerTargetType.all_articles,
  targetValue: null
};
var RycWebsiteTopBannerAssignmentResponseSchema = RycWebsiteTopBannerAssignmentSchema.innerType().extend({
  id: z207.string().uuid(),
  bannerId: z207.string().uuid(),
  createdAt: z207.string()
});
var RYC_WEBSITE_TOP_BANNER_MAX_HEIGHT = 400;
var RycWebsiteTopBannerHeightSchema = z207.number({
  invalid_type_error: "Enter a whole number"
}).int("Enter a whole number").min(1, "Must be at least 1px").max(RYC_WEBSITE_TOP_BANNER_MAX_HEIGHT, `Must be ${RYC_WEBSITE_TOP_BANNER_MAX_HEIGHT}px or less`).nullable();
var RycWebsiteTopBannerSchema = z207.object({
  id: z207.string().uuid(),
  title: z207.string(),
  customHtml: z207.string(),
  isActive: z207.boolean(),
  heightMobile: RycWebsiteTopBannerHeightSchema,
  heightDesktop: RycWebsiteTopBannerHeightSchema,
  assignments: z207.array(RycWebsiteTopBannerAssignmentResponseSchema),
  createdAt: z207.string(),
  updatedAt: z207.string()
});
var RycWebsiteTopBannerFormSchema = z207.object({
  title: z207.string().trim().min(1, "Title is required").max(255, "Title must be 255 characters or less"),
  customHtml: z207.string().trim().min(1, "Custom markup is required").max(2e4, "Custom markup is too long"),
  isActive: z207.boolean(),
  heightMobile: RycWebsiteTopBannerHeightSchema,
  heightDesktop: RycWebsiteTopBannerHeightSchema,
  displayOnAllArticlePages: z207.boolean(),
  assignments: z207.array(RycWebsiteTopBannerAssignmentSchema)
}).superRefine((data, ctx) => {
  if (!data.displayOnAllArticlePages && data.assignments.length === 0) {
    ctx.addIssue({
      code: z207.ZodIssueCode.custom,
      path: [
        "assignments"
      ],
      message: "At least one assignment is required"
    });
  }
});
var CreateRycWebsiteTopBannerSchema = z207.object({
  title: z207.string().min(1).max(255),
  customHtml: z207.string().min(1).max(2e4),
  isActive: z207.boolean(),
  heightMobile: RycWebsiteTopBannerHeightSchema.optional(),
  heightDesktop: RycWebsiteTopBannerHeightSchema.optional(),
  assignments: z207.array(RycWebsiteTopBannerAssignmentSchema).min(1),
  force: z207.boolean().optional()
});
var UpdateRycWebsiteTopBannerSchema = CreateRycWebsiteTopBannerSchema.partial();
var RycWebsiteTopBannerResolveSchema = z207.object({
  banner: RycWebsiteTopBannerSchema.omit({
    assignments: true
  }).nullable()
});
var RycWebsiteTopBannerConflictSchema = z207.object({
  id: z207.string().uuid(),
  title: z207.string()
});
export {
  ADMIN_ONLY_POST_TYPES,
  ADMIN_PASSWORD_MAX_LENGTH,
  ADMIN_PASSWORD_MIN_LENGTH,
  ADMIN_POST_STATUS_FILTER,
  ANALYTICS_NO_ROLE,
  ANALYTICS_NO_USER_GROUP,
  ASSIGN_STUDENTS_MAX,
  ATTACHMENT_TYPES,
  AUTH_PROVIDER_HEADER,
  AcceptSpaceTermsSchema,
  AccessAppSchema,
  AccessAppsResponseSchema,
  AccessConfigEntrySchema,
  AccessConfigRoleSchema,
  ActiveCampaignFieldSchema,
  ActiveCampaignFieldsParamsSchema,
  ActiveCampaignFieldsResponseSchema,
  ActiveCampaignListSchema,
  ActiveCampaignListsResponseSchema,
  ActiveCampaignStatusSchema,
  ActiveCampaignTagConfigSchema,
  ActiveCampaignTagSchema,
  ActivityJourneySchema,
  AddPermissionToRoleSchema,
  AddUserGroupMemberSchema,
  AddonAllStatusContentSchema,
  AddonCategoryEnum,
  AddonCategoryEnumObj,
  AddonCategoryEnumValues,
  AddonCategoryLabels,
  AddonContent,
  AddonContentAndTrashContentUnion,
  AddonContentBaseSchema,
  AddonContentFindAllResponseSchema,
  AddonContentRefSchemaBE,
  AddonContentTypeObject,
  AddonContentWithRatingFlagSchema,
  AddonCreateContentSchemaBE,
  AddonDashboardCreateContentSchemaFE,
  AddonDashboardCreateContentSchemaFEWithoutValidation,
  AddonDashboardUpdateContentSchemaFE,
  AddonTrashContentSchema,
  AddonUpdateContentSchemaBE,
  AddonUserTotalWatchedByCategory,
  AdminChangeUserEmailSchema,
  AdminCommentRowSchema,
  AdminFeedModerationQuerySchema,
  AdminListPostsQuerySchema,
  AdminPostStatusFilterSchema,
  AdminReplyDtoSchema,
  AdminSetPasswordSchema,
  AdminSetUserPasswordSchema,
  AfterPurchaseRequestDtoBe,
  AllStatusContentSchema,
  AnalyticsAggregateSchemaBE,
  AnalyticsCatalogItemSchemaBE,
  AnalyticsCellProgressSchemaBE,
  AnalyticsCellSchemaBE,
  AnalyticsCertificateStatusEnumObj,
  AnalyticsCertificateStatusValues,
  AnalyticsColumnKindEnumObj,
  AnalyticsColumnKindValues,
  AnalyticsColumnSchemaBE,
  AnalyticsCompositeEventEnumObj,
  AnalyticsCompositeEventParts,
  AnalyticsCompositeEventValues,
  AnalyticsConditionEventSchema,
  AnalyticsConditionSchemaBE,
  AnalyticsContentRefSchemaBE,
  AnalyticsContentSideEnumObj,
  AnalyticsContentSideValues,
  AnalyticsEventLabels,
  AnalyticsGroupSchemaBE,
  AnalyticsJobStateEnumObj,
  AnalyticsJobStateValues,
  AnalyticsJobStatusSchemaBE,
  AnalyticsMyAnalyticsSchemaBE,
  AnalyticsMyPlacementNodeSchemaBE,
  AnalyticsMyRequirementSchemaBE,
  AnalyticsMyRuleSchemaBE,
  AnalyticsNodeSchemaBE,
  AnalyticsOperatorEnumObj,
  AnalyticsOperatorValues,
  AnalyticsResultRowSchemaBE,
  AnalyticsRuleExportItemSchemaBE,
  AnalyticsRuleRefSchemaBE,
  AnalyticsRuleResponseSchemaBE,
  AnalyticsRuleSchemaBE,
  AnalyticsRuleSnapshotSchemaBE,
  AnalyticsRulesExportSchemaBE,
  AnalyticsRulesImportSchemaBE,
  AnalyticsRunStatusEnumObj,
  AnalyticsRunStatusValues,
  AnalyticsSnapshotListItemSchemaBE,
  AnalyticsSourceEnumObj,
  AnalyticsSourceLabels,
  AnalyticsSourceValues,
  AnalyticsSpaceConfigSchemaBE,
  AnalyticsSpaceRuleConfigItemSchemaBE,
  AnalyticsSpaceRuleConfigSchemaBE,
  AnalyticsSpacesTargetKindEnumObj,
  AnalyticsSpacesTargetKindValues,
  AnalyticsUserGroupRefSchemaBE,
  AnalyticsUserRolesSchemaBE,
  AnalyticsUserStatusEnumObj,
  AnalyticsUserStatusValues,
  AppAccessConfigSchema,
  AppAssignmentItemSchema,
  AppKeySchema,
  AppNameEnumObj,
  AppNameValues,
  AppRegistryTypeEnumObject,
  AppThumbnailsSchema,
  AppTierLabelsSchema,
  ApproveProDirectoryRevisionSchema,
  ArticleStatusEnumObj,
  ArticleStatusValues,
  AssignAppToGroupRequestSchema,
  AssignFeatureFlagRequestSchema,
  AssignPromoBannerSchema,
  AssignReviewTeacherSchema,
  AssignRoleSchema,
  AssignTeacherStudentsSchema,
  AssignTicketSchema,
  AttachmentSchema,
  AttemptStatus,
  AttemptStatusSchema,
  AuthExceptionEnumObj,
  AuthExceptionValues,
  AuthProviderEnum,
  AuthProviderEnumObj,
  AuthorInfoSchema,
  AvailableTagSchema,
  BIO_ALLOWED_ATTRIBUTES,
  BIO_ALLOWED_SCHEMES,
  BIO_ALLOWED_TAGS,
  BIO_LINK_REL,
  BIO_LINK_TARGET,
  BIO_MAX_RAW_CHARS,
  BIO_MAX_VISIBLE_CHARS,
  BIO_MIN_VISIBLE_CHARS,
  BLACK_FRIDAY_BANNER_DEFAULT_CTA_URL,
  BLACK_FRIDAY_BANNER_ELIGIBLE_APP_KEYS,
  BLOCK_TYPE_TO_SEGMENT,
  BLOCK_VIDEO_COMPLETION_PERCENT_KEY,
  BULK_POST_TAGS_MODE,
  BadgeConfigKeyEnumObj,
  BadgeConfigKeyValues,
  BadgeConfigLabels,
  BadgeMetaSchemaBE,
  BadgeNameEnum,
  BadgeSchema,
  BadgeSettingSchema,
  BadgeTogglesSchema,
  BadgeTypeArray,
  BadgeTypeEnumObject,
  BadgeTypeNameSchema,
  BadgeWeightEnum,
  BadgesResponseSchema,
  BareContent,
  BaseAddonUserProgressSchema,
  BaseCommentSchema,
  BaseEventSchema,
  BaseFitChallengeContentSchema,
  BaseFitChallengeSchema,
  BaseFitOnboardingSchema,
  BaseFitUserProgressSchema,
  BaseHelpCenterArticleSchema,
  BaseJournalSchema,
  BaseJourneySchema,
  BaseOnboardingSchema,
  BaseRYCContentSchema,
  BaseRYCContentWitMetaInformation,
  BaseRuleConditionSchema,
  BaseSettingSchema,
  BaseSlideshowSchema,
  BaseSlideshowSchemaWithoutUnion,
  BaseStepContentSchema,
  BaseStepContentSchemaWithContentInfo,
  BaseStepDaySchema,
  BaseStepDayWithContentsSchema,
  BaseStepSchema,
  BaseStepSchemaWithBonusVideos,
  BaseStepSchemaWithContents,
  BaseTaxonomySchema,
  BaseTopicTaxonomySchema,
  BaseUserProgressSchema,
  BaseUserSchema,
  BasicRuleSchema,
  BillingSubscriptionSchema,
  BlackFridayBannerSettingSchema,
  BlackFridayBannerStateSchema,
  BlockUserBodySchema,
  BlockedUserSchema,
  BonusSchemaWithContent,
  BoxShadowConfigSchema,
  BulkAssignFeatureFlagRequestSchema,
  BulkAssignFeatureFlagResultSchema,
  BulkCreateCommunityTagsSchema,
  BulkCreateMonitoredLinkSchema,
  BulkGrantUserAccessByAppSchema,
  BulkGrantUserAccessSchema,
  BulkImportRycWebsiteRedirectRowSchema,
  BulkImportRycWebsiteRedirectsSchema,
  BulkLinkEntrySchema,
  BulkNotificationBatchStatusSchema,
  BulkPostTagsModeSchema,
  BulkUpdateCommunityTagsSchema,
  BulkUpdatePostsResultSchema,
  BulkUpdatePostsSchema,
  ButtonConfigSchema,
  CODPayloadItem,
  COMMENT_ACTIVITY_ACTION_LABELS,
  COMMENT_MAX_LENGTH,
  COMMENT_REJECT_REASON_LABELS,
  COMMUNITY_UPDATES_MAX_ITEMS,
  CalendarStateResponse,
  CancelEmailChangeSchema,
  CategoryEnum,
  CategoryEnumObj,
  CategoryEnumValues,
  ChCommentReactionConditionSchema,
  ChCommentReplyConditionSchema,
  ChMentionConditionSchema,
  ChNewPostConditionSchema,
  ChPostCommentConditionSchema,
  ChPostReactionConditionSchema,
  ChallengeBadgeNameArray,
  ChallengeBadgeNameEnumObject,
  ChallengeBadgeSchema,
  ChallengeBannerSettingSchema,
  ChallengeCompletionStatusSchema,
  ChallengeFormContentSchemaFE,
  ChallengeFormSchemaFE,
  ChallengePageSettingSchema,
  ChangePasswordApiSchema,
  ChangePasswordSchema,
  CheckInSchema,
  CitySchema,
  ClassOfTheDayTheme,
  ClassOfTheDayThemeSchemaFE,
  CoerceBoolean,
  CommentActivityActionEnum,
  CommentActivityActionValues,
  CommentActivitySchema,
  CommentAnalyticsByInstructorSchema,
  CommentAnalyticsFiltersSchema,
  CommentAnalyticsGranularityEnum,
  CommentAnalyticsInstructorRowSchema,
  CommentAnalyticsOverviewSchema,
  CommentAnalyticsRejectionReasonSchema,
  CommentAnalyticsRejectionReasonsSchema,
  CommentAnalyticsReviewerSchema,
  CommentAnalyticsReviewersSchema,
  CommentAnalyticsTimelineFiltersSchema,
  CommentAnalyticsTimelinePointSchema,
  CommentAnalyticsTimelineSchema,
  CommentAttachmentSchema,
  CommentBaseSchema,
  CommentRejectReasonEnum,
  CommentRejectReasonValues,
  CommentSchema,
  CommentStatus,
  CommentStatusSchema,
  CommentWithAuthorBaseSchema,
  CommentWithAuthorSchema,
  CommentWithRepliesSchema,
  CommentsResponseSchema,
  CommonContentFields,
  CommonCustomDateSchema,
  CommunityActivityResponseSchema,
  CommunityActivitySchema,
  CommunityActivityTypeEnum,
  CommunityStatsSchema,
  CommunityTagAdminRowSchema,
  CommunityTagType,
  CommunityTagTypeSchema,
  CommunityUpdatesEventPattern,
  CommunityUpdatesNamespace,
  CompleteContentActionEnumObject,
  CompleteContentRequestSchema,
  ConditionClauseSchema,
  ConditionOperatorSchema,
  ConfirmEmailChangeSchema,
  Constants,
  ConsumeOttSchema,
  ContactFormSettingSchema,
  ContactFormSettingSchemaBE,
  ContactFormSettingSchemaFE,
  Content,
  ContentAndTrashContentUnion,
  ContentBlockBaseSchema,
  ContentBlockContentCategory,
  ContentBlockContentCategorySchema,
  ContentBlockResourceIcon,
  ContentBlockResourceIconSchema,
  ContentBlockResourceType,
  ContentBlockResourceTypeSchema,
  ContentBlockType,
  ContentBlockTypeEvents,
  ContentBlockTypeSchema,
  ContentBlockUsageKind,
  ContentBlockUsageKindSchema,
  ContentBlockUsageMapSchema,
  ContentBlockUsageSchema,
  ContentByDate,
  ContentByDateResponseSchema,
  ContentDefaultTabEnum,
  ContentFilterTypeEnum,
  ContentFilterTypeObj,
  ContentFilterTypeValues,
  ContentFindAllResponseSchema,
  ContentFindByIdsResponseSchema,
  ContentRating,
  ContentRatingResponse,
  ContentRequestBESchema,
  ContentRequestSchema,
  ContentResponseSchema,
  ContentScheduleItem,
  ContentScheduleItemWithContent,
  ContentScheduleResponseSchema,
  ContentSettingSchema,
  ContentSettingSchemaBE,
  ContentSettingSchemaFE,
  ContentStatusSchema,
  ContentTypeEnum,
  ContentTypeEnumObj,
  ContentTypeEnumValues,
  ContentWithRatingFlagSchema,
  ContentWithWatchedDate,
  ConversationBaseSchema,
  ConversationType,
  ConversationTypeSchema,
  CountrySchema,
  CreateAnalyticsRuleSchemaBE,
  CreateAppRequestSchema,
  CreateArticleSchemaBE,
  CreateBadgeSchema,
  CreateBadgeSettingSchemaBE,
  CreateBulkNotificationResponseSchema,
  CreateBulkNotificationSchema,
  CreateCODThemeSchemaBE,
  CreateChallengeBadgeSchema,
  CreateCommentDtoSchema,
  CreateCommentSchema,
  CreateCommunityTagSchema,
  CreateContentBasicSchemaFE,
  CreateContentBlockSchema,
  CreateContentReportSchema,
  CreateContentSchemaBE,
  CreateContentSchemaFE,
  CreateContentSchemaFEWithoutValidation,
  CreateContentVideoSchemaFE,
  CreateConversationSchema,
  CreateDashboardFeedCardSchema,
  CreateEquipmentRequest,
  CreateEventSchemaBE,
  CreateEventSchemaFE,
  CreateFeatureFlagRequestSchema,
  CreateFeatureSeriesContentSchemaBE,
  CreateFeatureSeriesContentSchemaFE,
  CreateFeatureSeriesSchemaBE,
  CreateFeatureSeriesSchemaFE,
  CreateFitChallengeSchemaBE,
  CreateFitChallengeSchemaFE,
  CreateFitOnboardingSchemaBE,
  CreateFitOnboardingStepSchemaBE,
  CreateFormDefinitionSchema,
  CreateFormOptionSchema,
  CreateFormQuestionGroupSchema,
  CreateFormQuestionSchema,
  CreateFormSchema,
  CreateHelpCenterArticleSchemaBE,
  CreateHelpCenterCategoryTaxonomySchemaBE,
  CreateHelpCenterTopicTaxonomySchemaBE,
  CreateInstructionSchema,
  CreateInstructorSchema,
  CreateIssueCategorySchema,
  CreateJournalSchemaBE,
  CreateLessonCategorySchema,
  CreateLessonSchema,
  CreateLinkGroupSchema,
  CreateMediaFileSchema,
  CreateMilestoneBadgeSchema,
  CreateMonitoredLinkSchema,
  CreateNoteSchema,
  CreateNotificationRuleObjectSchemaBE,
  CreateNotificationRuleSchemaBE,
  CreateOnboardingSchemaBE,
  CreateOnboardingStepSchemaBE,
  CreateOnboardingVideoSchemaBE,
  CreateOptionSchema,
  CreatePermissionSchema,
  CreatePlanRequestSchemaBE,
  CreatePlanSchemaBE,
  CreatePlanSchemaFE,
  CreatePlaylistBeRequestSchema,
  CreatePlaylistRequestSchema,
  CreatePlaylistSchema,
  CreatePollOptionSchema,
  CreatePollSchema,
  CreatePostSchema,
  CreateProductSchema,
  CreateProgramFormSchemaFE,
  CreateProgramGroupRequestSchema,
  CreateProgramRequestSchemaBE,
  CreateProgramSchemaBE,
  CreateProgramSchemaFE,
  CreatePromoBannerSchema,
  CreatePurchaseLogSchemaBE,
  CreateQuestionSchema,
  CreateQuizSchema,
  CreateRYCContentRequestWithMetaSchema,
  CreateRYCContentSchemaBE,
  CreateRYCContentSchemaFE,
  CreateRYCContentWithMetaSchemaBE,
  CreateReportSchema,
  CreateRoleSchema,
  CreateRycWebsiteArticlePrefixSchema,
  CreateRycWebsiteArticleSchema,
  CreateRycWebsiteAttachmentSchema,
  CreateRycWebsiteAuthorSchema,
  CreateRycWebsiteCategorySchema,
  CreateRycWebsiteMediaUploadSchema,
  CreateRycWebsiteRedirectSchema,
  CreateRycWebsiteTopBannerSchema,
  CreateSeriesBadgeSchema,
  CreateSeriesFormSchemaFE,
  CreateSeriesGroupSchemaFE,
  CreateSeriesRequestSchemaBE,
  CreateSeriesSchemaBE,
  CreateSeriesSchemaFE,
  CreateSlideshowSchemaFE,
  CreateSpaceSchema,
  CreateStepSchemaFE,
  CreateSubSpaceSchema,
  CreateTemplateSchema,
  CreateTermsSchema,
  CreateTicketCommentSchema,
  CreateTicketSchema,
  CreateUserGroupSchema,
  CreateUserLogSchemaBE,
  CreateWatchHistoryBeSchema,
  CreateZoomEventSchema,
  CronExpressionSchema,
  CronNotificationEventTypeValues,
  CurrentJourneyFiltersSchema,
  CustomDateTimeSchema,
  CustomLuxonDateSchema,
  CustomNotificationConditionSchema,
  DEFAULT_AI_SYSTEM_PROMPT,
  DEFAULT_ARTICLE_SYSTEM_PROMPT,
  DEFAULT_BADGE_SETTINGS,
  DEFAULT_GRADING_OPT_OUT,
  DEFAULT_GRADING_SCALE,
  DEFAULT_LESSON_COLLAPSE_BUTTON_TEXT,
  DEFAULT_LESSON_EXPAND_BUTTON_TEXT,
  DEFAULT_LESSON_MOBILE_COLLAPSE_BUTTON_TEXT,
  DEFAULT_LESSON_MOBILE_EXPAND_BUTTON_TEXT,
  DEFAULT_REVIEW_TIMING,
  DEFAULT_VIDEO_COMPLETION_PERCENT,
  DashboardFeedCardBaseSchema,
  DashboardFeedCardVariantSchema,
  DateRangeQuerySchema,
  DeleteContentFromPlaylistBeRequestSchema,
  DeleteContentFromPlaylistRequestSchema,
  DeleteWatchHistoryBeSchema,
  DeviceTokenRegisterPayloadSchemaBE,
  DeviceTokenUnregisterPayloadSchemaBE,
  DownloadPdfRequestBESchema,
  DuplicateRoleSchema,
  EAddonContentType,
  EAnalyticsOperatorEnum,
  EAnalyticsRunStatusEnum,
  EAnalyticsSourceEnum,
  EAnalyticsSpacesTargetKindEnum,
  EAnalyticsUserStatusEnum,
  EAppNameEnum,
  EArticleStatus,
  EAuthExceptionEnum,
  EAuthType,
  EBadgeType,
  EChallengeBadgeName,
  ECommentActivityAction,
  ECommentRejectReason,
  ECompleteContentAction,
  EContentStatus,
  EEmailSentReason,
  EEmailSentStatus,
  EEngagementEntityType,
  EEventTypeEnum,
  EFeatureFlagSlug,
  EFitChallengeContentType,
  EFitOnboardingStep,
  EFormBlockBackground,
  EFormBlockMediaLayout,
  EFormQuestionType,
  EFormType,
  EHelpCenterAppNameEnum,
  EImageVariant,
  EImmediateAfterPurchaseSchema,
  EMPTY_ANALYTICS_USER_ROLES,
  EMediaFileStatus,
  EMediaProcessingKind,
  EMilestoneBadgeName,
  ENotificationChannel,
  ENotificationRuleStatus,
  ENotificationRulesType,
  ENotificationStatus,
  ENotificationType,
  ENovuEmailTemplateNameEnum,
  ENovuTenantIdentifierEnum,
  ENovuWorkflowsEnum,
  EOnboardingStep,
  EPageSpeedReportStatus,
  EPageSpeedStrategy,
  EProSpecialtyEnum,
  EProSpecialtyValues,
  EProfileFieldKind,
  EPurchaseStatusEnum,
  EQuestionInputType,
  EQueuedPageState,
  ERYCContentMetaSeries,
  ERYCContentMetaType,
  ERYCContentPath,
  ERYCContentType,
  ERealtimeNotificationMessageType,
  EReviewDueState,
  EReviewMissingProgress,
  EReviewReminderKind,
  EReviewSubmissionStatus,
  EReviewTimeState,
  ERolesEnum,
  ERycWebsiteArticlePrefixStatus,
  ERycWebsiteArticleStatus,
  ERycWebsiteCategoryStatus,
  ERycWebsiteTopBannerTargetType,
  ESeriesBadgeName,
  ESlideBadgeImagePositionEnum,
  ESlideshowAppEnum,
  ESlideshowTypeEnum,
  ESpaceParticipantRole,
  EStagesEnum,
  EStepTypeEnum,
  EStepsEnum,
  EStorageSortField,
  EStorageSortOrder,
  ETargetApp,
  EUserActivityTypeEnum,
  EUserGroupImportSource,
  EUserLogActionEnum,
  EUserOnlinePubSub,
  EUserOnlineTopicEnum,
  EmailChangeConfirmedConditionSchema,
  EmailChangeSearchParamsSchema,
  EmailChangeSecurityAlertConditionSchema,
  EmailChangeVerifyConditionSchema,
  EmailListConfigSchema,
  EmailLoginSchema,
  EmailMetaSchema,
  EmailResponse,
  EmailReturnResponse,
  EmailSendReasonObj,
  EmailSentReasonValues,
  EmailSentStatusObj,
  EmailSentStatusValues,
  EngagementCountSchema,
  EngagementEntityTypeEnumObj,
  EngagementEntityTypeValues,
  EngagementGroupTreatmentEnumObj,
  EngagementGroupTreatmentValues,
  EngagementLessonSchema,
  EngagementLogItemSchema,
  EngagementLogsQuerySchema,
  EngagementLogsResponseSchema,
  EngagementMemberSchema,
  EngagementMembersQuerySchema,
  EngagementMembersResponseSchema,
  EngagementMembersSortEnumObj,
  EngagementMembersSortValues,
  EngagementReportingGroupSchema,
  EngagementRowTagSchema,
  EngagementSubSpaceSchema,
  EngagementSummaryQuerySchema,
  EngagementSummaryResponseSchema,
  EngagementTimelineGranularityEnumObj,
  EngagementTimelineGranularityValues,
  EngagementTimelineMetricEnumObj,
  EngagementTimelineMetricValues,
  EngagementTimelineQuerySchema,
  EngagementTimelineResponseSchema,
  EngagementTimelineSeriesSchema,
  EngagementTopContentItemSchema,
  EngagementTopContentQuerySchema,
  EngagementTopContentResponseSchema,
  EngagementUserSchema,
  EngagementUsersQuerySchema,
  EnumRuleConditionJsonColumnObject,
  Equipment,
  ErrorSchema,
  EventAttendanceBaseSchema,
  EventBaseSchema,
  EventContentSchema,
  EventMessagePayloadSchema,
  EventMessageSchema,
  EventMessageSchemaWithReplies,
  EventMessageUserInfoSchema,
  EventReactionSchema,
  EventStatus,
  EventStatusEnum,
  EventStatusEnumObj,
  EventStatusEnumValues,
  EventStatusSchema,
  EventType,
  EventTypeObj,
  EventTypeSchema,
  EventTypeValues,
  ExpertiseItemSchema,
  ExportAdminCommentsDtoSchema,
  ExportFeedModerationQuerySchema,
  FEATURE_FLAGS_STORAGE_KEY,
  FEED_MODERATION_ACTIVITY_ACTION_LABELS,
  FITBareContent,
  FITCommonContentFields,
  FITContent,
  FITContentAndTrashContentUnion,
  FITContentByDate,
  FITContentByDateResponseSchema,
  FITContentFindAllResponseSchema,
  FITContentResponseSchema,
  FITContentWithRatingFlagSchema,
  FITContentWithWatchedDate,
  FITDashboardCreateContentSchemaFE,
  FITDashboardCreateContentSchemaFEWithoutValidation,
  FITDashboardUpdateContentSchemaFE,
  FITDateRangeQuerySchema,
  FITTrashContentSchema,
  FITUserContentRatingResponse,
  FITWatchedFilterEnum,
  FITWatchedStatusEnumObj,
  FITWatchedStatusEnumValues,
  FORM_BLOCK_BACKGROUNDS,
  FeatureFlagAssignmentSchema,
  FeatureFlagAudienceTypeEnumObject,
  FeatureFlagMapSchema,
  FeatureFlagSchema,
  FeaturedSeriesSettingSchema,
  FeedModerationActivityActionEnum,
  FeedModerationActivityEntrySchema,
  FeedModerationActivityResponseSchema,
  FeedModerationAnalyticsByCommunitySchema,
  FeedModerationAnalyticsCommunityRowSchema,
  FeedModerationAnalyticsFiltersSchema,
  FeedModerationAnalyticsGranularityEnum,
  FeedModerationAnalyticsOverviewSchema,
  FeedModerationAnalyticsReasonSchema,
  FeedModerationAnalyticsReasonsSchema,
  FeedModerationAnalyticsReviewerSchema,
  FeedModerationAnalyticsReviewersSchema,
  FeedModerationAnalyticsTimelineFiltersSchema,
  FeedModerationAnalyticsTimelinePointSchema,
  FeedModerationAnalyticsTimelineSchema,
  FeedModerationCommunitiesResponseSchema,
  FeedModerationCommunitySchema,
  FeedModerationItemParamsSchema,
  FeedModerationItemSchema,
  FeedModerationItemStateSchema,
  FeedModerationItemTypeEnum,
  FeedModerationItemsResponseSchema,
  FeedModerationReportEntrySchema,
  FeedModerationReportedCountSchema,
  FeedModerationThreadSchema,
  FeedSpaceItemSchema,
  FieldTypeSchema,
  FieldVisibilitySchema,
  FindAllByContentIdBeSchema,
  FindAllWatchHistoryBeSchema,
  FindOneUserLogSchemaBe,
  FindOneWatchHistoryBeSchema,
  FindUserLogSchemaBe,
  FindVideoTagsRequestSchema,
  FitBadgeEarnedConditionSchema,
  FitChallengeContentTypeEnumObject,
  FitChallengeContentTypeValues,
  FitChallengeMaintainedBySchema,
  FitCommentLikeConditionSchema,
  FitCommentMentionConditionSchema,
  FitContentRefSchemaBE,
  FitInstructorCommentConditionSchema,
  FitOnboardingStepEnumObject,
  FitOnboardingStepSchema,
  FitOnboardingStepValues,
  FitVideoCommentConditionSchema,
  FitWelcomeConditionSchema,
  ForgotPasswordSchema,
  FormAnalyticsSchema,
  FormAnalyticsSubmissionByDateSchema,
  FormAnalyticsUserSchema,
  FormBaseSchema,
  FormBlockMediaSchema,
  FormDefinitionSchema,
  FormExportFileSchema,
  FormExportItemSchema,
  FormFieldSchema,
  FormGradingOptOutSchema,
  FormGradingReflectionSchema,
  FormGradingRowSchema,
  FormGradingScaleSchema,
  FormPageUsageSchema,
  FormQuestionGroupSchema,
  FormQuestionTypeSchema,
  FormStatus,
  FormStatusSchema,
  FormSubmissionSchema,
  FormTextBlockSchema,
  FormTypeSchema,
  ForwardResolutionSchema,
  FromToDateORSchema,
  GCS_MEDIA_TYPE_PRESETS,
  GLOBAL_SETTING_VALUE_SCHEMAS,
  GcsAllowedMediaType,
  GcsAllowedMediaTypeSchema,
  GcsUploadReportRowSchema,
  GcsUploadRowSchema,
  GcsUploadStatus,
  GcsUploadStatusSchema,
  GenerateOttSchema,
  GenerateOttUserSchema,
  GenerateSubscriberIdWithTenantSchema,
  GeographyCacheEntryDetailSchema,
  GeographyCacheEntrySchema,
  GeographyCacheStatusSchema,
  GetActivityDatesByMonthBeSchema,
  GetAdminCommentsDtoSchema,
  GetAssignedInstructorsWidthUserIdsBESchema,
  GetBadgesQuerySchema,
  GetCommentsDtoSchema,
  GetContentRatingsSchema,
  GetContentsByCommentsDateRangeSchema,
  GetEventAttendeesSchemaBe,
  GetFavoriteContentBeRequestSchema,
  GetNotificationLogsRequestSchema,
  GetNotificationLogsResponseSchema,
  GetNotificationUsersRequestBESchema,
  GetOrdersSchema,
  GetPlaylistsBeRequestSchema,
  GetPlaylistsRequestSchema,
  GetSinglePlaylistBeRequestSchema,
  GetSinglePlaylistRequestSchema,
  GetSpacePostsQuerySchema,
  GetSubscribedUsersRequestBESchema,
  GetUserBadgesParamsSchema,
  GetUserIdsBESchema,
  GetUsersRequestBESchema,
  GlobalCacheKeyEnum,
  GlobalSearchRequestSchema,
  GlobalSearchResultSchema,
  GlobalSettingBEResponseSchema,
  GlobalSettingsSchema,
  GlobalSettingsTypeEnum,
  GlobalSettingsTypeEnumObj,
  GlobalSettingsTypeEnumValues,
  GlobalSettingsValue,
  GrantUserAccessByAppSchema,
  GrantUserAccessSchema,
  GrantUserGroupAccessByAppSchema,
  GrantUserGroupAccessResultSchema,
  GrantUserGroupAccessSchema,
  GridLayoutSchema,
  GroupedAppSchema,
  GroupedAppsGroupSchema,
  GroupedAppsResponseSchema,
  GroupedSeriesResponseSchema,
  HeartbeatResponseSchema,
  HelpCenterAppNameEnumObj,
  HelpCenterAppNameValues,
  HelpCenterArticle,
  HelpCenterArticleCategory,
  HelpCenterArticleCreationPayloadSchema,
  HelpCenterArticleDetails,
  HelpCenterArticleEditHistoryDataSchema,
  HelpCenterArticleEditHistoryListSchema,
  HelpCenterArticleEditHistorySchema,
  HelpCenterArticleSearchResponse,
  HelpCenterArticleTopic,
  HelpCenterArticleTopicWithCategory,
  HelpCenterArticlesFiltersSchema,
  HopAdminNoteConditionSchema,
  HopFeedbackReadyConditionSchema,
  HopReviewReminderConditionSchema,
  HopSubmissionReceivedConditionSchema,
  HopSubmissionRejectedConditionSchema,
  HopSubmissionReminderConditionSchema,
  HostAvailabilitySchema,
  HostAvailabilitySlotSchema,
  HostUpcomingMeetingSchema,
  ImportNotificationRulesSchemaBE,
  InactivityRuleConditionJsonSchemaBE,
  IndicateorsEnumValues,
  IndicatorEnum,
  IndicatorsEnumObj,
  InsertContentInPlaylistBeRequestSchema,
  InsertContentInPlaylistRequestSchema,
  Instructor,
  InstructorAuthorSchema,
  InstructorFilterModeEnum,
  InstructorProfilePictureSchema,
  InstructorRequestSchema,
  InstructorTypeEnum,
  InstructorTypeEnumObj,
  InstructorTypeEnumValues,
  InstructorsByIdsRequestSchema,
  IssueCategorySchema,
  JournalEntryDatesRequestSchema,
  JourneyAlreadyClaimedBonusValues,
  JourneyFiltersSchema,
  JourneyUserActivitiesSchema,
  JourniesUserActivitiesSchema,
  JwtExceptionEnumObj,
  LC_SSO_CONTEXT_QUERY,
  LC_SSO_CONTEXT_VALUE,
  LIVE_SESSION_BUFFER_MINUTES,
  LIVE_SESSION_DAY_END_HOUR,
  LIVE_SESSION_DAY_START_HOUR,
  LIVE_SESSION_REPLAY_AVAILABLE_MINUTES,
  LIVE_SESSION_REPLAY_NOTICE_MINUTES,
  LIVE_SESSION_SLOT_MINUTES,
  LIVE_SESSION_TIME_ZONE,
  LeaderBoardRequestSchema,
  LeaderBoardSchema,
  LeaderBoardTypeEnum,
  LeaderBoardTypeEnumObj,
  LeaderBoardTypeEnumValues,
  LessonBaseSchema,
  LessonCategoryBaseSchema,
  LessonColorScheme,
  LessonColorSchemeSchema,
  LessonIconScheme,
  LessonIconSchemeSchema,
  LessonProgressBaseSchema,
  LessonProgressStatus,
  LessonProgressStatusSchema,
  LessonRefSchema,
  LessonStatus,
  LessonStatusSchema,
  LessonTemplateType,
  LessonTemplateTypeSchema,
  LikeResponseSchema,
  LinkGroupBaseSchema,
  ListCommunityTagsQuerySchema,
  ListProDirectoryRevisionsQuerySchema,
  ListProQuerySchema,
  ListProQueryWithSearchSchema,
  LiveSessionState,
  LoginSchema,
  MANAGEMENT_ROLES,
  MAPPABLE_PROFILE_FIELDS,
  MAX_BULK_RECIPIENT_IDENTIFIERS,
  MAX_NON_VIDEO_ATTACHMENT_BYTES,
  MAX_REDIS_DB,
  MEMBER_MAX_ATTACHMENT_BYTES,
  MEMBER_MAX_VIDEO_DURATION_SEC,
  MULTI_SELECT_FIELD_TYPES,
  MagicLinkEmailSchema,
  MagicLinkLoginConditionSchema,
  ManualCompleteContentRequestSchema,
  MarginConfigSchema,
  MarkAsReadSchema,
  MarkNotificationsAsReadSchema,
  MediaCdnUrlsSchema,
  MediaFileBaseSchema,
  MediaFileFiltersSchema,
  MediaFilePageSchema,
  MediaMonthlyStatSchema,
  MediaTypeEnum,
  MediaTypeEnumObj,
  MediaTypeEnumValues,
  MediaUploadLimitSchema,
  MediaUserStatsSchema,
  MembersLoginSchema,
  MentionUserCacheSchema,
  MentionUserSchema,
  MergedValueConfigSchema,
  MessageBaseSchema,
  MessageType,
  MessageTypeSchema,
  MetaSchema,
  MilestoneBadgeNameArray,
  MilestoneBadgeNameEnumObject,
  MilestoneBadgeSchema,
  MiniProgramCatalogItemSchema,
  ModuleProgressSchema,
  MonitoredLinkBaseSchema,
  MovePlaylistContentRequestSchema,
  MovePlaylistContentRequestSchemaBE,
  MyFeatureFlagSchema,
  NOTE_ENTITY_TYPE,
  NoteAuthorSchema,
  NoteSchema,
  NotificationChannelEnumObject,
  NotificationChannelValues,
  NotificationFindAllRequestQuerySchema,
  NotificationLogFindAllRequestQuerySchema,
  NotificationLogMetadataSchema,
  NotificationLogResponseSchemaBE,
  NotificationLogSchema,
  NotificationRuleExportItemSchemaBE,
  NotificationRuleExportQuerySchema,
  NotificationRuleExportSchemaBE,
  NotificationRuleImportResultSchemaBE,
  NotificationRuleResponseSchemaBE,
  NotificationRuleSchema,
  NotificationRuleSchemaBE,
  NotificationRuleStatusEnumObject,
  NotificationRulesTypeEnumObject,
  NotificationStatusEnumObject,
  NotificationTemplateSchemaBE,
  NotificationType,
  NotificationTypeEnumObject,
  NotificationTypeSchema,
  NotificationTypeValues,
  NotifyReviewSubmissionSchema,
  NovuEmailTemplateNameEnumObject,
  NovuEmailTemplateNameValues,
  NovuTenantIdentifierEnumObject,
  NovuTenantIdentifierValues,
  NovuWorkflowTemplateSchema,
  NovuWorkflowValues,
  NovuWorkflowsEnumObject,
  OTP_LOGIN_CODE_LENGTH,
  OnboardingSettingSchema,
  OnboardingSettingSchemaBE,
  OnboardingSettingSchemaFE,
  OnboardingStepEnumObject,
  OnboardingStepSchema,
  OnboardingStepValues,
  OnboardingVideoSchema,
  OnlineUserSchema,
  OnlineUsersResponseSchema,
  OptionSchema,
  OptionsLayoutSchema,
  OrderProductSchema,
  OrderSchema,
  OrdersResponseSchema,
  OtpLoginConditionSchema,
  POLL_MAX_OPTIONS,
  POLL_MIN_OPTIONS,
  POST_SORT,
  POST_SORT_DEFINITIONS,
  POST_TYPE,
  POST_TYPE_DEFINITIONS,
  PROGRAM_DISPLAY_NAMES,
  PROMO_BANNER_CUSTOM_HTML_MAX_LENGTH,
  PUBLIC_GLOBAL_SETTING_TYPES,
  PageSpeedReportBaseSchema,
  PasswordChangeConditionSchema,
  PasswordResetConditionSchema,
  PaymentPlanSchema,
  PaymentPlansResponseSchema,
  PermissionBaseSchema,
  PermissionWithUsageSchema,
  Permissions,
  Plan,
  PlanItem,
  PlanItemContent,
  PlanItemReorder,
  PlanItemsRequestSchemaFE,
  PlanResponseSchema,
  PlanTypeEnum,
  PlanTypeObj,
  PlanTypeValues,
  PlansResponseSchema,
  Playlist,
  PlaylistFormSchema,
  PlaylistItem,
  PlaylistItemReorder,
  PlaylistResponseSchema,
  PlaylistSettingsSchema,
  PlaylistStatusEnum,
  PlaylistStatusEnumObj,
  PlaylistStatusEnumValues,
  PlaylistTypeEnum,
  PlaylistTypeObj,
  PlaylistTypeValues,
  PlaylistsResponseSchema,
  PollOptionSchema,
  PollOptionVotersSchema,
  PollSchema,
  PollVotersSchema,
  PostAttachmentSchema,
  PostBaseSchema,
  PostSortSchema,
  PostStatus,
  PostStatusSchema,
  PostTagInputSchema,
  PostTypeDefinitionSchema,
  PostTypeSchema,
  PostWithAuthorSchema,
  PresignedUploadRequestSchema,
  PresignedUploadResultSchema,
  ProDirectoryApprovedConditionSchema,
  ProDirectoryCacheEntrySchema,
  ProDirectoryCacheStatusSchema,
  ProDirectoryListResponseSchema,
  ProDirectoryPaginationSchema,
  ProDirectoryRecacheJobSchema,
  ProDirectoryRejectedConditionSchema,
  ProDirectoryRevisionRowSchema,
  ProDirectoryRevisionSchema,
  ProDirectoryRevisionStatusSchema,
  ProDirectoryRevisionWithProSchema,
  ProDirectoryRowSchema,
  ProDirectorySchema,
  ProDirectorySubmissionConfirmedConditionSchema,
  ProDirectorySubmittedConditionSchema,
  ProPublicProfileSchema,
  ProductFiltersSchema,
  ProductSchema,
  ProfessionSchema,
  ProfileFieldKeySchema,
  ProfileFormSchema,
  ProfileMetaSchema,
  ProfilePicture,
  ProfileSchema,
  Program,
  ProgramGroupSchema,
  ProgramListResponseSchema,
  ProgramResponseSchema,
  ProgramSectionInput,
  ProgramSectionResponse,
  PromoBannerAnalyticsSchema,
  PromoBannerBaseSchema,
  PromoBannerEntityQuerySchema,
  PromoBannerEntityType,
  PromoBannerEntityTypeLabels,
  PromoBannerEntityTypeSchema,
  PromoBannerForEntitySchema,
  PromoBannerIconScheme,
  PromoBannerIconSchemeSchema,
  PromoBannerPlacementInfoSchema,
  PromoBannerPlacementSchema,
  PromoBannerPosition,
  PromoBannerPositionLabels,
  PromoBannerPositionSchema,
  PromoBannerType,
  PromoBannerTypeLabels,
  PromoBannerTypeSchema,
  PubSubEventsEnum,
  PubSubEventsEnumObj,
  PubSubEventsEnumValues,
  PublicInstructor,
  PublicSeriesListResponseSchema,
  PublicSeriesSchema,
  PurchaseRequestSchema,
  PurchaseStatusEnum,
  QuestionInputTypeSchema,
  QuestionType,
  QuestionTypeSchema,
  QueuedPageSchema,
  QueuedPagesResponseSchema,
  QuizBaseSchema,
  QuizStatus,
  QuizStatusSchema,
  REACTION_EMOJIS,
  REDIS_DB_BY_APP,
  REDIS_DB_LIST,
  REPORT_DESCRIPTION_MAX_LENGTH,
  REPORT_REASON_HINTS,
  REPORT_REASON_LABELS,
  REVIEW_EXPORT_MAX_ROWS,
  REVIEW_NOTE_MAX,
  REVIEW_REMINDER_COOLDOWN_HOURS,
  REVIEW_REMINDER_NOTE_MAX,
  RULE_EXPORT_VERSION,
  RYCContent,
  RYCContentCategoryResponseSchema,
  RYCContentCategorySchema,
  RYCContentMeTypeEnumValues,
  RYCContentMetaInformationBaseSchema,
  RYCContentMetaInfromationSchema,
  RYCContentMetaSeriesEnumObject,
  RYCContentMetaSeriesEnumValues,
  RYCContentMetaTypeEnumObject,
  RYCContentPathEnumObject,
  RYCContentPathValues,
  RYCContentRequestBESchema,
  RYCContentTypeEnumObject,
  RYCContentTypeValues,
  RYCDashboardCreateContentSchemaFE,
  RYCDashboardCreateContentSchemaFEWithoutValidation,
  RYCDashboardUpdateContentSchemaFE,
  RYCJournalRequestBESchema,
  RYC_WEBSITE_REDIRECT_MAX_SOURCES,
  RYC_WEBSITE_REDIRECT_NOTE_FORM_MAX_LENGTH,
  RYC_WEBSITE_TOP_BANNER_ALL_ARTICLES_ASSIGNMENT,
  RYC_WEBSITE_TOP_BANNER_MAX_HEIGHT,
  RYC_WEBSITE_TWITTER_CARD_OPTIONS,
  RateContentSchema,
  RatingIndicator,
  ReactToEventMessageSchema,
  ReactionBaseSchema,
  ReactionDetailsSchema,
  ReactionTargetType,
  ReactionTargetTypeSchema,
  RealTimeNotificationEventTypeValues,
  RealtimeNotificationBePayloadSchemaBE,
  RealtimeNotificationMessageTypeEnumObject,
  RealtimeNotificationMessageTypeValues,
  RealtimeNotificationMetaSchemaBE,
  RecordEventLeaveSchema,
  RefreshTokenSchema,
  RegisterDeviceTokenRequestSchema,
  RejectProDirectoryRevisionSchema,
  RejectReviewSubmissionSchema,
  RemindReviewStudentsSchema,
  RemindReviewTeachersSchema,
  RemovePlaylistBeRequestSchema,
  RemovePlaylistRequestSchema,
  ReorderPlaylistRequestSchema,
  ReorderPlaylistRequestSchemaBE,
  ReorderSeriesGroupSeriesSchema,
  ReorderSeriesGroupsSchema,
  RepliesSchema,
  ReportQueryFiltersSchema,
  ReportReasonEnum,
  RequestEmailChangeSchema,
  RequestMagicLinkSchema,
  RequestOtpLoginSchema,
  RequestSchema,
  ResetPasswordSchema,
  ResetPasswordSearchParamsSchema,
  ResolveBulkRecipientsResponseSchema,
  ResolveBulkRecipientsSchema,
  ResolvedBulkRecipientSchema,
  RestoreRycWebsiteArticleRevisionSchema,
  ReviewDueStateSchema,
  ReviewDueStateValues,
  ReviewExportQuerySchema,
  ReviewFacetOptionSchema,
  ReviewFacetsResponseSchema,
  ReviewFilterModeSchema,
  ReviewMissingCountsSchema,
  ReviewMissingDateFieldValues,
  ReviewMissingFacetsResponseSchema,
  ReviewMissingFiltersSchema,
  ReviewMissingFormSchema,
  ReviewMissingItemSchema,
  ReviewMissingProgressSchema,
  ReviewMissingProgressValues,
  ReviewMissingQuerySchema,
  ReviewMissingResponseSchema,
  ReviewPersonSchema,
  ReviewQueueDateFieldValues,
  ReviewQueueFacetsResponseSchema,
  ReviewQueueFiltersSchema,
  ReviewQueueItemSchema,
  ReviewQueueQuerySchema,
  ReviewQueueResponseSchema,
  ReviewReminderKindSchema,
  ReviewReminderKindValues,
  ReviewReminderRecipientSchema,
  ReviewReminderResultSchema,
  ReviewSubmissionNoteSchema,
  ReviewSubmissionStatusSchema,
  ReviewSubmissionStatusValues,
  ReviewTeachersQuerySchema,
  ReviewTimeStateSchema,
  ReviewTimeStateValues,
  ReviewTimingSchema,
  RoleAppUsageMapSchema,
  RoleAppUsageSchema,
  RoleBaseSchema,
  RoleUserSchema,
  RoleUsersPageSchema,
  RoleValues,
  RoleWithPermissionsSchema,
  RolesEnumObj,
  RuleActionSchema,
  RuleConditionJsonColumnObject,
  RuleConditionJsonColumnValues,
  RuleConditionJsonSchemaBE,
  RuleConditionTypeSchema,
  RuleEvaluationRequestSchema,
  RuleEvaluationResponseSchema,
  RuleMatchResultSchema,
  RuleSchema,
  RycContentRefSchemaBE,
  RycWebsiteArticleCategorySchema,
  RycWebsiteArticleDetailCacheEntrySchema,
  RycWebsiteArticleFaqSchema,
  RycWebsiteArticleFormSchema,
  RycWebsiteArticleListCacheEntrySchema,
  RycWebsiteArticleListParamsSchema,
  RycWebsiteArticlePrefixFormSchema,
  RycWebsiteArticlePrefixSchema,
  RycWebsiteArticlePrefixStatusDescriptions,
  RycWebsiteArticlePrefixStatusSchema,
  RycWebsiteArticlePrefixTagSchema,
  RycWebsiteArticleReferenceSchema,
  RycWebsiteArticleRevisionListSchema,
  RycWebsiteArticleRevisionSchema,
  RycWebsiteArticleSchema,
  RycWebsiteArticleSeoFormSchema,
  RycWebsiteArticleSeoPayloadSchema,
  RycWebsiteArticleSeoSchema,
  RycWebsiteArticleStatusLabels,
  RycWebsiteArticleStatusSchema,
  RycWebsiteArticleStatusValues,
  RycWebsiteAttachmentSchema,
  RycWebsiteAttachmentStatusSchema,
  RycWebsiteAttachmentVariantSchema,
  RycWebsiteAuthorFormSchema,
  RycWebsiteAuthorSchema,
  RycWebsiteCacheEntrySchema,
  RycWebsiteCacheRegionSchema,
  RycWebsiteCategoryDetailCacheEntrySchema,
  RycWebsiteCategoryFormSchema,
  RycWebsiteCategoryListCacheEntrySchema,
  RycWebsiteCategorySchema,
  RycWebsiteCategoryStatusDescriptions,
  RycWebsiteCategoryStatusLabels,
  RycWebsiteCategoryStatusSchema,
  RycWebsiteCategoryStatusValues,
  RycWebsiteCloudflareCacheStatusSchema,
  RycWebsiteCloudflarePurgeSchema,
  RycWebsiteCloudflareStaticPageSchema,
  RycWebsiteCloudflareWarmStateSchema,
  RycWebsiteCloudflareWarmUrlsSchema,
  RycWebsitePresignedAttachmentSchema,
  RycWebsitePresignedMediaSchema,
  RycWebsiteRedirectBulkImportRowResultSchema,
  RycWebsiteRedirectFormSchema,
  RycWebsiteRedirectLiveProbeSchema,
  RycWebsiteRedirectMatchTypeLabels,
  RycWebsiteRedirectMatchTypeSchema,
  RycWebsiteRedirectMatchTypeValues,
  RycWebsiteRedirectPathSchema,
  RycWebsiteRedirectResolveSchema,
  RycWebsiteRedirectSchema,
  RycWebsiteRedirectStatusCodeLabels,
  RycWebsiteRedirectStatusCodeSchema,
  RycWebsiteRedirectStatusCodeValues,
  RycWebsiteRedirectTargetSchema,
  RycWebsiteTopBannerAssignmentResponseSchema,
  RycWebsiteTopBannerAssignmentSchema,
  RycWebsiteTopBannerConflictSchema,
  RycWebsiteTopBannerFormSchema,
  RycWebsiteTopBannerHeightSchema,
  RycWebsiteTopBannerPriorityByTargetType,
  RycWebsiteTopBannerPriorityLabels,
  RycWebsiteTopBannerPrioritySchema,
  RycWebsiteTopBannerPriorityValues,
  RycWebsiteTopBannerResolveSchema,
  RycWebsiteTopBannerRowTargetTypeValues,
  RycWebsiteTopBannerSchema,
  RycWebsiteTopBannerTargetTypeLabels,
  RycWebsiteTopBannerTargetTypeSchema,
  RycWebsiteTopBannerTargetTypeValues,
  SLUG_PATTERN,
  SLUG_PATTERN_MESSAGE,
  SPACE_BANNER_DISPLAY_KEY,
  SPACE_OVERRIDABLE_ACTIONS,
  SPACE_SLACK_EVENTS,
  SPACE_SLACK_EVENT_LABELS,
  SPACE_VIDEO_COMPLETION_PERCENT_KEY,
  SSO_CONTEXT_PARAM,
  SaveFormProgressSchema,
  SearchCategoryItemSchema,
  SearchContentItemSchema,
  SearchInstructorItemSchema,
  SearchProQuerySchema,
  SearchTextItemSchema,
  SelectBonusContentRequestSchema,
  SelectElectiveContentsSchema,
  SendEmailSchema,
  SendEventMessageRequestSchema,
  SendMessageSchema,
  SendPasswordResetSchema,
  SendStepAndDayCompletionSchema,
  SendTransactionalEmailSchema,
  Series,
  SeriesBadgeNameArray,
  SeriesBadgeNameEnumObject,
  SeriesBadgeSchema,
  SeriesFormItem,
  SeriesGroup,
  SeriesGroupListResponseSchema,
  SeriesGroupResponse,
  SeriesGroupSeriesItemSchema,
  SeriesGroupSeriesListResponseSchema,
  SeriesGroupWithSeriesSchema,
  SeriesInstructorReportResponseSchema,
  SeriesInstructorReportRowSchema,
  SeriesItemReorder,
  SeriesItemsRequestSchemaFE,
  SeriesListResponseSchema,
  SeriesResponseItem,
  SeriesResponseSchema,
  SeriesSectionInput,
  SeriesSectionResponse,
  SeriesTypeEnum,
  SeriesTypeObj,
  SeriesTypeValues,
  SeriesVisibilityStatusEnum,
  SeriesVisibilityStatusValues,
  ServiceResponseDescriminatedUnionSchema,
  ServiceResponseErrorSchema,
  SetPasswordWithTokenSchema,
  SetPasswordWithWpTokenSchema,
  SettingBEResponseSchema,
  SettingsSchema,
  SettingsTypeEnum,
  SettingsTypeEnumObj,
  SettingsTypeEnumValues,
  SingleContentSchedule,
  SinglePlan,
  SingleProgram,
  SingleSeries,
  SingleUserSchema,
  SkipJournalSchemaBE,
  SlackNotificationEventEnum,
  SlackNotificationEventValues,
  SlackWebhookUrlSchema,
  SlideBadgeImagePositionEnumObj,
  SlideBadgeImagePositionValues,
  SlideBadgeSchema,
  SlideshowAppEnumObj,
  SlideshowAppValues,
  SlideshowFiltersSchema,
  SlideshowTypeEnumObj,
  SlideshowTypeValues,
  SlugPathSchema,
  SlugSchema,
  SocketEventTypeEnum,
  SocketEventTypeEnumObj,
  SocketEventTypeEnumValues,
  SourceAllowedActions,
  SpaceActionPermissionsSchema,
  SpaceBannerDisplaySchema,
  SpaceBannerDisplayValues,
  SpaceBaseSchema,
  SpaceParticipantCandidateSchema,
  SpaceParticipantCandidatesQuerySchema,
  SpaceParticipantPermissionsSchema,
  SpaceParticipantRoleSchema,
  SpaceParticipantRoleValues,
  SpaceParticipantUserSchema,
  SpaceRefSchema,
  SpaceReportingConfigSchema,
  SpaceReportingGroupTreatmentSchema,
  SpaceReviewFormsSchema,
  SpaceSlackEventEnum,
  SpaceSlackEventsSchema,
  SpaceStatus,
  SpaceStatusSchema,
  SpaceStudentIdsResponseSchema,
  SpaceStudentSchema,
  SpaceStudentsQuerySchema,
  SpaceStudentsResponseSchema,
  SpaceTeacherSchema,
  SpaceTeacherStudentSchema,
  SpaceTeacherStudentsQuerySchema,
  SpaceTeacherStudentsResponseSchema,
  SpaceTeachersQuerySchema,
  SpaceTeachersResponseSchema,
  SpaceType,
  SpaceTypeSchema,
  SpaceUserGroupOptionSchema,
  SpacesContentRefSchemaBE,
  SpacesEventTargetKind,
  SpacesTargetKindEvents,
  Stages,
  StagesEnumObject,
  StartGcsUploadResultSchema,
  StartGcsUploadSchema,
  StateSchema,
  StatusEnum,
  StatusEnumObj,
  StatusEnumValues,
  StepType,
  StepTypeEnumObject,
  Steps,
  StepsEnumObject,
  StorageAnalyticsFiltersSchema,
  StorageAnalyticsResponseSchema,
  StorageAnalyticsSummarySchema,
  StorageAnalyticsUserRowSchema,
  StringToBooleanSchema,
  StudentTeacherStatusSchema,
  SubSpaceUrlSlugSchema,
  SubmissionStatus,
  SubmissionStatusSchema,
  SubmitAnswerSchema,
  SubmitFormAnswerSchema,
  SubmitFormSchema,
  SubmitQuizAttemptSchema,
  SubscribedUserResponseSchema,
  SubscribedUserSchema,
  Subscription,
  SubscriptionAddon,
  SubscriptionObjectSchema,
  SubscriptionsResponseSchema,
  SupabaseJwtPayloadSchema,
  SupabaseLoginSchema,
  SupabaseMentionableProfileRowSchema,
  SupabaseMentionableProfileSchema,
  SupabaseProfileSchema,
  SupabaseRowProfileSchema,
  SupportNewTicketConditionSchema,
  SupportPermissionKeyEnum,
  SupportPermissionKeyValues,
  SupportRoleSchema,
  SupportSettingsSchema,
  SupportStaffMemberSchema,
  SupportTicketReplyConditionSchema,
  TagRefSchema,
  TargetAppEnum,
  TeachingFormatSchema,
  TemplateResponseSchema,
  TemplateVariables,
  TermsAcceptanceResponseSchema,
  TermsBaseSchema,
  TicketCommentSchema,
  TicketEventSchema,
  TicketEventTypeEnum,
  TicketEventTypeValues,
  TicketFiltersSchema,
  TicketSchema,
  TicketStatusEnum,
  TicketStatusValues,
  TierValues,
  TiersEnumObject,
  TimePeriodEnum,
  TimePeriodEnumObj,
  TimePeriodEnumValues,
  TodaysWorkoutSchemaFE,
  ToggleDashboardFeedCardSchema,
  ToggleProgramPublishSchema,
  TogglePromoBannerSchema,
  ToggleReactionSchema,
  ToggleRejectDtoSchema,
  ToggleRejectFeedItemSchema,
  TopContributorSchema,
  TopContributorsResponseSchema,
  TranscodeJobSchema,
  TranscodeResultEventSchema,
  TranscodeResultSchema,
  TrashContentSchema,
  TrashContentVimeoVideo,
  TrendingTagSchema,
  TrendingTagsResponseSchema,
  UNASSIGNED_TEACHER_ID,
  USERNAME_REGEX,
  USER_ONLINE_REDIS_CHANNEL,
  UnregisterDeviceTokenRequestSchema,
  UnsignedIDSchema,
  UpcomingLiveBannerSettingSchema,
  UpcomingLiveBannerSettingSchemaBE,
  UpcomingLiveBannerSettingSchemaFE,
  UpdateAddonProgramRequestSchemaFE,
  UpdateAnalyticsRuleSchemaBE,
  UpdateAnalyticsSpaceConfigSchemaBE,
  UpdateAppRequestSchema,
  UpdateCODThemeSchemaBE,
  UpdateCommentDtoSchema,
  UpdateCommentSchema,
  UpdateCommunityTagSchema,
  UpdateContentBlockSchema,
  UpdateContentScheduleSettingsFE,
  UpdateContentScheduleSettingsSchemaBE,
  UpdateContentSchemaBE,
  UpdateContentSchemaFE,
  UpdateDashboardFeedCardSchema,
  UpdateEquipmentRequest,
  UpdateEventSchemaBE,
  UpdateEventSchemaFE,
  UpdateFeatureFlagRequestSchema,
  UpdateFitOnboardingStepSchemaBE,
  UpdateFormDefinitionSchema,
  UpdateFormOptionSchema,
  UpdateFormQuestionGroupSchema,
  UpdateFormQuestionSchema,
  UpdateFormSchema,
  UpdateHelpCenterArticleSchemaBE,
  UpdateHelpCenterCategoryTaxonomySchemaBE,
  UpdateHelpCenterTopicTaxonomySchemaBE,
  UpdateInstructionSchema,
  UpdateInstructorSchema,
  UpdateIssueCategorySchema,
  UpdateLessonCategorySchema,
  UpdateLessonSchema,
  UpdateLinkGroupSchema,
  UpdateMediaFileSchema,
  UpdateMediaUploadLimitSchema,
  UpdateMessageSchema,
  UpdateMonitoredLinkSchema,
  UpdateNoteSchema,
  UpdateNotificationPreferencesSchema,
  UpdateNotificationRuleSchemaBE,
  UpdateOnboardingStepVideoWatchedSchemaBE,
  UpdateOptionSchema,
  UpdatePermissionSchema,
  UpdatePlanRequestSchemaFE,
  UpdatePlaylistBeRequestSchema,
  UpdatePlaylistRequestSchema,
  UpdatePlaylistSchema,
  UpdatePostSchema,
  UpdatePrivacySchema,
  UpdateProDirectorySchema,
  UpdateProfileSchema,
  UpdateProgramGroupRequestSchema,
  UpdateProgressSchema,
  UpdatePromoBannerSchema,
  UpdateQuestionSchema,
  UpdateQuizSchema,
  UpdateRYCContentRequestWithMetaSchema,
  UpdateRYCContentSchemaBE,
  UpdateRYCContentWithMetaSchemaBE,
  UpdateReportStatusSchema,
  UpdateRoleSchema,
  UpdateRycWebsiteArticlePrefixSchema,
  UpdateRycWebsiteArticleSchema,
  UpdateRycWebsiteAuthorSchema,
  UpdateRycWebsiteCategorySchema,
  UpdateRycWebsiteRedirectSchema,
  UpdateRycWebsiteTopBannerSchema,
  UpdateSeriesGroupSchemaFE,
  UpdateSeriesRequestSchemaFE,
  UpdateSlideshowSchemaFE,
  UpdateSpaceSchema,
  UpdateStepContentSchemaBE,
  UpdateStepContentSchemaFE,
  UpdateStepContentsSchemaBE,
  UpdateStepDaySchemaBE,
  UpdateStepSchemaBE,
  UpdateStepSchemaFE,
  UpdateSupportSettingsSchema,
  UpdateTermsSchema,
  UpdateTicketStatusSchema,
  UpdateTimezoneSchema,
  UpdateUserGroupSchema,
  UpdateUserPrivacyBESchema,
  UpdateUserSchema,
  UpdateWatchHistoryBeSchema,
  UpdateZoomEventSchema,
  UploadedFileSchema,
  UserAccessItemSchema,
  UserAccessMapSchema,
  UserAccessPermissionSchema,
  UserActivitiesTypeEnum,
  UserActivitiesTypeObj,
  UserActivitiesTypeValues,
  UserActivityItemSchema,
  UserActivityQuerySchema,
  UserActivitySchema,
  UserActivityTypeEnumObject,
  UserActivityTypeValues,
  UserCheckInSchemaBe,
  UserContentRatingResponse,
  UserDataSchema,
  UserDayChangeSchemaBe,
  UserGroupBaseSchema,
  UserGroupGrantJobSchema,
  UserGroupGrantJobStatusSchema,
  UserGroupGrantPreviewAppSchema,
  UserGroupGrantPreviewSchema,
  UserGroupGrantResultItemSchema,
  UserGroupGrantResultStatusSchema,
  UserGroupImportJobSchema,
  UserGroupImportJobStatusSchema,
  UserGroupImportModeSchema,
  UserGroupImportPreviewSchema,
  UserGroupImportRequestSchema,
  UserGroupImportSourceSchema,
  UserGroupMemberBaseSchema,
  UserGroupSourceConfigSchema,
  UserGroupStatus,
  UserGroupStatusSchema,
  UserJwtSchema,
  UserLastCheckInSchemaBe,
  UserLogActionEnumObj,
  UserLogActionValues,
  UserLogBaseSchema,
  UserLogBaseSchemaWithFullContent,
  UserLogFilterDtoBe,
  UserManageItemTypeEnum,
  UserManageItemTypeObj,
  UserManageItemTypeValues,
  UserMetaSchema,
  UserOnlineLastWatchedContentSchema,
  UserOnlineNamespace,
  UserOnlinePubSubSchema,
  UserOnlinePubSubSchemaStringifiedSchema,
  UserOnlinePubSubValues,
  UserOnlineTopicEnumObject,
  UserOnlineTopicValues,
  UserOwnershipSummarySchema,
  UserPrivacyRedisSchemaBE,
  UserPrivacySchemaBE,
  UserResponseSchema,
  UserSchema,
  UserSourceEnum,
  UserTotalWatchedByCategory,
  UserWatchHistoryDates,
  UserWatchedAContentSchema,
  UsernameSchema,
  VIDEO_COMPLETION_PERCENT_OPTIONS,
  ValidateOttSchema,
  ValidationRulesSchema,
  VerifyOtpLoginSchema,
  VersionInfoSchema,
  VideoCompletionPercentSchema,
  VideoPlayedBlocksSchema,
  VideoWatchCountsSchema,
  VimeoSearchResultItemSchema,
  VimeoSearchResultsSchema,
  VimeoVideo,
  VimeoVideoDurationsSchema,
  VimeoVideoInfoSchema,
  VimeoVideoInput,
  VotePollSchema,
  WELCOME_PAGE_REDIRECT_FIELD_TYPES,
  WPSubscriptionArraySchema,
  WatchHistoryBaseSchema,
  WatchedFilterEnum,
  WatchedStatusEnumObj,
  WatchedStatusEnumValues,
  WelcomeNotificationPayloadSchemaBE,
  WelcomePageRedirectSchema,
  WidgetStyleSchema,
  WpLoginSchema,
  WpProductDetailResponseSchema,
  WpProductSchema,
  WpProductSearchResponseSchema,
  WsUrl,
  YouMayLikeRequestFilterSchema,
  ZoomSignatureResponseSchema,
  allowedTargetKindsForEvent,
  analyticsCatalogKey,
  analyticsContentKey,
  analyticsEventLabel,
  auditRycWebsiteRedirects,
  bioVisibleTextLength,
  buildRycWebsiteRedirectProbes,
  canPerformSpaceAction,
  contentFilterDefaultValues,
  contentFilterEmptyDefaultValues,
  dedupeOptionValues,
  defaultAddonContentSchemaValues,
  defaultAttachmentLimits,
  defaultBadgeMetaValuesBE,
  defaultClassOfTheDayThemeSchemaValues,
  defaultContactFormSettingValues,
  defaultContentSchemaValues,
  defaultContentSettingValues,
  defaultEventSchemaValues,
  defaultFeatureSeriesContentValues,
  defaultFitChallengeValues,
  defaultHelpCenterSchemaValues,
  defaultOnboardingSettingValues,
  defaultPlanSchemaValues,
  defaultProgramSchemaValues,
  defaultRYCContentSchemaValues,
  defaultSeriesGroupValues,
  defaultSeriesSchemaValues,
  defaultSettingsValues,
  defaultSlideshowSchemaValues,
  defaultUpcomingLiveBannerSettingValues,
  deriveLiveSessionState,
  ensureUniqueFieldOptionValues,
  ensureUniqueOptionValues,
  eventsForBlockType,
  eventsForTargetKinds,
  findDuplicateOptionValues,
  findRejectedAttachment,
  flattenContentTree,
  formatAnalyticsUserRoles,
  formatBytes,
  gcsMimeTypeForExtension,
  getAcceptButtonLabel,
  getAcceptCheckboxLabel,
  getAddonProgramViewPermission,
  getAnswerGrades,
  getAnswerOptedOut,
  getCommentContentLength,
  getDropdownOptions,
  getFormBlockTint,
  getGradingOptOut,
  getGradingReflection,
  getGradingRows,
  getGradingScale,
  getMappableProfileFieldsForQuestionType,
  getOverridableActionsForSpaceType,
  getPermissionIdSetForApp,
  getPermissionIdSetFromAccessMap,
  getProfileFieldByKey,
  getQuestionAnswerShape,
  getQuestionInputType,
  getSpaceBannerDisplay,
  getSpaceParticipantRole,
  getSpaceVideoCompletionPercent,
  getTextBlocks,
  groupRycWebsiteRedirects,
  hasFeatureFlag,
  hasPermissionForApp,
  hasPermissionInAccessMap,
  instructionSchema,
  isActionAllowedForSource,
  isAnalyticsCompositeEvent,
  isAnswerableQuestionType,
  isBlackFridayBannerEligible,
  isCellCompletedLate,
  isCellOnTime,
  isContentManagerForApp,
  isGcsFileAllowed,
  isGradingAnswerComplete,
  isMultiValueField,
  isPdfAttachment,
  isQuestionTypeMappableToFieldKind,
  isQuestionTypeMappableToProfileFieldKey,
  isRycWebsiteRedirectExternalTarget,
  isRycWebsiteRedirectPathUnder,
  isRycWebsiteTopBannerRouteTargetType,
  isShortAnswerValueValid,
  isTeacherReviewedFormType,
  isVideoAttachment,
  isWelcomePageRedirectField,
  liveProbeMatches,
  mapOptionValues,
  matchRycWebsiteRedirect,
  maxAttachmentBytesFor,
  nextOptionValue,
  parseAllowedMediaTypes,
  parseBlockVideoCompletionPercent,
  parseGcsFilenamePrefix,
  parseUserGroupFilters,
  passesPermissionRestriction,
  plainTextToBioHtml,
  remapOptionValue,
  resetOptionValues,
  resolveProcessingKind,
  resolveVideoCompletionPercent,
  resolveWelcomePageUrl,
  rycContentFilterDefaultValues,
  rycContentFilterEmptyDefaultValues,
  rycJournalFilterDefaultValues,
  sanitizeAppName,
  serializeUserGroupFilters,
  spacesTargetKindForEvent,
  stringifyUserOnlinePubSubSchema,
  timezoneSchema,
  toBioHtml,
  transformSubscriptionArrayToObject,
  userGroupAppliesToApp,
  validateComment,
  validateCommentsResponse,
  validateCreateComment,
  validateGetComments,
  validateGetContentsByCommentsDateRange,
  validateLikeResponse,
  validateRuleChannels,
  validateRuleConditions,
  validateUpdateComment,
  visibleTextLength
};
//# sourceMappingURL=index.mjs.map